import { z } from 'zod'
import { useMutation, useQuery, useInfiniteQuery, UseMutationOptions, UseQueryOptions, UseInfiniteQueryOptions } from '@tanstack/react-query';
import { fetchByAuth } from '@/fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  _text: any;
  date: any;
  json: any;
  jsonb: any;
  timestamp: any;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type GachaResult = {
  __typename?: 'GachaResult';
  error_code?: Maybe<Scalars['String']>;
  error_message?: Maybe<Scalars['String']>;
  gacha_lose_id?: Maybe<Scalars['String']>;
  physical_prize_id?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type PresignedUrl = {
  __typename?: 'PresignedUrl';
  fileName?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  url?: Maybe<Scalars['String']>;
};

export type SimpleResult = {
  __typename?: 'SimpleResult';
  error_message?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "address" */
export type Address = {
  __typename?: 'address';
  building?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  created_at: Scalars['timestamp'];
  id: Scalars['String'];
  name: Scalars['String'];
  postal_code: Scalars['String'];
  prefecture: Scalars['String'];
  street: Scalars['String'];
  tel_body: Scalars['String'];
  tel_head: Scalars['String'];
  tel_tail: Scalars['String'];
  updated_at: Scalars['timestamp'];
  /** An object relationship */
  user: User;
  user_id: Scalars['String'];
};

/** order by aggregate values of table "address" */
export type Address_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Address_Max_Order_By>;
  min?: InputMaybe<Address_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "address". All fields are combined with a logical 'AND'. */
export type Address_Bool_Exp = {
  _and?: InputMaybe<Array<Address_Bool_Exp>>;
  _not?: InputMaybe<Address_Bool_Exp>;
  _or?: InputMaybe<Array<Address_Bool_Exp>>;
  building?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  postal_code?: InputMaybe<String_Comparison_Exp>;
  prefecture?: InputMaybe<String_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  tel_body?: InputMaybe<String_Comparison_Exp>;
  tel_head?: InputMaybe<String_Comparison_Exp>;
  tel_tail?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "address" */
export enum Address_Constraint {
  /** unique or primary key constraint on columns "id" */
  AddressPkey = 'address_pkey'
}

/** input type for inserting data into table "address" */
export type Address_Insert_Input = {
  building?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  name?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  prefecture?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  tel_body?: InputMaybe<Scalars['String']>;
  tel_head?: InputMaybe<Scalars['String']>;
  tel_tail?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "address" */
export type Address_Max_Order_By = {
  building?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  postal_code?: InputMaybe<Order_By>;
  prefecture?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  tel_body?: InputMaybe<Order_By>;
  tel_head?: InputMaybe<Order_By>;
  tel_tail?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "address" */
export type Address_Min_Order_By = {
  building?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  postal_code?: InputMaybe<Order_By>;
  prefecture?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  tel_body?: InputMaybe<Order_By>;
  tel_head?: InputMaybe<Order_By>;
  tel_tail?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "address" */
export type Address_Mutation_Response = {
  __typename?: 'address_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Address>;
};

/** on_conflict condition type for table "address" */
export type Address_On_Conflict = {
  constraint: Address_Constraint;
  update_columns?: Array<Address_Update_Column>;
  where?: InputMaybe<Address_Bool_Exp>;
};

/** Ordering options when selecting data from "address". */
export type Address_Order_By = {
  building?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  postal_code?: InputMaybe<Order_By>;
  prefecture?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  tel_body?: InputMaybe<Order_By>;
  tel_head?: InputMaybe<Order_By>;
  tel_tail?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: address */
export type Address_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "address" */
export enum Address_Select_Column {
  /** column name */
  Building = 'building',
  /** column name */
  City = 'city',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  Prefecture = 'prefecture',
  /** column name */
  Street = 'street',
  /** column name */
  TelBody = 'tel_body',
  /** column name */
  TelHead = 'tel_head',
  /** column name */
  TelTail = 'tel_tail',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "address" */
export type Address_Set_Input = {
  building?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  prefecture?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  tel_body?: InputMaybe<Scalars['String']>;
  tel_head?: InputMaybe<Scalars['String']>;
  tel_tail?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "address" */
export type Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Address_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Address_Stream_Cursor_Value_Input = {
  building?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  prefecture?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  tel_body?: InputMaybe<Scalars['String']>;
  tel_head?: InputMaybe<Scalars['String']>;
  tel_tail?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "address" */
export enum Address_Update_Column {
  /** column name */
  Building = 'building',
  /** column name */
  City = 'city',
  /** column name */
  Name = 'name',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  Prefecture = 'prefecture',
  /** column name */
  Street = 'street',
  /** column name */
  TelBody = 'tel_body',
  /** column name */
  TelHead = 'tel_head',
  /** column name */
  TelTail = 'tel_tail',
  /** column name */
  UserId = 'user_id'
}

export type Address_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Address_Set_Input>;
  /** filter the rows which have to be updated */
  where: Address_Bool_Exp;
};

/** columns and relationships of "campsite" */
export type Campsite = {
  __typename?: 'campsite';
  access_count: Scalars['Int'];
  activity_athletic: Scalars['Boolean'];
  activity_bbq: Scalars['Boolean'];
  activity_bicycle: Scalars['Boolean'];
  activity_canoe: Scalars['Boolean'];
  activity_craft: Scalars['Boolean'];
  activity_fishing: Scalars['Boolean'];
  activity_flower: Scalars['Boolean'];
  activity_hiking: Scalars['Boolean'];
  activity_insect: Scalars['Boolean'];
  activity_playset: Scalars['Boolean'];
  activity_pool: Scalars['Boolean'];
  activity_ranch: Scalars['Boolean'];
  activity_river: Scalars['Boolean'];
  activity_sauna: Scalars['Boolean'];
  activity_sea: Scalars['Boolean'];
  activity_star: Scalars['Boolean'];
  activity_taste: Scalars['Boolean'];
  activity_tentsauna: Scalars['Boolean'];
  address: Scalars['String'];
  bath_hotspring: Scalars['Boolean'];
  bath_room: Scalars['Boolean'];
  business_newyear: Scalars['Boolean'];
  business_period: Scalars['Boolean'];
  /** An array relationship */
  campsite_likes: Array<Campsite_Likes>;
  /** An aggregate relationship */
  campsite_likes_aggregate: Campsite_Likes_Aggregate;
  checkin_end_hour?: Maybe<Scalars['String']>;
  checkin_end_minute?: Maybe<Scalars['String']>;
  checkin_start_hour?: Maybe<Scalars['String']>;
  checkin_start_minute?: Maybe<Scalars['String']>;
  checkout_end_hour?: Maybe<Scalars['String']>;
  checkout_end_minute?: Maybe<Scalars['String']>;
  checkout_start_hour?: Maybe<Scalars['String']>;
  checkout_start_minute?: Maybe<Scalars['String']>;
  closed_friday: Scalars['Boolean'];
  closed_holiday: Scalars['Boolean'];
  closed_irregular: Scalars['Boolean'];
  closed_monday: Scalars['Boolean'];
  closed_not: Scalars['Boolean'];
  closed_saturday: Scalars['Boolean'];
  closed_sunday: Scalars['Boolean'];
  closed_thursday: Scalars['Boolean'];
  closed_tuesday: Scalars['Boolean'];
  closed_wednesday: Scalars['Boolean'];
  created_at: Scalars['timestamp'];
  facilities_barrierfree: Scalars['Boolean'];
  facilities_dogrun: Scalars['Boolean'];
  facilities_laundry: Scalars['Boolean'];
  facilities_restaurant: Scalars['Boolean'];
  facilities_store: Scalars['Boolean'];
  facilities_workspace: Scalars['Boolean'];
  facility_acsite: Scalars['Boolean'];
  facility_bungalow: Scalars['Boolean'];
  facility_cottage: Scalars['Boolean'];
  facility_freesite: Scalars['Boolean'];
  facility_glamping: Scalars['Boolean'];
  facility_privatesite: Scalars['Boolean'];
  facility_sectionsite: Scalars['Boolean'];
  facility_solo: Scalars['Boolean'];
  facility_tipi: Scalars['Boolean'];
  facility_trailerhouse: Scalars['Boolean'];
  facility_treehouse: Scalars['Boolean'];
  id: Scalars['String'];
  /** An object relationship */
  image?: Maybe<Image>;
  introduction_content?: Maybe<Scalars['String']>;
  introduction_title?: Maybe<Scalars['String']>;
  is_affiliated: Scalars['Boolean'];
  location_forest: Scalars['Boolean'];
  location_hill: Scalars['Boolean'];
  location_lake: Scalars['Boolean'];
  location_meadow: Scalars['Boolean'];
  location_ocean: Scalars['Boolean'];
  location_park: Scalars['Boolean'];
  location_plateau: Scalars['Boolean'];
  location_river: Scalars['Boolean'];
  main_image_id?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  official_url?: Maybe<Scalars['String']>;
  prefectures: Scalars['String'];
  prefectures_code: Scalars['String'];
  region_code: Scalars['String'];
  /** An array relationship */
  reviews: Array<Review>;
  /** An aggregate relationship */
  reviews_aggregate: Review_Aggregate;
  service_firewood: Scalars['Boolean'];
  service_firework: Scalars['Boolean'];
  service_freecharge: Scalars['Boolean'];
  service_garbage: Scalars['Boolean'];
  service_group: Scalars['Boolean'];
  service_hotwater: Scalars['Boolean'];
  service_openfire: Scalars['Boolean'];
  service_pet: Scalars['Boolean'];
  service_rental: Scalars['Boolean'];
  service_washlet: Scalars['Boolean'];
  service_wifi: Scalars['Boolean'];
  tel_bottom?: Maybe<Scalars['String']>;
  tel_head?: Maybe<Scalars['String']>;
  tel_while?: Maybe<Scalars['String']>;
  total_like_num: Scalars['Int'];
  total_review_num: Scalars['Int'];
  total_visited_num: Scalars['Int'];
  updated_at: Scalars['timestamp'];
  vehicles_autocamp: Scalars['Boolean'];
  vehicles_campingcar: Scalars['Boolean'];
  visibility_status: Scalars['String'];
  /** An array relationship */
  visiteds: Array<Visited>;
  /** An aggregate relationship */
  visiteds_aggregate: Visited_Aggregate;
};


/** columns and relationships of "campsite" */
export type CampsiteCampsite_LikesArgs = {
  distinct_on?: InputMaybe<Array<Campsite_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Campsite_Likes_Order_By>>;
  where?: InputMaybe<Campsite_Likes_Bool_Exp>;
};


/** columns and relationships of "campsite" */
export type CampsiteCampsite_Likes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campsite_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Campsite_Likes_Order_By>>;
  where?: InputMaybe<Campsite_Likes_Bool_Exp>;
};


/** columns and relationships of "campsite" */
export type CampsiteReviewsArgs = {
  distinct_on?: InputMaybe<Array<Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Order_By>>;
  where?: InputMaybe<Review_Bool_Exp>;
};


/** columns and relationships of "campsite" */
export type CampsiteReviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Order_By>>;
  where?: InputMaybe<Review_Bool_Exp>;
};


/** columns and relationships of "campsite" */
export type CampsiteVisitedsArgs = {
  distinct_on?: InputMaybe<Array<Visited_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Visited_Order_By>>;
  where?: InputMaybe<Visited_Bool_Exp>;
};


/** columns and relationships of "campsite" */
export type CampsiteVisiteds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visited_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Visited_Order_By>>;
  where?: InputMaybe<Visited_Bool_Exp>;
};

/** aggregated selection of "campsite" */
export type Campsite_Aggregate = {
  __typename?: 'campsite_aggregate';
  aggregate?: Maybe<Campsite_Aggregate_Fields>;
  nodes: Array<Campsite>;
};

export type Campsite_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Campsite_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Campsite_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Campsite_Aggregate_Bool_Exp_Count>;
};

export type Campsite_Aggregate_Bool_Exp_Bool_And = {
  arguments: Campsite_Select_Column_Campsite_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Campsite_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Campsite_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Campsite_Select_Column_Campsite_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Campsite_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Campsite_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Campsite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Campsite_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "campsite" */
export type Campsite_Aggregate_Fields = {
  __typename?: 'campsite_aggregate_fields';
  avg?: Maybe<Campsite_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Campsite_Max_Fields>;
  min?: Maybe<Campsite_Min_Fields>;
  stddev?: Maybe<Campsite_Stddev_Fields>;
  stddev_pop?: Maybe<Campsite_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Campsite_Stddev_Samp_Fields>;
  sum?: Maybe<Campsite_Sum_Fields>;
  var_pop?: Maybe<Campsite_Var_Pop_Fields>;
  var_samp?: Maybe<Campsite_Var_Samp_Fields>;
  variance?: Maybe<Campsite_Variance_Fields>;
};


/** aggregate fields of "campsite" */
export type Campsite_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Campsite_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "campsite" */
export type Campsite_Aggregate_Order_By = {
  avg?: InputMaybe<Campsite_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Campsite_Max_Order_By>;
  min?: InputMaybe<Campsite_Min_Order_By>;
  stddev?: InputMaybe<Campsite_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Campsite_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Campsite_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Campsite_Sum_Order_By>;
  var_pop?: InputMaybe<Campsite_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Campsite_Var_Samp_Order_By>;
  variance?: InputMaybe<Campsite_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Campsite_Avg_Fields = {
  __typename?: 'campsite_avg_fields';
  access_count?: Maybe<Scalars['Float']>;
  total_like_num?: Maybe<Scalars['Float']>;
  total_review_num?: Maybe<Scalars['Float']>;
  total_visited_num?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "campsite" */
export type Campsite_Avg_Order_By = {
  access_count?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "campsite". All fields are combined with a logical 'AND'. */
export type Campsite_Bool_Exp = {
  _and?: InputMaybe<Array<Campsite_Bool_Exp>>;
  _not?: InputMaybe<Campsite_Bool_Exp>;
  _or?: InputMaybe<Array<Campsite_Bool_Exp>>;
  access_count?: InputMaybe<Int_Comparison_Exp>;
  activity_athletic?: InputMaybe<Boolean_Comparison_Exp>;
  activity_bbq?: InputMaybe<Boolean_Comparison_Exp>;
  activity_bicycle?: InputMaybe<Boolean_Comparison_Exp>;
  activity_canoe?: InputMaybe<Boolean_Comparison_Exp>;
  activity_craft?: InputMaybe<Boolean_Comparison_Exp>;
  activity_fishing?: InputMaybe<Boolean_Comparison_Exp>;
  activity_flower?: InputMaybe<Boolean_Comparison_Exp>;
  activity_hiking?: InputMaybe<Boolean_Comparison_Exp>;
  activity_insect?: InputMaybe<Boolean_Comparison_Exp>;
  activity_playset?: InputMaybe<Boolean_Comparison_Exp>;
  activity_pool?: InputMaybe<Boolean_Comparison_Exp>;
  activity_ranch?: InputMaybe<Boolean_Comparison_Exp>;
  activity_river?: InputMaybe<Boolean_Comparison_Exp>;
  activity_sauna?: InputMaybe<Boolean_Comparison_Exp>;
  activity_sea?: InputMaybe<Boolean_Comparison_Exp>;
  activity_star?: InputMaybe<Boolean_Comparison_Exp>;
  activity_taste?: InputMaybe<Boolean_Comparison_Exp>;
  activity_tentsauna?: InputMaybe<Boolean_Comparison_Exp>;
  address?: InputMaybe<String_Comparison_Exp>;
  bath_hotspring?: InputMaybe<Boolean_Comparison_Exp>;
  bath_room?: InputMaybe<Boolean_Comparison_Exp>;
  business_newyear?: InputMaybe<Boolean_Comparison_Exp>;
  business_period?: InputMaybe<Boolean_Comparison_Exp>;
  campsite_likes?: InputMaybe<Campsite_Likes_Bool_Exp>;
  campsite_likes_aggregate?: InputMaybe<Campsite_Likes_Aggregate_Bool_Exp>;
  checkin_end_hour?: InputMaybe<String_Comparison_Exp>;
  checkin_end_minute?: InputMaybe<String_Comparison_Exp>;
  checkin_start_hour?: InputMaybe<String_Comparison_Exp>;
  checkin_start_minute?: InputMaybe<String_Comparison_Exp>;
  checkout_end_hour?: InputMaybe<String_Comparison_Exp>;
  checkout_end_minute?: InputMaybe<String_Comparison_Exp>;
  checkout_start_hour?: InputMaybe<String_Comparison_Exp>;
  checkout_start_minute?: InputMaybe<String_Comparison_Exp>;
  closed_friday?: InputMaybe<Boolean_Comparison_Exp>;
  closed_holiday?: InputMaybe<Boolean_Comparison_Exp>;
  closed_irregular?: InputMaybe<Boolean_Comparison_Exp>;
  closed_monday?: InputMaybe<Boolean_Comparison_Exp>;
  closed_not?: InputMaybe<Boolean_Comparison_Exp>;
  closed_saturday?: InputMaybe<Boolean_Comparison_Exp>;
  closed_sunday?: InputMaybe<Boolean_Comparison_Exp>;
  closed_thursday?: InputMaybe<Boolean_Comparison_Exp>;
  closed_tuesday?: InputMaybe<Boolean_Comparison_Exp>;
  closed_wednesday?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  facilities_barrierfree?: InputMaybe<Boolean_Comparison_Exp>;
  facilities_dogrun?: InputMaybe<Boolean_Comparison_Exp>;
  facilities_laundry?: InputMaybe<Boolean_Comparison_Exp>;
  facilities_restaurant?: InputMaybe<Boolean_Comparison_Exp>;
  facilities_store?: InputMaybe<Boolean_Comparison_Exp>;
  facilities_workspace?: InputMaybe<Boolean_Comparison_Exp>;
  facility_acsite?: InputMaybe<Boolean_Comparison_Exp>;
  facility_bungalow?: InputMaybe<Boolean_Comparison_Exp>;
  facility_cottage?: InputMaybe<Boolean_Comparison_Exp>;
  facility_freesite?: InputMaybe<Boolean_Comparison_Exp>;
  facility_glamping?: InputMaybe<Boolean_Comparison_Exp>;
  facility_privatesite?: InputMaybe<Boolean_Comparison_Exp>;
  facility_sectionsite?: InputMaybe<Boolean_Comparison_Exp>;
  facility_solo?: InputMaybe<Boolean_Comparison_Exp>;
  facility_tipi?: InputMaybe<Boolean_Comparison_Exp>;
  facility_trailerhouse?: InputMaybe<Boolean_Comparison_Exp>;
  facility_treehouse?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  image?: InputMaybe<Image_Bool_Exp>;
  introduction_content?: InputMaybe<String_Comparison_Exp>;
  introduction_title?: InputMaybe<String_Comparison_Exp>;
  is_affiliated?: InputMaybe<Boolean_Comparison_Exp>;
  location_forest?: InputMaybe<Boolean_Comparison_Exp>;
  location_hill?: InputMaybe<Boolean_Comparison_Exp>;
  location_lake?: InputMaybe<Boolean_Comparison_Exp>;
  location_meadow?: InputMaybe<Boolean_Comparison_Exp>;
  location_ocean?: InputMaybe<Boolean_Comparison_Exp>;
  location_park?: InputMaybe<Boolean_Comparison_Exp>;
  location_plateau?: InputMaybe<Boolean_Comparison_Exp>;
  location_river?: InputMaybe<Boolean_Comparison_Exp>;
  main_image_id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  official_url?: InputMaybe<String_Comparison_Exp>;
  prefectures?: InputMaybe<String_Comparison_Exp>;
  prefectures_code?: InputMaybe<String_Comparison_Exp>;
  region_code?: InputMaybe<String_Comparison_Exp>;
  reviews?: InputMaybe<Review_Bool_Exp>;
  reviews_aggregate?: InputMaybe<Review_Aggregate_Bool_Exp>;
  service_firewood?: InputMaybe<Boolean_Comparison_Exp>;
  service_firework?: InputMaybe<Boolean_Comparison_Exp>;
  service_freecharge?: InputMaybe<Boolean_Comparison_Exp>;
  service_garbage?: InputMaybe<Boolean_Comparison_Exp>;
  service_group?: InputMaybe<Boolean_Comparison_Exp>;
  service_hotwater?: InputMaybe<Boolean_Comparison_Exp>;
  service_openfire?: InputMaybe<Boolean_Comparison_Exp>;
  service_pet?: InputMaybe<Boolean_Comparison_Exp>;
  service_rental?: InputMaybe<Boolean_Comparison_Exp>;
  service_washlet?: InputMaybe<Boolean_Comparison_Exp>;
  service_wifi?: InputMaybe<Boolean_Comparison_Exp>;
  tel_bottom?: InputMaybe<String_Comparison_Exp>;
  tel_head?: InputMaybe<String_Comparison_Exp>;
  tel_while?: InputMaybe<String_Comparison_Exp>;
  total_like_num?: InputMaybe<Int_Comparison_Exp>;
  total_review_num?: InputMaybe<Int_Comparison_Exp>;
  total_visited_num?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  vehicles_autocamp?: InputMaybe<Boolean_Comparison_Exp>;
  vehicles_campingcar?: InputMaybe<Boolean_Comparison_Exp>;
  visibility_status?: InputMaybe<String_Comparison_Exp>;
  visiteds?: InputMaybe<Visited_Bool_Exp>;
  visiteds_aggregate?: InputMaybe<Visited_Aggregate_Bool_Exp>;
};

/** columns and relationships of "campsite_likes" */
export type Campsite_Likes = {
  __typename?: 'campsite_likes';
  /** An object relationship */
  campsite: Campsite;
  campsite_id: Scalars['String'];
  created_at: Scalars['timestamp'];
  id: Scalars['String'];
  order_index?: Maybe<Scalars['Int']>;
  type: Scalars['String'];
  updated_at: Scalars['timestamp'];
  /** An object relationship */
  user: User;
  user_id: Scalars['String'];
};

/** aggregated selection of "campsite_likes" */
export type Campsite_Likes_Aggregate = {
  __typename?: 'campsite_likes_aggregate';
  aggregate?: Maybe<Campsite_Likes_Aggregate_Fields>;
  nodes: Array<Campsite_Likes>;
};

export type Campsite_Likes_Aggregate_Bool_Exp = {
  count?: InputMaybe<Campsite_Likes_Aggregate_Bool_Exp_Count>;
};

export type Campsite_Likes_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Campsite_Likes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Campsite_Likes_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "campsite_likes" */
export type Campsite_Likes_Aggregate_Fields = {
  __typename?: 'campsite_likes_aggregate_fields';
  avg?: Maybe<Campsite_Likes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Campsite_Likes_Max_Fields>;
  min?: Maybe<Campsite_Likes_Min_Fields>;
  stddev?: Maybe<Campsite_Likes_Stddev_Fields>;
  stddev_pop?: Maybe<Campsite_Likes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Campsite_Likes_Stddev_Samp_Fields>;
  sum?: Maybe<Campsite_Likes_Sum_Fields>;
  var_pop?: Maybe<Campsite_Likes_Var_Pop_Fields>;
  var_samp?: Maybe<Campsite_Likes_Var_Samp_Fields>;
  variance?: Maybe<Campsite_Likes_Variance_Fields>;
};


/** aggregate fields of "campsite_likes" */
export type Campsite_Likes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Campsite_Likes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "campsite_likes" */
export type Campsite_Likes_Aggregate_Order_By = {
  avg?: InputMaybe<Campsite_Likes_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Campsite_Likes_Max_Order_By>;
  min?: InputMaybe<Campsite_Likes_Min_Order_By>;
  stddev?: InputMaybe<Campsite_Likes_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Campsite_Likes_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Campsite_Likes_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Campsite_Likes_Sum_Order_By>;
  var_pop?: InputMaybe<Campsite_Likes_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Campsite_Likes_Var_Samp_Order_By>;
  variance?: InputMaybe<Campsite_Likes_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Campsite_Likes_Avg_Fields = {
  __typename?: 'campsite_likes_avg_fields';
  order_index?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "campsite_likes" */
export type Campsite_Likes_Avg_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "campsite_likes". All fields are combined with a logical 'AND'. */
export type Campsite_Likes_Bool_Exp = {
  _and?: InputMaybe<Array<Campsite_Likes_Bool_Exp>>;
  _not?: InputMaybe<Campsite_Likes_Bool_Exp>;
  _or?: InputMaybe<Array<Campsite_Likes_Bool_Exp>>;
  campsite?: InputMaybe<Campsite_Bool_Exp>;
  campsite_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  order_index?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "campsite_likes" */
export enum Campsite_Likes_Constraint {
  /** unique or primary key constraint on columns "campsite_id", "user_id", "type" */
  CampsiteLikesCampsiteIdUserIdKey = 'campsite_likes_campsite_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  CampsiteLikesPkey = 'campsite_likes_pkey'
}

/** input type for incrementing numeric columns in table "campsite_likes" */
export type Campsite_Likes_Inc_Input = {
  order_index?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "campsite_likes" */
export type Campsite_Likes_Insert_Input = {
  campsite_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  order_index?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Campsite_Likes_Max_Fields = {
  __typename?: 'campsite_likes_max_fields';
  campsite_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  order_index?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "campsite_likes" */
export type Campsite_Likes_Max_Order_By = {
  campsite_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Campsite_Likes_Min_Fields = {
  __typename?: 'campsite_likes_min_fields';
  campsite_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  order_index?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "campsite_likes" */
export type Campsite_Likes_Min_Order_By = {
  campsite_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "campsite_likes" */
export type Campsite_Likes_Mutation_Response = {
  __typename?: 'campsite_likes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Campsite_Likes>;
};

/** on_conflict condition type for table "campsite_likes" */
export type Campsite_Likes_On_Conflict = {
  constraint: Campsite_Likes_Constraint;
  update_columns?: Array<Campsite_Likes_Update_Column>;
  where?: InputMaybe<Campsite_Likes_Bool_Exp>;
};

/** Ordering options when selecting data from "campsite_likes". */
export type Campsite_Likes_Order_By = {
  campsite?: InputMaybe<Campsite_Order_By>;
  campsite_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  order_index?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: campsite_likes */
export type Campsite_Likes_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "campsite_likes" */
export enum Campsite_Likes_Select_Column {
  /** column name */
  CampsiteId = 'campsite_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  OrderIndex = 'order_index',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "campsite_likes" */
export type Campsite_Likes_Set_Input = {
  order_index?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Campsite_Likes_Stddev_Fields = {
  __typename?: 'campsite_likes_stddev_fields';
  order_index?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "campsite_likes" */
export type Campsite_Likes_Stddev_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Campsite_Likes_Stddev_Pop_Fields = {
  __typename?: 'campsite_likes_stddev_pop_fields';
  order_index?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "campsite_likes" */
export type Campsite_Likes_Stddev_Pop_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Campsite_Likes_Stddev_Samp_Fields = {
  __typename?: 'campsite_likes_stddev_samp_fields';
  order_index?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "campsite_likes" */
export type Campsite_Likes_Stddev_Samp_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "campsite_likes" */
export type Campsite_Likes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Campsite_Likes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Campsite_Likes_Stream_Cursor_Value_Input = {
  campsite_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  order_index?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Campsite_Likes_Sum_Fields = {
  __typename?: 'campsite_likes_sum_fields';
  order_index?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "campsite_likes" */
export type Campsite_Likes_Sum_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** update columns of table "campsite_likes" */
export enum Campsite_Likes_Update_Column {
  /** column name */
  OrderIndex = 'order_index'
}

export type Campsite_Likes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Campsite_Likes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Campsite_Likes_Set_Input>;
  /** filter the rows which have to be updated */
  where: Campsite_Likes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Campsite_Likes_Var_Pop_Fields = {
  __typename?: 'campsite_likes_var_pop_fields';
  order_index?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "campsite_likes" */
export type Campsite_Likes_Var_Pop_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Campsite_Likes_Var_Samp_Fields = {
  __typename?: 'campsite_likes_var_samp_fields';
  order_index?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "campsite_likes" */
export type Campsite_Likes_Var_Samp_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Campsite_Likes_Variance_Fields = {
  __typename?: 'campsite_likes_variance_fields';
  order_index?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "campsite_likes" */
export type Campsite_Likes_Variance_Order_By = {
  order_index?: InputMaybe<Order_By>;
};

/** aggregate max on columns */
export type Campsite_Max_Fields = {
  __typename?: 'campsite_max_fields';
  access_count?: Maybe<Scalars['Int']>;
  address?: Maybe<Scalars['String']>;
  checkin_end_hour?: Maybe<Scalars['String']>;
  checkin_end_minute?: Maybe<Scalars['String']>;
  checkin_start_hour?: Maybe<Scalars['String']>;
  checkin_start_minute?: Maybe<Scalars['String']>;
  checkout_end_hour?: Maybe<Scalars['String']>;
  checkout_end_minute?: Maybe<Scalars['String']>;
  checkout_start_hour?: Maybe<Scalars['String']>;
  checkout_start_minute?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  introduction_content?: Maybe<Scalars['String']>;
  introduction_title?: Maybe<Scalars['String']>;
  main_image_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  official_url?: Maybe<Scalars['String']>;
  prefectures?: Maybe<Scalars['String']>;
  prefectures_code?: Maybe<Scalars['String']>;
  region_code?: Maybe<Scalars['String']>;
  tel_bottom?: Maybe<Scalars['String']>;
  tel_head?: Maybe<Scalars['String']>;
  tel_while?: Maybe<Scalars['String']>;
  total_like_num?: Maybe<Scalars['Int']>;
  total_review_num?: Maybe<Scalars['Int']>;
  total_visited_num?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  visibility_status?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "campsite" */
export type Campsite_Max_Order_By = {
  access_count?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  checkin_end_hour?: InputMaybe<Order_By>;
  checkin_end_minute?: InputMaybe<Order_By>;
  checkin_start_hour?: InputMaybe<Order_By>;
  checkin_start_minute?: InputMaybe<Order_By>;
  checkout_end_hour?: InputMaybe<Order_By>;
  checkout_end_minute?: InputMaybe<Order_By>;
  checkout_start_hour?: InputMaybe<Order_By>;
  checkout_start_minute?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  introduction_content?: InputMaybe<Order_By>;
  introduction_title?: InputMaybe<Order_By>;
  main_image_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  official_url?: InputMaybe<Order_By>;
  prefectures?: InputMaybe<Order_By>;
  prefectures_code?: InputMaybe<Order_By>;
  region_code?: InputMaybe<Order_By>;
  tel_bottom?: InputMaybe<Order_By>;
  tel_head?: InputMaybe<Order_By>;
  tel_while?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  visibility_status?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Campsite_Min_Fields = {
  __typename?: 'campsite_min_fields';
  access_count?: Maybe<Scalars['Int']>;
  address?: Maybe<Scalars['String']>;
  checkin_end_hour?: Maybe<Scalars['String']>;
  checkin_end_minute?: Maybe<Scalars['String']>;
  checkin_start_hour?: Maybe<Scalars['String']>;
  checkin_start_minute?: Maybe<Scalars['String']>;
  checkout_end_hour?: Maybe<Scalars['String']>;
  checkout_end_minute?: Maybe<Scalars['String']>;
  checkout_start_hour?: Maybe<Scalars['String']>;
  checkout_start_minute?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  introduction_content?: Maybe<Scalars['String']>;
  introduction_title?: Maybe<Scalars['String']>;
  main_image_id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  official_url?: Maybe<Scalars['String']>;
  prefectures?: Maybe<Scalars['String']>;
  prefectures_code?: Maybe<Scalars['String']>;
  region_code?: Maybe<Scalars['String']>;
  tel_bottom?: Maybe<Scalars['String']>;
  tel_head?: Maybe<Scalars['String']>;
  tel_while?: Maybe<Scalars['String']>;
  total_like_num?: Maybe<Scalars['Int']>;
  total_review_num?: Maybe<Scalars['Int']>;
  total_visited_num?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  visibility_status?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "campsite" */
export type Campsite_Min_Order_By = {
  access_count?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  checkin_end_hour?: InputMaybe<Order_By>;
  checkin_end_minute?: InputMaybe<Order_By>;
  checkin_start_hour?: InputMaybe<Order_By>;
  checkin_start_minute?: InputMaybe<Order_By>;
  checkout_end_hour?: InputMaybe<Order_By>;
  checkout_end_minute?: InputMaybe<Order_By>;
  checkout_start_hour?: InputMaybe<Order_By>;
  checkout_start_minute?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  introduction_content?: InputMaybe<Order_By>;
  introduction_title?: InputMaybe<Order_By>;
  main_image_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  official_url?: InputMaybe<Order_By>;
  prefectures?: InputMaybe<Order_By>;
  prefectures_code?: InputMaybe<Order_By>;
  region_code?: InputMaybe<Order_By>;
  tel_bottom?: InputMaybe<Order_By>;
  tel_head?: InputMaybe<Order_By>;
  tel_while?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  visibility_status?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "campsite" */
export type Campsite_Mutation_Response = {
  __typename?: 'campsite_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Campsite>;
};

/** Ordering options when selecting data from "campsite". */
export type Campsite_Order_By = {
  access_count?: InputMaybe<Order_By>;
  activity_athletic?: InputMaybe<Order_By>;
  activity_bbq?: InputMaybe<Order_By>;
  activity_bicycle?: InputMaybe<Order_By>;
  activity_canoe?: InputMaybe<Order_By>;
  activity_craft?: InputMaybe<Order_By>;
  activity_fishing?: InputMaybe<Order_By>;
  activity_flower?: InputMaybe<Order_By>;
  activity_hiking?: InputMaybe<Order_By>;
  activity_insect?: InputMaybe<Order_By>;
  activity_playset?: InputMaybe<Order_By>;
  activity_pool?: InputMaybe<Order_By>;
  activity_ranch?: InputMaybe<Order_By>;
  activity_river?: InputMaybe<Order_By>;
  activity_sauna?: InputMaybe<Order_By>;
  activity_sea?: InputMaybe<Order_By>;
  activity_star?: InputMaybe<Order_By>;
  activity_taste?: InputMaybe<Order_By>;
  activity_tentsauna?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  bath_hotspring?: InputMaybe<Order_By>;
  bath_room?: InputMaybe<Order_By>;
  business_newyear?: InputMaybe<Order_By>;
  business_period?: InputMaybe<Order_By>;
  campsite_likes_aggregate?: InputMaybe<Campsite_Likes_Aggregate_Order_By>;
  checkin_end_hour?: InputMaybe<Order_By>;
  checkin_end_minute?: InputMaybe<Order_By>;
  checkin_start_hour?: InputMaybe<Order_By>;
  checkin_start_minute?: InputMaybe<Order_By>;
  checkout_end_hour?: InputMaybe<Order_By>;
  checkout_end_minute?: InputMaybe<Order_By>;
  checkout_start_hour?: InputMaybe<Order_By>;
  checkout_start_minute?: InputMaybe<Order_By>;
  closed_friday?: InputMaybe<Order_By>;
  closed_holiday?: InputMaybe<Order_By>;
  closed_irregular?: InputMaybe<Order_By>;
  closed_monday?: InputMaybe<Order_By>;
  closed_not?: InputMaybe<Order_By>;
  closed_saturday?: InputMaybe<Order_By>;
  closed_sunday?: InputMaybe<Order_By>;
  closed_thursday?: InputMaybe<Order_By>;
  closed_tuesday?: InputMaybe<Order_By>;
  closed_wednesday?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  facilities_barrierfree?: InputMaybe<Order_By>;
  facilities_dogrun?: InputMaybe<Order_By>;
  facilities_laundry?: InputMaybe<Order_By>;
  facilities_restaurant?: InputMaybe<Order_By>;
  facilities_store?: InputMaybe<Order_By>;
  facilities_workspace?: InputMaybe<Order_By>;
  facility_acsite?: InputMaybe<Order_By>;
  facility_bungalow?: InputMaybe<Order_By>;
  facility_cottage?: InputMaybe<Order_By>;
  facility_freesite?: InputMaybe<Order_By>;
  facility_glamping?: InputMaybe<Order_By>;
  facility_privatesite?: InputMaybe<Order_By>;
  facility_sectionsite?: InputMaybe<Order_By>;
  facility_solo?: InputMaybe<Order_By>;
  facility_tipi?: InputMaybe<Order_By>;
  facility_trailerhouse?: InputMaybe<Order_By>;
  facility_treehouse?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Image_Order_By>;
  introduction_content?: InputMaybe<Order_By>;
  introduction_title?: InputMaybe<Order_By>;
  is_affiliated?: InputMaybe<Order_By>;
  location_forest?: InputMaybe<Order_By>;
  location_hill?: InputMaybe<Order_By>;
  location_lake?: InputMaybe<Order_By>;
  location_meadow?: InputMaybe<Order_By>;
  location_ocean?: InputMaybe<Order_By>;
  location_park?: InputMaybe<Order_By>;
  location_plateau?: InputMaybe<Order_By>;
  location_river?: InputMaybe<Order_By>;
  main_image_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  official_url?: InputMaybe<Order_By>;
  prefectures?: InputMaybe<Order_By>;
  prefectures_code?: InputMaybe<Order_By>;
  region_code?: InputMaybe<Order_By>;
  reviews_aggregate?: InputMaybe<Review_Aggregate_Order_By>;
  service_firewood?: InputMaybe<Order_By>;
  service_firework?: InputMaybe<Order_By>;
  service_freecharge?: InputMaybe<Order_By>;
  service_garbage?: InputMaybe<Order_By>;
  service_group?: InputMaybe<Order_By>;
  service_hotwater?: InputMaybe<Order_By>;
  service_openfire?: InputMaybe<Order_By>;
  service_pet?: InputMaybe<Order_By>;
  service_rental?: InputMaybe<Order_By>;
  service_washlet?: InputMaybe<Order_By>;
  service_wifi?: InputMaybe<Order_By>;
  tel_bottom?: InputMaybe<Order_By>;
  tel_head?: InputMaybe<Order_By>;
  tel_while?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  vehicles_autocamp?: InputMaybe<Order_By>;
  vehicles_campingcar?: InputMaybe<Order_By>;
  visibility_status?: InputMaybe<Order_By>;
  visiteds_aggregate?: InputMaybe<Visited_Aggregate_Order_By>;
};

/** primary key columns input for table: campsite */
export type Campsite_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** Boolean expression to filter rows from the table "campsite_search_log". All fields are combined with a logical 'AND'. */
export type Campsite_Search_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Campsite_Search_Log_Bool_Exp>>;
  _not?: InputMaybe<Campsite_Search_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Campsite_Search_Log_Bool_Exp>>;
};

/** unique or primary key constraints on table "campsite_search_log" */
export enum Campsite_Search_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  CampsiteSearchLogPkey = 'campsite_search_log_pkey'
}

/** input type for inserting data into table "campsite_search_log" */
export type Campsite_Search_Log_Insert_Input = {
  filter?: InputMaybe<Scalars['json']>;
  order_by?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "campsite_search_log" */
export type Campsite_Search_Log_Mutation_Response = {
  __typename?: 'campsite_search_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
};

/** on_conflict condition type for table "campsite_search_log" */
export type Campsite_Search_Log_On_Conflict = {
  constraint: Campsite_Search_Log_Constraint;
  update_columns?: Array<Campsite_Search_Log_Update_Column>;
  where?: InputMaybe<Campsite_Search_Log_Bool_Exp>;
};

/** placeholder for update columns of table "campsite_search_log" (current role has no relevant permissions) */
export enum Campsite_Search_Log_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** select columns of table "campsite" */
export enum Campsite_Select_Column {
  /** column name */
  AccessCount = 'access_count',
  /** column name */
  ActivityAthletic = 'activity_athletic',
  /** column name */
  ActivityBbq = 'activity_bbq',
  /** column name */
  ActivityBicycle = 'activity_bicycle',
  /** column name */
  ActivityCanoe = 'activity_canoe',
  /** column name */
  ActivityCraft = 'activity_craft',
  /** column name */
  ActivityFishing = 'activity_fishing',
  /** column name */
  ActivityFlower = 'activity_flower',
  /** column name */
  ActivityHiking = 'activity_hiking',
  /** column name */
  ActivityInsect = 'activity_insect',
  /** column name */
  ActivityPlayset = 'activity_playset',
  /** column name */
  ActivityPool = 'activity_pool',
  /** column name */
  ActivityRanch = 'activity_ranch',
  /** column name */
  ActivityRiver = 'activity_river',
  /** column name */
  ActivitySauna = 'activity_sauna',
  /** column name */
  ActivitySea = 'activity_sea',
  /** column name */
  ActivityStar = 'activity_star',
  /** column name */
  ActivityTaste = 'activity_taste',
  /** column name */
  ActivityTentsauna = 'activity_tentsauna',
  /** column name */
  Address = 'address',
  /** column name */
  BathHotspring = 'bath_hotspring',
  /** column name */
  BathRoom = 'bath_room',
  /** column name */
  BusinessNewyear = 'business_newyear',
  /** column name */
  BusinessPeriod = 'business_period',
  /** column name */
  CheckinEndHour = 'checkin_end_hour',
  /** column name */
  CheckinEndMinute = 'checkin_end_minute',
  /** column name */
  CheckinStartHour = 'checkin_start_hour',
  /** column name */
  CheckinStartMinute = 'checkin_start_minute',
  /** column name */
  CheckoutEndHour = 'checkout_end_hour',
  /** column name */
  CheckoutEndMinute = 'checkout_end_minute',
  /** column name */
  CheckoutStartHour = 'checkout_start_hour',
  /** column name */
  CheckoutStartMinute = 'checkout_start_minute',
  /** column name */
  ClosedFriday = 'closed_friday',
  /** column name */
  ClosedHoliday = 'closed_holiday',
  /** column name */
  ClosedIrregular = 'closed_irregular',
  /** column name */
  ClosedMonday = 'closed_monday',
  /** column name */
  ClosedNot = 'closed_not',
  /** column name */
  ClosedSaturday = 'closed_saturday',
  /** column name */
  ClosedSunday = 'closed_sunday',
  /** column name */
  ClosedThursday = 'closed_thursday',
  /** column name */
  ClosedTuesday = 'closed_tuesday',
  /** column name */
  ClosedWednesday = 'closed_wednesday',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FacilitiesBarrierfree = 'facilities_barrierfree',
  /** column name */
  FacilitiesDogrun = 'facilities_dogrun',
  /** column name */
  FacilitiesLaundry = 'facilities_laundry',
  /** column name */
  FacilitiesRestaurant = 'facilities_restaurant',
  /** column name */
  FacilitiesStore = 'facilities_store',
  /** column name */
  FacilitiesWorkspace = 'facilities_workspace',
  /** column name */
  FacilityAcsite = 'facility_acsite',
  /** column name */
  FacilityBungalow = 'facility_bungalow',
  /** column name */
  FacilityCottage = 'facility_cottage',
  /** column name */
  FacilityFreesite = 'facility_freesite',
  /** column name */
  FacilityGlamping = 'facility_glamping',
  /** column name */
  FacilityPrivatesite = 'facility_privatesite',
  /** column name */
  FacilitySectionsite = 'facility_sectionsite',
  /** column name */
  FacilitySolo = 'facility_solo',
  /** column name */
  FacilityTipi = 'facility_tipi',
  /** column name */
  FacilityTrailerhouse = 'facility_trailerhouse',
  /** column name */
  FacilityTreehouse = 'facility_treehouse',
  /** column name */
  Id = 'id',
  /** column name */
  IntroductionContent = 'introduction_content',
  /** column name */
  IntroductionTitle = 'introduction_title',
  /** column name */
  IsAffiliated = 'is_affiliated',
  /** column name */
  LocationForest = 'location_forest',
  /** column name */
  LocationHill = 'location_hill',
  /** column name */
  LocationLake = 'location_lake',
  /** column name */
  LocationMeadow = 'location_meadow',
  /** column name */
  LocationOcean = 'location_ocean',
  /** column name */
  LocationPark = 'location_park',
  /** column name */
  LocationPlateau = 'location_plateau',
  /** column name */
  LocationRiver = 'location_river',
  /** column name */
  MainImageId = 'main_image_id',
  /** column name */
  Name = 'name',
  /** column name */
  OfficialUrl = 'official_url',
  /** column name */
  Prefectures = 'prefectures',
  /** column name */
  PrefecturesCode = 'prefectures_code',
  /** column name */
  RegionCode = 'region_code',
  /** column name */
  ServiceFirewood = 'service_firewood',
  /** column name */
  ServiceFirework = 'service_firework',
  /** column name */
  ServiceFreecharge = 'service_freecharge',
  /** column name */
  ServiceGarbage = 'service_garbage',
  /** column name */
  ServiceGroup = 'service_group',
  /** column name */
  ServiceHotwater = 'service_hotwater',
  /** column name */
  ServiceOpenfire = 'service_openfire',
  /** column name */
  ServicePet = 'service_pet',
  /** column name */
  ServiceRental = 'service_rental',
  /** column name */
  ServiceWashlet = 'service_washlet',
  /** column name */
  ServiceWifi = 'service_wifi',
  /** column name */
  TelBottom = 'tel_bottom',
  /** column name */
  TelHead = 'tel_head',
  /** column name */
  TelWhile = 'tel_while',
  /** column name */
  TotalLikeNum = 'total_like_num',
  /** column name */
  TotalReviewNum = 'total_review_num',
  /** column name */
  TotalVisitedNum = 'total_visited_num',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VehiclesAutocamp = 'vehicles_autocamp',
  /** column name */
  VehiclesCampingcar = 'vehicles_campingcar',
  /** column name */
  VisibilityStatus = 'visibility_status'
}

/** select "campsite_aggregate_bool_exp_bool_and_arguments_columns" columns of table "campsite" */
export enum Campsite_Select_Column_Campsite_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  ActivityAthletic = 'activity_athletic',
  /** column name */
  ActivityBbq = 'activity_bbq',
  /** column name */
  ActivityBicycle = 'activity_bicycle',
  /** column name */
  ActivityCanoe = 'activity_canoe',
  /** column name */
  ActivityCraft = 'activity_craft',
  /** column name */
  ActivityFishing = 'activity_fishing',
  /** column name */
  ActivityFlower = 'activity_flower',
  /** column name */
  ActivityHiking = 'activity_hiking',
  /** column name */
  ActivityInsect = 'activity_insect',
  /** column name */
  ActivityPlayset = 'activity_playset',
  /** column name */
  ActivityPool = 'activity_pool',
  /** column name */
  ActivityRanch = 'activity_ranch',
  /** column name */
  ActivityRiver = 'activity_river',
  /** column name */
  ActivitySauna = 'activity_sauna',
  /** column name */
  ActivitySea = 'activity_sea',
  /** column name */
  ActivityStar = 'activity_star',
  /** column name */
  ActivityTaste = 'activity_taste',
  /** column name */
  ActivityTentsauna = 'activity_tentsauna',
  /** column name */
  BathHotspring = 'bath_hotspring',
  /** column name */
  BathRoom = 'bath_room',
  /** column name */
  BusinessNewyear = 'business_newyear',
  /** column name */
  BusinessPeriod = 'business_period',
  /** column name */
  ClosedFriday = 'closed_friday',
  /** column name */
  ClosedHoliday = 'closed_holiday',
  /** column name */
  ClosedIrregular = 'closed_irregular',
  /** column name */
  ClosedMonday = 'closed_monday',
  /** column name */
  ClosedNot = 'closed_not',
  /** column name */
  ClosedSaturday = 'closed_saturday',
  /** column name */
  ClosedSunday = 'closed_sunday',
  /** column name */
  ClosedThursday = 'closed_thursday',
  /** column name */
  ClosedTuesday = 'closed_tuesday',
  /** column name */
  ClosedWednesday = 'closed_wednesday',
  /** column name */
  FacilitiesBarrierfree = 'facilities_barrierfree',
  /** column name */
  FacilitiesDogrun = 'facilities_dogrun',
  /** column name */
  FacilitiesLaundry = 'facilities_laundry',
  /** column name */
  FacilitiesRestaurant = 'facilities_restaurant',
  /** column name */
  FacilitiesStore = 'facilities_store',
  /** column name */
  FacilitiesWorkspace = 'facilities_workspace',
  /** column name */
  FacilityAcsite = 'facility_acsite',
  /** column name */
  FacilityBungalow = 'facility_bungalow',
  /** column name */
  FacilityCottage = 'facility_cottage',
  /** column name */
  FacilityFreesite = 'facility_freesite',
  /** column name */
  FacilityGlamping = 'facility_glamping',
  /** column name */
  FacilityPrivatesite = 'facility_privatesite',
  /** column name */
  FacilitySectionsite = 'facility_sectionsite',
  /** column name */
  FacilitySolo = 'facility_solo',
  /** column name */
  FacilityTipi = 'facility_tipi',
  /** column name */
  FacilityTrailerhouse = 'facility_trailerhouse',
  /** column name */
  FacilityTreehouse = 'facility_treehouse',
  /** column name */
  IsAffiliated = 'is_affiliated',
  /** column name */
  LocationForest = 'location_forest',
  /** column name */
  LocationHill = 'location_hill',
  /** column name */
  LocationLake = 'location_lake',
  /** column name */
  LocationMeadow = 'location_meadow',
  /** column name */
  LocationOcean = 'location_ocean',
  /** column name */
  LocationPark = 'location_park',
  /** column name */
  LocationPlateau = 'location_plateau',
  /** column name */
  LocationRiver = 'location_river',
  /** column name */
  ServiceFirewood = 'service_firewood',
  /** column name */
  ServiceFirework = 'service_firework',
  /** column name */
  ServiceFreecharge = 'service_freecharge',
  /** column name */
  ServiceGarbage = 'service_garbage',
  /** column name */
  ServiceGroup = 'service_group',
  /** column name */
  ServiceHotwater = 'service_hotwater',
  /** column name */
  ServiceOpenfire = 'service_openfire',
  /** column name */
  ServicePet = 'service_pet',
  /** column name */
  ServiceRental = 'service_rental',
  /** column name */
  ServiceWashlet = 'service_washlet',
  /** column name */
  ServiceWifi = 'service_wifi',
  /** column name */
  VehiclesAutocamp = 'vehicles_autocamp',
  /** column name */
  VehiclesCampingcar = 'vehicles_campingcar'
}

/** select "campsite_aggregate_bool_exp_bool_or_arguments_columns" columns of table "campsite" */
export enum Campsite_Select_Column_Campsite_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  ActivityAthletic = 'activity_athletic',
  /** column name */
  ActivityBbq = 'activity_bbq',
  /** column name */
  ActivityBicycle = 'activity_bicycle',
  /** column name */
  ActivityCanoe = 'activity_canoe',
  /** column name */
  ActivityCraft = 'activity_craft',
  /** column name */
  ActivityFishing = 'activity_fishing',
  /** column name */
  ActivityFlower = 'activity_flower',
  /** column name */
  ActivityHiking = 'activity_hiking',
  /** column name */
  ActivityInsect = 'activity_insect',
  /** column name */
  ActivityPlayset = 'activity_playset',
  /** column name */
  ActivityPool = 'activity_pool',
  /** column name */
  ActivityRanch = 'activity_ranch',
  /** column name */
  ActivityRiver = 'activity_river',
  /** column name */
  ActivitySauna = 'activity_sauna',
  /** column name */
  ActivitySea = 'activity_sea',
  /** column name */
  ActivityStar = 'activity_star',
  /** column name */
  ActivityTaste = 'activity_taste',
  /** column name */
  ActivityTentsauna = 'activity_tentsauna',
  /** column name */
  BathHotspring = 'bath_hotspring',
  /** column name */
  BathRoom = 'bath_room',
  /** column name */
  BusinessNewyear = 'business_newyear',
  /** column name */
  BusinessPeriod = 'business_period',
  /** column name */
  ClosedFriday = 'closed_friday',
  /** column name */
  ClosedHoliday = 'closed_holiday',
  /** column name */
  ClosedIrregular = 'closed_irregular',
  /** column name */
  ClosedMonday = 'closed_monday',
  /** column name */
  ClosedNot = 'closed_not',
  /** column name */
  ClosedSaturday = 'closed_saturday',
  /** column name */
  ClosedSunday = 'closed_sunday',
  /** column name */
  ClosedThursday = 'closed_thursday',
  /** column name */
  ClosedTuesday = 'closed_tuesday',
  /** column name */
  ClosedWednesday = 'closed_wednesday',
  /** column name */
  FacilitiesBarrierfree = 'facilities_barrierfree',
  /** column name */
  FacilitiesDogrun = 'facilities_dogrun',
  /** column name */
  FacilitiesLaundry = 'facilities_laundry',
  /** column name */
  FacilitiesRestaurant = 'facilities_restaurant',
  /** column name */
  FacilitiesStore = 'facilities_store',
  /** column name */
  FacilitiesWorkspace = 'facilities_workspace',
  /** column name */
  FacilityAcsite = 'facility_acsite',
  /** column name */
  FacilityBungalow = 'facility_bungalow',
  /** column name */
  FacilityCottage = 'facility_cottage',
  /** column name */
  FacilityFreesite = 'facility_freesite',
  /** column name */
  FacilityGlamping = 'facility_glamping',
  /** column name */
  FacilityPrivatesite = 'facility_privatesite',
  /** column name */
  FacilitySectionsite = 'facility_sectionsite',
  /** column name */
  FacilitySolo = 'facility_solo',
  /** column name */
  FacilityTipi = 'facility_tipi',
  /** column name */
  FacilityTrailerhouse = 'facility_trailerhouse',
  /** column name */
  FacilityTreehouse = 'facility_treehouse',
  /** column name */
  IsAffiliated = 'is_affiliated',
  /** column name */
  LocationForest = 'location_forest',
  /** column name */
  LocationHill = 'location_hill',
  /** column name */
  LocationLake = 'location_lake',
  /** column name */
  LocationMeadow = 'location_meadow',
  /** column name */
  LocationOcean = 'location_ocean',
  /** column name */
  LocationPark = 'location_park',
  /** column name */
  LocationPlateau = 'location_plateau',
  /** column name */
  LocationRiver = 'location_river',
  /** column name */
  ServiceFirewood = 'service_firewood',
  /** column name */
  ServiceFirework = 'service_firework',
  /** column name */
  ServiceFreecharge = 'service_freecharge',
  /** column name */
  ServiceGarbage = 'service_garbage',
  /** column name */
  ServiceGroup = 'service_group',
  /** column name */
  ServiceHotwater = 'service_hotwater',
  /** column name */
  ServiceOpenfire = 'service_openfire',
  /** column name */
  ServicePet = 'service_pet',
  /** column name */
  ServiceRental = 'service_rental',
  /** column name */
  ServiceWashlet = 'service_washlet',
  /** column name */
  ServiceWifi = 'service_wifi',
  /** column name */
  VehiclesAutocamp = 'vehicles_autocamp',
  /** column name */
  VehiclesCampingcar = 'vehicles_campingcar'
}

/** input type for updating data in table "campsite" */
export type Campsite_Set_Input = {
  activity_athletic?: InputMaybe<Scalars['Boolean']>;
  activity_bbq?: InputMaybe<Scalars['Boolean']>;
  activity_bicycle?: InputMaybe<Scalars['Boolean']>;
  activity_canoe?: InputMaybe<Scalars['Boolean']>;
  activity_craft?: InputMaybe<Scalars['Boolean']>;
  activity_fishing?: InputMaybe<Scalars['Boolean']>;
  activity_flower?: InputMaybe<Scalars['Boolean']>;
  activity_hiking?: InputMaybe<Scalars['Boolean']>;
  activity_insect?: InputMaybe<Scalars['Boolean']>;
  activity_playset?: InputMaybe<Scalars['Boolean']>;
  activity_pool?: InputMaybe<Scalars['Boolean']>;
  activity_ranch?: InputMaybe<Scalars['Boolean']>;
  activity_river?: InputMaybe<Scalars['Boolean']>;
  activity_sauna?: InputMaybe<Scalars['Boolean']>;
  activity_sea?: InputMaybe<Scalars['Boolean']>;
  activity_star?: InputMaybe<Scalars['Boolean']>;
  activity_taste?: InputMaybe<Scalars['Boolean']>;
  activity_tentsauna?: InputMaybe<Scalars['Boolean']>;
  bath_hotspring?: InputMaybe<Scalars['Boolean']>;
  bath_room?: InputMaybe<Scalars['Boolean']>;
  business_newyear?: InputMaybe<Scalars['Boolean']>;
  business_period?: InputMaybe<Scalars['Boolean']>;
  checkin_end_hour?: InputMaybe<Scalars['String']>;
  checkin_end_minute?: InputMaybe<Scalars['String']>;
  checkin_start_hour?: InputMaybe<Scalars['String']>;
  checkin_start_minute?: InputMaybe<Scalars['String']>;
  checkout_end_hour?: InputMaybe<Scalars['String']>;
  checkout_end_minute?: InputMaybe<Scalars['String']>;
  checkout_start_hour?: InputMaybe<Scalars['String']>;
  checkout_start_minute?: InputMaybe<Scalars['String']>;
  closed_friday?: InputMaybe<Scalars['Boolean']>;
  closed_holiday?: InputMaybe<Scalars['Boolean']>;
  closed_irregular?: InputMaybe<Scalars['Boolean']>;
  closed_monday?: InputMaybe<Scalars['Boolean']>;
  closed_not?: InputMaybe<Scalars['Boolean']>;
  closed_saturday?: InputMaybe<Scalars['Boolean']>;
  closed_sunday?: InputMaybe<Scalars['Boolean']>;
  closed_thursday?: InputMaybe<Scalars['Boolean']>;
  closed_tuesday?: InputMaybe<Scalars['Boolean']>;
  closed_wednesday?: InputMaybe<Scalars['Boolean']>;
  facilities_barrierfree?: InputMaybe<Scalars['Boolean']>;
  facilities_dogrun?: InputMaybe<Scalars['Boolean']>;
  facilities_laundry?: InputMaybe<Scalars['Boolean']>;
  facilities_restaurant?: InputMaybe<Scalars['Boolean']>;
  facilities_store?: InputMaybe<Scalars['Boolean']>;
  facilities_workspace?: InputMaybe<Scalars['Boolean']>;
  facility_acsite?: InputMaybe<Scalars['Boolean']>;
  facility_bungalow?: InputMaybe<Scalars['Boolean']>;
  facility_cottage?: InputMaybe<Scalars['Boolean']>;
  facility_freesite?: InputMaybe<Scalars['Boolean']>;
  facility_glamping?: InputMaybe<Scalars['Boolean']>;
  facility_privatesite?: InputMaybe<Scalars['Boolean']>;
  facility_sectionsite?: InputMaybe<Scalars['Boolean']>;
  facility_solo?: InputMaybe<Scalars['Boolean']>;
  facility_tipi?: InputMaybe<Scalars['Boolean']>;
  facility_trailerhouse?: InputMaybe<Scalars['Boolean']>;
  facility_treehouse?: InputMaybe<Scalars['Boolean']>;
  introduction_content?: InputMaybe<Scalars['String']>;
  introduction_title?: InputMaybe<Scalars['String']>;
  is_affiliated?: InputMaybe<Scalars['Boolean']>;
  location_forest?: InputMaybe<Scalars['Boolean']>;
  location_hill?: InputMaybe<Scalars['Boolean']>;
  location_lake?: InputMaybe<Scalars['Boolean']>;
  location_meadow?: InputMaybe<Scalars['Boolean']>;
  location_ocean?: InputMaybe<Scalars['Boolean']>;
  location_park?: InputMaybe<Scalars['Boolean']>;
  location_plateau?: InputMaybe<Scalars['Boolean']>;
  location_river?: InputMaybe<Scalars['Boolean']>;
  main_image_id?: InputMaybe<Scalars['String']>;
  official_url?: InputMaybe<Scalars['String']>;
  prefectures?: InputMaybe<Scalars['String']>;
  prefectures_code?: InputMaybe<Scalars['String']>;
  region_code?: InputMaybe<Scalars['String']>;
  service_firewood?: InputMaybe<Scalars['Boolean']>;
  service_firework?: InputMaybe<Scalars['Boolean']>;
  service_freecharge?: InputMaybe<Scalars['Boolean']>;
  service_garbage?: InputMaybe<Scalars['Boolean']>;
  service_group?: InputMaybe<Scalars['Boolean']>;
  service_hotwater?: InputMaybe<Scalars['Boolean']>;
  service_openfire?: InputMaybe<Scalars['Boolean']>;
  service_pet?: InputMaybe<Scalars['Boolean']>;
  service_rental?: InputMaybe<Scalars['Boolean']>;
  service_washlet?: InputMaybe<Scalars['Boolean']>;
  service_wifi?: InputMaybe<Scalars['Boolean']>;
  tel_bottom?: InputMaybe<Scalars['String']>;
  tel_head?: InputMaybe<Scalars['String']>;
  tel_while?: InputMaybe<Scalars['String']>;
  vehicles_autocamp?: InputMaybe<Scalars['Boolean']>;
  vehicles_campingcar?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Campsite_Stddev_Fields = {
  __typename?: 'campsite_stddev_fields';
  access_count?: Maybe<Scalars['Float']>;
  total_like_num?: Maybe<Scalars['Float']>;
  total_review_num?: Maybe<Scalars['Float']>;
  total_visited_num?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "campsite" */
export type Campsite_Stddev_Order_By = {
  access_count?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Campsite_Stddev_Pop_Fields = {
  __typename?: 'campsite_stddev_pop_fields';
  access_count?: Maybe<Scalars['Float']>;
  total_like_num?: Maybe<Scalars['Float']>;
  total_review_num?: Maybe<Scalars['Float']>;
  total_visited_num?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "campsite" */
export type Campsite_Stddev_Pop_Order_By = {
  access_count?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Campsite_Stddev_Samp_Fields = {
  __typename?: 'campsite_stddev_samp_fields';
  access_count?: Maybe<Scalars['Float']>;
  total_like_num?: Maybe<Scalars['Float']>;
  total_review_num?: Maybe<Scalars['Float']>;
  total_visited_num?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "campsite" */
export type Campsite_Stddev_Samp_Order_By = {
  access_count?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "campsite" */
export type Campsite_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Campsite_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Campsite_Stream_Cursor_Value_Input = {
  access_count?: InputMaybe<Scalars['Int']>;
  activity_athletic?: InputMaybe<Scalars['Boolean']>;
  activity_bbq?: InputMaybe<Scalars['Boolean']>;
  activity_bicycle?: InputMaybe<Scalars['Boolean']>;
  activity_canoe?: InputMaybe<Scalars['Boolean']>;
  activity_craft?: InputMaybe<Scalars['Boolean']>;
  activity_fishing?: InputMaybe<Scalars['Boolean']>;
  activity_flower?: InputMaybe<Scalars['Boolean']>;
  activity_hiking?: InputMaybe<Scalars['Boolean']>;
  activity_insect?: InputMaybe<Scalars['Boolean']>;
  activity_playset?: InputMaybe<Scalars['Boolean']>;
  activity_pool?: InputMaybe<Scalars['Boolean']>;
  activity_ranch?: InputMaybe<Scalars['Boolean']>;
  activity_river?: InputMaybe<Scalars['Boolean']>;
  activity_sauna?: InputMaybe<Scalars['Boolean']>;
  activity_sea?: InputMaybe<Scalars['Boolean']>;
  activity_star?: InputMaybe<Scalars['Boolean']>;
  activity_taste?: InputMaybe<Scalars['Boolean']>;
  activity_tentsauna?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<Scalars['String']>;
  bath_hotspring?: InputMaybe<Scalars['Boolean']>;
  bath_room?: InputMaybe<Scalars['Boolean']>;
  business_newyear?: InputMaybe<Scalars['Boolean']>;
  business_period?: InputMaybe<Scalars['Boolean']>;
  checkin_end_hour?: InputMaybe<Scalars['String']>;
  checkin_end_minute?: InputMaybe<Scalars['String']>;
  checkin_start_hour?: InputMaybe<Scalars['String']>;
  checkin_start_minute?: InputMaybe<Scalars['String']>;
  checkout_end_hour?: InputMaybe<Scalars['String']>;
  checkout_end_minute?: InputMaybe<Scalars['String']>;
  checkout_start_hour?: InputMaybe<Scalars['String']>;
  checkout_start_minute?: InputMaybe<Scalars['String']>;
  closed_friday?: InputMaybe<Scalars['Boolean']>;
  closed_holiday?: InputMaybe<Scalars['Boolean']>;
  closed_irregular?: InputMaybe<Scalars['Boolean']>;
  closed_monday?: InputMaybe<Scalars['Boolean']>;
  closed_not?: InputMaybe<Scalars['Boolean']>;
  closed_saturday?: InputMaybe<Scalars['Boolean']>;
  closed_sunday?: InputMaybe<Scalars['Boolean']>;
  closed_thursday?: InputMaybe<Scalars['Boolean']>;
  closed_tuesday?: InputMaybe<Scalars['Boolean']>;
  closed_wednesday?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  facilities_barrierfree?: InputMaybe<Scalars['Boolean']>;
  facilities_dogrun?: InputMaybe<Scalars['Boolean']>;
  facilities_laundry?: InputMaybe<Scalars['Boolean']>;
  facilities_restaurant?: InputMaybe<Scalars['Boolean']>;
  facilities_store?: InputMaybe<Scalars['Boolean']>;
  facilities_workspace?: InputMaybe<Scalars['Boolean']>;
  facility_acsite?: InputMaybe<Scalars['Boolean']>;
  facility_bungalow?: InputMaybe<Scalars['Boolean']>;
  facility_cottage?: InputMaybe<Scalars['Boolean']>;
  facility_freesite?: InputMaybe<Scalars['Boolean']>;
  facility_glamping?: InputMaybe<Scalars['Boolean']>;
  facility_privatesite?: InputMaybe<Scalars['Boolean']>;
  facility_sectionsite?: InputMaybe<Scalars['Boolean']>;
  facility_solo?: InputMaybe<Scalars['Boolean']>;
  facility_tipi?: InputMaybe<Scalars['Boolean']>;
  facility_trailerhouse?: InputMaybe<Scalars['Boolean']>;
  facility_treehouse?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  introduction_content?: InputMaybe<Scalars['String']>;
  introduction_title?: InputMaybe<Scalars['String']>;
  is_affiliated?: InputMaybe<Scalars['Boolean']>;
  location_forest?: InputMaybe<Scalars['Boolean']>;
  location_hill?: InputMaybe<Scalars['Boolean']>;
  location_lake?: InputMaybe<Scalars['Boolean']>;
  location_meadow?: InputMaybe<Scalars['Boolean']>;
  location_ocean?: InputMaybe<Scalars['Boolean']>;
  location_park?: InputMaybe<Scalars['Boolean']>;
  location_plateau?: InputMaybe<Scalars['Boolean']>;
  location_river?: InputMaybe<Scalars['Boolean']>;
  main_image_id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  official_url?: InputMaybe<Scalars['String']>;
  prefectures?: InputMaybe<Scalars['String']>;
  prefectures_code?: InputMaybe<Scalars['String']>;
  region_code?: InputMaybe<Scalars['String']>;
  service_firewood?: InputMaybe<Scalars['Boolean']>;
  service_firework?: InputMaybe<Scalars['Boolean']>;
  service_freecharge?: InputMaybe<Scalars['Boolean']>;
  service_garbage?: InputMaybe<Scalars['Boolean']>;
  service_group?: InputMaybe<Scalars['Boolean']>;
  service_hotwater?: InputMaybe<Scalars['Boolean']>;
  service_openfire?: InputMaybe<Scalars['Boolean']>;
  service_pet?: InputMaybe<Scalars['Boolean']>;
  service_rental?: InputMaybe<Scalars['Boolean']>;
  service_washlet?: InputMaybe<Scalars['Boolean']>;
  service_wifi?: InputMaybe<Scalars['Boolean']>;
  tel_bottom?: InputMaybe<Scalars['String']>;
  tel_head?: InputMaybe<Scalars['String']>;
  tel_while?: InputMaybe<Scalars['String']>;
  total_like_num?: InputMaybe<Scalars['Int']>;
  total_review_num?: InputMaybe<Scalars['Int']>;
  total_visited_num?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  vehicles_autocamp?: InputMaybe<Scalars['Boolean']>;
  vehicles_campingcar?: InputMaybe<Scalars['Boolean']>;
  visibility_status?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Campsite_Sum_Fields = {
  __typename?: 'campsite_sum_fields';
  access_count?: Maybe<Scalars['Int']>;
  total_like_num?: Maybe<Scalars['Int']>;
  total_review_num?: Maybe<Scalars['Int']>;
  total_visited_num?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "campsite" */
export type Campsite_Sum_Order_By = {
  access_count?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
};

export type Campsite_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Campsite_Set_Input>;
  /** filter the rows which have to be updated */
  where: Campsite_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Campsite_Var_Pop_Fields = {
  __typename?: 'campsite_var_pop_fields';
  access_count?: Maybe<Scalars['Float']>;
  total_like_num?: Maybe<Scalars['Float']>;
  total_review_num?: Maybe<Scalars['Float']>;
  total_visited_num?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "campsite" */
export type Campsite_Var_Pop_Order_By = {
  access_count?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Campsite_Var_Samp_Fields = {
  __typename?: 'campsite_var_samp_fields';
  access_count?: Maybe<Scalars['Float']>;
  total_like_num?: Maybe<Scalars['Float']>;
  total_review_num?: Maybe<Scalars['Float']>;
  total_visited_num?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "campsite" */
export type Campsite_Var_Samp_Order_By = {
  access_count?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Campsite_Variance_Fields = {
  __typename?: 'campsite_variance_fields';
  access_count?: Maybe<Scalars['Float']>;
  total_like_num?: Maybe<Scalars['Float']>;
  total_review_num?: Maybe<Scalars['Float']>;
  total_visited_num?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "campsite" */
export type Campsite_Variance_Order_By = {
  access_count?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

export type Exchange_Fixed_Exchange_Product_Args = {
  target_campsite_id?: InputMaybe<Scalars['String']>;
  target_fixed_exchange_product_id?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "fixed_exchange_product_exchanged" */
export type Fixed_Exchange_Product_Exchanged = {
  __typename?: 'fixed_exchange_product_exchanged';
  created_at: Scalars['timestamp'];
  fixed_exchange_product_id: Scalars['String'];
  id: Scalars['String'];
  point_used_id: Scalars['String'];
  updated_at: Scalars['timestamp'];
  /** An object relationship */
  user: User;
  user_id: Scalars['String'];
};

/** aggregated selection of "fixed_exchange_product_exchanged" */
export type Fixed_Exchange_Product_Exchanged_Aggregate = {
  __typename?: 'fixed_exchange_product_exchanged_aggregate';
  aggregate?: Maybe<Fixed_Exchange_Product_Exchanged_Aggregate_Fields>;
  nodes: Array<Fixed_Exchange_Product_Exchanged>;
};

export type Fixed_Exchange_Product_Exchanged_Aggregate_Bool_Exp = {
  count?: InputMaybe<Fixed_Exchange_Product_Exchanged_Aggregate_Bool_Exp_Count>;
};

export type Fixed_Exchange_Product_Exchanged_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Fixed_Exchange_Product_Exchanged_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Fixed_Exchange_Product_Exchanged_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "fixed_exchange_product_exchanged" */
export type Fixed_Exchange_Product_Exchanged_Aggregate_Fields = {
  __typename?: 'fixed_exchange_product_exchanged_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Fixed_Exchange_Product_Exchanged_Max_Fields>;
  min?: Maybe<Fixed_Exchange_Product_Exchanged_Min_Fields>;
};


/** aggregate fields of "fixed_exchange_product_exchanged" */
export type Fixed_Exchange_Product_Exchanged_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Fixed_Exchange_Product_Exchanged_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "fixed_exchange_product_exchanged" */
export type Fixed_Exchange_Product_Exchanged_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Fixed_Exchange_Product_Exchanged_Max_Order_By>;
  min?: InputMaybe<Fixed_Exchange_Product_Exchanged_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "fixed_exchange_product_exchanged". All fields are combined with a logical 'AND'. */
export type Fixed_Exchange_Product_Exchanged_Bool_Exp = {
  _and?: InputMaybe<Array<Fixed_Exchange_Product_Exchanged_Bool_Exp>>;
  _not?: InputMaybe<Fixed_Exchange_Product_Exchanged_Bool_Exp>;
  _or?: InputMaybe<Array<Fixed_Exchange_Product_Exchanged_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  fixed_exchange_product_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  point_used_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Fixed_Exchange_Product_Exchanged_Max_Fields = {
  __typename?: 'fixed_exchange_product_exchanged_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  fixed_exchange_product_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  point_used_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "fixed_exchange_product_exchanged" */
export type Fixed_Exchange_Product_Exchanged_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fixed_exchange_product_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  point_used_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Fixed_Exchange_Product_Exchanged_Min_Fields = {
  __typename?: 'fixed_exchange_product_exchanged_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  fixed_exchange_product_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  point_used_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "fixed_exchange_product_exchanged" */
export type Fixed_Exchange_Product_Exchanged_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fixed_exchange_product_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  point_used_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "fixed_exchange_product_exchanged". */
export type Fixed_Exchange_Product_Exchanged_Order_By = {
  created_at?: InputMaybe<Order_By>;
  fixed_exchange_product_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  point_used_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "fixed_exchange_product_exchanged" */
export enum Fixed_Exchange_Product_Exchanged_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FixedExchangeProductId = 'fixed_exchange_product_id',
  /** column name */
  Id = 'id',
  /** column name */
  PointUsedId = 'point_used_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "fixed_exchange_product_exchanged" */
export type Fixed_Exchange_Product_Exchanged_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Fixed_Exchange_Product_Exchanged_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Fixed_Exchange_Product_Exchanged_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  fixed_exchange_product_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  point_used_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "gacha" */
export type Gacha = {
  __typename?: 'gacha';
  created_at: Scalars['timestamp'];
  end_at?: Maybe<Scalars['timestamp']>;
  /** An array relationship */
  gacha_loses: Array<Gacha_Lose>;
  /** An aggregate relationship */
  gacha_loses_aggregate: Gacha_Lose_Aggregate;
  gacha_physical_prize_id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  /** An array relationship */
  physical_prizes: Array<Physical_Prize>;
  /** An aggregate relationship */
  physical_prizes_aggregate: Physical_Prize_Aggregate;
  point: Scalars['Int'];
  probability: Scalars['Int'];
  start_at: Scalars['timestamp'];
  total_win_num: Scalars['Int'];
  total_win_num_limit?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamp'];
};


/** columns and relationships of "gacha" */
export type GachaGacha_LosesArgs = {
  distinct_on?: InputMaybe<Array<Gacha_Lose_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gacha_Lose_Order_By>>;
  where?: InputMaybe<Gacha_Lose_Bool_Exp>;
};


/** columns and relationships of "gacha" */
export type GachaGacha_Loses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gacha_Lose_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gacha_Lose_Order_By>>;
  where?: InputMaybe<Gacha_Lose_Bool_Exp>;
};


/** columns and relationships of "gacha" */
export type GachaPhysical_PrizesArgs = {
  distinct_on?: InputMaybe<Array<Physical_Prize_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Physical_Prize_Order_By>>;
  where?: InputMaybe<Physical_Prize_Bool_Exp>;
};


/** columns and relationships of "gacha" */
export type GachaPhysical_Prizes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Physical_Prize_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Physical_Prize_Order_By>>;
  where?: InputMaybe<Physical_Prize_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "gacha". All fields are combined with a logical 'AND'. */
export type Gacha_Bool_Exp = {
  _and?: InputMaybe<Array<Gacha_Bool_Exp>>;
  _not?: InputMaybe<Gacha_Bool_Exp>;
  _or?: InputMaybe<Array<Gacha_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  end_at?: InputMaybe<Timestamp_Comparison_Exp>;
  gacha_loses?: InputMaybe<Gacha_Lose_Bool_Exp>;
  gacha_loses_aggregate?: InputMaybe<Gacha_Lose_Aggregate_Bool_Exp>;
  gacha_physical_prize_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  physical_prizes?: InputMaybe<Physical_Prize_Bool_Exp>;
  physical_prizes_aggregate?: InputMaybe<Physical_Prize_Aggregate_Bool_Exp>;
  point?: InputMaybe<Int_Comparison_Exp>;
  probability?: InputMaybe<Int_Comparison_Exp>;
  start_at?: InputMaybe<Timestamp_Comparison_Exp>;
  total_win_num?: InputMaybe<Int_Comparison_Exp>;
  total_win_num_limit?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** columns and relationships of "gacha_lose" */
export type Gacha_Lose = {
  __typename?: 'gacha_lose';
  created_at: Scalars['timestamp'];
  /** An object relationship */
  gacha: Gacha;
  gacha_id: Scalars['String'];
  id: Scalars['String'];
  point_used_id: Scalars['String'];
  updated_at: Scalars['timestamp'];
  /** An object relationship */
  user: User;
  user_id: Scalars['String'];
};

/** aggregated selection of "gacha_lose" */
export type Gacha_Lose_Aggregate = {
  __typename?: 'gacha_lose_aggregate';
  aggregate?: Maybe<Gacha_Lose_Aggregate_Fields>;
  nodes: Array<Gacha_Lose>;
};

export type Gacha_Lose_Aggregate_Bool_Exp = {
  count?: InputMaybe<Gacha_Lose_Aggregate_Bool_Exp_Count>;
};

export type Gacha_Lose_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Gacha_Lose_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Gacha_Lose_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "gacha_lose" */
export type Gacha_Lose_Aggregate_Fields = {
  __typename?: 'gacha_lose_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Gacha_Lose_Max_Fields>;
  min?: Maybe<Gacha_Lose_Min_Fields>;
};


/** aggregate fields of "gacha_lose" */
export type Gacha_Lose_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Gacha_Lose_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "gacha_lose" */
export type Gacha_Lose_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Gacha_Lose_Max_Order_By>;
  min?: InputMaybe<Gacha_Lose_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "gacha_lose". All fields are combined with a logical 'AND'. */
export type Gacha_Lose_Bool_Exp = {
  _and?: InputMaybe<Array<Gacha_Lose_Bool_Exp>>;
  _not?: InputMaybe<Gacha_Lose_Bool_Exp>;
  _or?: InputMaybe<Array<Gacha_Lose_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  gacha?: InputMaybe<Gacha_Bool_Exp>;
  gacha_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  point_used_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Gacha_Lose_Max_Fields = {
  __typename?: 'gacha_lose_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  gacha_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  point_used_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "gacha_lose" */
export type Gacha_Lose_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  gacha_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  point_used_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Gacha_Lose_Min_Fields = {
  __typename?: 'gacha_lose_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  gacha_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  point_used_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "gacha_lose" */
export type Gacha_Lose_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  gacha_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  point_used_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "gacha_lose". */
export type Gacha_Lose_Order_By = {
  created_at?: InputMaybe<Order_By>;
  gacha?: InputMaybe<Gacha_Order_By>;
  gacha_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  point_used_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "gacha_lose" */
export enum Gacha_Lose_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GachaId = 'gacha_id',
  /** column name */
  Id = 'id',
  /** column name */
  PointUsedId = 'point_used_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "gacha_lose" */
export type Gacha_Lose_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gacha_Lose_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gacha_Lose_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  gacha_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  point_used_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** Ordering options when selecting data from "gacha". */
export type Gacha_Order_By = {
  created_at?: InputMaybe<Order_By>;
  end_at?: InputMaybe<Order_By>;
  gacha_loses_aggregate?: InputMaybe<Gacha_Lose_Aggregate_Order_By>;
  gacha_physical_prize_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  physical_prizes_aggregate?: InputMaybe<Physical_Prize_Aggregate_Order_By>;
  point?: InputMaybe<Order_By>;
  probability?: InputMaybe<Order_By>;
  start_at?: InputMaybe<Order_By>;
  total_win_num?: InputMaybe<Order_By>;
  total_win_num_limit?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "gacha" */
export enum Gacha_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndAt = 'end_at',
  /** column name */
  GachaPhysicalPrizeId = 'gacha_physical_prize_id',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Point = 'point',
  /** column name */
  Probability = 'probability',
  /** column name */
  StartAt = 'start_at',
  /** column name */
  TotalWinNum = 'total_win_num',
  /** column name */
  TotalWinNumLimit = 'total_win_num_limit',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "gacha" */
export type Gacha_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Gacha_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Gacha_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  end_at?: InputMaybe<Scalars['timestamp']>;
  gacha_physical_prize_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  point?: InputMaybe<Scalars['Int']>;
  probability?: InputMaybe<Scalars['Int']>;
  start_at?: InputMaybe<Scalars['timestamp']>;
  total_win_num?: InputMaybe<Scalars['Int']>;
  total_win_num_limit?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** columns and relationships of "image" */
export type Image = {
  __typename?: 'image';
  alt: Scalars['String'];
  /** An array relationship */
  campsites: Array<Campsite>;
  /** An aggregate relationship */
  campsites_aggregate: Campsite_Aggregate;
  created_at: Scalars['timestamp'];
  file_name: Scalars['String'];
  id: Scalars['String'];
  /** An array relationship */
  review_images: Array<Review_Image>;
  /** An aggregate relationship */
  review_images_aggregate: Review_Image_Aggregate;
  title: Scalars['String'];
  user_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  users: Array<User>;
  /** An array relationship */
  usersByIconImageId: Array<User>;
};


/** columns and relationships of "image" */
export type ImageCampsitesArgs = {
  distinct_on?: InputMaybe<Array<Campsite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Campsite_Order_By>>;
  where?: InputMaybe<Campsite_Bool_Exp>;
};


/** columns and relationships of "image" */
export type ImageCampsites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campsite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Campsite_Order_By>>;
  where?: InputMaybe<Campsite_Bool_Exp>;
};


/** columns and relationships of "image" */
export type ImageReview_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Review_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Image_Order_By>>;
  where?: InputMaybe<Review_Image_Bool_Exp>;
};


/** columns and relationships of "image" */
export type ImageReview_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Image_Order_By>>;
  where?: InputMaybe<Review_Image_Bool_Exp>;
};


/** columns and relationships of "image" */
export type ImageUsersArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


/** columns and relationships of "image" */
export type ImageUsersByIconImageIdArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};

/** Boolean expression to filter rows from the table "image". All fields are combined with a logical 'AND'. */
export type Image_Bool_Exp = {
  _and?: InputMaybe<Array<Image_Bool_Exp>>;
  _not?: InputMaybe<Image_Bool_Exp>;
  _or?: InputMaybe<Array<Image_Bool_Exp>>;
  alt?: InputMaybe<String_Comparison_Exp>;
  campsites?: InputMaybe<Campsite_Bool_Exp>;
  campsites_aggregate?: InputMaybe<Campsite_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  file_name?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  review_images?: InputMaybe<Review_Image_Bool_Exp>;
  review_images_aggregate?: InputMaybe<Review_Image_Aggregate_Bool_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  users?: InputMaybe<User_Bool_Exp>;
  usersByIconImageId?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "image" */
export enum Image_Constraint {
  /** unique or primary key constraint on columns "id" */
  ImagePkey = 'image_pkey'
}

/** input type for inserting data into table "image" */
export type Image_Insert_Input = {
  alt?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  file_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  review_images?: InputMaybe<Review_Image_Arr_Rel_Insert_Input>;
  title?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** response of any mutation on the table "image" */
export type Image_Mutation_Response = {
  __typename?: 'image_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Image>;
};

/** input type for inserting object relation for remote table "image" */
export type Image_Obj_Rel_Insert_Input = {
  data: Image_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Image_On_Conflict>;
};

/** on_conflict condition type for table "image" */
export type Image_On_Conflict = {
  constraint: Image_Constraint;
  update_columns?: Array<Image_Update_Column>;
  where?: InputMaybe<Image_Bool_Exp>;
};

/** Ordering options when selecting data from "image". */
export type Image_Order_By = {
  alt?: InputMaybe<Order_By>;
  campsites_aggregate?: InputMaybe<Campsite_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  file_name?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  review_images_aggregate?: InputMaybe<Review_Image_Aggregate_Order_By>;
  title?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  usersByIconImageId_aggregate?: InputMaybe<User_Aggregate_Order_By>;
  users_aggregate?: InputMaybe<User_Aggregate_Order_By>;
};

/** primary key columns input for table: image */
export type Image_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "image" */
export enum Image_Select_Column {
  /** column name */
  Alt = 'alt',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "image" */
export type Image_Set_Input = {
  alt?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  file_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "image" */
export type Image_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Image_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Image_Stream_Cursor_Value_Input = {
  alt?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  file_name?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** update columns of table "image" */
export enum Image_Update_Column {
  /** column name */
  Alt = 'alt',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FileName = 'file_name',
  /** column name */
  Id = 'id',
  /** column name */
  Title = 'title'
}

export type Image_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Image_Set_Input>;
  /** filter the rows which have to be updated */
  where: Image_Bool_Exp;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  afterLogin?: Maybe<Scalars['String']>;
  /** delete data from the table: "campsite_likes" */
  delete_campsite_likes?: Maybe<Campsite_Likes_Mutation_Response>;
  /** delete single row from the table: "campsite_likes" */
  delete_campsite_likes_by_pk?: Maybe<Campsite_Likes>;
  /** delete data from the table: "review" */
  delete_review?: Maybe<Review_Mutation_Response>;
  /** delete single row from the table: "review" */
  delete_review_by_pk?: Maybe<Review>;
  /** delete data from the table: "review_good" */
  delete_review_good?: Maybe<Review_Good_Mutation_Response>;
  /** delete single row from the table: "review_good" */
  delete_review_good_by_pk?: Maybe<Review_Good>;
  /** delete data from the table: "review_image" */
  delete_review_image?: Maybe<Review_Image_Mutation_Response>;
  /** delete single row from the table: "review_image" */
  delete_review_image_by_pk?: Maybe<Review_Image>;
  /** delete data from the table: "visited" */
  delete_visited?: Maybe<Visited_Mutation_Response>;
  /** delete single row from the table: "visited" */
  delete_visited_by_pk?: Maybe<Visited>;
  drawGacha: GachaResult;
  /** execute VOLATILE function "exchange_fixed_exchange_product" which returns "fixed_exchange_product_exchanged" */
  exchange_fixed_exchange_product: Array<Fixed_Exchange_Product_Exchanged>;
  generatePresignedUrl: PresignedUrl;
  /** insert data into the table: "address" */
  insert_address?: Maybe<Address_Mutation_Response>;
  /** insert a single row into the table: "address" */
  insert_address_one?: Maybe<Address>;
  /** insert data into the table: "campsite_likes" */
  insert_campsite_likes?: Maybe<Campsite_Likes_Mutation_Response>;
  /** insert a single row into the table: "campsite_likes" */
  insert_campsite_likes_one?: Maybe<Campsite_Likes>;
  /** insert data into the table: "campsite_search_log" */
  insert_campsite_search_log?: Maybe<Campsite_Search_Log_Mutation_Response>;
  /** insert data into the table: "image" */
  insert_image?: Maybe<Image_Mutation_Response>;
  /** insert a single row into the table: "image" */
  insert_image_one?: Maybe<Image>;
  /** insert data into the table: "review" */
  insert_review?: Maybe<Review_Mutation_Response>;
  /** insert data into the table: "review_good" */
  insert_review_good?: Maybe<Review_Good_Mutation_Response>;
  /** insert a single row into the table: "review_good" */
  insert_review_good_one?: Maybe<Review_Good>;
  /** insert data into the table: "review_image" */
  insert_review_image?: Maybe<Review_Image_Mutation_Response>;
  /** insert a single row into the table: "review_image" */
  insert_review_image_one?: Maybe<Review_Image>;
  /** insert a single row into the table: "review" */
  insert_review_one?: Maybe<Review>;
  /** insert data into the table: "visited" */
  insert_visited?: Maybe<Visited_Mutation_Response>;
  /** insert a single row into the table: "visited" */
  insert_visited_one?: Maybe<Visited>;
  /** execute VOLATILE function "submit_physical_prize_delivery_address" which returns "physical_prize_delivery_address" */
  submit_physical_prize_delivery_address: Array<Physical_Prize_Delivery_Address>;
  /** update data of the table: "address" */
  update_address?: Maybe<Address_Mutation_Response>;
  /** update single row of the table: "address" */
  update_address_by_pk?: Maybe<Address>;
  /** update multiples rows of table: "address" */
  update_address_many?: Maybe<Array<Maybe<Address_Mutation_Response>>>;
  /** update data of the table: "campsite" */
  update_campsite?: Maybe<Campsite_Mutation_Response>;
  /** update single row of the table: "campsite" */
  update_campsite_by_pk?: Maybe<Campsite>;
  /** execute VOLATILE function "update_campsite_info" which returns "campsite" */
  update_campsite_info: Array<Campsite>;
  /** execute VOLATILE function "update_campsite_like_from_edit" which returns "campsite_likes" */
  update_campsite_like_from_edit: Array<Campsite_Likes>;
  /** update data of the table: "campsite_likes" */
  update_campsite_likes?: Maybe<Campsite_Likes_Mutation_Response>;
  /** update single row of the table: "campsite_likes" */
  update_campsite_likes_by_pk?: Maybe<Campsite_Likes>;
  /** update multiples rows of table: "campsite_likes" */
  update_campsite_likes_many?: Maybe<Array<Maybe<Campsite_Likes_Mutation_Response>>>;
  /** update multiples rows of table: "campsite" */
  update_campsite_many?: Maybe<Array<Maybe<Campsite_Mutation_Response>>>;
  /** update data of the table: "image" */
  update_image?: Maybe<Image_Mutation_Response>;
  /** update single row of the table: "image" */
  update_image_by_pk?: Maybe<Image>;
  /** update multiples rows of table: "image" */
  update_image_many?: Maybe<Array<Maybe<Image_Mutation_Response>>>;
  /** update data of the table: "point" */
  update_point?: Maybe<Point_Mutation_Response>;
  /** update single row of the table: "point" */
  update_point_by_pk?: Maybe<Point>;
  /** update multiples rows of table: "point" */
  update_point_many?: Maybe<Array<Maybe<Point_Mutation_Response>>>;
  /** update data of the table: "review" */
  update_review?: Maybe<Review_Mutation_Response>;
  /** update single row of the table: "review" */
  update_review_by_pk?: Maybe<Review>;
  /** update multiples rows of table: "review" */
  update_review_many?: Maybe<Array<Maybe<Review_Mutation_Response>>>;
  /** update data of the table: "user" */
  update_user?: Maybe<User_Mutation_Response>;
  /** update single row of the table: "user" */
  update_user_by_pk?: Maybe<User>;
  /** update multiples rows of table: "user" */
  update_user_many?: Maybe<Array<Maybe<User_Mutation_Response>>>;
  /** update data of the table: "user_notification" */
  update_user_notification?: Maybe<User_Notification_Mutation_Response>;
  /** update single row of the table: "user_notification" */
  update_user_notification_by_pk?: Maybe<User_Notification>;
  /** update multiples rows of table: "user_notification" */
  update_user_notification_many?: Maybe<Array<Maybe<User_Notification_Mutation_Response>>>;
  /** execute VOLATILE function "upsert_campsite_image" which returns "campsite" */
  upsert_campsite_image: Array<Campsite>;
  withDraw: SimpleResult;
};


/** mutation root */
export type Mutation_RootAfterLoginArgs = {
  cognitoUserId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Campsite_LikesArgs = {
  where: Campsite_Likes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Campsite_Likes_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_ReviewArgs = {
  where: Review_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Review_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Review_GoodArgs = {
  where: Review_Good_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Review_Good_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Review_ImageArgs = {
  where: Review_Image_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Review_Image_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_VisitedArgs = {
  where: Visited_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Visited_By_PkArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDrawGachaArgs = {
  targetGachaId: Scalars['String'];
  targetUserId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootExchange_Fixed_Exchange_ProductArgs = {
  args: Exchange_Fixed_Exchange_Product_Args;
  distinct_on?: InputMaybe<Array<Fixed_Exchange_Product_Exchanged_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fixed_Exchange_Product_Exchanged_Order_By>>;
  where?: InputMaybe<Fixed_Exchange_Product_Exchanged_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootGeneratePresignedUrlArgs = {
  fileName: Scalars['String'];
};


/** mutation root */
export type Mutation_RootInsert_AddressArgs = {
  objects: Array<Address_Insert_Input>;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Address_OneArgs = {
  object: Address_Insert_Input;
  on_conflict?: InputMaybe<Address_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campsite_LikesArgs = {
  objects: Array<Campsite_Likes_Insert_Input>;
  on_conflict?: InputMaybe<Campsite_Likes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campsite_Likes_OneArgs = {
  object: Campsite_Likes_Insert_Input;
  on_conflict?: InputMaybe<Campsite_Likes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Campsite_Search_LogArgs = {
  objects: Array<Campsite_Search_Log_Insert_Input>;
  on_conflict?: InputMaybe<Campsite_Search_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ImageArgs = {
  objects: Array<Image_Insert_Input>;
  on_conflict?: InputMaybe<Image_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Image_OneArgs = {
  object: Image_Insert_Input;
  on_conflict?: InputMaybe<Image_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ReviewArgs = {
  objects: Array<Review_Insert_Input>;
  on_conflict?: InputMaybe<Review_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Review_GoodArgs = {
  objects: Array<Review_Good_Insert_Input>;
  on_conflict?: InputMaybe<Review_Good_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Review_Good_OneArgs = {
  object: Review_Good_Insert_Input;
  on_conflict?: InputMaybe<Review_Good_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Review_ImageArgs = {
  objects: Array<Review_Image_Insert_Input>;
  on_conflict?: InputMaybe<Review_Image_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Review_Image_OneArgs = {
  object: Review_Image_Insert_Input;
  on_conflict?: InputMaybe<Review_Image_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Review_OneArgs = {
  object: Review_Insert_Input;
  on_conflict?: InputMaybe<Review_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_VisitedArgs = {
  objects: Array<Visited_Insert_Input>;
  on_conflict?: InputMaybe<Visited_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Visited_OneArgs = {
  object: Visited_Insert_Input;
  on_conflict?: InputMaybe<Visited_On_Conflict>;
};


/** mutation root */
export type Mutation_RootSubmit_Physical_Prize_Delivery_AddressArgs = {
  args: Submit_Physical_Prize_Delivery_Address_Args;
  distinct_on?: InputMaybe<Array<Physical_Prize_Delivery_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Physical_Prize_Delivery_Address_Order_By>>;
  where?: InputMaybe<Physical_Prize_Delivery_Address_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootUpdate_AddressArgs = {
  _set?: InputMaybe<Address_Set_Input>;
  where: Address_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Address_By_PkArgs = {
  _set?: InputMaybe<Address_Set_Input>;
  pk_columns: Address_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Address_ManyArgs = {
  updates: Array<Address_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CampsiteArgs = {
  _set?: InputMaybe<Campsite_Set_Input>;
  where: Campsite_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Campsite_By_PkArgs = {
  _set?: InputMaybe<Campsite_Set_Input>;
  pk_columns: Campsite_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Campsite_InfoArgs = {
  args: Update_Campsite_Info_Args;
  distinct_on?: InputMaybe<Array<Campsite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Campsite_Order_By>>;
  where?: InputMaybe<Campsite_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootUpdate_Campsite_Like_From_EditArgs = {
  args: Update_Campsite_Like_From_Edit_Args;
  distinct_on?: InputMaybe<Array<Campsite_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Campsite_Likes_Order_By>>;
  where?: InputMaybe<Campsite_Likes_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootUpdate_Campsite_LikesArgs = {
  _inc?: InputMaybe<Campsite_Likes_Inc_Input>;
  _set?: InputMaybe<Campsite_Likes_Set_Input>;
  where: Campsite_Likes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Campsite_Likes_By_PkArgs = {
  _inc?: InputMaybe<Campsite_Likes_Inc_Input>;
  _set?: InputMaybe<Campsite_Likes_Set_Input>;
  pk_columns: Campsite_Likes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Campsite_Likes_ManyArgs = {
  updates: Array<Campsite_Likes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Campsite_ManyArgs = {
  updates: Array<Campsite_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ImageArgs = {
  _set?: InputMaybe<Image_Set_Input>;
  where: Image_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Image_By_PkArgs = {
  _set?: InputMaybe<Image_Set_Input>;
  pk_columns: Image_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Image_ManyArgs = {
  updates: Array<Image_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PointArgs = {
  _set?: InputMaybe<Point_Set_Input>;
  where: Point_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Point_By_PkArgs = {
  _set?: InputMaybe<Point_Set_Input>;
  pk_columns: Point_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Point_ManyArgs = {
  updates: Array<Point_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ReviewArgs = {
  _set?: InputMaybe<Review_Set_Input>;
  where: Review_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Review_By_PkArgs = {
  _set?: InputMaybe<Review_Set_Input>;
  pk_columns: Review_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Review_ManyArgs = {
  updates: Array<Review_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserArgs = {
  _inc?: InputMaybe<User_Inc_Input>;
  _set?: InputMaybe<User_Set_Input>;
  where: User_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_By_PkArgs = {
  _inc?: InputMaybe<User_Inc_Input>;
  _set?: InputMaybe<User_Set_Input>;
  pk_columns: User_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_ManyArgs = {
  updates: Array<User_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_NotificationArgs = {
  _set?: InputMaybe<User_Notification_Set_Input>;
  where: User_Notification_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Notification_By_PkArgs = {
  _set?: InputMaybe<User_Notification_Set_Input>;
  pk_columns: User_Notification_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Notification_ManyArgs = {
  updates: Array<User_Notification_Updates>;
};


/** mutation root */
export type Mutation_RootUpsert_Campsite_ImageArgs = {
  args: Upsert_Campsite_Image_Args;
  distinct_on?: InputMaybe<Array<Campsite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Campsite_Order_By>>;
  where?: InputMaybe<Campsite_Bool_Exp>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "physical_prize" */
export type Physical_Prize = {
  __typename?: 'physical_prize';
  created_at: Scalars['timestamp'];
  /** An object relationship */
  gacha: Gacha;
  gacha_id: Scalars['String'];
  id: Scalars['String'];
  input_delivery_address_at?: Maybe<Scalars['timestamp']>;
  /** An object relationship */
  physical_prize_delivery_address?: Maybe<Physical_Prize_Delivery_Address>;
  physical_prize_delivery_address_id?: Maybe<Scalars['String']>;
  point_used_id: Scalars['String'];
  updated_at: Scalars['timestamp'];
  /** An object relationship */
  user: User;
  user_id: Scalars['String'];
};

/** aggregated selection of "physical_prize" */
export type Physical_Prize_Aggregate = {
  __typename?: 'physical_prize_aggregate';
  aggregate?: Maybe<Physical_Prize_Aggregate_Fields>;
  nodes: Array<Physical_Prize>;
};

export type Physical_Prize_Aggregate_Bool_Exp = {
  count?: InputMaybe<Physical_Prize_Aggregate_Bool_Exp_Count>;
};

export type Physical_Prize_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Physical_Prize_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Physical_Prize_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "physical_prize" */
export type Physical_Prize_Aggregate_Fields = {
  __typename?: 'physical_prize_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Physical_Prize_Max_Fields>;
  min?: Maybe<Physical_Prize_Min_Fields>;
};


/** aggregate fields of "physical_prize" */
export type Physical_Prize_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Physical_Prize_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "physical_prize" */
export type Physical_Prize_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Physical_Prize_Max_Order_By>;
  min?: InputMaybe<Physical_Prize_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "physical_prize". All fields are combined with a logical 'AND'. */
export type Physical_Prize_Bool_Exp = {
  _and?: InputMaybe<Array<Physical_Prize_Bool_Exp>>;
  _not?: InputMaybe<Physical_Prize_Bool_Exp>;
  _or?: InputMaybe<Array<Physical_Prize_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  gacha?: InputMaybe<Gacha_Bool_Exp>;
  gacha_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  input_delivery_address_at?: InputMaybe<Timestamp_Comparison_Exp>;
  physical_prize_delivery_address?: InputMaybe<Physical_Prize_Delivery_Address_Bool_Exp>;
  physical_prize_delivery_address_id?: InputMaybe<String_Comparison_Exp>;
  point_used_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** columns and relationships of "physical_prize_delivery_address" */
export type Physical_Prize_Delivery_Address = {
  __typename?: 'physical_prize_delivery_address';
  building?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  created_at: Scalars['timestamp'];
  id: Scalars['String'];
  name: Scalars['String'];
  postal_code: Scalars['String'];
  prefecture: Scalars['String'];
  street: Scalars['String'];
  tel_body: Scalars['String'];
  tel_head: Scalars['String'];
  tel_tail: Scalars['String'];
  updated_at: Scalars['timestamp'];
  /** An object relationship */
  user: User;
  user_id: Scalars['String'];
};

/** aggregated selection of "physical_prize_delivery_address" */
export type Physical_Prize_Delivery_Address_Aggregate = {
  __typename?: 'physical_prize_delivery_address_aggregate';
  aggregate?: Maybe<Physical_Prize_Delivery_Address_Aggregate_Fields>;
  nodes: Array<Physical_Prize_Delivery_Address>;
};

export type Physical_Prize_Delivery_Address_Aggregate_Bool_Exp = {
  count?: InputMaybe<Physical_Prize_Delivery_Address_Aggregate_Bool_Exp_Count>;
};

export type Physical_Prize_Delivery_Address_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Physical_Prize_Delivery_Address_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Physical_Prize_Delivery_Address_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "physical_prize_delivery_address" */
export type Physical_Prize_Delivery_Address_Aggregate_Fields = {
  __typename?: 'physical_prize_delivery_address_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Physical_Prize_Delivery_Address_Max_Fields>;
  min?: Maybe<Physical_Prize_Delivery_Address_Min_Fields>;
};


/** aggregate fields of "physical_prize_delivery_address" */
export type Physical_Prize_Delivery_Address_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Physical_Prize_Delivery_Address_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "physical_prize_delivery_address" */
export type Physical_Prize_Delivery_Address_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Physical_Prize_Delivery_Address_Max_Order_By>;
  min?: InputMaybe<Physical_Prize_Delivery_Address_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "physical_prize_delivery_address". All fields are combined with a logical 'AND'. */
export type Physical_Prize_Delivery_Address_Bool_Exp = {
  _and?: InputMaybe<Array<Physical_Prize_Delivery_Address_Bool_Exp>>;
  _not?: InputMaybe<Physical_Prize_Delivery_Address_Bool_Exp>;
  _or?: InputMaybe<Array<Physical_Prize_Delivery_Address_Bool_Exp>>;
  building?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  postal_code?: InputMaybe<String_Comparison_Exp>;
  prefecture?: InputMaybe<String_Comparison_Exp>;
  street?: InputMaybe<String_Comparison_Exp>;
  tel_body?: InputMaybe<String_Comparison_Exp>;
  tel_head?: InputMaybe<String_Comparison_Exp>;
  tel_tail?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Physical_Prize_Delivery_Address_Max_Fields = {
  __typename?: 'physical_prize_delivery_address_max_fields';
  building?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  prefecture?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  tel_body?: Maybe<Scalars['String']>;
  tel_head?: Maybe<Scalars['String']>;
  tel_tail?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "physical_prize_delivery_address" */
export type Physical_Prize_Delivery_Address_Max_Order_By = {
  building?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  postal_code?: InputMaybe<Order_By>;
  prefecture?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  tel_body?: InputMaybe<Order_By>;
  tel_head?: InputMaybe<Order_By>;
  tel_tail?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Physical_Prize_Delivery_Address_Min_Fields = {
  __typename?: 'physical_prize_delivery_address_min_fields';
  building?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  postal_code?: Maybe<Scalars['String']>;
  prefecture?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  tel_body?: Maybe<Scalars['String']>;
  tel_head?: Maybe<Scalars['String']>;
  tel_tail?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "physical_prize_delivery_address" */
export type Physical_Prize_Delivery_Address_Min_Order_By = {
  building?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  postal_code?: InputMaybe<Order_By>;
  prefecture?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  tel_body?: InputMaybe<Order_By>;
  tel_head?: InputMaybe<Order_By>;
  tel_tail?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "physical_prize_delivery_address". */
export type Physical_Prize_Delivery_Address_Order_By = {
  building?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  postal_code?: InputMaybe<Order_By>;
  prefecture?: InputMaybe<Order_By>;
  street?: InputMaybe<Order_By>;
  tel_body?: InputMaybe<Order_By>;
  tel_head?: InputMaybe<Order_By>;
  tel_tail?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "physical_prize_delivery_address" */
export enum Physical_Prize_Delivery_Address_Select_Column {
  /** column name */
  Building = 'building',
  /** column name */
  City = 'city',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PostalCode = 'postal_code',
  /** column name */
  Prefecture = 'prefecture',
  /** column name */
  Street = 'street',
  /** column name */
  TelBody = 'tel_body',
  /** column name */
  TelHead = 'tel_head',
  /** column name */
  TelTail = 'tel_tail',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "physical_prize_delivery_address" */
export type Physical_Prize_Delivery_Address_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Physical_Prize_Delivery_Address_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Physical_Prize_Delivery_Address_Stream_Cursor_Value_Input = {
  building?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  prefecture?: InputMaybe<Scalars['String']>;
  street?: InputMaybe<Scalars['String']>;
  tel_body?: InputMaybe<Scalars['String']>;
  tel_head?: InputMaybe<Scalars['String']>;
  tel_tail?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Physical_Prize_Max_Fields = {
  __typename?: 'physical_prize_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  gacha_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  input_delivery_address_at?: Maybe<Scalars['timestamp']>;
  physical_prize_delivery_address_id?: Maybe<Scalars['String']>;
  point_used_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "physical_prize" */
export type Physical_Prize_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  gacha_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_delivery_address_at?: InputMaybe<Order_By>;
  physical_prize_delivery_address_id?: InputMaybe<Order_By>;
  point_used_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Physical_Prize_Min_Fields = {
  __typename?: 'physical_prize_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  gacha_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  input_delivery_address_at?: Maybe<Scalars['timestamp']>;
  physical_prize_delivery_address_id?: Maybe<Scalars['String']>;
  point_used_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "physical_prize" */
export type Physical_Prize_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  gacha_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_delivery_address_at?: InputMaybe<Order_By>;
  physical_prize_delivery_address_id?: InputMaybe<Order_By>;
  point_used_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "physical_prize". */
export type Physical_Prize_Order_By = {
  created_at?: InputMaybe<Order_By>;
  gacha?: InputMaybe<Gacha_Order_By>;
  gacha_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  input_delivery_address_at?: InputMaybe<Order_By>;
  physical_prize_delivery_address?: InputMaybe<Physical_Prize_Delivery_Address_Order_By>;
  physical_prize_delivery_address_id?: InputMaybe<Order_By>;
  point_used_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "physical_prize" */
export enum Physical_Prize_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GachaId = 'gacha_id',
  /** column name */
  Id = 'id',
  /** column name */
  InputDeliveryAddressAt = 'input_delivery_address_at',
  /** column name */
  PhysicalPrizeDeliveryAddressId = 'physical_prize_delivery_address_id',
  /** column name */
  PointUsedId = 'point_used_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "physical_prize" */
export type Physical_Prize_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Physical_Prize_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Physical_Prize_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  gacha_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  input_delivery_address_at?: InputMaybe<Scalars['timestamp']>;
  physical_prize_delivery_address_id?: InputMaybe<Scalars['String']>;
  point_used_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "point" */
export type Point = {
  __typename?: 'point';
  created_at: Scalars['timestamp'];
  day_point_count?: Maybe<Scalars['Int']>;
  earned_type: Scalars['String'];
  id: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  month_first_point_id?: Maybe<Scalars['String']>;
  rate: Scalars['Int'];
  read_at?: Maybe<Scalars['timestamp']>;
  updated_at: Scalars['timestamp'];
  /** An object relationship */
  user: User;
  user_id: Scalars['String'];
  value: Scalars['Int'];
};

/** aggregated selection of "point" */
export type Point_Aggregate = {
  __typename?: 'point_aggregate';
  aggregate?: Maybe<Point_Aggregate_Fields>;
  nodes: Array<Point>;
};

export type Point_Aggregate_Bool_Exp = {
  count?: InputMaybe<Point_Aggregate_Bool_Exp_Count>;
};

export type Point_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Point_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Point_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "point" */
export type Point_Aggregate_Fields = {
  __typename?: 'point_aggregate_fields';
  avg?: Maybe<Point_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Point_Max_Fields>;
  min?: Maybe<Point_Min_Fields>;
  stddev?: Maybe<Point_Stddev_Fields>;
  stddev_pop?: Maybe<Point_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Point_Stddev_Samp_Fields>;
  sum?: Maybe<Point_Sum_Fields>;
  var_pop?: Maybe<Point_Var_Pop_Fields>;
  var_samp?: Maybe<Point_Var_Samp_Fields>;
  variance?: Maybe<Point_Variance_Fields>;
};


/** aggregate fields of "point" */
export type Point_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Point_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "point" */
export type Point_Aggregate_Order_By = {
  avg?: InputMaybe<Point_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Point_Max_Order_By>;
  min?: InputMaybe<Point_Min_Order_By>;
  stddev?: InputMaybe<Point_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Point_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Point_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Point_Sum_Order_By>;
  var_pop?: InputMaybe<Point_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Point_Var_Samp_Order_By>;
  variance?: InputMaybe<Point_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Point_Avg_Fields = {
  __typename?: 'point_avg_fields';
  day_point_count?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "point" */
export type Point_Avg_Order_By = {
  day_point_count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "point". All fields are combined with a logical 'AND'. */
export type Point_Bool_Exp = {
  _and?: InputMaybe<Array<Point_Bool_Exp>>;
  _not?: InputMaybe<Point_Bool_Exp>;
  _or?: InputMaybe<Array<Point_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  day_point_count?: InputMaybe<Int_Comparison_Exp>;
  earned_type?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  month_first_point_id?: InputMaybe<String_Comparison_Exp>;
  rate?: InputMaybe<Int_Comparison_Exp>;
  read_at?: InputMaybe<Timestamp_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Int_Comparison_Exp>;
};

/** columns and relationships of "point_history" */
export type Point_History = {
  __typename?: 'point_history';
  created_at?: Maybe<Scalars['timestamp']>;
  earn_id?: Maybe<Scalars['String']>;
  earned_type?: Maybe<Scalars['String']>;
  fixed_exchange_product_exchanged_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  gacha_lose?: Maybe<Gacha_Lose>;
  gacha_lose_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  month_first_point_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  physical_prize?: Maybe<Physical_Prize>;
  physical_prize_id?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  use_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "point_history" */
export type Point_History_Aggregate = {
  __typename?: 'point_history_aggregate';
  aggregate?: Maybe<Point_History_Aggregate_Fields>;
  nodes: Array<Point_History>;
};

/** aggregate fields of "point_history" */
export type Point_History_Aggregate_Fields = {
  __typename?: 'point_history_aggregate_fields';
  avg?: Maybe<Point_History_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Point_History_Max_Fields>;
  min?: Maybe<Point_History_Min_Fields>;
  stddev?: Maybe<Point_History_Stddev_Fields>;
  stddev_pop?: Maybe<Point_History_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Point_History_Stddev_Samp_Fields>;
  sum?: Maybe<Point_History_Sum_Fields>;
  var_pop?: Maybe<Point_History_Var_Pop_Fields>;
  var_samp?: Maybe<Point_History_Var_Samp_Fields>;
  variance?: Maybe<Point_History_Variance_Fields>;
};


/** aggregate fields of "point_history" */
export type Point_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Point_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Point_History_Avg_Fields = {
  __typename?: 'point_history_avg_fields';
  rate?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "point_history". All fields are combined with a logical 'AND'. */
export type Point_History_Bool_Exp = {
  _and?: InputMaybe<Array<Point_History_Bool_Exp>>;
  _not?: InputMaybe<Point_History_Bool_Exp>;
  _or?: InputMaybe<Array<Point_History_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  earn_id?: InputMaybe<String_Comparison_Exp>;
  earned_type?: InputMaybe<String_Comparison_Exp>;
  fixed_exchange_product_exchanged_id?: InputMaybe<String_Comparison_Exp>;
  gacha_lose?: InputMaybe<Gacha_Lose_Bool_Exp>;
  gacha_lose_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  month_first_point_id?: InputMaybe<String_Comparison_Exp>;
  physical_prize?: InputMaybe<Physical_Prize_Bool_Exp>;
  physical_prize_id?: InputMaybe<String_Comparison_Exp>;
  rate?: InputMaybe<Int_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  use_id?: InputMaybe<String_Comparison_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<Int_Comparison_Exp>;
};

/** aggregate max on columns */
export type Point_History_Max_Fields = {
  __typename?: 'point_history_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  earn_id?: Maybe<Scalars['String']>;
  earned_type?: Maybe<Scalars['String']>;
  fixed_exchange_product_exchanged_id?: Maybe<Scalars['String']>;
  gacha_lose_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  month_first_point_id?: Maybe<Scalars['String']>;
  physical_prize_id?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  use_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Point_History_Min_Fields = {
  __typename?: 'point_history_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  earn_id?: Maybe<Scalars['String']>;
  earned_type?: Maybe<Scalars['String']>;
  fixed_exchange_product_exchanged_id?: Maybe<Scalars['String']>;
  gacha_lose_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  month_first_point_id?: Maybe<Scalars['String']>;
  physical_prize_id?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  use_id?: Maybe<Scalars['String']>;
  user_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

/** Ordering options when selecting data from "point_history". */
export type Point_History_Order_By = {
  created_at?: InputMaybe<Order_By>;
  earn_id?: InputMaybe<Order_By>;
  earned_type?: InputMaybe<Order_By>;
  fixed_exchange_product_exchanged_id?: InputMaybe<Order_By>;
  gacha_lose?: InputMaybe<Gacha_Lose_Order_By>;
  gacha_lose_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  month_first_point_id?: InputMaybe<Order_By>;
  physical_prize?: InputMaybe<Physical_Prize_Order_By>;
  physical_prize_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  use_id?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** select columns of table "point_history" */
export enum Point_History_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EarnId = 'earn_id',
  /** column name */
  EarnedType = 'earned_type',
  /** column name */
  FixedExchangeProductExchangedId = 'fixed_exchange_product_exchanged_id',
  /** column name */
  GachaLoseId = 'gacha_lose_id',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  MonthFirstPointId = 'month_first_point_id',
  /** column name */
  PhysicalPrizeId = 'physical_prize_id',
  /** column name */
  Rate = 'rate',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UseId = 'use_id',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

/** aggregate stddev on columns */
export type Point_History_Stddev_Fields = {
  __typename?: 'point_history_stddev_fields';
  rate?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Point_History_Stddev_Pop_Fields = {
  __typename?: 'point_history_stddev_pop_fields';
  rate?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Point_History_Stddev_Samp_Fields = {
  __typename?: 'point_history_stddev_samp_fields';
  rate?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "point_history" */
export type Point_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Point_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Point_History_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  earn_id?: InputMaybe<Scalars['String']>;
  earned_type?: InputMaybe<Scalars['String']>;
  fixed_exchange_product_exchanged_id?: InputMaybe<Scalars['String']>;
  gacha_lose_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  month_first_point_id?: InputMaybe<Scalars['String']>;
  physical_prize_id?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  use_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Point_History_Sum_Fields = {
  __typename?: 'point_history_sum_fields';
  rate?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

/** aggregate var_pop on columns */
export type Point_History_Var_Pop_Fields = {
  __typename?: 'point_history_var_pop_fields';
  rate?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Point_History_Var_Samp_Fields = {
  __typename?: 'point_history_var_samp_fields';
  rate?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Point_History_Variance_Fields = {
  __typename?: 'point_history_variance_fields';
  rate?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** aggregate max on columns */
export type Point_Max_Fields = {
  __typename?: 'point_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  day_point_count?: Maybe<Scalars['Int']>;
  earned_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  month_first_point_id?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Int']>;
  read_at?: Maybe<Scalars['timestamp']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "point" */
export type Point_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  day_point_count?: InputMaybe<Order_By>;
  earned_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  month_first_point_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  read_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Point_Min_Fields = {
  __typename?: 'point_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  day_point_count?: Maybe<Scalars['Int']>;
  earned_type?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  month_first_point_id?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Int']>;
  read_at?: Maybe<Scalars['timestamp']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "point" */
export type Point_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  day_point_count?: InputMaybe<Order_By>;
  earned_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  month_first_point_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  read_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "point" */
export type Point_Mutation_Response = {
  __typename?: 'point_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Point>;
};

/** Ordering options when selecting data from "point". */
export type Point_Order_By = {
  created_at?: InputMaybe<Order_By>;
  day_point_count?: InputMaybe<Order_By>;
  earned_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  month_first_point_id?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  read_at?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: point */
export type Point_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "point" */
export enum Point_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DayPointCount = 'day_point_count',
  /** column name */
  EarnedType = 'earned_type',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  MonthFirstPointId = 'month_first_point_id',
  /** column name */
  Rate = 'rate',
  /** column name */
  ReadAt = 'read_at',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "point" */
export type Point_Set_Input = {
  read_at?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate stddev on columns */
export type Point_Stddev_Fields = {
  __typename?: 'point_stddev_fields';
  day_point_count?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "point" */
export type Point_Stddev_Order_By = {
  day_point_count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Point_Stddev_Pop_Fields = {
  __typename?: 'point_stddev_pop_fields';
  day_point_count?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "point" */
export type Point_Stddev_Pop_Order_By = {
  day_point_count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Point_Stddev_Samp_Fields = {
  __typename?: 'point_stddev_samp_fields';
  day_point_count?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "point" */
export type Point_Stddev_Samp_Order_By = {
  day_point_count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "point" */
export type Point_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Point_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Point_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  day_point_count?: InputMaybe<Scalars['Int']>;
  earned_type?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  month_first_point_id?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<Scalars['Int']>;
  read_at?: InputMaybe<Scalars['timestamp']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  user_id?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Point_Sum_Fields = {
  __typename?: 'point_sum_fields';
  day_point_count?: Maybe<Scalars['Int']>;
  rate?: Maybe<Scalars['Int']>;
  value?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "point" */
export type Point_Sum_Order_By = {
  day_point_count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

export type Point_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Point_Set_Input>;
  /** filter the rows which have to be updated */
  where: Point_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Point_Var_Pop_Fields = {
  __typename?: 'point_var_pop_fields';
  day_point_count?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "point" */
export type Point_Var_Pop_Order_By = {
  day_point_count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Point_Var_Samp_Fields = {
  __typename?: 'point_var_samp_fields';
  day_point_count?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "point" */
export type Point_Var_Samp_Order_By = {
  day_point_count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Point_Variance_Fields = {
  __typename?: 'point_variance_fields';
  day_point_count?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  value?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "point" */
export type Point_Variance_Order_By = {
  day_point_count?: InputMaybe<Order_By>;
  rate?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "address" */
  address: Array<Address>;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk?: Maybe<Address>;
  /** fetch data from the table: "campsite" */
  campsite: Array<Campsite>;
  /** fetch aggregated fields from the table: "campsite" */
  campsite_aggregate: Campsite_Aggregate;
  /** fetch data from the table: "campsite" using primary key columns */
  campsite_by_pk?: Maybe<Campsite>;
  /** An array relationship */
  campsite_likes: Array<Campsite_Likes>;
  /** An aggregate relationship */
  campsite_likes_aggregate: Campsite_Likes_Aggregate;
  /** fetch data from the table: "campsite_likes" using primary key columns */
  campsite_likes_by_pk?: Maybe<Campsite_Likes>;
  /** fetch data from the table: "fixed_exchange_product_exchanged" */
  fixed_exchange_product_exchanged: Array<Fixed_Exchange_Product_Exchanged>;
  /** fetch aggregated fields from the table: "fixed_exchange_product_exchanged" */
  fixed_exchange_product_exchanged_aggregate: Fixed_Exchange_Product_Exchanged_Aggregate;
  /** fetch data from the table: "fixed_exchange_product_exchanged" using primary key columns */
  fixed_exchange_product_exchanged_by_pk?: Maybe<Fixed_Exchange_Product_Exchanged>;
  /** fetch data from the table: "gacha" */
  gacha: Array<Gacha>;
  /** fetch data from the table: "gacha" using primary key columns */
  gacha_by_pk?: Maybe<Gacha>;
  /** fetch data from the table: "gacha_lose" */
  gacha_lose: Array<Gacha_Lose>;
  /** fetch aggregated fields from the table: "gacha_lose" */
  gacha_lose_aggregate: Gacha_Lose_Aggregate;
  /** fetch data from the table: "gacha_lose" using primary key columns */
  gacha_lose_by_pk?: Maybe<Gacha_Lose>;
  /** fetch data from the table: "image" */
  image: Array<Image>;
  /** fetch data from the table: "image" using primary key columns */
  image_by_pk?: Maybe<Image>;
  /** fetch data from the table: "physical_prize" */
  physical_prize: Array<Physical_Prize>;
  /** fetch aggregated fields from the table: "physical_prize" */
  physical_prize_aggregate: Physical_Prize_Aggregate;
  /** fetch data from the table: "physical_prize" using primary key columns */
  physical_prize_by_pk?: Maybe<Physical_Prize>;
  /** fetch data from the table: "physical_prize_delivery_address" */
  physical_prize_delivery_address: Array<Physical_Prize_Delivery_Address>;
  /** fetch aggregated fields from the table: "physical_prize_delivery_address" */
  physical_prize_delivery_address_aggregate: Physical_Prize_Delivery_Address_Aggregate;
  /** fetch data from the table: "physical_prize_delivery_address" using primary key columns */
  physical_prize_delivery_address_by_pk?: Maybe<Physical_Prize_Delivery_Address>;
  /** fetch data from the table: "point" */
  point: Array<Point>;
  /** fetch aggregated fields from the table: "point" */
  point_aggregate: Point_Aggregate;
  /** fetch data from the table: "point" using primary key columns */
  point_by_pk?: Maybe<Point>;
  /** fetch data from the table: "point_history" */
  point_history: Array<Point_History>;
  /** fetch aggregated fields from the table: "point_history" */
  point_history_aggregate: Point_History_Aggregate;
  /** fetch data from the table: "review" */
  review: Array<Review>;
  /** fetch aggregated fields from the table: "review" */
  review_aggregate: Review_Aggregate;
  /** fetch data from the table: "review" using primary key columns */
  review_by_pk?: Maybe<Review>;
  /** fetch data from the table: "review_good" */
  review_good: Array<Review_Good>;
  /** fetch aggregated fields from the table: "review_good" */
  review_good_aggregate: Review_Good_Aggregate;
  /** fetch data from the table: "review_good" using primary key columns */
  review_good_by_pk?: Maybe<Review_Good>;
  /** fetch data from the table: "review_image" */
  review_image: Array<Review_Image>;
  /** fetch aggregated fields from the table: "review_image" */
  review_image_aggregate: Review_Image_Aggregate;
  /** fetch data from the table: "review_image" using primary key columns */
  review_image_by_pk?: Maybe<Review_Image>;
  test?: Maybe<Scalars['String']>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table: "user_notification" */
  user_notification: Array<User_Notification>;
  /** fetch aggregated fields from the table: "user_notification" */
  user_notification_aggregate: User_Notification_Aggregate;
  /** fetch data from the table: "user_notification" using primary key columns */
  user_notification_by_pk?: Maybe<User_Notification>;
  /** fetch data from the table: "user_public" */
  user_public: Array<User_Public>;
  /** fetch data from the table: "visited" */
  visited: Array<Visited>;
  /** fetch aggregated fields from the table: "visited" */
  visited_aggregate: Visited_Aggregate;
  /** fetch data from the table: "visited" using primary key columns */
  visited_by_pk?: Maybe<Visited>;
};


export type Query_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Query_RootAddress_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootCampsiteArgs = {
  distinct_on?: InputMaybe<Array<Campsite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Campsite_Order_By>>;
  where?: InputMaybe<Campsite_Bool_Exp>;
};


export type Query_RootCampsite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campsite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Campsite_Order_By>>;
  where?: InputMaybe<Campsite_Bool_Exp>;
};


export type Query_RootCampsite_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootCampsite_LikesArgs = {
  distinct_on?: InputMaybe<Array<Campsite_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Campsite_Likes_Order_By>>;
  where?: InputMaybe<Campsite_Likes_Bool_Exp>;
};


export type Query_RootCampsite_Likes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campsite_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Campsite_Likes_Order_By>>;
  where?: InputMaybe<Campsite_Likes_Bool_Exp>;
};


export type Query_RootCampsite_Likes_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootFixed_Exchange_Product_ExchangedArgs = {
  distinct_on?: InputMaybe<Array<Fixed_Exchange_Product_Exchanged_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fixed_Exchange_Product_Exchanged_Order_By>>;
  where?: InputMaybe<Fixed_Exchange_Product_Exchanged_Bool_Exp>;
};


export type Query_RootFixed_Exchange_Product_Exchanged_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fixed_Exchange_Product_Exchanged_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fixed_Exchange_Product_Exchanged_Order_By>>;
  where?: InputMaybe<Fixed_Exchange_Product_Exchanged_Bool_Exp>;
};


export type Query_RootFixed_Exchange_Product_Exchanged_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootGachaArgs = {
  distinct_on?: InputMaybe<Array<Gacha_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gacha_Order_By>>;
  where?: InputMaybe<Gacha_Bool_Exp>;
};


export type Query_RootGacha_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootGacha_LoseArgs = {
  distinct_on?: InputMaybe<Array<Gacha_Lose_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gacha_Lose_Order_By>>;
  where?: InputMaybe<Gacha_Lose_Bool_Exp>;
};


export type Query_RootGacha_Lose_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gacha_Lose_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gacha_Lose_Order_By>>;
  where?: InputMaybe<Gacha_Lose_Bool_Exp>;
};


export type Query_RootGacha_Lose_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootImageArgs = {
  distinct_on?: InputMaybe<Array<Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Image_Order_By>>;
  where?: InputMaybe<Image_Bool_Exp>;
};


export type Query_RootImage_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootPhysical_PrizeArgs = {
  distinct_on?: InputMaybe<Array<Physical_Prize_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Physical_Prize_Order_By>>;
  where?: InputMaybe<Physical_Prize_Bool_Exp>;
};


export type Query_RootPhysical_Prize_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Physical_Prize_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Physical_Prize_Order_By>>;
  where?: InputMaybe<Physical_Prize_Bool_Exp>;
};


export type Query_RootPhysical_Prize_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootPhysical_Prize_Delivery_AddressArgs = {
  distinct_on?: InputMaybe<Array<Physical_Prize_Delivery_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Physical_Prize_Delivery_Address_Order_By>>;
  where?: InputMaybe<Physical_Prize_Delivery_Address_Bool_Exp>;
};


export type Query_RootPhysical_Prize_Delivery_Address_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Physical_Prize_Delivery_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Physical_Prize_Delivery_Address_Order_By>>;
  where?: InputMaybe<Physical_Prize_Delivery_Address_Bool_Exp>;
};


export type Query_RootPhysical_Prize_Delivery_Address_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootPointArgs = {
  distinct_on?: InputMaybe<Array<Point_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Point_Order_By>>;
  where?: InputMaybe<Point_Bool_Exp>;
};


export type Query_RootPoint_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Point_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Point_Order_By>>;
  where?: InputMaybe<Point_Bool_Exp>;
};


export type Query_RootPoint_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootPoint_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Point_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Point_History_Order_By>>;
  where?: InputMaybe<Point_History_Bool_Exp>;
};


export type Query_RootPoint_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Point_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Point_History_Order_By>>;
  where?: InputMaybe<Point_History_Bool_Exp>;
};


export type Query_RootReviewArgs = {
  distinct_on?: InputMaybe<Array<Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Order_By>>;
  where?: InputMaybe<Review_Bool_Exp>;
};


export type Query_RootReview_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Order_By>>;
  where?: InputMaybe<Review_Bool_Exp>;
};


export type Query_RootReview_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootReview_GoodArgs = {
  distinct_on?: InputMaybe<Array<Review_Good_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Good_Order_By>>;
  where?: InputMaybe<Review_Good_Bool_Exp>;
};


export type Query_RootReview_Good_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Good_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Good_Order_By>>;
  where?: InputMaybe<Review_Good_Bool_Exp>;
};


export type Query_RootReview_Good_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootReview_ImageArgs = {
  distinct_on?: InputMaybe<Array<Review_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Image_Order_By>>;
  where?: InputMaybe<Review_Image_Bool_Exp>;
};


export type Query_RootReview_Image_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Image_Order_By>>;
  where?: InputMaybe<Review_Image_Bool_Exp>;
};


export type Query_RootReview_Image_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Query_RootUser_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootUser_NotificationArgs = {
  distinct_on?: InputMaybe<Array<User_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Notification_Order_By>>;
  where?: InputMaybe<User_Notification_Bool_Exp>;
};


export type Query_RootUser_Notification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Notification_Order_By>>;
  where?: InputMaybe<User_Notification_Bool_Exp>;
};


export type Query_RootUser_Notification_By_PkArgs = {
  id: Scalars['String'];
};


export type Query_RootUser_PublicArgs = {
  distinct_on?: InputMaybe<Array<User_Public_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Public_Order_By>>;
  where?: InputMaybe<User_Public_Bool_Exp>;
};


export type Query_RootVisitedArgs = {
  distinct_on?: InputMaybe<Array<Visited_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Visited_Order_By>>;
  where?: InputMaybe<Visited_Bool_Exp>;
};


export type Query_RootVisited_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visited_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Visited_Order_By>>;
  where?: InputMaybe<Visited_Bool_Exp>;
};


export type Query_RootVisited_By_PkArgs = {
  id: Scalars['String'];
};

/** columns and relationships of "review" */
export type Review = {
  __typename?: 'review';
  /** An object relationship */
  campsite: Campsite;
  campsite_id: Scalars['String'];
  content: Scalars['String'];
  created_at: Scalars['timestamp'];
  id: Scalars['String'];
  public: Scalars['Boolean'];
  /** An array relationship */
  review_goods: Array<Review_Good>;
  /** An aggregate relationship */
  review_goods_aggregate: Review_Good_Aggregate;
  /** An array relationship */
  review_images: Array<Review_Image>;
  /** An aggregate relationship */
  review_images_aggregate: Review_Image_Aggregate;
  total_good_num: Scalars['Int'];
  updated_at: Scalars['timestamp'];
  /** An object relationship */
  user: User;
  user_id: Scalars['String'];
  /** An object relationship */
  user_public?: Maybe<User_Public>;
};


/** columns and relationships of "review" */
export type ReviewReview_GoodsArgs = {
  distinct_on?: InputMaybe<Array<Review_Good_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Good_Order_By>>;
  where?: InputMaybe<Review_Good_Bool_Exp>;
};


/** columns and relationships of "review" */
export type ReviewReview_Goods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Good_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Good_Order_By>>;
  where?: InputMaybe<Review_Good_Bool_Exp>;
};


/** columns and relationships of "review" */
export type ReviewReview_ImagesArgs = {
  distinct_on?: InputMaybe<Array<Review_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Image_Order_By>>;
  where?: InputMaybe<Review_Image_Bool_Exp>;
};


/** columns and relationships of "review" */
export type ReviewReview_Images_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Image_Order_By>>;
  where?: InputMaybe<Review_Image_Bool_Exp>;
};

/** aggregated selection of "review" */
export type Review_Aggregate = {
  __typename?: 'review_aggregate';
  aggregate?: Maybe<Review_Aggregate_Fields>;
  nodes: Array<Review>;
};

export type Review_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Review_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Review_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Review_Aggregate_Bool_Exp_Count>;
};

export type Review_Aggregate_Bool_Exp_Bool_And = {
  arguments: Review_Select_Column_Review_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Review_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Review_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Review_Select_Column_Review_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Review_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Review_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Review_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Review_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "review" */
export type Review_Aggregate_Fields = {
  __typename?: 'review_aggregate_fields';
  avg?: Maybe<Review_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Review_Max_Fields>;
  min?: Maybe<Review_Min_Fields>;
  stddev?: Maybe<Review_Stddev_Fields>;
  stddev_pop?: Maybe<Review_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Review_Stddev_Samp_Fields>;
  sum?: Maybe<Review_Sum_Fields>;
  var_pop?: Maybe<Review_Var_Pop_Fields>;
  var_samp?: Maybe<Review_Var_Samp_Fields>;
  variance?: Maybe<Review_Variance_Fields>;
};


/** aggregate fields of "review" */
export type Review_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Review_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "review" */
export type Review_Aggregate_Order_By = {
  avg?: InputMaybe<Review_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Review_Max_Order_By>;
  min?: InputMaybe<Review_Min_Order_By>;
  stddev?: InputMaybe<Review_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Review_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Review_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Review_Sum_Order_By>;
  var_pop?: InputMaybe<Review_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Review_Var_Samp_Order_By>;
  variance?: InputMaybe<Review_Variance_Order_By>;
};

/** aggregate avg on columns */
export type Review_Avg_Fields = {
  __typename?: 'review_avg_fields';
  total_good_num?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "review" */
export type Review_Avg_Order_By = {
  total_good_num?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "review". All fields are combined with a logical 'AND'. */
export type Review_Bool_Exp = {
  _and?: InputMaybe<Array<Review_Bool_Exp>>;
  _not?: InputMaybe<Review_Bool_Exp>;
  _or?: InputMaybe<Array<Review_Bool_Exp>>;
  campsite?: InputMaybe<Campsite_Bool_Exp>;
  campsite_id?: InputMaybe<String_Comparison_Exp>;
  content?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  public?: InputMaybe<Boolean_Comparison_Exp>;
  review_goods?: InputMaybe<Review_Good_Bool_Exp>;
  review_goods_aggregate?: InputMaybe<Review_Good_Aggregate_Bool_Exp>;
  review_images?: InputMaybe<Review_Image_Bool_Exp>;
  review_images_aggregate?: InputMaybe<Review_Image_Aggregate_Bool_Exp>;
  total_good_num?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
  user_public?: InputMaybe<User_Public_Bool_Exp>;
};

/** unique or primary key constraints on table "review" */
export enum Review_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReviewPkey = 'review_pkey'
}

/** columns and relationships of "review_good" */
export type Review_Good = {
  __typename?: 'review_good';
  created_at: Scalars['timestamp'];
  for_review_id: Scalars['String'];
  from_user_id: Scalars['String'];
  id: Scalars['String'];
  /** An object relationship */
  review: Review;
  /** An object relationship */
  user: User;
};

/** aggregated selection of "review_good" */
export type Review_Good_Aggregate = {
  __typename?: 'review_good_aggregate';
  aggregate?: Maybe<Review_Good_Aggregate_Fields>;
  nodes: Array<Review_Good>;
};

export type Review_Good_Aggregate_Bool_Exp = {
  count?: InputMaybe<Review_Good_Aggregate_Bool_Exp_Count>;
};

export type Review_Good_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Review_Good_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Review_Good_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "review_good" */
export type Review_Good_Aggregate_Fields = {
  __typename?: 'review_good_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Review_Good_Max_Fields>;
  min?: Maybe<Review_Good_Min_Fields>;
};


/** aggregate fields of "review_good" */
export type Review_Good_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Review_Good_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "review_good" */
export type Review_Good_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Review_Good_Max_Order_By>;
  min?: InputMaybe<Review_Good_Min_Order_By>;
};

/** input type for inserting array relation for remote table "review_good" */
export type Review_Good_Arr_Rel_Insert_Input = {
  data: Array<Review_Good_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Review_Good_On_Conflict>;
};

/** Boolean expression to filter rows from the table "review_good". All fields are combined with a logical 'AND'. */
export type Review_Good_Bool_Exp = {
  _and?: InputMaybe<Array<Review_Good_Bool_Exp>>;
  _not?: InputMaybe<Review_Good_Bool_Exp>;
  _or?: InputMaybe<Array<Review_Good_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  for_review_id?: InputMaybe<String_Comparison_Exp>;
  from_user_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  review?: InputMaybe<Review_Bool_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
};

/** unique or primary key constraints on table "review_good" */
export enum Review_Good_Constraint {
  /** unique or primary key constraint on columns "for_review_id", "from_user_id" */
  ReviewGoodFromUserIdForReviewIdKey = 'review_good_from_user_id_for_review_id_key',
  /** unique or primary key constraint on columns "id" */
  ReviewGoodPkey = 'review_good_pkey'
}

/** input type for inserting data into table "review_good" */
export type Review_Good_Insert_Input = {
  for_review_id?: InputMaybe<Scalars['String']>;
  from_user_id?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<Review_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Review_Good_Max_Fields = {
  __typename?: 'review_good_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  for_review_id?: Maybe<Scalars['String']>;
  from_user_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "review_good" */
export type Review_Good_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  for_review_id?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Review_Good_Min_Fields = {
  __typename?: 'review_good_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  for_review_id?: Maybe<Scalars['String']>;
  from_user_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "review_good" */
export type Review_Good_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  for_review_id?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "review_good" */
export type Review_Good_Mutation_Response = {
  __typename?: 'review_good_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Review_Good>;
};

/** on_conflict condition type for table "review_good" */
export type Review_Good_On_Conflict = {
  constraint: Review_Good_Constraint;
  update_columns?: Array<Review_Good_Update_Column>;
  where?: InputMaybe<Review_Good_Bool_Exp>;
};

/** Ordering options when selecting data from "review_good". */
export type Review_Good_Order_By = {
  created_at?: InputMaybe<Order_By>;
  for_review_id?: InputMaybe<Order_By>;
  from_user_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  review?: InputMaybe<Review_Order_By>;
  user?: InputMaybe<User_Order_By>;
};

/** select columns of table "review_good" */
export enum Review_Good_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ForReviewId = 'for_review_id',
  /** column name */
  FromUserId = 'from_user_id',
  /** column name */
  Id = 'id'
}

/** Streaming cursor of the table "review_good" */
export type Review_Good_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Review_Good_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Review_Good_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  for_review_id?: InputMaybe<Scalars['String']>;
  from_user_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

/** placeholder for update columns of table "review_good" (current role has no relevant permissions) */
export enum Review_Good_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** columns and relationships of "review_image" */
export type Review_Image = {
  __typename?: 'review_image';
  created_at: Scalars['timestamp'];
  id: Scalars['String'];
  /** An object relationship */
  image: Image;
  image_id: Scalars['String'];
  /** An object relationship */
  review: Review;
  review_id: Scalars['String'];
  updated_at: Scalars['timestamp'];
};

/** aggregated selection of "review_image" */
export type Review_Image_Aggregate = {
  __typename?: 'review_image_aggregate';
  aggregate?: Maybe<Review_Image_Aggregate_Fields>;
  nodes: Array<Review_Image>;
};

export type Review_Image_Aggregate_Bool_Exp = {
  count?: InputMaybe<Review_Image_Aggregate_Bool_Exp_Count>;
};

export type Review_Image_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Review_Image_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Review_Image_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "review_image" */
export type Review_Image_Aggregate_Fields = {
  __typename?: 'review_image_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Review_Image_Max_Fields>;
  min?: Maybe<Review_Image_Min_Fields>;
};


/** aggregate fields of "review_image" */
export type Review_Image_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Review_Image_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "review_image" */
export type Review_Image_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Review_Image_Max_Order_By>;
  min?: InputMaybe<Review_Image_Min_Order_By>;
};

/** input type for inserting array relation for remote table "review_image" */
export type Review_Image_Arr_Rel_Insert_Input = {
  data: Array<Review_Image_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Review_Image_On_Conflict>;
};

/** Boolean expression to filter rows from the table "review_image". All fields are combined with a logical 'AND'. */
export type Review_Image_Bool_Exp = {
  _and?: InputMaybe<Array<Review_Image_Bool_Exp>>;
  _not?: InputMaybe<Review_Image_Bool_Exp>;
  _or?: InputMaybe<Array<Review_Image_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  image?: InputMaybe<Image_Bool_Exp>;
  image_id?: InputMaybe<String_Comparison_Exp>;
  review?: InputMaybe<Review_Bool_Exp>;
  review_id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "review_image" */
export enum Review_Image_Constraint {
  /** unique or primary key constraint on columns "id" */
  ReviewImagePkey = 'review_image_pkey'
}

/** input type for inserting data into table "review_image" */
export type Review_Image_Insert_Input = {
  image?: InputMaybe<Image_Obj_Rel_Insert_Input>;
  image_id?: InputMaybe<Scalars['String']>;
  review?: InputMaybe<Review_Obj_Rel_Insert_Input>;
  review_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Review_Image_Max_Fields = {
  __typename?: 'review_image_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  image_id?: Maybe<Scalars['String']>;
  review_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** order by max() on columns of table "review_image" */
export type Review_Image_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  review_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Review_Image_Min_Fields = {
  __typename?: 'review_image_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  image_id?: Maybe<Scalars['String']>;
  review_id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
};

/** order by min() on columns of table "review_image" */
export type Review_Image_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image_id?: InputMaybe<Order_By>;
  review_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "review_image" */
export type Review_Image_Mutation_Response = {
  __typename?: 'review_image_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Review_Image>;
};

/** on_conflict condition type for table "review_image" */
export type Review_Image_On_Conflict = {
  constraint: Review_Image_Constraint;
  update_columns?: Array<Review_Image_Update_Column>;
  where?: InputMaybe<Review_Image_Bool_Exp>;
};

/** Ordering options when selecting data from "review_image". */
export type Review_Image_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  image?: InputMaybe<Image_Order_By>;
  image_id?: InputMaybe<Order_By>;
  review?: InputMaybe<Review_Order_By>;
  review_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** select columns of table "review_image" */
export enum Review_Image_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ImageId = 'image_id',
  /** column name */
  ReviewId = 'review_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** Streaming cursor of the table "review_image" */
export type Review_Image_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Review_Image_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Review_Image_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  image_id?: InputMaybe<Scalars['String']>;
  review_id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
};

/** placeholder for update columns of table "review_image" (current role has no relevant permissions) */
export enum Review_Image_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

/** input type for inserting data into table "review" */
export type Review_Insert_Input = {
  campsite_id?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
  review_goods?: InputMaybe<Review_Good_Arr_Rel_Insert_Input>;
  review_images?: InputMaybe<Review_Image_Arr_Rel_Insert_Input>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Review_Max_Fields = {
  __typename?: 'review_max_fields';
  campsite_id?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  total_good_num?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "review" */
export type Review_Max_Order_By = {
  campsite_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  total_good_num?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Review_Min_Fields = {
  __typename?: 'review_min_fields';
  campsite_id?: Maybe<Scalars['String']>;
  content?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  total_good_num?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "review" */
export type Review_Min_Order_By = {
  campsite_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  total_good_num?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "review" */
export type Review_Mutation_Response = {
  __typename?: 'review_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Review>;
};

/** input type for inserting object relation for remote table "review" */
export type Review_Obj_Rel_Insert_Input = {
  data: Review_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Review_On_Conflict>;
};

/** on_conflict condition type for table "review" */
export type Review_On_Conflict = {
  constraint: Review_Constraint;
  update_columns?: Array<Review_Update_Column>;
  where?: InputMaybe<Review_Bool_Exp>;
};

/** Ordering options when selecting data from "review". */
export type Review_Order_By = {
  campsite?: InputMaybe<Campsite_Order_By>;
  campsite_id?: InputMaybe<Order_By>;
  content?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  public?: InputMaybe<Order_By>;
  review_goods_aggregate?: InputMaybe<Review_Good_Aggregate_Order_By>;
  review_images_aggregate?: InputMaybe<Review_Image_Aggregate_Order_By>;
  total_good_num?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
  user_public?: InputMaybe<User_Public_Order_By>;
};

/** primary key columns input for table: review */
export type Review_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "review" */
export enum Review_Select_Column {
  /** column name */
  CampsiteId = 'campsite_id',
  /** column name */
  Content = 'content',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Public = 'public',
  /** column name */
  TotalGoodNum = 'total_good_num',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select "review_aggregate_bool_exp_bool_and_arguments_columns" columns of table "review" */
export enum Review_Select_Column_Review_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Public = 'public'
}

/** select "review_aggregate_bool_exp_bool_or_arguments_columns" columns of table "review" */
export enum Review_Select_Column_Review_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Public = 'public'
}

/** input type for updating data in table "review" */
export type Review_Set_Input = {
  content?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Review_Stddev_Fields = {
  __typename?: 'review_stddev_fields';
  total_good_num?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "review" */
export type Review_Stddev_Order_By = {
  total_good_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Review_Stddev_Pop_Fields = {
  __typename?: 'review_stddev_pop_fields';
  total_good_num?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "review" */
export type Review_Stddev_Pop_Order_By = {
  total_good_num?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Review_Stddev_Samp_Fields = {
  __typename?: 'review_stddev_samp_fields';
  total_good_num?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "review" */
export type Review_Stddev_Samp_Order_By = {
  total_good_num?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "review" */
export type Review_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Review_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Review_Stream_Cursor_Value_Input = {
  campsite_id?: InputMaybe<Scalars['String']>;
  content?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  public?: InputMaybe<Scalars['Boolean']>;
  total_good_num?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Review_Sum_Fields = {
  __typename?: 'review_sum_fields';
  total_good_num?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "review" */
export type Review_Sum_Order_By = {
  total_good_num?: InputMaybe<Order_By>;
};

/** update columns of table "review" */
export enum Review_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  Public = 'public'
}

export type Review_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Review_Set_Input>;
  /** filter the rows which have to be updated */
  where: Review_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Review_Var_Pop_Fields = {
  __typename?: 'review_var_pop_fields';
  total_good_num?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "review" */
export type Review_Var_Pop_Order_By = {
  total_good_num?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Review_Var_Samp_Fields = {
  __typename?: 'review_var_samp_fields';
  total_good_num?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "review" */
export type Review_Var_Samp_Order_By = {
  total_good_num?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Review_Variance_Fields = {
  __typename?: 'review_variance_fields';
  total_good_num?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "review" */
export type Review_Variance_Order_By = {
  total_good_num?: InputMaybe<Order_By>;
};

export type Submit_Physical_Prize_Delivery_Address_Args = {
  target_building?: InputMaybe<Scalars['String']>;
  target_city?: InputMaybe<Scalars['String']>;
  target_name?: InputMaybe<Scalars['String']>;
  target_physical_prize_id?: InputMaybe<Scalars['String']>;
  target_postal_code?: InputMaybe<Scalars['String']>;
  target_prefecture?: InputMaybe<Scalars['String']>;
  target_street?: InputMaybe<Scalars['String']>;
  target_tel_body?: InputMaybe<Scalars['String']>;
  target_tel_head?: InputMaybe<Scalars['String']>;
  target_tel_tail?: InputMaybe<Scalars['String']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "address" */
  address: Array<Address>;
  /** fetch data from the table: "address" using primary key columns */
  address_by_pk?: Maybe<Address>;
  /** fetch data from the table in a streaming manner: "address" */
  address_stream: Array<Address>;
  /** fetch data from the table: "campsite" */
  campsite: Array<Campsite>;
  /** fetch aggregated fields from the table: "campsite" */
  campsite_aggregate: Campsite_Aggregate;
  /** fetch data from the table: "campsite" using primary key columns */
  campsite_by_pk?: Maybe<Campsite>;
  /** An array relationship */
  campsite_likes: Array<Campsite_Likes>;
  /** An aggregate relationship */
  campsite_likes_aggregate: Campsite_Likes_Aggregate;
  /** fetch data from the table: "campsite_likes" using primary key columns */
  campsite_likes_by_pk?: Maybe<Campsite_Likes>;
  /** fetch data from the table in a streaming manner: "campsite_likes" */
  campsite_likes_stream: Array<Campsite_Likes>;
  /** fetch data from the table in a streaming manner: "campsite" */
  campsite_stream: Array<Campsite>;
  /** fetch data from the table: "fixed_exchange_product_exchanged" */
  fixed_exchange_product_exchanged: Array<Fixed_Exchange_Product_Exchanged>;
  /** fetch aggregated fields from the table: "fixed_exchange_product_exchanged" */
  fixed_exchange_product_exchanged_aggregate: Fixed_Exchange_Product_Exchanged_Aggregate;
  /** fetch data from the table: "fixed_exchange_product_exchanged" using primary key columns */
  fixed_exchange_product_exchanged_by_pk?: Maybe<Fixed_Exchange_Product_Exchanged>;
  /** fetch data from the table in a streaming manner: "fixed_exchange_product_exchanged" */
  fixed_exchange_product_exchanged_stream: Array<Fixed_Exchange_Product_Exchanged>;
  /** fetch data from the table: "gacha" */
  gacha: Array<Gacha>;
  /** fetch data from the table: "gacha" using primary key columns */
  gacha_by_pk?: Maybe<Gacha>;
  /** fetch data from the table: "gacha_lose" */
  gacha_lose: Array<Gacha_Lose>;
  /** fetch aggregated fields from the table: "gacha_lose" */
  gacha_lose_aggregate: Gacha_Lose_Aggregate;
  /** fetch data from the table: "gacha_lose" using primary key columns */
  gacha_lose_by_pk?: Maybe<Gacha_Lose>;
  /** fetch data from the table in a streaming manner: "gacha_lose" */
  gacha_lose_stream: Array<Gacha_Lose>;
  /** fetch data from the table in a streaming manner: "gacha" */
  gacha_stream: Array<Gacha>;
  /** fetch data from the table: "image" */
  image: Array<Image>;
  /** fetch data from the table: "image" using primary key columns */
  image_by_pk?: Maybe<Image>;
  /** fetch data from the table in a streaming manner: "image" */
  image_stream: Array<Image>;
  /** fetch data from the table: "physical_prize" */
  physical_prize: Array<Physical_Prize>;
  /** fetch aggregated fields from the table: "physical_prize" */
  physical_prize_aggregate: Physical_Prize_Aggregate;
  /** fetch data from the table: "physical_prize" using primary key columns */
  physical_prize_by_pk?: Maybe<Physical_Prize>;
  /** fetch data from the table: "physical_prize_delivery_address" */
  physical_prize_delivery_address: Array<Physical_Prize_Delivery_Address>;
  /** fetch aggregated fields from the table: "physical_prize_delivery_address" */
  physical_prize_delivery_address_aggregate: Physical_Prize_Delivery_Address_Aggregate;
  /** fetch data from the table: "physical_prize_delivery_address" using primary key columns */
  physical_prize_delivery_address_by_pk?: Maybe<Physical_Prize_Delivery_Address>;
  /** fetch data from the table in a streaming manner: "physical_prize_delivery_address" */
  physical_prize_delivery_address_stream: Array<Physical_Prize_Delivery_Address>;
  /** fetch data from the table in a streaming manner: "physical_prize" */
  physical_prize_stream: Array<Physical_Prize>;
  /** fetch data from the table: "point" */
  point: Array<Point>;
  /** fetch aggregated fields from the table: "point" */
  point_aggregate: Point_Aggregate;
  /** fetch data from the table: "point" using primary key columns */
  point_by_pk?: Maybe<Point>;
  /** fetch data from the table: "point_history" */
  point_history: Array<Point_History>;
  /** fetch aggregated fields from the table: "point_history" */
  point_history_aggregate: Point_History_Aggregate;
  /** fetch data from the table in a streaming manner: "point_history" */
  point_history_stream: Array<Point_History>;
  /** fetch data from the table in a streaming manner: "point" */
  point_stream: Array<Point>;
  /** fetch data from the table: "review" */
  review: Array<Review>;
  /** fetch aggregated fields from the table: "review" */
  review_aggregate: Review_Aggregate;
  /** fetch data from the table: "review" using primary key columns */
  review_by_pk?: Maybe<Review>;
  /** fetch data from the table: "review_good" */
  review_good: Array<Review_Good>;
  /** fetch aggregated fields from the table: "review_good" */
  review_good_aggregate: Review_Good_Aggregate;
  /** fetch data from the table: "review_good" using primary key columns */
  review_good_by_pk?: Maybe<Review_Good>;
  /** fetch data from the table in a streaming manner: "review_good" */
  review_good_stream: Array<Review_Good>;
  /** fetch data from the table: "review_image" */
  review_image: Array<Review_Image>;
  /** fetch aggregated fields from the table: "review_image" */
  review_image_aggregate: Review_Image_Aggregate;
  /** fetch data from the table: "review_image" using primary key columns */
  review_image_by_pk?: Maybe<Review_Image>;
  /** fetch data from the table in a streaming manner: "review_image" */
  review_image_stream: Array<Review_Image>;
  /** fetch data from the table in a streaming manner: "review" */
  review_stream: Array<Review>;
  /** fetch data from the table: "user" */
  user: Array<User>;
  /** fetch data from the table: "user" using primary key columns */
  user_by_pk?: Maybe<User>;
  /** fetch data from the table: "user_notification" */
  user_notification: Array<User_Notification>;
  /** fetch aggregated fields from the table: "user_notification" */
  user_notification_aggregate: User_Notification_Aggregate;
  /** fetch data from the table: "user_notification" using primary key columns */
  user_notification_by_pk?: Maybe<User_Notification>;
  /** fetch data from the table in a streaming manner: "user_notification" */
  user_notification_stream: Array<User_Notification>;
  /** fetch data from the table: "user_public" */
  user_public: Array<User_Public>;
  /** fetch data from the table in a streaming manner: "user_public" */
  user_public_stream: Array<User_Public>;
  /** fetch data from the table in a streaming manner: "user" */
  user_stream: Array<User>;
  /** fetch data from the table: "visited" */
  visited: Array<Visited>;
  /** fetch aggregated fields from the table: "visited" */
  visited_aggregate: Visited_Aggregate;
  /** fetch data from the table: "visited" using primary key columns */
  visited_by_pk?: Maybe<Visited>;
  /** fetch data from the table in a streaming manner: "visited" */
  visited_stream: Array<Visited>;
};


export type Subscription_RootAddressArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootAddress_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootAddress_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Address_Stream_Cursor_Input>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


export type Subscription_RootCampsiteArgs = {
  distinct_on?: InputMaybe<Array<Campsite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Campsite_Order_By>>;
  where?: InputMaybe<Campsite_Bool_Exp>;
};


export type Subscription_RootCampsite_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campsite_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Campsite_Order_By>>;
  where?: InputMaybe<Campsite_Bool_Exp>;
};


export type Subscription_RootCampsite_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootCampsite_LikesArgs = {
  distinct_on?: InputMaybe<Array<Campsite_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Campsite_Likes_Order_By>>;
  where?: InputMaybe<Campsite_Likes_Bool_Exp>;
};


export type Subscription_RootCampsite_Likes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campsite_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Campsite_Likes_Order_By>>;
  where?: InputMaybe<Campsite_Likes_Bool_Exp>;
};


export type Subscription_RootCampsite_Likes_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootCampsite_Likes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Campsite_Likes_Stream_Cursor_Input>>;
  where?: InputMaybe<Campsite_Likes_Bool_Exp>;
};


export type Subscription_RootCampsite_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Campsite_Stream_Cursor_Input>>;
  where?: InputMaybe<Campsite_Bool_Exp>;
};


export type Subscription_RootFixed_Exchange_Product_ExchangedArgs = {
  distinct_on?: InputMaybe<Array<Fixed_Exchange_Product_Exchanged_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fixed_Exchange_Product_Exchanged_Order_By>>;
  where?: InputMaybe<Fixed_Exchange_Product_Exchanged_Bool_Exp>;
};


export type Subscription_RootFixed_Exchange_Product_Exchanged_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fixed_Exchange_Product_Exchanged_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fixed_Exchange_Product_Exchanged_Order_By>>;
  where?: InputMaybe<Fixed_Exchange_Product_Exchanged_Bool_Exp>;
};


export type Subscription_RootFixed_Exchange_Product_Exchanged_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootFixed_Exchange_Product_Exchanged_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Fixed_Exchange_Product_Exchanged_Stream_Cursor_Input>>;
  where?: InputMaybe<Fixed_Exchange_Product_Exchanged_Bool_Exp>;
};


export type Subscription_RootGachaArgs = {
  distinct_on?: InputMaybe<Array<Gacha_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gacha_Order_By>>;
  where?: InputMaybe<Gacha_Bool_Exp>;
};


export type Subscription_RootGacha_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootGacha_LoseArgs = {
  distinct_on?: InputMaybe<Array<Gacha_Lose_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gacha_Lose_Order_By>>;
  where?: InputMaybe<Gacha_Lose_Bool_Exp>;
};


export type Subscription_RootGacha_Lose_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gacha_Lose_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gacha_Lose_Order_By>>;
  where?: InputMaybe<Gacha_Lose_Bool_Exp>;
};


export type Subscription_RootGacha_Lose_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootGacha_Lose_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Gacha_Lose_Stream_Cursor_Input>>;
  where?: InputMaybe<Gacha_Lose_Bool_Exp>;
};


export type Subscription_RootGacha_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Gacha_Stream_Cursor_Input>>;
  where?: InputMaybe<Gacha_Bool_Exp>;
};


export type Subscription_RootImageArgs = {
  distinct_on?: InputMaybe<Array<Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Image_Order_By>>;
  where?: InputMaybe<Image_Bool_Exp>;
};


export type Subscription_RootImage_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootImage_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Image_Stream_Cursor_Input>>;
  where?: InputMaybe<Image_Bool_Exp>;
};


export type Subscription_RootPhysical_PrizeArgs = {
  distinct_on?: InputMaybe<Array<Physical_Prize_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Physical_Prize_Order_By>>;
  where?: InputMaybe<Physical_Prize_Bool_Exp>;
};


export type Subscription_RootPhysical_Prize_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Physical_Prize_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Physical_Prize_Order_By>>;
  where?: InputMaybe<Physical_Prize_Bool_Exp>;
};


export type Subscription_RootPhysical_Prize_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootPhysical_Prize_Delivery_AddressArgs = {
  distinct_on?: InputMaybe<Array<Physical_Prize_Delivery_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Physical_Prize_Delivery_Address_Order_By>>;
  where?: InputMaybe<Physical_Prize_Delivery_Address_Bool_Exp>;
};


export type Subscription_RootPhysical_Prize_Delivery_Address_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Physical_Prize_Delivery_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Physical_Prize_Delivery_Address_Order_By>>;
  where?: InputMaybe<Physical_Prize_Delivery_Address_Bool_Exp>;
};


export type Subscription_RootPhysical_Prize_Delivery_Address_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootPhysical_Prize_Delivery_Address_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Physical_Prize_Delivery_Address_Stream_Cursor_Input>>;
  where?: InputMaybe<Physical_Prize_Delivery_Address_Bool_Exp>;
};


export type Subscription_RootPhysical_Prize_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Physical_Prize_Stream_Cursor_Input>>;
  where?: InputMaybe<Physical_Prize_Bool_Exp>;
};


export type Subscription_RootPointArgs = {
  distinct_on?: InputMaybe<Array<Point_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Point_Order_By>>;
  where?: InputMaybe<Point_Bool_Exp>;
};


export type Subscription_RootPoint_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Point_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Point_Order_By>>;
  where?: InputMaybe<Point_Bool_Exp>;
};


export type Subscription_RootPoint_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootPoint_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Point_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Point_History_Order_By>>;
  where?: InputMaybe<Point_History_Bool_Exp>;
};


export type Subscription_RootPoint_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Point_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Point_History_Order_By>>;
  where?: InputMaybe<Point_History_Bool_Exp>;
};


export type Subscription_RootPoint_History_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Point_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Point_History_Bool_Exp>;
};


export type Subscription_RootPoint_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Point_Stream_Cursor_Input>>;
  where?: InputMaybe<Point_Bool_Exp>;
};


export type Subscription_RootReviewArgs = {
  distinct_on?: InputMaybe<Array<Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Order_By>>;
  where?: InputMaybe<Review_Bool_Exp>;
};


export type Subscription_RootReview_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Order_By>>;
  where?: InputMaybe<Review_Bool_Exp>;
};


export type Subscription_RootReview_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootReview_GoodArgs = {
  distinct_on?: InputMaybe<Array<Review_Good_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Good_Order_By>>;
  where?: InputMaybe<Review_Good_Bool_Exp>;
};


export type Subscription_RootReview_Good_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Good_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Good_Order_By>>;
  where?: InputMaybe<Review_Good_Bool_Exp>;
};


export type Subscription_RootReview_Good_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootReview_Good_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Review_Good_Stream_Cursor_Input>>;
  where?: InputMaybe<Review_Good_Bool_Exp>;
};


export type Subscription_RootReview_ImageArgs = {
  distinct_on?: InputMaybe<Array<Review_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Image_Order_By>>;
  where?: InputMaybe<Review_Image_Bool_Exp>;
};


export type Subscription_RootReview_Image_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Image_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Image_Order_By>>;
  where?: InputMaybe<Review_Image_Bool_Exp>;
};


export type Subscription_RootReview_Image_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootReview_Image_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Review_Image_Stream_Cursor_Input>>;
  where?: InputMaybe<Review_Image_Bool_Exp>;
};


export type Subscription_RootReview_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Review_Stream_Cursor_Input>>;
  where?: InputMaybe<Review_Bool_Exp>;
};


export type Subscription_RootUserArgs = {
  distinct_on?: InputMaybe<Array<User_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Order_By>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootUser_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUser_NotificationArgs = {
  distinct_on?: InputMaybe<Array<User_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Notification_Order_By>>;
  where?: InputMaybe<User_Notification_Bool_Exp>;
};


export type Subscription_RootUser_Notification_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Notification_Order_By>>;
  where?: InputMaybe<User_Notification_Bool_Exp>;
};


export type Subscription_RootUser_Notification_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUser_Notification_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Notification_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Notification_Bool_Exp>;
};


export type Subscription_RootUser_PublicArgs = {
  distinct_on?: InputMaybe<Array<User_Public_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Public_Order_By>>;
  where?: InputMaybe<User_Public_Bool_Exp>;
};


export type Subscription_RootUser_Public_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Public_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Public_Bool_Exp>;
};


export type Subscription_RootUser_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Bool_Exp>;
};


export type Subscription_RootVisitedArgs = {
  distinct_on?: InputMaybe<Array<Visited_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Visited_Order_By>>;
  where?: InputMaybe<Visited_Bool_Exp>;
};


export type Subscription_RootVisited_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visited_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Visited_Order_By>>;
  where?: InputMaybe<Visited_Bool_Exp>;
};


export type Subscription_RootVisited_By_PkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootVisited_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Visited_Stream_Cursor_Input>>;
  where?: InputMaybe<Visited_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

export type Update_Campsite_Info_Args = {
  target_campsite_id?: InputMaybe<Scalars['String']>;
  v_activity_athletic?: InputMaybe<Scalars['Boolean']>;
  v_activity_bbq?: InputMaybe<Scalars['Boolean']>;
  v_activity_bicycle?: InputMaybe<Scalars['Boolean']>;
  v_activity_canoe?: InputMaybe<Scalars['Boolean']>;
  v_activity_craft?: InputMaybe<Scalars['Boolean']>;
  v_activity_fishing?: InputMaybe<Scalars['Boolean']>;
  v_activity_flower?: InputMaybe<Scalars['Boolean']>;
  v_activity_hiking?: InputMaybe<Scalars['Boolean']>;
  v_activity_insect?: InputMaybe<Scalars['Boolean']>;
  v_activity_playset?: InputMaybe<Scalars['Boolean']>;
  v_activity_pool?: InputMaybe<Scalars['Boolean']>;
  v_activity_ranch?: InputMaybe<Scalars['Boolean']>;
  v_activity_river?: InputMaybe<Scalars['Boolean']>;
  v_activity_sauna?: InputMaybe<Scalars['Boolean']>;
  v_activity_sea?: InputMaybe<Scalars['Boolean']>;
  v_activity_star?: InputMaybe<Scalars['Boolean']>;
  v_activity_taste?: InputMaybe<Scalars['Boolean']>;
  v_activity_tentsauna?: InputMaybe<Scalars['Boolean']>;
  v_bath_hotspring?: InputMaybe<Scalars['Boolean']>;
  v_bath_room?: InputMaybe<Scalars['Boolean']>;
  v_business_newyear?: InputMaybe<Scalars['Boolean']>;
  v_business_period?: InputMaybe<Scalars['Boolean']>;
  v_checkin_end_hour?: InputMaybe<Scalars['String']>;
  v_checkin_end_minute?: InputMaybe<Scalars['String']>;
  v_checkin_start_hour?: InputMaybe<Scalars['String']>;
  v_checkin_start_minute?: InputMaybe<Scalars['String']>;
  v_checkout_end_hour?: InputMaybe<Scalars['String']>;
  v_checkout_end_minute?: InputMaybe<Scalars['String']>;
  v_checkout_start_hour?: InputMaybe<Scalars['String']>;
  v_checkout_start_minute?: InputMaybe<Scalars['String']>;
  v_closed_friday?: InputMaybe<Scalars['Boolean']>;
  v_closed_holiday?: InputMaybe<Scalars['Boolean']>;
  v_closed_irregular?: InputMaybe<Scalars['Boolean']>;
  v_closed_monday?: InputMaybe<Scalars['Boolean']>;
  v_closed_not?: InputMaybe<Scalars['Boolean']>;
  v_closed_saturday?: InputMaybe<Scalars['Boolean']>;
  v_closed_sunday?: InputMaybe<Scalars['Boolean']>;
  v_closed_thursday?: InputMaybe<Scalars['Boolean']>;
  v_closed_tuesday?: InputMaybe<Scalars['Boolean']>;
  v_closed_wednesday?: InputMaybe<Scalars['Boolean']>;
  v_facilities_barrierfree?: InputMaybe<Scalars['Boolean']>;
  v_facilities_dogrun?: InputMaybe<Scalars['Boolean']>;
  v_facilities_laundry?: InputMaybe<Scalars['Boolean']>;
  v_facilities_restaurant?: InputMaybe<Scalars['Boolean']>;
  v_facilities_store?: InputMaybe<Scalars['Boolean']>;
  v_facilities_workspace?: InputMaybe<Scalars['Boolean']>;
  v_facility_acsite?: InputMaybe<Scalars['Boolean']>;
  v_facility_bungalow?: InputMaybe<Scalars['Boolean']>;
  v_facility_cottage?: InputMaybe<Scalars['Boolean']>;
  v_facility_freesite?: InputMaybe<Scalars['Boolean']>;
  v_facility_glamping?: InputMaybe<Scalars['Boolean']>;
  v_facility_privatesite?: InputMaybe<Scalars['Boolean']>;
  v_facility_sectionsite?: InputMaybe<Scalars['Boolean']>;
  v_facility_solo?: InputMaybe<Scalars['Boolean']>;
  v_facility_tipi?: InputMaybe<Scalars['Boolean']>;
  v_facility_trailerhouse?: InputMaybe<Scalars['Boolean']>;
  v_facility_treehouse?: InputMaybe<Scalars['Boolean']>;
  v_introduction_content?: InputMaybe<Scalars['String']>;
  v_introduction_title?: InputMaybe<Scalars['String']>;
  v_location_forest?: InputMaybe<Scalars['Boolean']>;
  v_location_hill?: InputMaybe<Scalars['Boolean']>;
  v_location_lake?: InputMaybe<Scalars['Boolean']>;
  v_location_meadow?: InputMaybe<Scalars['Boolean']>;
  v_location_ocean?: InputMaybe<Scalars['Boolean']>;
  v_location_park?: InputMaybe<Scalars['Boolean']>;
  v_location_plateau?: InputMaybe<Scalars['Boolean']>;
  v_location_river?: InputMaybe<Scalars['Boolean']>;
  v_main_image_id?: InputMaybe<Scalars['String']>;
  v_official_url?: InputMaybe<Scalars['String']>;
  v_service_firewood?: InputMaybe<Scalars['Boolean']>;
  v_service_firework?: InputMaybe<Scalars['Boolean']>;
  v_service_freecharge?: InputMaybe<Scalars['Boolean']>;
  v_service_garbage?: InputMaybe<Scalars['Boolean']>;
  v_service_group?: InputMaybe<Scalars['Boolean']>;
  v_service_hotwater?: InputMaybe<Scalars['Boolean']>;
  v_service_openfire?: InputMaybe<Scalars['Boolean']>;
  v_service_pet?: InputMaybe<Scalars['Boolean']>;
  v_service_rental?: InputMaybe<Scalars['Boolean']>;
  v_service_washlet?: InputMaybe<Scalars['Boolean']>;
  v_service_wifi?: InputMaybe<Scalars['Boolean']>;
  v_tel_bottom?: InputMaybe<Scalars['String']>;
  v_tel_head?: InputMaybe<Scalars['String']>;
  v_tel_while?: InputMaybe<Scalars['String']>;
  v_vehicles_autocamp?: InputMaybe<Scalars['Boolean']>;
  v_vehicles_campingcar?: InputMaybe<Scalars['Boolean']>;
};

export type Update_Campsite_Like_From_Edit_Args = {
  campsite_ids?: InputMaybe<Scalars['_text']>;
  input_type?: InputMaybe<Scalars['String']>;
};

export type Upsert_Campsite_Image_Args = {
  target_campsite_id?: InputMaybe<Scalars['String']>;
  target_image_ids?: InputMaybe<Scalars['_text']>;
  target_image_titles?: InputMaybe<Scalars['_text']>;
  target_type?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "user" */
export type User = {
  __typename?: 'user';
  /** An array relationship */
  addresses: Array<Address>;
  /** An object relationship */
  background_icon?: Maybe<Image>;
  background_image_id?: Maybe<Scalars['String']>;
  birthday?: Maybe<Scalars['date']>;
  camping_days?: Maybe<Scalars['Int']>;
  /** An array relationship */
  campsite_likes: Array<Campsite_Likes>;
  /** An aggregate relationship */
  campsite_likes_aggregate: Campsite_Likes_Aggregate;
  created_at: Scalars['timestamp'];
  display_name: Scalars['String'];
  email: Scalars['String'];
  /** An array relationship */
  fixed_exchange_product_exchangeds: Array<Fixed_Exchange_Product_Exchanged>;
  /** An aggregate relationship */
  fixed_exchange_product_exchangeds_aggregate: Fixed_Exchange_Product_Exchanged_Aggregate;
  /** An array relationship */
  gacha_loses: Array<Gacha_Lose>;
  /** An aggregate relationship */
  gacha_loses_aggregate: Gacha_Lose_Aggregate;
  /** An object relationship */
  icon?: Maybe<Image>;
  icon_image_id?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  liked_gear?: Maybe<Scalars['String']>;
  /** An array relationship */
  physical_prize_delivery_addresses: Array<Physical_Prize_Delivery_Address>;
  /** An aggregate relationship */
  physical_prize_delivery_addresses_aggregate: Physical_Prize_Delivery_Address_Aggregate;
  /** An array relationship */
  physical_prizes: Array<Physical_Prize>;
  /** An aggregate relationship */
  physical_prizes_aggregate: Physical_Prize_Aggregate;
  /** An array relationship */
  points: Array<Point>;
  /** An aggregate relationship */
  points_aggregate: Point_Aggregate;
  /** An array relationship */
  review_goods: Array<Review_Good>;
  /** An aggregate relationship */
  review_goods_aggregate: Review_Good_Aggregate;
  /** An array relationship */
  reviews: Array<Review>;
  /** An aggregate relationship */
  reviews_aggregate: Review_Aggregate;
  self_introduction: Scalars['String'];
  sex?: Maybe<Scalars['String']>;
  start_history?: Maybe<Scalars['date']>;
  total_like_num?: Maybe<Scalars['Int']>;
  total_point?: Maybe<Scalars['Int']>;
  total_review_num?: Maybe<Scalars['Int']>;
  total_visited_num?: Maybe<Scalars['Int']>;
  updated_at: Scalars['timestamp'];
  url?: Maybe<Scalars['String']>;
  url_title?: Maybe<Scalars['String']>;
  user_email: Scalars['String'];
  /** An array relationship */
  user_notifications: Array<User_Notification>;
  /** An aggregate relationship */
  user_notifications_aggregate: User_Notification_Aggregate;
  /** An array relationship */
  visiteds: Array<Visited>;
  /** An aggregate relationship */
  visiteds_aggregate: Visited_Aggregate;
  withdrawal_date?: Maybe<Scalars['timestamp']>;
};


/** columns and relationships of "user" */
export type UserAddressesArgs = {
  distinct_on?: InputMaybe<Array<Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Address_Order_By>>;
  where?: InputMaybe<Address_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCampsite_LikesArgs = {
  distinct_on?: InputMaybe<Array<Campsite_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Campsite_Likes_Order_By>>;
  where?: InputMaybe<Campsite_Likes_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserCampsite_Likes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Campsite_Likes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Campsite_Likes_Order_By>>;
  where?: InputMaybe<Campsite_Likes_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserFixed_Exchange_Product_ExchangedsArgs = {
  distinct_on?: InputMaybe<Array<Fixed_Exchange_Product_Exchanged_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fixed_Exchange_Product_Exchanged_Order_By>>;
  where?: InputMaybe<Fixed_Exchange_Product_Exchanged_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserFixed_Exchange_Product_Exchangeds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Fixed_Exchange_Product_Exchanged_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Fixed_Exchange_Product_Exchanged_Order_By>>;
  where?: InputMaybe<Fixed_Exchange_Product_Exchanged_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserGacha_LosesArgs = {
  distinct_on?: InputMaybe<Array<Gacha_Lose_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gacha_Lose_Order_By>>;
  where?: InputMaybe<Gacha_Lose_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserGacha_Loses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Gacha_Lose_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Gacha_Lose_Order_By>>;
  where?: InputMaybe<Gacha_Lose_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPhysical_Prize_Delivery_AddressesArgs = {
  distinct_on?: InputMaybe<Array<Physical_Prize_Delivery_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Physical_Prize_Delivery_Address_Order_By>>;
  where?: InputMaybe<Physical_Prize_Delivery_Address_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPhysical_Prize_Delivery_Addresses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Physical_Prize_Delivery_Address_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Physical_Prize_Delivery_Address_Order_By>>;
  where?: InputMaybe<Physical_Prize_Delivery_Address_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPhysical_PrizesArgs = {
  distinct_on?: InputMaybe<Array<Physical_Prize_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Physical_Prize_Order_By>>;
  where?: InputMaybe<Physical_Prize_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPhysical_Prizes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Physical_Prize_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Physical_Prize_Order_By>>;
  where?: InputMaybe<Physical_Prize_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPointsArgs = {
  distinct_on?: InputMaybe<Array<Point_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Point_Order_By>>;
  where?: InputMaybe<Point_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserPoints_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Point_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Point_Order_By>>;
  where?: InputMaybe<Point_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserReview_GoodsArgs = {
  distinct_on?: InputMaybe<Array<Review_Good_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Good_Order_By>>;
  where?: InputMaybe<Review_Good_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserReview_Goods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Good_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Good_Order_By>>;
  where?: InputMaybe<Review_Good_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserReviewsArgs = {
  distinct_on?: InputMaybe<Array<Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Order_By>>;
  where?: InputMaybe<Review_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserReviews_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Review_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Review_Order_By>>;
  where?: InputMaybe<Review_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<User_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Notification_Order_By>>;
  where?: InputMaybe<User_Notification_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserUser_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Notification_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Notification_Order_By>>;
  where?: InputMaybe<User_Notification_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserVisitedsArgs = {
  distinct_on?: InputMaybe<Array<Visited_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Visited_Order_By>>;
  where?: InputMaybe<Visited_Bool_Exp>;
};


/** columns and relationships of "user" */
export type UserVisiteds_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Visited_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Visited_Order_By>>;
  where?: InputMaybe<Visited_Bool_Exp>;
};

/** order by aggregate values of table "user" */
export type User_Aggregate_Order_By = {
  avg?: InputMaybe<User_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Max_Order_By>;
  min?: InputMaybe<User_Min_Order_By>;
  stddev?: InputMaybe<User_Stddev_Order_By>;
  stddev_pop?: InputMaybe<User_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<User_Stddev_Samp_Order_By>;
  sum?: InputMaybe<User_Sum_Order_By>;
  var_pop?: InputMaybe<User_Var_Pop_Order_By>;
  var_samp?: InputMaybe<User_Var_Samp_Order_By>;
  variance?: InputMaybe<User_Variance_Order_By>;
};

/** order by avg() on columns of table "user" */
export type User_Avg_Order_By = {
  camping_days?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_point?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "user". All fields are combined with a logical 'AND'. */
export type User_Bool_Exp = {
  _and?: InputMaybe<Array<User_Bool_Exp>>;
  _not?: InputMaybe<User_Bool_Exp>;
  _or?: InputMaybe<Array<User_Bool_Exp>>;
  addresses?: InputMaybe<Address_Bool_Exp>;
  background_icon?: InputMaybe<Image_Bool_Exp>;
  background_image_id?: InputMaybe<String_Comparison_Exp>;
  birthday?: InputMaybe<Date_Comparison_Exp>;
  camping_days?: InputMaybe<Int_Comparison_Exp>;
  campsite_likes?: InputMaybe<Campsite_Likes_Bool_Exp>;
  campsite_likes_aggregate?: InputMaybe<Campsite_Likes_Aggregate_Bool_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  fixed_exchange_product_exchangeds?: InputMaybe<Fixed_Exchange_Product_Exchanged_Bool_Exp>;
  fixed_exchange_product_exchangeds_aggregate?: InputMaybe<Fixed_Exchange_Product_Exchanged_Aggregate_Bool_Exp>;
  gacha_loses?: InputMaybe<Gacha_Lose_Bool_Exp>;
  gacha_loses_aggregate?: InputMaybe<Gacha_Lose_Aggregate_Bool_Exp>;
  icon?: InputMaybe<Image_Bool_Exp>;
  icon_image_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  liked_gear?: InputMaybe<String_Comparison_Exp>;
  physical_prize_delivery_addresses?: InputMaybe<Physical_Prize_Delivery_Address_Bool_Exp>;
  physical_prize_delivery_addresses_aggregate?: InputMaybe<Physical_Prize_Delivery_Address_Aggregate_Bool_Exp>;
  physical_prizes?: InputMaybe<Physical_Prize_Bool_Exp>;
  physical_prizes_aggregate?: InputMaybe<Physical_Prize_Aggregate_Bool_Exp>;
  points?: InputMaybe<Point_Bool_Exp>;
  points_aggregate?: InputMaybe<Point_Aggregate_Bool_Exp>;
  review_goods?: InputMaybe<Review_Good_Bool_Exp>;
  review_goods_aggregate?: InputMaybe<Review_Good_Aggregate_Bool_Exp>;
  reviews?: InputMaybe<Review_Bool_Exp>;
  reviews_aggregate?: InputMaybe<Review_Aggregate_Bool_Exp>;
  self_introduction?: InputMaybe<String_Comparison_Exp>;
  sex?: InputMaybe<String_Comparison_Exp>;
  start_history?: InputMaybe<Date_Comparison_Exp>;
  total_like_num?: InputMaybe<Int_Comparison_Exp>;
  total_point?: InputMaybe<Int_Comparison_Exp>;
  total_review_num?: InputMaybe<Int_Comparison_Exp>;
  total_visited_num?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  url_title?: InputMaybe<String_Comparison_Exp>;
  user_email?: InputMaybe<String_Comparison_Exp>;
  user_notifications?: InputMaybe<User_Notification_Bool_Exp>;
  user_notifications_aggregate?: InputMaybe<User_Notification_Aggregate_Bool_Exp>;
  visiteds?: InputMaybe<Visited_Bool_Exp>;
  visiteds_aggregate?: InputMaybe<Visited_Aggregate_Bool_Exp>;
  withdrawal_date?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "user" */
export type User_Inc_Input = {
  camping_days?: InputMaybe<Scalars['Int']>;
  total_like_num?: InputMaybe<Scalars['Int']>;
  total_point?: InputMaybe<Scalars['Int']>;
  total_review_num?: InputMaybe<Scalars['Int']>;
  total_visited_num?: InputMaybe<Scalars['Int']>;
};

/** order by max() on columns of table "user" */
export type User_Max_Order_By = {
  background_image_id?: InputMaybe<Order_By>;
  birthday?: InputMaybe<Order_By>;
  camping_days?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  icon_image_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liked_gear?: InputMaybe<Order_By>;
  self_introduction?: InputMaybe<Order_By>;
  sex?: InputMaybe<Order_By>;
  start_history?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_point?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  url_title?: InputMaybe<Order_By>;
  user_email?: InputMaybe<Order_By>;
  withdrawal_date?: InputMaybe<Order_By>;
};

/** order by min() on columns of table "user" */
export type User_Min_Order_By = {
  background_image_id?: InputMaybe<Order_By>;
  birthday?: InputMaybe<Order_By>;
  camping_days?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  icon_image_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liked_gear?: InputMaybe<Order_By>;
  self_introduction?: InputMaybe<Order_By>;
  sex?: InputMaybe<Order_By>;
  start_history?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_point?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  url_title?: InputMaybe<Order_By>;
  user_email?: InputMaybe<Order_By>;
  withdrawal_date?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user" */
export type User_Mutation_Response = {
  __typename?: 'user_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User>;
};

/** columns and relationships of "user_notification" */
export type User_Notification = {
  __typename?: 'user_notification';
  created_at: Scalars['timestamp'];
  id: Scalars['String'];
  read_at?: Maybe<Scalars['timestamp']>;
  review_like_values?: Maybe<Scalars['jsonb']>;
  type: Scalars['String'];
  updated_at: Scalars['timestamp'];
  /** An object relationship */
  user: User;
  user_id: Scalars['String'];
};


/** columns and relationships of "user_notification" */
export type User_NotificationReview_Like_ValuesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "user_notification" */
export type User_Notification_Aggregate = {
  __typename?: 'user_notification_aggregate';
  aggregate?: Maybe<User_Notification_Aggregate_Fields>;
  nodes: Array<User_Notification>;
};

export type User_Notification_Aggregate_Bool_Exp = {
  count?: InputMaybe<User_Notification_Aggregate_Bool_Exp_Count>;
};

export type User_Notification_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<User_Notification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<User_Notification_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "user_notification" */
export type User_Notification_Aggregate_Fields = {
  __typename?: 'user_notification_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Notification_Max_Fields>;
  min?: Maybe<User_Notification_Min_Fields>;
};


/** aggregate fields of "user_notification" */
export type User_Notification_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Notification_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "user_notification" */
export type User_Notification_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<User_Notification_Max_Order_By>;
  min?: InputMaybe<User_Notification_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "user_notification". All fields are combined with a logical 'AND'. */
export type User_Notification_Bool_Exp = {
  _and?: InputMaybe<Array<User_Notification_Bool_Exp>>;
  _not?: InputMaybe<User_Notification_Bool_Exp>;
  _or?: InputMaybe<Array<User_Notification_Bool_Exp>>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  read_at?: InputMaybe<Timestamp_Comparison_Exp>;
  review_like_values?: InputMaybe<Jsonb_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type User_Notification_Max_Fields = {
  __typename?: 'user_notification_max_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  read_at?: Maybe<Scalars['timestamp']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "user_notification" */
export type User_Notification_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_at?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type User_Notification_Min_Fields = {
  __typename?: 'user_notification_min_fields';
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  read_at?: Maybe<Scalars['timestamp']>;
  type?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "user_notification" */
export type User_Notification_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_at?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "user_notification" */
export type User_Notification_Mutation_Response = {
  __typename?: 'user_notification_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Notification>;
};

/** Ordering options when selecting data from "user_notification". */
export type User_Notification_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  read_at?: InputMaybe<Order_By>;
  review_like_values?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_notification */
export type User_Notification_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "user_notification" */
export enum User_Notification_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ReadAt = 'read_at',
  /** column name */
  ReviewLikeValues = 'review_like_values',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** input type for updating data in table "user_notification" */
export type User_Notification_Set_Input = {
  read_at?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "user_notification" */
export type User_Notification_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Notification_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Notification_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  read_at?: InputMaybe<Scalars['timestamp']>;
  review_like_values?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  user_id?: InputMaybe<Scalars['String']>;
};

export type User_Notification_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Notification_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Notification_Bool_Exp;
};

/** Ordering options when selecting data from "user". */
export type User_Order_By = {
  addresses_aggregate?: InputMaybe<Address_Aggregate_Order_By>;
  background_icon?: InputMaybe<Image_Order_By>;
  background_image_id?: InputMaybe<Order_By>;
  birthday?: InputMaybe<Order_By>;
  camping_days?: InputMaybe<Order_By>;
  campsite_likes_aggregate?: InputMaybe<Campsite_Likes_Aggregate_Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  fixed_exchange_product_exchangeds_aggregate?: InputMaybe<Fixed_Exchange_Product_Exchanged_Aggregate_Order_By>;
  gacha_loses_aggregate?: InputMaybe<Gacha_Lose_Aggregate_Order_By>;
  icon?: InputMaybe<Image_Order_By>;
  icon_image_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liked_gear?: InputMaybe<Order_By>;
  physical_prize_delivery_addresses_aggregate?: InputMaybe<Physical_Prize_Delivery_Address_Aggregate_Order_By>;
  physical_prizes_aggregate?: InputMaybe<Physical_Prize_Aggregate_Order_By>;
  points_aggregate?: InputMaybe<Point_Aggregate_Order_By>;
  review_goods_aggregate?: InputMaybe<Review_Good_Aggregate_Order_By>;
  reviews_aggregate?: InputMaybe<Review_Aggregate_Order_By>;
  self_introduction?: InputMaybe<Order_By>;
  sex?: InputMaybe<Order_By>;
  start_history?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_point?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  url_title?: InputMaybe<Order_By>;
  user_email?: InputMaybe<Order_By>;
  user_notifications_aggregate?: InputMaybe<User_Notification_Aggregate_Order_By>;
  visiteds_aggregate?: InputMaybe<Visited_Aggregate_Order_By>;
  withdrawal_date?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user */
export type User_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** columns and relationships of "user_public" */
export type User_Public = {
  __typename?: 'user_public';
  /** An object relationship */
  backgound_icon?: Maybe<Image>;
  background_image_id?: Maybe<Scalars['String']>;
  camping_days?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamp']>;
  display_name?: Maybe<Scalars['String']>;
  /** An object relationship */
  icon?: Maybe<Image>;
  icon_image_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  liked_gear?: Maybe<Scalars['String']>;
  self_introduction?: Maybe<Scalars['String']>;
  start_history?: Maybe<Scalars['date']>;
  total_like_num?: Maybe<Scalars['Int']>;
  total_review_num?: Maybe<Scalars['Int']>;
  total_visited_num?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  url?: Maybe<Scalars['String']>;
  url_title?: Maybe<Scalars['String']>;
};

/** Boolean expression to filter rows from the table "user_public". All fields are combined with a logical 'AND'. */
export type User_Public_Bool_Exp = {
  _and?: InputMaybe<Array<User_Public_Bool_Exp>>;
  _not?: InputMaybe<User_Public_Bool_Exp>;
  _or?: InputMaybe<Array<User_Public_Bool_Exp>>;
  backgound_icon?: InputMaybe<Image_Bool_Exp>;
  background_image_id?: InputMaybe<String_Comparison_Exp>;
  camping_days?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  display_name?: InputMaybe<String_Comparison_Exp>;
  icon?: InputMaybe<Image_Bool_Exp>;
  icon_image_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  liked_gear?: InputMaybe<String_Comparison_Exp>;
  self_introduction?: InputMaybe<String_Comparison_Exp>;
  start_history?: InputMaybe<Date_Comparison_Exp>;
  total_like_num?: InputMaybe<Int_Comparison_Exp>;
  total_review_num?: InputMaybe<Int_Comparison_Exp>;
  total_visited_num?: InputMaybe<Int_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  url?: InputMaybe<String_Comparison_Exp>;
  url_title?: InputMaybe<String_Comparison_Exp>;
};

/** Ordering options when selecting data from "user_public". */
export type User_Public_Order_By = {
  backgound_icon?: InputMaybe<Image_Order_By>;
  background_image_id?: InputMaybe<Order_By>;
  camping_days?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  display_name?: InputMaybe<Order_By>;
  icon?: InputMaybe<Image_Order_By>;
  icon_image_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  liked_gear?: InputMaybe<Order_By>;
  self_introduction?: InputMaybe<Order_By>;
  start_history?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  url?: InputMaybe<Order_By>;
  url_title?: InputMaybe<Order_By>;
};

/** select columns of table "user_public" */
export enum User_Public_Select_Column {
  /** column name */
  BackgroundImageId = 'background_image_id',
  /** column name */
  CampingDays = 'camping_days',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  IconImageId = 'icon_image_id',
  /** column name */
  Id = 'id',
  /** column name */
  LikedGear = 'liked_gear',
  /** column name */
  SelfIntroduction = 'self_introduction',
  /** column name */
  StartHistory = 'start_history',
  /** column name */
  TotalLikeNum = 'total_like_num',
  /** column name */
  TotalReviewNum = 'total_review_num',
  /** column name */
  TotalVisitedNum = 'total_visited_num',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  UrlTitle = 'url_title'
}

/** Streaming cursor of the table "user_public" */
export type User_Public_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Public_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Public_Stream_Cursor_Value_Input = {
  background_image_id?: InputMaybe<Scalars['String']>;
  camping_days?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  display_name?: InputMaybe<Scalars['String']>;
  icon_image_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  liked_gear?: InputMaybe<Scalars['String']>;
  self_introduction?: InputMaybe<Scalars['String']>;
  start_history?: InputMaybe<Scalars['date']>;
  total_like_num?: InputMaybe<Scalars['Int']>;
  total_review_num?: InputMaybe<Scalars['Int']>;
  total_visited_num?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  url?: InputMaybe<Scalars['String']>;
  url_title?: InputMaybe<Scalars['String']>;
};

/** select columns of table "user" */
export enum User_Select_Column {
  /** column name */
  BackgroundImageId = 'background_image_id',
  /** column name */
  Birthday = 'birthday',
  /** column name */
  CampingDays = 'camping_days',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'display_name',
  /** column name */
  Email = 'email',
  /** column name */
  IconImageId = 'icon_image_id',
  /** column name */
  Id = 'id',
  /** column name */
  LikedGear = 'liked_gear',
  /** column name */
  SelfIntroduction = 'self_introduction',
  /** column name */
  Sex = 'sex',
  /** column name */
  StartHistory = 'start_history',
  /** column name */
  TotalLikeNum = 'total_like_num',
  /** column name */
  TotalPoint = 'total_point',
  /** column name */
  TotalReviewNum = 'total_review_num',
  /** column name */
  TotalVisitedNum = 'total_visited_num',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  Url = 'url',
  /** column name */
  UrlTitle = 'url_title',
  /** column name */
  UserEmail = 'user_email',
  /** column name */
  WithdrawalDate = 'withdrawal_date'
}

/** input type for updating data in table "user" */
export type User_Set_Input = {
  background_image_id?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['date']>;
  camping_days?: InputMaybe<Scalars['Int']>;
  display_name?: InputMaybe<Scalars['String']>;
  icon_image_id?: InputMaybe<Scalars['String']>;
  liked_gear?: InputMaybe<Scalars['String']>;
  self_introduction?: InputMaybe<Scalars['String']>;
  sex?: InputMaybe<Scalars['String']>;
  start_history?: InputMaybe<Scalars['date']>;
  total_like_num?: InputMaybe<Scalars['Int']>;
  total_point?: InputMaybe<Scalars['Int']>;
  total_review_num?: InputMaybe<Scalars['Int']>;
  total_visited_num?: InputMaybe<Scalars['Int']>;
  url?: InputMaybe<Scalars['String']>;
  url_title?: InputMaybe<Scalars['String']>;
  user_email?: InputMaybe<Scalars['String']>;
};

/** order by stddev() on columns of table "user" */
export type User_Stddev_Order_By = {
  camping_days?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_point?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
};

/** order by stddev_pop() on columns of table "user" */
export type User_Stddev_Pop_Order_By = {
  camping_days?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_point?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
};

/** order by stddev_samp() on columns of table "user" */
export type User_Stddev_Samp_Order_By = {
  camping_days?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_point?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "user" */
export type User_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Stream_Cursor_Value_Input = {
  background_image_id?: InputMaybe<Scalars['String']>;
  birthday?: InputMaybe<Scalars['date']>;
  camping_days?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  display_name?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  icon_image_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  liked_gear?: InputMaybe<Scalars['String']>;
  self_introduction?: InputMaybe<Scalars['String']>;
  sex?: InputMaybe<Scalars['String']>;
  start_history?: InputMaybe<Scalars['date']>;
  total_like_num?: InputMaybe<Scalars['Int']>;
  total_point?: InputMaybe<Scalars['Int']>;
  total_review_num?: InputMaybe<Scalars['Int']>;
  total_visited_num?: InputMaybe<Scalars['Int']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  url?: InputMaybe<Scalars['String']>;
  url_title?: InputMaybe<Scalars['String']>;
  user_email?: InputMaybe<Scalars['String']>;
  withdrawal_date?: InputMaybe<Scalars['timestamp']>;
};

/** order by sum() on columns of table "user" */
export type User_Sum_Order_By = {
  camping_days?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_point?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
};

export type User_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<User_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Bool_Exp;
};

/** order by var_pop() on columns of table "user" */
export type User_Var_Pop_Order_By = {
  camping_days?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_point?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
};

/** order by var_samp() on columns of table "user" */
export type User_Var_Samp_Order_By = {
  camping_days?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_point?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
};

/** order by variance() on columns of table "user" */
export type User_Variance_Order_By = {
  camping_days?: InputMaybe<Order_By>;
  total_like_num?: InputMaybe<Order_By>;
  total_point?: InputMaybe<Order_By>;
  total_review_num?: InputMaybe<Order_By>;
  total_visited_num?: InputMaybe<Order_By>;
};

/** columns and relationships of "visited" */
export type Visited = {
  __typename?: 'visited';
  /** An object relationship */
  campsite: Campsite;
  campsite_id: Scalars['String'];
  created_at: Scalars['timestamp'];
  id: Scalars['String'];
  updated_at: Scalars['timestamp'];
  /** An object relationship */
  user: User;
  user_id: Scalars['String'];
};

/** aggregated selection of "visited" */
export type Visited_Aggregate = {
  __typename?: 'visited_aggregate';
  aggregate?: Maybe<Visited_Aggregate_Fields>;
  nodes: Array<Visited>;
};

export type Visited_Aggregate_Bool_Exp = {
  count?: InputMaybe<Visited_Aggregate_Bool_Exp_Count>;
};

export type Visited_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Visited_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Visited_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "visited" */
export type Visited_Aggregate_Fields = {
  __typename?: 'visited_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Visited_Max_Fields>;
  min?: Maybe<Visited_Min_Fields>;
};


/** aggregate fields of "visited" */
export type Visited_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Visited_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "visited" */
export type Visited_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Visited_Max_Order_By>;
  min?: InputMaybe<Visited_Min_Order_By>;
};

/** Boolean expression to filter rows from the table "visited". All fields are combined with a logical 'AND'. */
export type Visited_Bool_Exp = {
  _and?: InputMaybe<Array<Visited_Bool_Exp>>;
  _not?: InputMaybe<Visited_Bool_Exp>;
  _or?: InputMaybe<Array<Visited_Bool_Exp>>;
  campsite?: InputMaybe<Campsite_Bool_Exp>;
  campsite_id?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamp_Comparison_Exp>;
  user?: InputMaybe<User_Bool_Exp>;
  user_id?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "visited" */
export enum Visited_Constraint {
  /** unique or primary key constraint on columns "campsite_id", "user_id" */
  VisitedCampsiteIdUserIdKey = 'visited_campsite_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  VisitedPkey = 'visited_pkey'
}

/** input type for inserting data into table "visited" */
export type Visited_Insert_Input = {
  campsite_id?: InputMaybe<Scalars['String']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Visited_Max_Fields = {
  __typename?: 'visited_max_fields';
  campsite_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "visited" */
export type Visited_Max_Order_By = {
  campsite_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Visited_Min_Fields = {
  __typename?: 'visited_min_fields';
  campsite_id?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamp']>;
  user_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "visited" */
export type Visited_Min_Order_By = {
  campsite_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "visited" */
export type Visited_Mutation_Response = {
  __typename?: 'visited_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Visited>;
};

/** on_conflict condition type for table "visited" */
export type Visited_On_Conflict = {
  constraint: Visited_Constraint;
  update_columns?: Array<Visited_Update_Column>;
  where?: InputMaybe<Visited_Bool_Exp>;
};

/** Ordering options when selecting data from "visited". */
export type Visited_Order_By = {
  campsite?: InputMaybe<Campsite_Order_By>;
  campsite_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  user?: InputMaybe<User_Order_By>;
  user_id?: InputMaybe<Order_By>;
};

/** select columns of table "visited" */
export enum Visited_Select_Column {
  /** column name */
  CampsiteId = 'campsite_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** Streaming cursor of the table "visited" */
export type Visited_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Visited_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Visited_Stream_Cursor_Value_Input = {
  campsite_id?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamp']>;
  user_id?: InputMaybe<Scalars['String']>;
};

/** placeholder for update columns of table "visited" (current role has no relevant permissions) */
export enum Visited_Update_Column {
  /** placeholder (do not use) */
  Placeholder = '_PLACEHOLDER'
}

export type AddCampsiteSearchLogByUserMutationVariables = Exact<{
  filter: Scalars['json'];
  order_by: Scalars['String'];
}>;


export type AddCampsiteSearchLogByUserMutation = { __typename?: 'mutation_root', insert_campsite_search_log?: { __typename?: 'campsite_search_log_mutation_response', affected_rows: number } | null };

export type CheckCampSiteFavoriteQueryVariables = Exact<{
  campsite_id: Scalars['String'];
}>;


export type CheckCampSiteFavoriteQuery = { __typename?: 'query_root', campsite_likes_aggregate: { __typename?: 'campsite_likes_aggregate', aggregate?: { __typename?: 'campsite_likes_aggregate_fields', count: number } | null } };

export type UpdateCampsiteByUserMutationVariables = Exact<{
  target_campsite_id: Scalars['String'];
  v_activity_athletic?: InputMaybe<Scalars['Boolean']>;
  v_activity_bbq?: InputMaybe<Scalars['Boolean']>;
  v_activity_bicycle?: InputMaybe<Scalars['Boolean']>;
  v_activity_canoe?: InputMaybe<Scalars['Boolean']>;
  v_activity_craft?: InputMaybe<Scalars['Boolean']>;
  v_activity_fishing?: InputMaybe<Scalars['Boolean']>;
  v_activity_flower?: InputMaybe<Scalars['Boolean']>;
  v_activity_hiking?: InputMaybe<Scalars['Boolean']>;
  v_activity_insect?: InputMaybe<Scalars['Boolean']>;
  v_activity_playset?: InputMaybe<Scalars['Boolean']>;
  v_activity_pool?: InputMaybe<Scalars['Boolean']>;
  v_activity_ranch?: InputMaybe<Scalars['Boolean']>;
  v_activity_river?: InputMaybe<Scalars['Boolean']>;
  v_activity_sauna?: InputMaybe<Scalars['Boolean']>;
  v_activity_sea?: InputMaybe<Scalars['Boolean']>;
  v_activity_star?: InputMaybe<Scalars['Boolean']>;
  v_activity_taste?: InputMaybe<Scalars['Boolean']>;
  v_activity_tentsauna?: InputMaybe<Scalars['Boolean']>;
  v_bath_hotspring?: InputMaybe<Scalars['Boolean']>;
  v_bath_room?: InputMaybe<Scalars['Boolean']>;
  v_business_newyear?: InputMaybe<Scalars['Boolean']>;
  v_business_period?: InputMaybe<Scalars['Boolean']>;
  v_checkin_start_hour?: InputMaybe<Scalars['String']>;
  v_checkin_start_minute?: InputMaybe<Scalars['String']>;
  v_checkin_end_hour?: InputMaybe<Scalars['String']>;
  v_checkin_end_minute?: InputMaybe<Scalars['String']>;
  v_checkout_start_hour?: InputMaybe<Scalars['String']>;
  v_checkout_start_minute?: InputMaybe<Scalars['String']>;
  v_checkout_end_hour?: InputMaybe<Scalars['String']>;
  v_checkout_end_minute?: InputMaybe<Scalars['String']>;
  v_closed_friday?: InputMaybe<Scalars['Boolean']>;
  v_closed_holiday?: InputMaybe<Scalars['Boolean']>;
  v_closed_irregular?: InputMaybe<Scalars['Boolean']>;
  v_closed_monday?: InputMaybe<Scalars['Boolean']>;
  v_closed_not?: InputMaybe<Scalars['Boolean']>;
  v_closed_saturday?: InputMaybe<Scalars['Boolean']>;
  v_closed_sunday?: InputMaybe<Scalars['Boolean']>;
  v_closed_thursday?: InputMaybe<Scalars['Boolean']>;
  v_closed_tuesday?: InputMaybe<Scalars['Boolean']>;
  v_closed_wednesday?: InputMaybe<Scalars['Boolean']>;
  v_facilities_barrierfree?: InputMaybe<Scalars['Boolean']>;
  v_facilities_dogrun?: InputMaybe<Scalars['Boolean']>;
  v_facilities_laundry?: InputMaybe<Scalars['Boolean']>;
  v_facilities_restaurant?: InputMaybe<Scalars['Boolean']>;
  v_facilities_store?: InputMaybe<Scalars['Boolean']>;
  v_facilities_workspace?: InputMaybe<Scalars['Boolean']>;
  v_facility_acsite?: InputMaybe<Scalars['Boolean']>;
  v_facility_bungalow?: InputMaybe<Scalars['Boolean']>;
  v_facility_cottage?: InputMaybe<Scalars['Boolean']>;
  v_facility_freesite?: InputMaybe<Scalars['Boolean']>;
  v_facility_glamping?: InputMaybe<Scalars['Boolean']>;
  v_facility_privatesite?: InputMaybe<Scalars['Boolean']>;
  v_facility_sectionsite?: InputMaybe<Scalars['Boolean']>;
  v_facility_solo?: InputMaybe<Scalars['Boolean']>;
  v_facility_tipi?: InputMaybe<Scalars['Boolean']>;
  v_facility_trailerhouse?: InputMaybe<Scalars['Boolean']>;
  v_facility_treehouse?: InputMaybe<Scalars['Boolean']>;
  v_introduction_content?: InputMaybe<Scalars['String']>;
  v_introduction_title?: InputMaybe<Scalars['String']>;
  v_location_forest?: InputMaybe<Scalars['Boolean']>;
  v_location_hill?: InputMaybe<Scalars['Boolean']>;
  v_location_lake?: InputMaybe<Scalars['Boolean']>;
  v_location_meadow?: InputMaybe<Scalars['Boolean']>;
  v_location_ocean?: InputMaybe<Scalars['Boolean']>;
  v_location_park?: InputMaybe<Scalars['Boolean']>;
  v_location_plateau?: InputMaybe<Scalars['Boolean']>;
  v_location_river?: InputMaybe<Scalars['Boolean']>;
  v_service_firewood?: InputMaybe<Scalars['Boolean']>;
  v_service_firework?: InputMaybe<Scalars['Boolean']>;
  v_service_freecharge?: InputMaybe<Scalars['Boolean']>;
  v_service_garbage?: InputMaybe<Scalars['Boolean']>;
  v_service_group?: InputMaybe<Scalars['Boolean']>;
  v_service_hotwater?: InputMaybe<Scalars['Boolean']>;
  v_service_openfire?: InputMaybe<Scalars['Boolean']>;
  v_service_pet?: InputMaybe<Scalars['Boolean']>;
  v_service_rental?: InputMaybe<Scalars['Boolean']>;
  v_service_washlet?: InputMaybe<Scalars['Boolean']>;
  v_service_wifi?: InputMaybe<Scalars['Boolean']>;
  v_tel_bottom?: InputMaybe<Scalars['String']>;
  v_tel_head?: InputMaybe<Scalars['String']>;
  v_tel_while?: InputMaybe<Scalars['String']>;
  v_vehicles_autocamp?: InputMaybe<Scalars['Boolean']>;
  v_vehicles_campingcar?: InputMaybe<Scalars['Boolean']>;
  v_official_url?: InputMaybe<Scalars['String']>;
  v_main_image_id?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCampsiteByUserMutation = { __typename?: 'mutation_root', update_campsite_info: Array<{ __typename?: 'campsite', id: string }> };

export type UpsertCampsiteImageMutationVariables = Exact<{
  target_campsite_id?: InputMaybe<Scalars['String']>;
  target_image_ids?: InputMaybe<Scalars['_text']>;
  target_image_titles?: InputMaybe<Scalars['_text']>;
  target_type?: InputMaybe<Scalars['String']>;
}>;


export type UpsertCampsiteImageMutation = { __typename?: 'mutation_root', upsert_campsite_image: Array<{ __typename?: 'campsite', id: string }> };

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUserByIdQuery = { __typename?: 'query_root', user_by_pk?: { __typename?: 'user', withdrawal_date?: any | null, user_email: string, url_title?: string | null, url?: string | null, updated_at: any, total_visited_num?: number | null, total_review_num?: number | null, total_point?: number | null, total_like_num?: number | null, start_history?: any | null, sex?: string | null, self_introduction: string, liked_gear?: string | null, id: string, icon_image_id?: string | null, email: string, display_name: string, created_at: any, birthday?: any | null, camping_days?: number | null, background_image_id?: string | null } | null };

export type AddCampSiteLikeMutationVariables = Exact<{
  campsite_id: Scalars['String'];
  type: Scalars['String'];
  user_id: Scalars['String'];
}>;


export type AddCampSiteLikeMutation = { __typename?: 'mutation_root', insert_campsite_likes_one?: { __typename?: 'campsite_likes', campsite_id: string, created_at: any, id: string, type: string, updated_at: any, user_id: string } | null };

export type DeleteCampSiteLikeMutationVariables = Exact<{
  campsite_id: Scalars['String'];
  user_id: Scalars['String'];
}>;


export type DeleteCampSiteLikeMutation = { __typename?: 'mutation_root', delete_campsite_likes?: { __typename?: 'campsite_likes_mutation_response', affected_rows: number } | null };

export type UpdateCampsiteLikeFromEditMutationVariables = Exact<{
  campsite_ids: Scalars['_text'];
  input_type: Scalars['String'];
}>;


export type UpdateCampsiteLikeFromEditMutation = { __typename?: 'mutation_root', update_campsite_like_from_edit: Array<{ __typename?: 'campsite_likes', id: string }> };

export type CampsiteLikeQueryVariables = Exact<{ [key: string]: never; }>;


export type CampsiteLikeQuery = { __typename?: 'query_root', favorite: Array<{ __typename?: 'campsite_likes', campsite_id: string, created_at: any, id: string, type: string, updated_at: any }>, favorite_count: { __typename?: 'campsite_likes_aggregate', aggregate?: { __typename?: 'campsite_likes_aggregate_fields', count: number } | null }, special: Array<{ __typename?: 'campsite_likes', campsite_id: string, created_at: any, id: string, type: string, updated_at: any }>, special_count: { __typename?: 'campsite_likes_aggregate', aggregate?: { __typename?: 'campsite_likes_aggregate_fields', count: number } | null }, all: Array<{ __typename?: 'campsite_likes', campsite_id: string, created_at: any, id: string, type: string, updated_at: any }>, all_count: { __typename?: 'campsite_likes_aggregate', aggregate?: { __typename?: 'campsite_likes_aggregate_fields', count: number } | null } };

export type AddVisitedMutationVariables = Exact<{
  campsite_id: Scalars['String'];
  user_id: Scalars['String'];
}>;


export type AddVisitedMutation = { __typename?: 'mutation_root', insert_visited?: { __typename?: 'visited_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'visited', campsite_id: string, created_at: any, id: string, updated_at: any, user_id: string }> } | null };

export type CheckVisitedByCampsiteIdQueryVariables = Exact<{
  user_id: Scalars['String'];
  campsite_id: Scalars['String'];
}>;


export type CheckVisitedByCampsiteIdQuery = { __typename?: 'query_root', visited: Array<{ __typename?: 'visited', campsite_id: string, created_at: any, id: string, updated_at: any, user_id: string }> };

export type RemoveVisitedMutationVariables = Exact<{
  campsite_id: Scalars['String'];
  user_id: Scalars['String'];
}>;


export type RemoveVisitedMutation = { __typename?: 'mutation_root', delete_visited?: { __typename?: 'visited_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'visited', campsite_id: string, created_at: any, id: string, updated_at: any, user_id: string }> } | null };

export type ExchangeFirewoodMutationVariables = Exact<{
  target_campsite_id: Scalars['String'];
}>;


export type ExchangeFirewoodMutation = { __typename?: 'mutation_root', exchange_fixed_exchange_product: Array<{ __typename?: 'fixed_exchange_product_exchanged', created_at: any, fixed_exchange_product_id: string, id: string, point_used_id: string, updated_at: any, user_id: string }> };

export type DrawGatchaMutationVariables = Exact<{
  targetGachaId: Scalars['String'];
}>;


export type DrawGatchaMutation = { __typename?: 'mutation_root', drawGacha: { __typename?: 'GachaResult', error_code?: string | null, error_message?: string | null, gacha_lose_id?: string | null, physical_prize_id?: string | null, result?: string | null, status: string } };

export type GetPrismicIdByPhysicalPrizeIdQueryVariables = Exact<{
  _eq: Scalars['String'];
}>;


export type GetPrismicIdByPhysicalPrizeIdQuery = { __typename?: 'query_root', physical_prize: Array<{ __typename?: 'physical_prize', id: string, gacha_id: string, physical_prize_delivery_address_id?: string | null }> };

export type SubmitPhysicalPriseDeliveryAddressMutationVariables = Exact<{
  target_street: Scalars['String'];
  target_building?: InputMaybe<Scalars['String']>;
  target_city: Scalars['String'];
  target_postal_code: Scalars['String'];
  target_prefecture: Scalars['String'];
  target_physical_prize_id?: InputMaybe<Scalars['String']>;
  target_tel_body: Scalars['String'];
  target_name: Scalars['String'];
  target_tel_head: Scalars['String'];
  target_tel_tail: Scalars['String'];
}>;


export type SubmitPhysicalPriseDeliveryAddressMutation = { __typename?: 'mutation_root', submit_physical_prize_delivery_address: Array<{ __typename?: 'physical_prize_delivery_address', building?: string | null, city: string, created_at: any, postal_code: string, id: string, updated_at: any, street: string, prefecture: string, user_id: string, name: string, tel_body: string, tel_head: string, tel_tail: string }> };

export type GeneratePresignUrlMutationVariables = Exact<{
  fileName: Scalars['String'];
}>;


export type GeneratePresignUrlMutation = { __typename?: 'mutation_root', generatePresignedUrl: { __typename?: 'PresignedUrl', fileName?: string | null, status: string, url?: string | null } };

export type InsertImageMutationVariables = Exact<{
  alt: Scalars['String'];
  file_name: Scalars['String'];
  title: Scalars['String'];
  user_id: Scalars['String'];
}>;


export type InsertImageMutation = { __typename?: 'mutation_root', insert_image_one?: { __typename?: 'image', id: string } | null };

export type GetMyPointNotificationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyPointNotificationQuery = { __typename?: 'query_root', point: Array<{ __typename?: 'point', created_at: any, earned_type: string, id: string, message?: string | null, rate: number, read_at?: any | null, updated_at: any, user_id: string, value: number, month_first_point_id?: string | null }> };

export type UpdateMyPointNotificationMutationVariables = Exact<{
  read_at: Scalars['timestamp'];
  _in: Array<Scalars['String']> | Scalars['String'];
}>;


export type UpdateMyPointNotificationMutation = { __typename?: 'mutation_root', update_point?: { __typename?: 'point_mutation_response', affected_rows: number } | null };

export type AddReviewGoodMutationVariables = Exact<{
  from_user_id: Scalars['String'];
  for_review_id: Scalars['String'];
}>;


export type AddReviewGoodMutation = { __typename?: 'mutation_root', insert_review_good?: { __typename?: 'review_good_mutation_response', affected_rows: number } | null };

export type DeleteReviewByPkMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteReviewByPkMutation = { __typename?: 'mutation_root', delete_review_by_pk?: { __typename?: 'review', id: string } | null };

export type DeleteReviewGoodMutationVariables = Exact<{
  for_review_id: Scalars['String'];
  from_user_id: Scalars['String'];
}>;


export type DeleteReviewGoodMutation = { __typename?: 'mutation_root', delete_review_good?: { __typename?: 'review_good_mutation_response', affected_rows: number } | null };

export type ReviewByPkFromUserQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type ReviewByPkFromUserQuery = { __typename?: 'query_root', review_by_pk?: { __typename?: 'review', user_id: string, updated_at: any, total_good_num: number, campsite_id: string, content: string, created_at: any, id: string, public: boolean, review_images: Array<{ __typename?: 'review_image', id: string, image: { __typename?: 'image', alt: string, created_at: any, file_name: string, id: string, title: string, user_id?: string | null } }>, review_goods_aggregate: { __typename?: 'review_good_aggregate', aggregate?: { __typename?: 'review_good_aggregate_fields', count: number } | null }, review_images_aggregate: { __typename?: 'review_image_aggregate', aggregate?: { __typename?: 'review_image_aggregate_fields', count: number } | null }, user_public?: { __typename?: 'user_public', icon_image_id?: string | null, id?: string | null, liked_gear?: string | null, self_introduction?: string | null, start_history?: any | null, total_review_num?: number | null, total_visited_num?: number | null, updated_at?: any | null, url?: string | null, url_title?: string | null, display_name?: string | null, created_at?: any | null, camping_days?: number | null, background_image_id?: string | null, icon?: { __typename?: 'image', file_name: string, id: string, created_at: any, alt: string, title: string, user_id?: string | null } | null } | null, campsite: { __typename?: 'campsite', id: string, name: string } } | null };

export type ReviewFromUserQueryVariables = Exact<{ [key: string]: never; }>;


export type ReviewFromUserQuery = { __typename?: 'query_root', review: Array<{ __typename?: 'review', user_id: string, updated_at: any, total_good_num: number, campsite_id: string, content: string, created_at: any, id: string, public: boolean, review_images: Array<{ __typename?: 'review_image', id: string, image: { __typename?: 'image', alt: string, created_at: any, file_name: string, id: string, title: string, user_id?: string | null } }>, review_goods_aggregate: { __typename?: 'review_good_aggregate', aggregate?: { __typename?: 'review_good_aggregate_fields', count: number } | null }, review_images_aggregate: { __typename?: 'review_image_aggregate', aggregate?: { __typename?: 'review_image_aggregate_fields', count: number } | null }, user_public?: { __typename?: 'user_public', icon_image_id?: string | null, id?: string | null, liked_gear?: string | null, self_introduction?: string | null, start_history?: any | null, total_review_num?: number | null, total_visited_num?: number | null, updated_at?: any | null, url?: string | null, url_title?: string | null, display_name?: string | null, created_at?: any | null, camping_days?: number | null, background_image_id?: string | null, icon?: { __typename?: 'image', file_name: string, id: string, created_at: any, alt: string, title: string, user_id?: string | null } | null } | null, campsite: { __typename?: 'campsite', id: string, name: string } }> };

export type AddReviewMutationVariables = Exact<{
  public: Scalars['Boolean'];
  content: Scalars['String'];
  campsite_id: Scalars['String'];
  user_id: Scalars['String'];
}>;


export type AddReviewMutation = { __typename?: 'mutation_root', insert_review?: { __typename?: 'review_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'review', id: string }> } | null };

export type UpdateReviewMutationVariables = Exact<{
  id: Scalars['String'];
  content: Scalars['String'];
  public: Scalars['Boolean'];
}>;


export type UpdateReviewMutation = { __typename?: 'mutation_root', update_review_by_pk?: { __typename?: 'review', id: string } | null };

export type DeleteReviewImageByPkMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteReviewImageByPkMutation = { __typename?: 'mutation_root', delete_review_image_by_pk?: { __typename?: 'review_image', id: string } | null };

export type AddReviewImagesMutationVariables = Exact<{
  images: Array<Review_Image_Insert_Input> | Review_Image_Insert_Input;
}>;


export type AddReviewImagesMutation = { __typename?: 'mutation_root', insert_review_image?: { __typename?: 'review_image_mutation_response', affected_rows: number } | null };

export type ReviewGoodQueryVariables = Exact<{ [key: string]: never; }>;


export type ReviewGoodQuery = { __typename?: 'query_root', review_good: Array<{ __typename?: 'review_good', created_at: any, for_review_id: string, from_user_id: string, id: string }> };

export type GetMyAddressQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyAddressQuery = { __typename?: 'query_root', address: Array<{ __typename?: 'address', building?: string | null, city: string, created_at: any, id: string, name: string, postal_code: string, tel_head: string, tel_tail: string, updated_at: any, tel_body: string, street: string, prefecture: string, user_id: string }> };

export type GetTotalAcquiredPointsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTotalAcquiredPointsQuery = { __typename?: 'query_root', point_history_aggregate: { __typename?: 'point_history_aggregate', aggregate?: { __typename?: 'point_history_aggregate_fields', count: number, sum?: { __typename?: 'point_history_sum_fields', value?: number | null, rate?: number | null } | null } | null } };

export type GetWinGachaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWinGachaQuery = { __typename?: 'query_root', physical_prize: Array<{ __typename?: 'physical_prize', created_at: any, gacha_id: string, id: string, input_delivery_address_at?: any | null, physical_prize_delivery_address_id?: string | null, point_used_id: string, updated_at: any, user_id: string }>, physical_prize_aggregate: { __typename?: 'physical_prize_aggregate', aggregate?: { __typename?: 'physical_prize_aggregate_fields', count: number } | null } };

export type InsertAddressFromUserMutationVariables = Exact<{
  object?: InputMaybe<Address_Insert_Input>;
}>;


export type InsertAddressFromUserMutation = { __typename?: 'mutation_root', insert_address_one?: { __typename?: 'address', id: string } | null };

export type MyPointQueryVariables = Exact<{ [key: string]: never; }>;


export type MyPointQuery = { __typename?: 'query_root', point_history_aggregate: { __typename?: 'point_history_aggregate', aggregate?: { __typename?: 'point_history_aggregate_fields', sum?: { __typename?: 'point_history_sum_fields', rate?: number | null, value?: number | null } | null } | null } };

export type MyPointHistoryQueryVariables = Exact<{
  offset: Scalars['Int'];
  limit?: InputMaybe<Scalars['Int']>;
  sumOffset: Scalars['Int'];
}>;


export type MyPointHistoryQuery = { __typename?: 'query_root', point_history: Array<{ __typename?: 'point_history', created_at?: any | null, earn_id?: string | null, earned_type?: string | null, fixed_exchange_product_exchanged_id?: string | null, gacha_lose_id?: string | null, message?: string | null, physical_prize_id?: string | null, rate?: number | null, type?: string | null, updated_at?: any | null, use_id?: string | null, user_id?: string | null, value?: number | null, month_first_point_id?: string | null, physical_prize?: { __typename?: 'physical_prize', gacha: { __typename?: 'gacha', name: string, total_win_num_limit?: number | null, end_at?: any | null } } | null, gacha_lose?: { __typename?: 'gacha_lose', gacha: { __typename?: 'gacha', name: string, end_at?: any | null, total_win_num_limit?: number | null } } | null }>, point_history_aggregate_with_offset: { __typename?: 'point_history_aggregate', aggregate?: { __typename?: 'point_history_aggregate_fields', count: number, sum?: { __typename?: 'point_history_sum_fields', value?: number | null } | null } | null }, point_history_aggregate_total: { __typename?: 'point_history_aggregate', aggregate?: { __typename?: 'point_history_aggregate_fields', count: number, sum?: { __typename?: 'point_history_sum_fields', value?: number | null } | null } | null } };

export type NotificationQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']>;
}>;


export type NotificationQuery = { __typename?: 'query_root', user_notification: Array<{ __typename?: 'user_notification', updated_at: any, type: string, review_like_values?: any | null, read_at?: any | null, id: string, created_at: any, user_id: string }>, unread_total: { __typename?: 'user_notification_aggregate', aggregate?: { __typename?: 'user_notification_aggregate_fields', count: number } | null } };

export type ReadNotificationMutationVariables = Exact<{
  id: Scalars['String'];
  read_at: Scalars['timestamp'];
}>;


export type ReadNotificationMutation = { __typename?: 'mutation_root', update_user_notification_by_pk?: { __typename?: 'user_notification', read_at?: any | null } | null };

export type UpdateAddressFromUserMutationVariables = Exact<{
  address_id: Scalars['String'];
  _set?: InputMaybe<Address_Set_Input>;
}>;


export type UpdateAddressFromUserMutation = { __typename?: 'mutation_root', update_address_by_pk?: { __typename?: 'address', id: string, name: string } | null };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['String'];
  _set?: InputMaybe<User_Set_Input>;
}>;


export type UpdateUserMutation = { __typename?: 'mutation_root', update_user_by_pk?: { __typename?: 'user', id: string } | null };

export type WithdrawMutationVariables = Exact<{ [key: string]: never; }>;


export type WithdrawMutation = { __typename?: 'mutation_root', withDraw: { __typename?: 'SimpleResult', error_message?: string | null, status: string } };

export type GetLoginUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLoginUserQuery = { __typename?: 'query_root', user: Array<{ __typename?: 'user', display_name: string, email: string, birthday?: any | null, background_image_id?: string | null, camping_days?: number | null, created_at: any, icon_image_id?: string | null, id: string, liked_gear?: string | null, self_introduction: string, sex?: string | null, start_history?: any | null, total_like_num?: number | null, total_point?: number | null, total_review_num?: number | null, total_visited_num?: number | null, updated_at: any, url?: string | null, url_title?: string | null, user_email: string, withdrawal_date?: any | null, campsite_likes_aggregate: { __typename?: 'campsite_likes_aggregate', aggregate?: { __typename?: 'campsite_likes_aggregate_fields', count: number } | null }, visiteds_aggregate: { __typename?: 'visited_aggregate', aggregate?: { __typename?: 'visited_aggregate_fields', count: number } | null }, user_notifications_aggregate: { __typename?: 'user_notification_aggregate', aggregate?: { __typename?: 'user_notification_aggregate_fields', count: number } | null }, background_icon?: { __typename?: 'image', user_id?: string | null, title: string, id: string, file_name: string, created_at: any, alt: string } | null, icon?: { __typename?: 'image', user_id?: string | null, title: string, id: string, file_name: string, created_at: any, alt: string } | null }> };

export type AfterLoginMutationVariables = Exact<{
  cognitoUserId: Scalars['String'];
}>;


export type AfterLoginMutation = { __typename?: 'mutation_root', afterLogin?: string | null };

export type UserNotificationQueryVariables = Exact<{ [key: string]: never; }>;


export type UserNotificationQuery = { __typename?: 'query_root', user_notification: Array<{ __typename?: 'user_notification', user_id: string, updated_at: any, type: string, read_at?: any | null, id: string, created_at: any, review_like_values?: any | null }>, user_notification_aggregate: { __typename?: 'user_notification_aggregate', aggregate?: { __typename?: 'user_notification_aggregate_fields', count: number } | null } };


type Properties<T> = Required<{
  [K in keyof T]: z.ZodType<T[K], any, T[K]>;
}>;

type definedNonNullAny = {};

export const isDefinedNonNullAny = (v: any): v is definedNonNullAny => v !== undefined && v !== null;

export const definedNonNullAnySchema = z.any().refine((v) => isDefinedNonNullAny(v));

export function Boolean_Comparison_ExpSchema(): z.ZodObject<Properties<Boolean_Comparison_Exp>> {
  return z.object<Properties<Boolean_Comparison_Exp>>({
    _eq: z.boolean().nullish(),
    _gt: z.boolean().nullish(),
    _gte: z.boolean().nullish(),
    _in: z.array(z.boolean()).nullish(),
    _is_null: z.boolean().nullish(),
    _lt: z.boolean().nullish(),
    _lte: z.boolean().nullish(),
    _neq: z.boolean().nullish(),
    _nin: z.array(z.boolean()).nullish()
  })
}

export function Int_Comparison_ExpSchema(): z.ZodObject<Properties<Int_Comparison_Exp>> {
  return z.object<Properties<Int_Comparison_Exp>>({
    _eq: z.number().nullish(),
    _gt: z.number().nullish(),
    _gte: z.number().nullish(),
    _in: z.array(z.number()).nullish(),
    _is_null: z.boolean().nullish(),
    _lt: z.number().nullish(),
    _lte: z.number().nullish(),
    _neq: z.number().nullish(),
    _nin: z.array(z.number()).nullish()
  })
}

export function String_Comparison_ExpSchema(): z.ZodObject<Properties<String_Comparison_Exp>> {
  return z.object<Properties<String_Comparison_Exp>>({
    _eq: z.string().nullish(),
    _gt: z.string().nullish(),
    _gte: z.string().nullish(),
    _ilike: z.string().nullish(),
    _in: z.array(z.string()).nullish(),
    _iregex: z.string().nullish(),
    _is_null: z.boolean().nullish(),
    _like: z.string().nullish(),
    _lt: z.string().nullish(),
    _lte: z.string().nullish(),
    _neq: z.string().nullish(),
    _nilike: z.string().nullish(),
    _nin: z.array(z.string()).nullish(),
    _niregex: z.string().nullish(),
    _nlike: z.string().nullish(),
    _nregex: z.string().nullish(),
    _nsimilar: z.string().nullish(),
    _regex: z.string().nullish(),
    _similar: z.string().nullish()
  })
}

export function Address_Aggregate_Order_BySchema(): z.ZodObject<Properties<Address_Aggregate_Order_By>> {
  return z.object<Properties<Address_Aggregate_Order_By>>({
    count: definedNonNullAnySchema.nullish(),
    max: definedNonNullAnySchema.nullish(),
    min: definedNonNullAnySchema.nullish()
  })
}

export function Address_Bool_ExpSchema(): z.ZodObject<Properties<Address_Bool_Exp>> {
  return z.object<Properties<Address_Bool_Exp>>({
    _and: z.array(definedNonNullAnySchema).nullish(),
    _not: definedNonNullAnySchema.nullish(),
    _or: z.array(definedNonNullAnySchema).nullish(),
    building: definedNonNullAnySchema.nullish(),
    city: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    name: definedNonNullAnySchema.nullish(),
    postal_code: definedNonNullAnySchema.nullish(),
    prefecture: definedNonNullAnySchema.nullish(),
    street: definedNonNullAnySchema.nullish(),
    tel_body: definedNonNullAnySchema.nullish(),
    tel_head: definedNonNullAnySchema.nullish(),
    tel_tail: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export const Address_ConstraintSchema = z.nativeEnum(Address_Constraint);

export function Address_Insert_InputSchema(): z.ZodObject<Properties<Address_Insert_Input>> {
  return z.object<Properties<Address_Insert_Input>>({
    building: z.string().nullish(),
    city: z.string().nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    name: z.string().nullish(),
    postal_code: z.string().nullish(),
    prefecture: z.string().nullish(),
    street: z.string().nullish(),
    tel_body: z.string().nullish(),
    tel_head: z.string().nullish(),
    tel_tail: z.string().nullish(),
    updated_at: definedNonNullAnySchema.nullish()
  })
}

export function Address_Max_Order_BySchema(): z.ZodObject<Properties<Address_Max_Order_By>> {
  return z.object<Properties<Address_Max_Order_By>>({
    building: definedNonNullAnySchema.nullish(),
    city: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    name: definedNonNullAnySchema.nullish(),
    postal_code: definedNonNullAnySchema.nullish(),
    prefecture: definedNonNullAnySchema.nullish(),
    street: definedNonNullAnySchema.nullish(),
    tel_body: definedNonNullAnySchema.nullish(),
    tel_head: definedNonNullAnySchema.nullish(),
    tel_tail: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function Address_Min_Order_BySchema(): z.ZodObject<Properties<Address_Min_Order_By>> {
  return z.object<Properties<Address_Min_Order_By>>({
    building: definedNonNullAnySchema.nullish(),
    city: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    name: definedNonNullAnySchema.nullish(),
    postal_code: definedNonNullAnySchema.nullish(),
    prefecture: definedNonNullAnySchema.nullish(),
    street: definedNonNullAnySchema.nullish(),
    tel_body: definedNonNullAnySchema.nullish(),
    tel_head: definedNonNullAnySchema.nullish(),
    tel_tail: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function Address_On_ConflictSchema(): z.ZodObject<Properties<Address_On_Conflict>> {
  return z.object<Properties<Address_On_Conflict>>({
    constraint: definedNonNullAnySchema,
    update_columns: z.array(definedNonNullAnySchema),
    where: definedNonNullAnySchema.nullish()
  })
}

export function Address_Order_BySchema(): z.ZodObject<Properties<Address_Order_By>> {
  return z.object<Properties<Address_Order_By>>({
    building: definedNonNullAnySchema.nullish(),
    city: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    name: definedNonNullAnySchema.nullish(),
    postal_code: definedNonNullAnySchema.nullish(),
    prefecture: definedNonNullAnySchema.nullish(),
    street: definedNonNullAnySchema.nullish(),
    tel_body: definedNonNullAnySchema.nullish(),
    tel_head: definedNonNullAnySchema.nullish(),
    tel_tail: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function Address_Pk_Columns_InputSchema(): z.ZodObject<Properties<Address_Pk_Columns_Input>> {
  return z.object<Properties<Address_Pk_Columns_Input>>({
    id: z.string()
  })
}

export const Address_Select_ColumnSchema = z.nativeEnum(Address_Select_Column);

export function Address_Set_InputSchema(): z.ZodObject<Properties<Address_Set_Input>> {
  return z.object<Properties<Address_Set_Input>>({
    building: z.string().nullish(),
    city: z.string().nullish(),
    name: z.string().nullish(),
    postal_code: z.string().nullish(),
    prefecture: z.string().nullish(),
    street: z.string().nullish(),
    tel_body: z.string().nullish(),
    tel_head: z.string().nullish(),
    tel_tail: z.string().nullish(),
    user_id: z.string().nullish()
  })
}

export function Address_Stream_Cursor_InputSchema(): z.ZodObject<Properties<Address_Stream_Cursor_Input>> {
  return z.object<Properties<Address_Stream_Cursor_Input>>({
    initial_value: definedNonNullAnySchema,
    ordering: definedNonNullAnySchema.nullish()
  })
}

export function Address_Stream_Cursor_Value_InputSchema(): z.ZodObject<Properties<Address_Stream_Cursor_Value_Input>> {
  return z.object<Properties<Address_Stream_Cursor_Value_Input>>({
    building: z.string().nullish(),
    city: z.string().nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: z.string().nullish(),
    name: z.string().nullish(),
    postal_code: z.string().nullish(),
    prefecture: z.string().nullish(),
    street: z.string().nullish(),
    tel_body: z.string().nullish(),
    tel_head: z.string().nullish(),
    tel_tail: z.string().nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: z.string().nullish()
  })
}

export const Address_Update_ColumnSchema = z.nativeEnum(Address_Update_Column);

export function Address_UpdatesSchema(): z.ZodObject<Properties<Address_Updates>> {
  return z.object<Properties<Address_Updates>>({
    _set: definedNonNullAnySchema.nullish(),
    where: definedNonNullAnySchema
  })
}

export function Campsite_Aggregate_Bool_ExpSchema(): z.ZodObject<Properties<Campsite_Aggregate_Bool_Exp>> {
  return z.object<Properties<Campsite_Aggregate_Bool_Exp>>({
    bool_and: definedNonNullAnySchema.nullish(),
    bool_or: definedNonNullAnySchema.nullish(),
    count: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Aggregate_Bool_Exp_Bool_AndSchema(): z.ZodObject<Properties<Campsite_Aggregate_Bool_Exp_Bool_And>> {
  return z.object<Properties<Campsite_Aggregate_Bool_Exp_Bool_And>>({
    arguments: definedNonNullAnySchema,
    distinct: z.boolean().nullish(),
    filter: definedNonNullAnySchema.nullish(),
    predicate: definedNonNullAnySchema
  })
}

export function Campsite_Aggregate_Bool_Exp_Bool_OrSchema(): z.ZodObject<Properties<Campsite_Aggregate_Bool_Exp_Bool_Or>> {
  return z.object<Properties<Campsite_Aggregate_Bool_Exp_Bool_Or>>({
    arguments: definedNonNullAnySchema,
    distinct: z.boolean().nullish(),
    filter: definedNonNullAnySchema.nullish(),
    predicate: definedNonNullAnySchema
  })
}

export function Campsite_Aggregate_Bool_Exp_CountSchema(): z.ZodObject<Properties<Campsite_Aggregate_Bool_Exp_Count>> {
  return z.object<Properties<Campsite_Aggregate_Bool_Exp_Count>>({
    arguments: z.array(definedNonNullAnySchema).nullish(),
    distinct: z.boolean().nullish(),
    filter: definedNonNullAnySchema.nullish(),
    predicate: definedNonNullAnySchema
  })
}

export function Campsite_Aggregate_Order_BySchema(): z.ZodObject<Properties<Campsite_Aggregate_Order_By>> {
  return z.object<Properties<Campsite_Aggregate_Order_By>>({
    avg: definedNonNullAnySchema.nullish(),
    count: definedNonNullAnySchema.nullish(),
    max: definedNonNullAnySchema.nullish(),
    min: definedNonNullAnySchema.nullish(),
    stddev: definedNonNullAnySchema.nullish(),
    stddev_pop: definedNonNullAnySchema.nullish(),
    stddev_samp: definedNonNullAnySchema.nullish(),
    sum: definedNonNullAnySchema.nullish(),
    var_pop: definedNonNullAnySchema.nullish(),
    var_samp: definedNonNullAnySchema.nullish(),
    variance: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Avg_Order_BySchema(): z.ZodObject<Properties<Campsite_Avg_Order_By>> {
  return z.object<Properties<Campsite_Avg_Order_By>>({
    access_count: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Bool_ExpSchema(): z.ZodObject<Properties<Campsite_Bool_Exp>> {
  return z.object<Properties<Campsite_Bool_Exp>>({
    _and: z.array(definedNonNullAnySchema).nullish(),
    _not: definedNonNullAnySchema.nullish(),
    _or: z.array(definedNonNullAnySchema).nullish(),
    access_count: definedNonNullAnySchema.nullish(),
    activity_athletic: definedNonNullAnySchema.nullish(),
    activity_bbq: definedNonNullAnySchema.nullish(),
    activity_bicycle: definedNonNullAnySchema.nullish(),
    activity_canoe: definedNonNullAnySchema.nullish(),
    activity_craft: definedNonNullAnySchema.nullish(),
    activity_fishing: definedNonNullAnySchema.nullish(),
    activity_flower: definedNonNullAnySchema.nullish(),
    activity_hiking: definedNonNullAnySchema.nullish(),
    activity_insect: definedNonNullAnySchema.nullish(),
    activity_playset: definedNonNullAnySchema.nullish(),
    activity_pool: definedNonNullAnySchema.nullish(),
    activity_ranch: definedNonNullAnySchema.nullish(),
    activity_river: definedNonNullAnySchema.nullish(),
    activity_sauna: definedNonNullAnySchema.nullish(),
    activity_sea: definedNonNullAnySchema.nullish(),
    activity_star: definedNonNullAnySchema.nullish(),
    activity_taste: definedNonNullAnySchema.nullish(),
    activity_tentsauna: definedNonNullAnySchema.nullish(),
    address: definedNonNullAnySchema.nullish(),
    bath_hotspring: definedNonNullAnySchema.nullish(),
    bath_room: definedNonNullAnySchema.nullish(),
    business_newyear: definedNonNullAnySchema.nullish(),
    business_period: definedNonNullAnySchema.nullish(),
    campsite_likes: definedNonNullAnySchema.nullish(),
    campsite_likes_aggregate: definedNonNullAnySchema.nullish(),
    checkin_end_hour: definedNonNullAnySchema.nullish(),
    checkin_end_minute: definedNonNullAnySchema.nullish(),
    checkin_start_hour: definedNonNullAnySchema.nullish(),
    checkin_start_minute: definedNonNullAnySchema.nullish(),
    checkout_end_hour: definedNonNullAnySchema.nullish(),
    checkout_end_minute: definedNonNullAnySchema.nullish(),
    checkout_start_hour: definedNonNullAnySchema.nullish(),
    checkout_start_minute: definedNonNullAnySchema.nullish(),
    closed_friday: definedNonNullAnySchema.nullish(),
    closed_holiday: definedNonNullAnySchema.nullish(),
    closed_irregular: definedNonNullAnySchema.nullish(),
    closed_monday: definedNonNullAnySchema.nullish(),
    closed_not: definedNonNullAnySchema.nullish(),
    closed_saturday: definedNonNullAnySchema.nullish(),
    closed_sunday: definedNonNullAnySchema.nullish(),
    closed_thursday: definedNonNullAnySchema.nullish(),
    closed_tuesday: definedNonNullAnySchema.nullish(),
    closed_wednesday: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    facilities_barrierfree: definedNonNullAnySchema.nullish(),
    facilities_dogrun: definedNonNullAnySchema.nullish(),
    facilities_laundry: definedNonNullAnySchema.nullish(),
    facilities_restaurant: definedNonNullAnySchema.nullish(),
    facilities_store: definedNonNullAnySchema.nullish(),
    facilities_workspace: definedNonNullAnySchema.nullish(),
    facility_acsite: definedNonNullAnySchema.nullish(),
    facility_bungalow: definedNonNullAnySchema.nullish(),
    facility_cottage: definedNonNullAnySchema.nullish(),
    facility_freesite: definedNonNullAnySchema.nullish(),
    facility_glamping: definedNonNullAnySchema.nullish(),
    facility_privatesite: definedNonNullAnySchema.nullish(),
    facility_sectionsite: definedNonNullAnySchema.nullish(),
    facility_solo: definedNonNullAnySchema.nullish(),
    facility_tipi: definedNonNullAnySchema.nullish(),
    facility_trailerhouse: definedNonNullAnySchema.nullish(),
    facility_treehouse: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    image: definedNonNullAnySchema.nullish(),
    introduction_content: definedNonNullAnySchema.nullish(),
    introduction_title: definedNonNullAnySchema.nullish(),
    is_affiliated: definedNonNullAnySchema.nullish(),
    location_forest: definedNonNullAnySchema.nullish(),
    location_hill: definedNonNullAnySchema.nullish(),
    location_lake: definedNonNullAnySchema.nullish(),
    location_meadow: definedNonNullAnySchema.nullish(),
    location_ocean: definedNonNullAnySchema.nullish(),
    location_park: definedNonNullAnySchema.nullish(),
    location_plateau: definedNonNullAnySchema.nullish(),
    location_river: definedNonNullAnySchema.nullish(),
    main_image_id: definedNonNullAnySchema.nullish(),
    name: definedNonNullAnySchema.nullish(),
    official_url: definedNonNullAnySchema.nullish(),
    prefectures: definedNonNullAnySchema.nullish(),
    prefectures_code: definedNonNullAnySchema.nullish(),
    region_code: definedNonNullAnySchema.nullish(),
    reviews: definedNonNullAnySchema.nullish(),
    reviews_aggregate: definedNonNullAnySchema.nullish(),
    service_firewood: definedNonNullAnySchema.nullish(),
    service_firework: definedNonNullAnySchema.nullish(),
    service_freecharge: definedNonNullAnySchema.nullish(),
    service_garbage: definedNonNullAnySchema.nullish(),
    service_group: definedNonNullAnySchema.nullish(),
    service_hotwater: definedNonNullAnySchema.nullish(),
    service_openfire: definedNonNullAnySchema.nullish(),
    service_pet: definedNonNullAnySchema.nullish(),
    service_rental: definedNonNullAnySchema.nullish(),
    service_washlet: definedNonNullAnySchema.nullish(),
    service_wifi: definedNonNullAnySchema.nullish(),
    tel_bottom: definedNonNullAnySchema.nullish(),
    tel_head: definedNonNullAnySchema.nullish(),
    tel_while: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    vehicles_autocamp: definedNonNullAnySchema.nullish(),
    vehicles_campingcar: definedNonNullAnySchema.nullish(),
    visibility_status: definedNonNullAnySchema.nullish(),
    visiteds: definedNonNullAnySchema.nullish(),
    visiteds_aggregate: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Likes_Aggregate_Bool_ExpSchema(): z.ZodObject<Properties<Campsite_Likes_Aggregate_Bool_Exp>> {
  return z.object<Properties<Campsite_Likes_Aggregate_Bool_Exp>>({
    count: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Likes_Aggregate_Bool_Exp_CountSchema(): z.ZodObject<Properties<Campsite_Likes_Aggregate_Bool_Exp_Count>> {
  return z.object<Properties<Campsite_Likes_Aggregate_Bool_Exp_Count>>({
    arguments: z.array(definedNonNullAnySchema).nullish(),
    distinct: z.boolean().nullish(),
    filter: definedNonNullAnySchema.nullish(),
    predicate: definedNonNullAnySchema
  })
}

export function Campsite_Likes_Aggregate_Order_BySchema(): z.ZodObject<Properties<Campsite_Likes_Aggregate_Order_By>> {
  return z.object<Properties<Campsite_Likes_Aggregate_Order_By>>({
    avg: definedNonNullAnySchema.nullish(),
    count: definedNonNullAnySchema.nullish(),
    max: definedNonNullAnySchema.nullish(),
    min: definedNonNullAnySchema.nullish(),
    stddev: definedNonNullAnySchema.nullish(),
    stddev_pop: definedNonNullAnySchema.nullish(),
    stddev_samp: definedNonNullAnySchema.nullish(),
    sum: definedNonNullAnySchema.nullish(),
    var_pop: definedNonNullAnySchema.nullish(),
    var_samp: definedNonNullAnySchema.nullish(),
    variance: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Likes_Avg_Order_BySchema(): z.ZodObject<Properties<Campsite_Likes_Avg_Order_By>> {
  return z.object<Properties<Campsite_Likes_Avg_Order_By>>({
    order_index: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Likes_Bool_ExpSchema(): z.ZodObject<Properties<Campsite_Likes_Bool_Exp>> {
  return z.object<Properties<Campsite_Likes_Bool_Exp>>({
    _and: z.array(definedNonNullAnySchema).nullish(),
    _not: definedNonNullAnySchema.nullish(),
    _or: z.array(definedNonNullAnySchema).nullish(),
    campsite: definedNonNullAnySchema.nullish(),
    campsite_id: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    order_index: definedNonNullAnySchema.nullish(),
    type: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export const Campsite_Likes_ConstraintSchema = z.nativeEnum(Campsite_Likes_Constraint);

export function Campsite_Likes_Inc_InputSchema(): z.ZodObject<Properties<Campsite_Likes_Inc_Input>> {
  return z.object<Properties<Campsite_Likes_Inc_Input>>({
    order_index: z.number().nullish()
  })
}

export function Campsite_Likes_Insert_InputSchema(): z.ZodObject<Properties<Campsite_Likes_Insert_Input>> {
  return z.object<Properties<Campsite_Likes_Insert_Input>>({
    campsite_id: z.string().nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    order_index: z.number().nullish(),
    type: z.string().nullish(),
    user_id: z.string().nullish()
  })
}

export function Campsite_Likes_Max_Order_BySchema(): z.ZodObject<Properties<Campsite_Likes_Max_Order_By>> {
  return z.object<Properties<Campsite_Likes_Max_Order_By>>({
    campsite_id: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    order_index: definedNonNullAnySchema.nullish(),
    type: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Likes_Min_Order_BySchema(): z.ZodObject<Properties<Campsite_Likes_Min_Order_By>> {
  return z.object<Properties<Campsite_Likes_Min_Order_By>>({
    campsite_id: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    order_index: definedNonNullAnySchema.nullish(),
    type: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Likes_On_ConflictSchema(): z.ZodObject<Properties<Campsite_Likes_On_Conflict>> {
  return z.object<Properties<Campsite_Likes_On_Conflict>>({
    constraint: definedNonNullAnySchema,
    update_columns: z.array(definedNonNullAnySchema),
    where: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Likes_Order_BySchema(): z.ZodObject<Properties<Campsite_Likes_Order_By>> {
  return z.object<Properties<Campsite_Likes_Order_By>>({
    campsite: definedNonNullAnySchema.nullish(),
    campsite_id: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    order_index: definedNonNullAnySchema.nullish(),
    type: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Likes_Pk_Columns_InputSchema(): z.ZodObject<Properties<Campsite_Likes_Pk_Columns_Input>> {
  return z.object<Properties<Campsite_Likes_Pk_Columns_Input>>({
    id: z.string()
  })
}

export const Campsite_Likes_Select_ColumnSchema = z.nativeEnum(Campsite_Likes_Select_Column);

export function Campsite_Likes_Set_InputSchema(): z.ZodObject<Properties<Campsite_Likes_Set_Input>> {
  return z.object<Properties<Campsite_Likes_Set_Input>>({
    order_index: z.number().nullish()
  })
}

export function Campsite_Likes_Stddev_Order_BySchema(): z.ZodObject<Properties<Campsite_Likes_Stddev_Order_By>> {
  return z.object<Properties<Campsite_Likes_Stddev_Order_By>>({
    order_index: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Likes_Stddev_Pop_Order_BySchema(): z.ZodObject<Properties<Campsite_Likes_Stddev_Pop_Order_By>> {
  return z.object<Properties<Campsite_Likes_Stddev_Pop_Order_By>>({
    order_index: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Likes_Stddev_Samp_Order_BySchema(): z.ZodObject<Properties<Campsite_Likes_Stddev_Samp_Order_By>> {
  return z.object<Properties<Campsite_Likes_Stddev_Samp_Order_By>>({
    order_index: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Likes_Stream_Cursor_InputSchema(): z.ZodObject<Properties<Campsite_Likes_Stream_Cursor_Input>> {
  return z.object<Properties<Campsite_Likes_Stream_Cursor_Input>>({
    initial_value: definedNonNullAnySchema,
    ordering: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Likes_Stream_Cursor_Value_InputSchema(): z.ZodObject<Properties<Campsite_Likes_Stream_Cursor_Value_Input>> {
  return z.object<Properties<Campsite_Likes_Stream_Cursor_Value_Input>>({
    campsite_id: z.string().nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: z.string().nullish(),
    order_index: z.number().nullish(),
    type: z.string().nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: z.string().nullish()
  })
}

export function Campsite_Likes_Sum_Order_BySchema(): z.ZodObject<Properties<Campsite_Likes_Sum_Order_By>> {
  return z.object<Properties<Campsite_Likes_Sum_Order_By>>({
    order_index: definedNonNullAnySchema.nullish()
  })
}

export const Campsite_Likes_Update_ColumnSchema = z.nativeEnum(Campsite_Likes_Update_Column);

export function Campsite_Likes_UpdatesSchema(): z.ZodObject<Properties<Campsite_Likes_Updates>> {
  return z.object<Properties<Campsite_Likes_Updates>>({
    _inc: definedNonNullAnySchema.nullish(),
    _set: definedNonNullAnySchema.nullish(),
    where: definedNonNullAnySchema
  })
}

export function Campsite_Likes_Var_Pop_Order_BySchema(): z.ZodObject<Properties<Campsite_Likes_Var_Pop_Order_By>> {
  return z.object<Properties<Campsite_Likes_Var_Pop_Order_By>>({
    order_index: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Likes_Var_Samp_Order_BySchema(): z.ZodObject<Properties<Campsite_Likes_Var_Samp_Order_By>> {
  return z.object<Properties<Campsite_Likes_Var_Samp_Order_By>>({
    order_index: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Likes_Variance_Order_BySchema(): z.ZodObject<Properties<Campsite_Likes_Variance_Order_By>> {
  return z.object<Properties<Campsite_Likes_Variance_Order_By>>({
    order_index: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Max_Order_BySchema(): z.ZodObject<Properties<Campsite_Max_Order_By>> {
  return z.object<Properties<Campsite_Max_Order_By>>({
    access_count: definedNonNullAnySchema.nullish(),
    address: definedNonNullAnySchema.nullish(),
    checkin_end_hour: definedNonNullAnySchema.nullish(),
    checkin_end_minute: definedNonNullAnySchema.nullish(),
    checkin_start_hour: definedNonNullAnySchema.nullish(),
    checkin_start_minute: definedNonNullAnySchema.nullish(),
    checkout_end_hour: definedNonNullAnySchema.nullish(),
    checkout_end_minute: definedNonNullAnySchema.nullish(),
    checkout_start_hour: definedNonNullAnySchema.nullish(),
    checkout_start_minute: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    introduction_content: definedNonNullAnySchema.nullish(),
    introduction_title: definedNonNullAnySchema.nullish(),
    main_image_id: definedNonNullAnySchema.nullish(),
    name: definedNonNullAnySchema.nullish(),
    official_url: definedNonNullAnySchema.nullish(),
    prefectures: definedNonNullAnySchema.nullish(),
    prefectures_code: definedNonNullAnySchema.nullish(),
    region_code: definedNonNullAnySchema.nullish(),
    tel_bottom: definedNonNullAnySchema.nullish(),
    tel_head: definedNonNullAnySchema.nullish(),
    tel_while: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    visibility_status: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Min_Order_BySchema(): z.ZodObject<Properties<Campsite_Min_Order_By>> {
  return z.object<Properties<Campsite_Min_Order_By>>({
    access_count: definedNonNullAnySchema.nullish(),
    address: definedNonNullAnySchema.nullish(),
    checkin_end_hour: definedNonNullAnySchema.nullish(),
    checkin_end_minute: definedNonNullAnySchema.nullish(),
    checkin_start_hour: definedNonNullAnySchema.nullish(),
    checkin_start_minute: definedNonNullAnySchema.nullish(),
    checkout_end_hour: definedNonNullAnySchema.nullish(),
    checkout_end_minute: definedNonNullAnySchema.nullish(),
    checkout_start_hour: definedNonNullAnySchema.nullish(),
    checkout_start_minute: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    introduction_content: definedNonNullAnySchema.nullish(),
    introduction_title: definedNonNullAnySchema.nullish(),
    main_image_id: definedNonNullAnySchema.nullish(),
    name: definedNonNullAnySchema.nullish(),
    official_url: definedNonNullAnySchema.nullish(),
    prefectures: definedNonNullAnySchema.nullish(),
    prefectures_code: definedNonNullAnySchema.nullish(),
    region_code: definedNonNullAnySchema.nullish(),
    tel_bottom: definedNonNullAnySchema.nullish(),
    tel_head: definedNonNullAnySchema.nullish(),
    tel_while: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    visibility_status: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Order_BySchema(): z.ZodObject<Properties<Campsite_Order_By>> {
  return z.object<Properties<Campsite_Order_By>>({
    access_count: definedNonNullAnySchema.nullish(),
    activity_athletic: definedNonNullAnySchema.nullish(),
    activity_bbq: definedNonNullAnySchema.nullish(),
    activity_bicycle: definedNonNullAnySchema.nullish(),
    activity_canoe: definedNonNullAnySchema.nullish(),
    activity_craft: definedNonNullAnySchema.nullish(),
    activity_fishing: definedNonNullAnySchema.nullish(),
    activity_flower: definedNonNullAnySchema.nullish(),
    activity_hiking: definedNonNullAnySchema.nullish(),
    activity_insect: definedNonNullAnySchema.nullish(),
    activity_playset: definedNonNullAnySchema.nullish(),
    activity_pool: definedNonNullAnySchema.nullish(),
    activity_ranch: definedNonNullAnySchema.nullish(),
    activity_river: definedNonNullAnySchema.nullish(),
    activity_sauna: definedNonNullAnySchema.nullish(),
    activity_sea: definedNonNullAnySchema.nullish(),
    activity_star: definedNonNullAnySchema.nullish(),
    activity_taste: definedNonNullAnySchema.nullish(),
    activity_tentsauna: definedNonNullAnySchema.nullish(),
    address: definedNonNullAnySchema.nullish(),
    bath_hotspring: definedNonNullAnySchema.nullish(),
    bath_room: definedNonNullAnySchema.nullish(),
    business_newyear: definedNonNullAnySchema.nullish(),
    business_period: definedNonNullAnySchema.nullish(),
    campsite_likes_aggregate: definedNonNullAnySchema.nullish(),
    checkin_end_hour: definedNonNullAnySchema.nullish(),
    checkin_end_minute: definedNonNullAnySchema.nullish(),
    checkin_start_hour: definedNonNullAnySchema.nullish(),
    checkin_start_minute: definedNonNullAnySchema.nullish(),
    checkout_end_hour: definedNonNullAnySchema.nullish(),
    checkout_end_minute: definedNonNullAnySchema.nullish(),
    checkout_start_hour: definedNonNullAnySchema.nullish(),
    checkout_start_minute: definedNonNullAnySchema.nullish(),
    closed_friday: definedNonNullAnySchema.nullish(),
    closed_holiday: definedNonNullAnySchema.nullish(),
    closed_irregular: definedNonNullAnySchema.nullish(),
    closed_monday: definedNonNullAnySchema.nullish(),
    closed_not: definedNonNullAnySchema.nullish(),
    closed_saturday: definedNonNullAnySchema.nullish(),
    closed_sunday: definedNonNullAnySchema.nullish(),
    closed_thursday: definedNonNullAnySchema.nullish(),
    closed_tuesday: definedNonNullAnySchema.nullish(),
    closed_wednesday: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    facilities_barrierfree: definedNonNullAnySchema.nullish(),
    facilities_dogrun: definedNonNullAnySchema.nullish(),
    facilities_laundry: definedNonNullAnySchema.nullish(),
    facilities_restaurant: definedNonNullAnySchema.nullish(),
    facilities_store: definedNonNullAnySchema.nullish(),
    facilities_workspace: definedNonNullAnySchema.nullish(),
    facility_acsite: definedNonNullAnySchema.nullish(),
    facility_bungalow: definedNonNullAnySchema.nullish(),
    facility_cottage: definedNonNullAnySchema.nullish(),
    facility_freesite: definedNonNullAnySchema.nullish(),
    facility_glamping: definedNonNullAnySchema.nullish(),
    facility_privatesite: definedNonNullAnySchema.nullish(),
    facility_sectionsite: definedNonNullAnySchema.nullish(),
    facility_solo: definedNonNullAnySchema.nullish(),
    facility_tipi: definedNonNullAnySchema.nullish(),
    facility_trailerhouse: definedNonNullAnySchema.nullish(),
    facility_treehouse: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    image: definedNonNullAnySchema.nullish(),
    introduction_content: definedNonNullAnySchema.nullish(),
    introduction_title: definedNonNullAnySchema.nullish(),
    is_affiliated: definedNonNullAnySchema.nullish(),
    location_forest: definedNonNullAnySchema.nullish(),
    location_hill: definedNonNullAnySchema.nullish(),
    location_lake: definedNonNullAnySchema.nullish(),
    location_meadow: definedNonNullAnySchema.nullish(),
    location_ocean: definedNonNullAnySchema.nullish(),
    location_park: definedNonNullAnySchema.nullish(),
    location_plateau: definedNonNullAnySchema.nullish(),
    location_river: definedNonNullAnySchema.nullish(),
    main_image_id: definedNonNullAnySchema.nullish(),
    name: definedNonNullAnySchema.nullish(),
    official_url: definedNonNullAnySchema.nullish(),
    prefectures: definedNonNullAnySchema.nullish(),
    prefectures_code: definedNonNullAnySchema.nullish(),
    region_code: definedNonNullAnySchema.nullish(),
    reviews_aggregate: definedNonNullAnySchema.nullish(),
    service_firewood: definedNonNullAnySchema.nullish(),
    service_firework: definedNonNullAnySchema.nullish(),
    service_freecharge: definedNonNullAnySchema.nullish(),
    service_garbage: definedNonNullAnySchema.nullish(),
    service_group: definedNonNullAnySchema.nullish(),
    service_hotwater: definedNonNullAnySchema.nullish(),
    service_openfire: definedNonNullAnySchema.nullish(),
    service_pet: definedNonNullAnySchema.nullish(),
    service_rental: definedNonNullAnySchema.nullish(),
    service_washlet: definedNonNullAnySchema.nullish(),
    service_wifi: definedNonNullAnySchema.nullish(),
    tel_bottom: definedNonNullAnySchema.nullish(),
    tel_head: definedNonNullAnySchema.nullish(),
    tel_while: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    vehicles_autocamp: definedNonNullAnySchema.nullish(),
    vehicles_campingcar: definedNonNullAnySchema.nullish(),
    visibility_status: definedNonNullAnySchema.nullish(),
    visiteds_aggregate: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Pk_Columns_InputSchema(): z.ZodObject<Properties<Campsite_Pk_Columns_Input>> {
  return z.object<Properties<Campsite_Pk_Columns_Input>>({
    id: z.string()
  })
}

export function Campsite_Search_Log_Bool_ExpSchema(): z.ZodObject<Properties<Campsite_Search_Log_Bool_Exp>> {
  return z.object<Properties<Campsite_Search_Log_Bool_Exp>>({
    _and: z.array(definedNonNullAnySchema).nullish(),
    _not: definedNonNullAnySchema.nullish(),
    _or: z.array(definedNonNullAnySchema).nullish()
  })
}

export const Campsite_Search_Log_ConstraintSchema = z.nativeEnum(Campsite_Search_Log_Constraint);

export function Campsite_Search_Log_Insert_InputSchema(): z.ZodObject<Properties<Campsite_Search_Log_Insert_Input>> {
  return z.object<Properties<Campsite_Search_Log_Insert_Input>>({
    filter: definedNonNullAnySchema.nullish(),
    order_by: z.string().nullish()
  })
}

export function Campsite_Search_Log_On_ConflictSchema(): z.ZodObject<Properties<Campsite_Search_Log_On_Conflict>> {
  return z.object<Properties<Campsite_Search_Log_On_Conflict>>({
    constraint: definedNonNullAnySchema,
    update_columns: z.array(definedNonNullAnySchema),
    where: definedNonNullAnySchema.nullish()
  })
}

export const Campsite_Search_Log_Update_ColumnSchema = z.nativeEnum(Campsite_Search_Log_Update_Column);

export const Campsite_Select_ColumnSchema = z.nativeEnum(Campsite_Select_Column);

export const Campsite_Select_Column_Campsite_Aggregate_Bool_Exp_Bool_And_Arguments_ColumnsSchema = z.nativeEnum(Campsite_Select_Column_Campsite_Aggregate_Bool_Exp_Bool_And_Arguments_Columns);

export const Campsite_Select_Column_Campsite_Aggregate_Bool_Exp_Bool_Or_Arguments_ColumnsSchema = z.nativeEnum(Campsite_Select_Column_Campsite_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns);

export function Campsite_Set_InputSchema(): z.ZodObject<Properties<Campsite_Set_Input>> {
  return z.object<Properties<Campsite_Set_Input>>({
    activity_athletic: z.boolean().nullish(),
    activity_bbq: z.boolean().nullish(),
    activity_bicycle: z.boolean().nullish(),
    activity_canoe: z.boolean().nullish(),
    activity_craft: z.boolean().nullish(),
    activity_fishing: z.boolean().nullish(),
    activity_flower: z.boolean().nullish(),
    activity_hiking: z.boolean().nullish(),
    activity_insect: z.boolean().nullish(),
    activity_playset: z.boolean().nullish(),
    activity_pool: z.boolean().nullish(),
    activity_ranch: z.boolean().nullish(),
    activity_river: z.boolean().nullish(),
    activity_sauna: z.boolean().nullish(),
    activity_sea: z.boolean().nullish(),
    activity_star: z.boolean().nullish(),
    activity_taste: z.boolean().nullish(),
    activity_tentsauna: z.boolean().nullish(),
    bath_hotspring: z.boolean().nullish(),
    bath_room: z.boolean().nullish(),
    business_newyear: z.boolean().nullish(),
    business_period: z.boolean().nullish(),
    checkin_end_hour: z.string().nullish(),
    checkin_end_minute: z.string().nullish(),
    checkin_start_hour: z.string().nullish(),
    checkin_start_minute: z.string().nullish(),
    checkout_end_hour: z.string().nullish(),
    checkout_end_minute: z.string().nullish(),
    checkout_start_hour: z.string().nullish(),
    checkout_start_minute: z.string().nullish(),
    closed_friday: z.boolean().nullish(),
    closed_holiday: z.boolean().nullish(),
    closed_irregular: z.boolean().nullish(),
    closed_monday: z.boolean().nullish(),
    closed_not: z.boolean().nullish(),
    closed_saturday: z.boolean().nullish(),
    closed_sunday: z.boolean().nullish(),
    closed_thursday: z.boolean().nullish(),
    closed_tuesday: z.boolean().nullish(),
    closed_wednesday: z.boolean().nullish(),
    facilities_barrierfree: z.boolean().nullish(),
    facilities_dogrun: z.boolean().nullish(),
    facilities_laundry: z.boolean().nullish(),
    facilities_restaurant: z.boolean().nullish(),
    facilities_store: z.boolean().nullish(),
    facilities_workspace: z.boolean().nullish(),
    facility_acsite: z.boolean().nullish(),
    facility_bungalow: z.boolean().nullish(),
    facility_cottage: z.boolean().nullish(),
    facility_freesite: z.boolean().nullish(),
    facility_glamping: z.boolean().nullish(),
    facility_privatesite: z.boolean().nullish(),
    facility_sectionsite: z.boolean().nullish(),
    facility_solo: z.boolean().nullish(),
    facility_tipi: z.boolean().nullish(),
    facility_trailerhouse: z.boolean().nullish(),
    facility_treehouse: z.boolean().nullish(),
    introduction_content: z.string().nullish(),
    introduction_title: z.string().nullish(),
    is_affiliated: z.boolean().nullish(),
    location_forest: z.boolean().nullish(),
    location_hill: z.boolean().nullish(),
    location_lake: z.boolean().nullish(),
    location_meadow: z.boolean().nullish(),
    location_ocean: z.boolean().nullish(),
    location_park: z.boolean().nullish(),
    location_plateau: z.boolean().nullish(),
    location_river: z.boolean().nullish(),
    main_image_id: z.string().nullish(),
    official_url: z.string().nullish(),
    prefectures: z.string().nullish(),
    prefectures_code: z.string().nullish(),
    region_code: z.string().nullish(),
    service_firewood: z.boolean().nullish(),
    service_firework: z.boolean().nullish(),
    service_freecharge: z.boolean().nullish(),
    service_garbage: z.boolean().nullish(),
    service_group: z.boolean().nullish(),
    service_hotwater: z.boolean().nullish(),
    service_openfire: z.boolean().nullish(),
    service_pet: z.boolean().nullish(),
    service_rental: z.boolean().nullish(),
    service_washlet: z.boolean().nullish(),
    service_wifi: z.boolean().nullish(),
    tel_bottom: z.string().nullish(),
    tel_head: z.string().nullish(),
    tel_while: z.string().nullish(),
    vehicles_autocamp: z.boolean().nullish(),
    vehicles_campingcar: z.boolean().nullish()
  })
}

export function Campsite_Stddev_Order_BySchema(): z.ZodObject<Properties<Campsite_Stddev_Order_By>> {
  return z.object<Properties<Campsite_Stddev_Order_By>>({
    access_count: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Stddev_Pop_Order_BySchema(): z.ZodObject<Properties<Campsite_Stddev_Pop_Order_By>> {
  return z.object<Properties<Campsite_Stddev_Pop_Order_By>>({
    access_count: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Stddev_Samp_Order_BySchema(): z.ZodObject<Properties<Campsite_Stddev_Samp_Order_By>> {
  return z.object<Properties<Campsite_Stddev_Samp_Order_By>>({
    access_count: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Stream_Cursor_InputSchema(): z.ZodObject<Properties<Campsite_Stream_Cursor_Input>> {
  return z.object<Properties<Campsite_Stream_Cursor_Input>>({
    initial_value: definedNonNullAnySchema,
    ordering: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Stream_Cursor_Value_InputSchema(): z.ZodObject<Properties<Campsite_Stream_Cursor_Value_Input>> {
  return z.object<Properties<Campsite_Stream_Cursor_Value_Input>>({
    access_count: z.number().nullish(),
    activity_athletic: z.boolean().nullish(),
    activity_bbq: z.boolean().nullish(),
    activity_bicycle: z.boolean().nullish(),
    activity_canoe: z.boolean().nullish(),
    activity_craft: z.boolean().nullish(),
    activity_fishing: z.boolean().nullish(),
    activity_flower: z.boolean().nullish(),
    activity_hiking: z.boolean().nullish(),
    activity_insect: z.boolean().nullish(),
    activity_playset: z.boolean().nullish(),
    activity_pool: z.boolean().nullish(),
    activity_ranch: z.boolean().nullish(),
    activity_river: z.boolean().nullish(),
    activity_sauna: z.boolean().nullish(),
    activity_sea: z.boolean().nullish(),
    activity_star: z.boolean().nullish(),
    activity_taste: z.boolean().nullish(),
    activity_tentsauna: z.boolean().nullish(),
    address: z.string().nullish(),
    bath_hotspring: z.boolean().nullish(),
    bath_room: z.boolean().nullish(),
    business_newyear: z.boolean().nullish(),
    business_period: z.boolean().nullish(),
    checkin_end_hour: z.string().nullish(),
    checkin_end_minute: z.string().nullish(),
    checkin_start_hour: z.string().nullish(),
    checkin_start_minute: z.string().nullish(),
    checkout_end_hour: z.string().nullish(),
    checkout_end_minute: z.string().nullish(),
    checkout_start_hour: z.string().nullish(),
    checkout_start_minute: z.string().nullish(),
    closed_friday: z.boolean().nullish(),
    closed_holiday: z.boolean().nullish(),
    closed_irregular: z.boolean().nullish(),
    closed_monday: z.boolean().nullish(),
    closed_not: z.boolean().nullish(),
    closed_saturday: z.boolean().nullish(),
    closed_sunday: z.boolean().nullish(),
    closed_thursday: z.boolean().nullish(),
    closed_tuesday: z.boolean().nullish(),
    closed_wednesday: z.boolean().nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    facilities_barrierfree: z.boolean().nullish(),
    facilities_dogrun: z.boolean().nullish(),
    facilities_laundry: z.boolean().nullish(),
    facilities_restaurant: z.boolean().nullish(),
    facilities_store: z.boolean().nullish(),
    facilities_workspace: z.boolean().nullish(),
    facility_acsite: z.boolean().nullish(),
    facility_bungalow: z.boolean().nullish(),
    facility_cottage: z.boolean().nullish(),
    facility_freesite: z.boolean().nullish(),
    facility_glamping: z.boolean().nullish(),
    facility_privatesite: z.boolean().nullish(),
    facility_sectionsite: z.boolean().nullish(),
    facility_solo: z.boolean().nullish(),
    facility_tipi: z.boolean().nullish(),
    facility_trailerhouse: z.boolean().nullish(),
    facility_treehouse: z.boolean().nullish(),
    id: z.string().nullish(),
    introduction_content: z.string().nullish(),
    introduction_title: z.string().nullish(),
    is_affiliated: z.boolean().nullish(),
    location_forest: z.boolean().nullish(),
    location_hill: z.boolean().nullish(),
    location_lake: z.boolean().nullish(),
    location_meadow: z.boolean().nullish(),
    location_ocean: z.boolean().nullish(),
    location_park: z.boolean().nullish(),
    location_plateau: z.boolean().nullish(),
    location_river: z.boolean().nullish(),
    main_image_id: z.string().nullish(),
    name: z.string().nullish(),
    official_url: z.string().nullish(),
    prefectures: z.string().nullish(),
    prefectures_code: z.string().nullish(),
    region_code: z.string().nullish(),
    service_firewood: z.boolean().nullish(),
    service_firework: z.boolean().nullish(),
    service_freecharge: z.boolean().nullish(),
    service_garbage: z.boolean().nullish(),
    service_group: z.boolean().nullish(),
    service_hotwater: z.boolean().nullish(),
    service_openfire: z.boolean().nullish(),
    service_pet: z.boolean().nullish(),
    service_rental: z.boolean().nullish(),
    service_washlet: z.boolean().nullish(),
    service_wifi: z.boolean().nullish(),
    tel_bottom: z.string().nullish(),
    tel_head: z.string().nullish(),
    tel_while: z.string().nullish(),
    total_like_num: z.number().nullish(),
    total_review_num: z.number().nullish(),
    total_visited_num: z.number().nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    vehicles_autocamp: z.boolean().nullish(),
    vehicles_campingcar: z.boolean().nullish(),
    visibility_status: z.string().nullish()
  })
}

export function Campsite_Sum_Order_BySchema(): z.ZodObject<Properties<Campsite_Sum_Order_By>> {
  return z.object<Properties<Campsite_Sum_Order_By>>({
    access_count: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_UpdatesSchema(): z.ZodObject<Properties<Campsite_Updates>> {
  return z.object<Properties<Campsite_Updates>>({
    _set: definedNonNullAnySchema.nullish(),
    where: definedNonNullAnySchema
  })
}

export function Campsite_Var_Pop_Order_BySchema(): z.ZodObject<Properties<Campsite_Var_Pop_Order_By>> {
  return z.object<Properties<Campsite_Var_Pop_Order_By>>({
    access_count: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Var_Samp_Order_BySchema(): z.ZodObject<Properties<Campsite_Var_Samp_Order_By>> {
  return z.object<Properties<Campsite_Var_Samp_Order_By>>({
    access_count: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish()
  })
}

export function Campsite_Variance_Order_BySchema(): z.ZodObject<Properties<Campsite_Variance_Order_By>> {
  return z.object<Properties<Campsite_Variance_Order_By>>({
    access_count: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish()
  })
}

export const Cursor_OrderingSchema = z.nativeEnum(Cursor_Ordering);

export function Date_Comparison_ExpSchema(): z.ZodObject<Properties<Date_Comparison_Exp>> {
  return z.object<Properties<Date_Comparison_Exp>>({
    _eq: definedNonNullAnySchema.nullish(),
    _gt: definedNonNullAnySchema.nullish(),
    _gte: definedNonNullAnySchema.nullish(),
    _in: z.array(definedNonNullAnySchema).nullish(),
    _is_null: z.boolean().nullish(),
    _lt: definedNonNullAnySchema.nullish(),
    _lte: definedNonNullAnySchema.nullish(),
    _neq: definedNonNullAnySchema.nullish(),
    _nin: z.array(definedNonNullAnySchema).nullish()
  })
}

export function Exchange_Fixed_Exchange_Product_ArgsSchema(): z.ZodObject<Properties<Exchange_Fixed_Exchange_Product_Args>> {
  return z.object<Properties<Exchange_Fixed_Exchange_Product_Args>>({
    target_campsite_id: z.string().nullish(),
    target_fixed_exchange_product_id: z.string().nullish()
  })
}

export function Fixed_Exchange_Product_Exchanged_Aggregate_Bool_ExpSchema(): z.ZodObject<Properties<Fixed_Exchange_Product_Exchanged_Aggregate_Bool_Exp>> {
  return z.object<Properties<Fixed_Exchange_Product_Exchanged_Aggregate_Bool_Exp>>({
    count: definedNonNullAnySchema.nullish()
  })
}

export function Fixed_Exchange_Product_Exchanged_Aggregate_Bool_Exp_CountSchema(): z.ZodObject<Properties<Fixed_Exchange_Product_Exchanged_Aggregate_Bool_Exp_Count>> {
  return z.object<Properties<Fixed_Exchange_Product_Exchanged_Aggregate_Bool_Exp_Count>>({
    arguments: z.array(definedNonNullAnySchema).nullish(),
    distinct: z.boolean().nullish(),
    filter: definedNonNullAnySchema.nullish(),
    predicate: definedNonNullAnySchema
  })
}

export function Fixed_Exchange_Product_Exchanged_Aggregate_Order_BySchema(): z.ZodObject<Properties<Fixed_Exchange_Product_Exchanged_Aggregate_Order_By>> {
  return z.object<Properties<Fixed_Exchange_Product_Exchanged_Aggregate_Order_By>>({
    count: definedNonNullAnySchema.nullish(),
    max: definedNonNullAnySchema.nullish(),
    min: definedNonNullAnySchema.nullish()
  })
}

export function Fixed_Exchange_Product_Exchanged_Bool_ExpSchema(): z.ZodObject<Properties<Fixed_Exchange_Product_Exchanged_Bool_Exp>> {
  return z.object<Properties<Fixed_Exchange_Product_Exchanged_Bool_Exp>>({
    _and: z.array(definedNonNullAnySchema).nullish(),
    _not: definedNonNullAnySchema.nullish(),
    _or: z.array(definedNonNullAnySchema).nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    fixed_exchange_product_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    point_used_id: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function Fixed_Exchange_Product_Exchanged_Max_Order_BySchema(): z.ZodObject<Properties<Fixed_Exchange_Product_Exchanged_Max_Order_By>> {
  return z.object<Properties<Fixed_Exchange_Product_Exchanged_Max_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    fixed_exchange_product_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    point_used_id: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function Fixed_Exchange_Product_Exchanged_Min_Order_BySchema(): z.ZodObject<Properties<Fixed_Exchange_Product_Exchanged_Min_Order_By>> {
  return z.object<Properties<Fixed_Exchange_Product_Exchanged_Min_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    fixed_exchange_product_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    point_used_id: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function Fixed_Exchange_Product_Exchanged_Order_BySchema(): z.ZodObject<Properties<Fixed_Exchange_Product_Exchanged_Order_By>> {
  return z.object<Properties<Fixed_Exchange_Product_Exchanged_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    fixed_exchange_product_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    point_used_id: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export const Fixed_Exchange_Product_Exchanged_Select_ColumnSchema = z.nativeEnum(Fixed_Exchange_Product_Exchanged_Select_Column);

export function Fixed_Exchange_Product_Exchanged_Stream_Cursor_InputSchema(): z.ZodObject<Properties<Fixed_Exchange_Product_Exchanged_Stream_Cursor_Input>> {
  return z.object<Properties<Fixed_Exchange_Product_Exchanged_Stream_Cursor_Input>>({
    initial_value: definedNonNullAnySchema,
    ordering: definedNonNullAnySchema.nullish()
  })
}

export function Fixed_Exchange_Product_Exchanged_Stream_Cursor_Value_InputSchema(): z.ZodObject<Properties<Fixed_Exchange_Product_Exchanged_Stream_Cursor_Value_Input>> {
  return z.object<Properties<Fixed_Exchange_Product_Exchanged_Stream_Cursor_Value_Input>>({
    created_at: definedNonNullAnySchema.nullish(),
    fixed_exchange_product_id: z.string().nullish(),
    id: z.string().nullish(),
    point_used_id: z.string().nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: z.string().nullish()
  })
}

export function Gacha_Bool_ExpSchema(): z.ZodObject<Properties<Gacha_Bool_Exp>> {
  return z.object<Properties<Gacha_Bool_Exp>>({
    _and: z.array(definedNonNullAnySchema).nullish(),
    _not: definedNonNullAnySchema.nullish(),
    _or: z.array(definedNonNullAnySchema).nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    end_at: definedNonNullAnySchema.nullish(),
    gacha_loses: definedNonNullAnySchema.nullish(),
    gacha_loses_aggregate: definedNonNullAnySchema.nullish(),
    gacha_physical_prize_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    name: definedNonNullAnySchema.nullish(),
    physical_prizes: definedNonNullAnySchema.nullish(),
    physical_prizes_aggregate: definedNonNullAnySchema.nullish(),
    point: definedNonNullAnySchema.nullish(),
    probability: definedNonNullAnySchema.nullish(),
    start_at: definedNonNullAnySchema.nullish(),
    total_win_num: definedNonNullAnySchema.nullish(),
    total_win_num_limit: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish()
  })
}

export function Gacha_Lose_Aggregate_Bool_ExpSchema(): z.ZodObject<Properties<Gacha_Lose_Aggregate_Bool_Exp>> {
  return z.object<Properties<Gacha_Lose_Aggregate_Bool_Exp>>({
    count: definedNonNullAnySchema.nullish()
  })
}

export function Gacha_Lose_Aggregate_Bool_Exp_CountSchema(): z.ZodObject<Properties<Gacha_Lose_Aggregate_Bool_Exp_Count>> {
  return z.object<Properties<Gacha_Lose_Aggregate_Bool_Exp_Count>>({
    arguments: z.array(definedNonNullAnySchema).nullish(),
    distinct: z.boolean().nullish(),
    filter: definedNonNullAnySchema.nullish(),
    predicate: definedNonNullAnySchema
  })
}

export function Gacha_Lose_Aggregate_Order_BySchema(): z.ZodObject<Properties<Gacha_Lose_Aggregate_Order_By>> {
  return z.object<Properties<Gacha_Lose_Aggregate_Order_By>>({
    count: definedNonNullAnySchema.nullish(),
    max: definedNonNullAnySchema.nullish(),
    min: definedNonNullAnySchema.nullish()
  })
}

export function Gacha_Lose_Bool_ExpSchema(): z.ZodObject<Properties<Gacha_Lose_Bool_Exp>> {
  return z.object<Properties<Gacha_Lose_Bool_Exp>>({
    _and: z.array(definedNonNullAnySchema).nullish(),
    _not: definedNonNullAnySchema.nullish(),
    _or: z.array(definedNonNullAnySchema).nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    gacha: definedNonNullAnySchema.nullish(),
    gacha_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    point_used_id: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function Gacha_Lose_Max_Order_BySchema(): z.ZodObject<Properties<Gacha_Lose_Max_Order_By>> {
  return z.object<Properties<Gacha_Lose_Max_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    gacha_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    point_used_id: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function Gacha_Lose_Min_Order_BySchema(): z.ZodObject<Properties<Gacha_Lose_Min_Order_By>> {
  return z.object<Properties<Gacha_Lose_Min_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    gacha_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    point_used_id: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function Gacha_Lose_Order_BySchema(): z.ZodObject<Properties<Gacha_Lose_Order_By>> {
  return z.object<Properties<Gacha_Lose_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    gacha: definedNonNullAnySchema.nullish(),
    gacha_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    point_used_id: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export const Gacha_Lose_Select_ColumnSchema = z.nativeEnum(Gacha_Lose_Select_Column);

export function Gacha_Lose_Stream_Cursor_InputSchema(): z.ZodObject<Properties<Gacha_Lose_Stream_Cursor_Input>> {
  return z.object<Properties<Gacha_Lose_Stream_Cursor_Input>>({
    initial_value: definedNonNullAnySchema,
    ordering: definedNonNullAnySchema.nullish()
  })
}

export function Gacha_Lose_Stream_Cursor_Value_InputSchema(): z.ZodObject<Properties<Gacha_Lose_Stream_Cursor_Value_Input>> {
  return z.object<Properties<Gacha_Lose_Stream_Cursor_Value_Input>>({
    created_at: definedNonNullAnySchema.nullish(),
    gacha_id: z.string().nullish(),
    id: z.string().nullish(),
    point_used_id: z.string().nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: z.string().nullish()
  })
}

export function Gacha_Order_BySchema(): z.ZodObject<Properties<Gacha_Order_By>> {
  return z.object<Properties<Gacha_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    end_at: definedNonNullAnySchema.nullish(),
    gacha_loses_aggregate: definedNonNullAnySchema.nullish(),
    gacha_physical_prize_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    name: definedNonNullAnySchema.nullish(),
    physical_prizes_aggregate: definedNonNullAnySchema.nullish(),
    point: definedNonNullAnySchema.nullish(),
    probability: definedNonNullAnySchema.nullish(),
    start_at: definedNonNullAnySchema.nullish(),
    total_win_num: definedNonNullAnySchema.nullish(),
    total_win_num_limit: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish()
  })
}

export const Gacha_Select_ColumnSchema = z.nativeEnum(Gacha_Select_Column);

export function Gacha_Stream_Cursor_InputSchema(): z.ZodObject<Properties<Gacha_Stream_Cursor_Input>> {
  return z.object<Properties<Gacha_Stream_Cursor_Input>>({
    initial_value: definedNonNullAnySchema,
    ordering: definedNonNullAnySchema.nullish()
  })
}

export function Gacha_Stream_Cursor_Value_InputSchema(): z.ZodObject<Properties<Gacha_Stream_Cursor_Value_Input>> {
  return z.object<Properties<Gacha_Stream_Cursor_Value_Input>>({
    created_at: definedNonNullAnySchema.nullish(),
    end_at: definedNonNullAnySchema.nullish(),
    gacha_physical_prize_id: z.string().nullish(),
    id: z.string().nullish(),
    name: z.string().nullish(),
    point: z.number().nullish(),
    probability: z.number().nullish(),
    start_at: definedNonNullAnySchema.nullish(),
    total_win_num: z.number().nullish(),
    total_win_num_limit: z.number().nullish(),
    updated_at: definedNonNullAnySchema.nullish()
  })
}

export function Image_Bool_ExpSchema(): z.ZodObject<Properties<Image_Bool_Exp>> {
  return z.object<Properties<Image_Bool_Exp>>({
    _and: z.array(definedNonNullAnySchema).nullish(),
    _not: definedNonNullAnySchema.nullish(),
    _or: z.array(definedNonNullAnySchema).nullish(),
    alt: definedNonNullAnySchema.nullish(),
    campsites: definedNonNullAnySchema.nullish(),
    campsites_aggregate: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    file_name: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    review_images: definedNonNullAnySchema.nullish(),
    review_images_aggregate: definedNonNullAnySchema.nullish(),
    title: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish(),
    users: definedNonNullAnySchema.nullish(),
    usersByIconImageId: definedNonNullAnySchema.nullish()
  })
}

export const Image_ConstraintSchema = z.nativeEnum(Image_Constraint);

export function Image_Insert_InputSchema(): z.ZodObject<Properties<Image_Insert_Input>> {
  return z.object<Properties<Image_Insert_Input>>({
    alt: z.string().nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    file_name: z.string().nullish(),
    id: z.string().nullish(),
    review_images: definedNonNullAnySchema.nullish(),
    title: z.string().nullish(),
    user_id: z.string().nullish()
  })
}

export function Image_Obj_Rel_Insert_InputSchema(): z.ZodObject<Properties<Image_Obj_Rel_Insert_Input>> {
  return z.object<Properties<Image_Obj_Rel_Insert_Input>>({
    data: definedNonNullAnySchema,
    on_conflict: definedNonNullAnySchema.nullish()
  })
}

export function Image_On_ConflictSchema(): z.ZodObject<Properties<Image_On_Conflict>> {
  return z.object<Properties<Image_On_Conflict>>({
    constraint: definedNonNullAnySchema,
    update_columns: z.array(definedNonNullAnySchema),
    where: definedNonNullAnySchema.nullish()
  })
}

export function Image_Order_BySchema(): z.ZodObject<Properties<Image_Order_By>> {
  return z.object<Properties<Image_Order_By>>({
    alt: definedNonNullAnySchema.nullish(),
    campsites_aggregate: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    file_name: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    review_images_aggregate: definedNonNullAnySchema.nullish(),
    title: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish(),
    usersByIconImageId_aggregate: definedNonNullAnySchema.nullish(),
    users_aggregate: definedNonNullAnySchema.nullish()
  })
}

export function Image_Pk_Columns_InputSchema(): z.ZodObject<Properties<Image_Pk_Columns_Input>> {
  return z.object<Properties<Image_Pk_Columns_Input>>({
    id: z.string()
  })
}

export const Image_Select_ColumnSchema = z.nativeEnum(Image_Select_Column);

export function Image_Set_InputSchema(): z.ZodObject<Properties<Image_Set_Input>> {
  return z.object<Properties<Image_Set_Input>>({
    alt: z.string().nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    file_name: z.string().nullish(),
    id: z.string().nullish(),
    title: z.string().nullish()
  })
}

export function Image_Stream_Cursor_InputSchema(): z.ZodObject<Properties<Image_Stream_Cursor_Input>> {
  return z.object<Properties<Image_Stream_Cursor_Input>>({
    initial_value: definedNonNullAnySchema,
    ordering: definedNonNullAnySchema.nullish()
  })
}

export function Image_Stream_Cursor_Value_InputSchema(): z.ZodObject<Properties<Image_Stream_Cursor_Value_Input>> {
  return z.object<Properties<Image_Stream_Cursor_Value_Input>>({
    alt: z.string().nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    file_name: z.string().nullish(),
    id: z.string().nullish(),
    title: z.string().nullish(),
    user_id: z.string().nullish()
  })
}

export const Image_Update_ColumnSchema = z.nativeEnum(Image_Update_Column);

export function Image_UpdatesSchema(): z.ZodObject<Properties<Image_Updates>> {
  return z.object<Properties<Image_Updates>>({
    _set: definedNonNullAnySchema.nullish(),
    where: definedNonNullAnySchema
  })
}

export function Jsonb_Cast_ExpSchema(): z.ZodObject<Properties<Jsonb_Cast_Exp>> {
  return z.object<Properties<Jsonb_Cast_Exp>>({
    String: definedNonNullAnySchema.nullish()
  })
}

export function Jsonb_Comparison_ExpSchema(): z.ZodObject<Properties<Jsonb_Comparison_Exp>> {
  return z.object<Properties<Jsonb_Comparison_Exp>>({
    _cast: definedNonNullAnySchema.nullish(),
    _contained_in: definedNonNullAnySchema.nullish(),
    _contains: definedNonNullAnySchema.nullish(),
    _eq: definedNonNullAnySchema.nullish(),
    _gt: definedNonNullAnySchema.nullish(),
    _gte: definedNonNullAnySchema.nullish(),
    _has_key: z.string().nullish(),
    _has_keys_all: z.array(z.string()).nullish(),
    _has_keys_any: z.array(z.string()).nullish(),
    _in: z.array(definedNonNullAnySchema).nullish(),
    _is_null: z.boolean().nullish(),
    _lt: definedNonNullAnySchema.nullish(),
    _lte: definedNonNullAnySchema.nullish(),
    _neq: definedNonNullAnySchema.nullish(),
    _nin: z.array(definedNonNullAnySchema).nullish()
  })
}

export const Order_BySchema = z.nativeEnum(Order_By);

export function Physical_Prize_Aggregate_Bool_ExpSchema(): z.ZodObject<Properties<Physical_Prize_Aggregate_Bool_Exp>> {
  return z.object<Properties<Physical_Prize_Aggregate_Bool_Exp>>({
    count: definedNonNullAnySchema.nullish()
  })
}

export function Physical_Prize_Aggregate_Bool_Exp_CountSchema(): z.ZodObject<Properties<Physical_Prize_Aggregate_Bool_Exp_Count>> {
  return z.object<Properties<Physical_Prize_Aggregate_Bool_Exp_Count>>({
    arguments: z.array(definedNonNullAnySchema).nullish(),
    distinct: z.boolean().nullish(),
    filter: definedNonNullAnySchema.nullish(),
    predicate: definedNonNullAnySchema
  })
}

export function Physical_Prize_Aggregate_Order_BySchema(): z.ZodObject<Properties<Physical_Prize_Aggregate_Order_By>> {
  return z.object<Properties<Physical_Prize_Aggregate_Order_By>>({
    count: definedNonNullAnySchema.nullish(),
    max: definedNonNullAnySchema.nullish(),
    min: definedNonNullAnySchema.nullish()
  })
}

export function Physical_Prize_Bool_ExpSchema(): z.ZodObject<Properties<Physical_Prize_Bool_Exp>> {
  return z.object<Properties<Physical_Prize_Bool_Exp>>({
    _and: z.array(definedNonNullAnySchema).nullish(),
    _not: definedNonNullAnySchema.nullish(),
    _or: z.array(definedNonNullAnySchema).nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    gacha: definedNonNullAnySchema.nullish(),
    gacha_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    input_delivery_address_at: definedNonNullAnySchema.nullish(),
    physical_prize_delivery_address: definedNonNullAnySchema.nullish(),
    physical_prize_delivery_address_id: definedNonNullAnySchema.nullish(),
    point_used_id: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function Physical_Prize_Delivery_Address_Aggregate_Bool_ExpSchema(): z.ZodObject<Properties<Physical_Prize_Delivery_Address_Aggregate_Bool_Exp>> {
  return z.object<Properties<Physical_Prize_Delivery_Address_Aggregate_Bool_Exp>>({
    count: definedNonNullAnySchema.nullish()
  })
}

export function Physical_Prize_Delivery_Address_Aggregate_Bool_Exp_CountSchema(): z.ZodObject<Properties<Physical_Prize_Delivery_Address_Aggregate_Bool_Exp_Count>> {
  return z.object<Properties<Physical_Prize_Delivery_Address_Aggregate_Bool_Exp_Count>>({
    arguments: z.array(definedNonNullAnySchema).nullish(),
    distinct: z.boolean().nullish(),
    filter: definedNonNullAnySchema.nullish(),
    predicate: definedNonNullAnySchema
  })
}

export function Physical_Prize_Delivery_Address_Aggregate_Order_BySchema(): z.ZodObject<Properties<Physical_Prize_Delivery_Address_Aggregate_Order_By>> {
  return z.object<Properties<Physical_Prize_Delivery_Address_Aggregate_Order_By>>({
    count: definedNonNullAnySchema.nullish(),
    max: definedNonNullAnySchema.nullish(),
    min: definedNonNullAnySchema.nullish()
  })
}

export function Physical_Prize_Delivery_Address_Bool_ExpSchema(): z.ZodObject<Properties<Physical_Prize_Delivery_Address_Bool_Exp>> {
  return z.object<Properties<Physical_Prize_Delivery_Address_Bool_Exp>>({
    _and: z.array(definedNonNullAnySchema).nullish(),
    _not: definedNonNullAnySchema.nullish(),
    _or: z.array(definedNonNullAnySchema).nullish(),
    building: definedNonNullAnySchema.nullish(),
    city: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    name: definedNonNullAnySchema.nullish(),
    postal_code: definedNonNullAnySchema.nullish(),
    prefecture: definedNonNullAnySchema.nullish(),
    street: definedNonNullAnySchema.nullish(),
    tel_body: definedNonNullAnySchema.nullish(),
    tel_head: definedNonNullAnySchema.nullish(),
    tel_tail: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function Physical_Prize_Delivery_Address_Max_Order_BySchema(): z.ZodObject<Properties<Physical_Prize_Delivery_Address_Max_Order_By>> {
  return z.object<Properties<Physical_Prize_Delivery_Address_Max_Order_By>>({
    building: definedNonNullAnySchema.nullish(),
    city: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    name: definedNonNullAnySchema.nullish(),
    postal_code: definedNonNullAnySchema.nullish(),
    prefecture: definedNonNullAnySchema.nullish(),
    street: definedNonNullAnySchema.nullish(),
    tel_body: definedNonNullAnySchema.nullish(),
    tel_head: definedNonNullAnySchema.nullish(),
    tel_tail: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function Physical_Prize_Delivery_Address_Min_Order_BySchema(): z.ZodObject<Properties<Physical_Prize_Delivery_Address_Min_Order_By>> {
  return z.object<Properties<Physical_Prize_Delivery_Address_Min_Order_By>>({
    building: definedNonNullAnySchema.nullish(),
    city: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    name: definedNonNullAnySchema.nullish(),
    postal_code: definedNonNullAnySchema.nullish(),
    prefecture: definedNonNullAnySchema.nullish(),
    street: definedNonNullAnySchema.nullish(),
    tel_body: definedNonNullAnySchema.nullish(),
    tel_head: definedNonNullAnySchema.nullish(),
    tel_tail: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function Physical_Prize_Delivery_Address_Order_BySchema(): z.ZodObject<Properties<Physical_Prize_Delivery_Address_Order_By>> {
  return z.object<Properties<Physical_Prize_Delivery_Address_Order_By>>({
    building: definedNonNullAnySchema.nullish(),
    city: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    name: definedNonNullAnySchema.nullish(),
    postal_code: definedNonNullAnySchema.nullish(),
    prefecture: definedNonNullAnySchema.nullish(),
    street: definedNonNullAnySchema.nullish(),
    tel_body: definedNonNullAnySchema.nullish(),
    tel_head: definedNonNullAnySchema.nullish(),
    tel_tail: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export const Physical_Prize_Delivery_Address_Select_ColumnSchema = z.nativeEnum(Physical_Prize_Delivery_Address_Select_Column);

export function Physical_Prize_Delivery_Address_Stream_Cursor_InputSchema(): z.ZodObject<Properties<Physical_Prize_Delivery_Address_Stream_Cursor_Input>> {
  return z.object<Properties<Physical_Prize_Delivery_Address_Stream_Cursor_Input>>({
    initial_value: definedNonNullAnySchema,
    ordering: definedNonNullAnySchema.nullish()
  })
}

export function Physical_Prize_Delivery_Address_Stream_Cursor_Value_InputSchema(): z.ZodObject<Properties<Physical_Prize_Delivery_Address_Stream_Cursor_Value_Input>> {
  return z.object<Properties<Physical_Prize_Delivery_Address_Stream_Cursor_Value_Input>>({
    building: z.string().nullish(),
    city: z.string().nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: z.string().nullish(),
    name: z.string().nullish(),
    postal_code: z.string().nullish(),
    prefecture: z.string().nullish(),
    street: z.string().nullish(),
    tel_body: z.string().nullish(),
    tel_head: z.string().nullish(),
    tel_tail: z.string().nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: z.string().nullish()
  })
}

export function Physical_Prize_Max_Order_BySchema(): z.ZodObject<Properties<Physical_Prize_Max_Order_By>> {
  return z.object<Properties<Physical_Prize_Max_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    gacha_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    input_delivery_address_at: definedNonNullAnySchema.nullish(),
    physical_prize_delivery_address_id: definedNonNullAnySchema.nullish(),
    point_used_id: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function Physical_Prize_Min_Order_BySchema(): z.ZodObject<Properties<Physical_Prize_Min_Order_By>> {
  return z.object<Properties<Physical_Prize_Min_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    gacha_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    input_delivery_address_at: definedNonNullAnySchema.nullish(),
    physical_prize_delivery_address_id: definedNonNullAnySchema.nullish(),
    point_used_id: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function Physical_Prize_Order_BySchema(): z.ZodObject<Properties<Physical_Prize_Order_By>> {
  return z.object<Properties<Physical_Prize_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    gacha: definedNonNullAnySchema.nullish(),
    gacha_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    input_delivery_address_at: definedNonNullAnySchema.nullish(),
    physical_prize_delivery_address: definedNonNullAnySchema.nullish(),
    physical_prize_delivery_address_id: definedNonNullAnySchema.nullish(),
    point_used_id: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export const Physical_Prize_Select_ColumnSchema = z.nativeEnum(Physical_Prize_Select_Column);

export function Physical_Prize_Stream_Cursor_InputSchema(): z.ZodObject<Properties<Physical_Prize_Stream_Cursor_Input>> {
  return z.object<Properties<Physical_Prize_Stream_Cursor_Input>>({
    initial_value: definedNonNullAnySchema,
    ordering: definedNonNullAnySchema.nullish()
  })
}

export function Physical_Prize_Stream_Cursor_Value_InputSchema(): z.ZodObject<Properties<Physical_Prize_Stream_Cursor_Value_Input>> {
  return z.object<Properties<Physical_Prize_Stream_Cursor_Value_Input>>({
    created_at: definedNonNullAnySchema.nullish(),
    gacha_id: z.string().nullish(),
    id: z.string().nullish(),
    input_delivery_address_at: definedNonNullAnySchema.nullish(),
    physical_prize_delivery_address_id: z.string().nullish(),
    point_used_id: z.string().nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: z.string().nullish()
  })
}

export function Point_Aggregate_Bool_ExpSchema(): z.ZodObject<Properties<Point_Aggregate_Bool_Exp>> {
  return z.object<Properties<Point_Aggregate_Bool_Exp>>({
    count: definedNonNullAnySchema.nullish()
  })
}

export function Point_Aggregate_Bool_Exp_CountSchema(): z.ZodObject<Properties<Point_Aggregate_Bool_Exp_Count>> {
  return z.object<Properties<Point_Aggregate_Bool_Exp_Count>>({
    arguments: z.array(definedNonNullAnySchema).nullish(),
    distinct: z.boolean().nullish(),
    filter: definedNonNullAnySchema.nullish(),
    predicate: definedNonNullAnySchema
  })
}

export function Point_Aggregate_Order_BySchema(): z.ZodObject<Properties<Point_Aggregate_Order_By>> {
  return z.object<Properties<Point_Aggregate_Order_By>>({
    avg: definedNonNullAnySchema.nullish(),
    count: definedNonNullAnySchema.nullish(),
    max: definedNonNullAnySchema.nullish(),
    min: definedNonNullAnySchema.nullish(),
    stddev: definedNonNullAnySchema.nullish(),
    stddev_pop: definedNonNullAnySchema.nullish(),
    stddev_samp: definedNonNullAnySchema.nullish(),
    sum: definedNonNullAnySchema.nullish(),
    var_pop: definedNonNullAnySchema.nullish(),
    var_samp: definedNonNullAnySchema.nullish(),
    variance: definedNonNullAnySchema.nullish()
  })
}

export function Point_Avg_Order_BySchema(): z.ZodObject<Properties<Point_Avg_Order_By>> {
  return z.object<Properties<Point_Avg_Order_By>>({
    day_point_count: definedNonNullAnySchema.nullish(),
    rate: definedNonNullAnySchema.nullish(),
    value: definedNonNullAnySchema.nullish()
  })
}

export function Point_Bool_ExpSchema(): z.ZodObject<Properties<Point_Bool_Exp>> {
  return z.object<Properties<Point_Bool_Exp>>({
    _and: z.array(definedNonNullAnySchema).nullish(),
    _not: definedNonNullAnySchema.nullish(),
    _or: z.array(definedNonNullAnySchema).nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    day_point_count: definedNonNullAnySchema.nullish(),
    earned_type: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    message: definedNonNullAnySchema.nullish(),
    month_first_point_id: definedNonNullAnySchema.nullish(),
    rate: definedNonNullAnySchema.nullish(),
    read_at: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish(),
    value: definedNonNullAnySchema.nullish()
  })
}

export function Point_History_Bool_ExpSchema(): z.ZodObject<Properties<Point_History_Bool_Exp>> {
  return z.object<Properties<Point_History_Bool_Exp>>({
    _and: z.array(definedNonNullAnySchema).nullish(),
    _not: definedNonNullAnySchema.nullish(),
    _or: z.array(definedNonNullAnySchema).nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    earn_id: definedNonNullAnySchema.nullish(),
    earned_type: definedNonNullAnySchema.nullish(),
    fixed_exchange_product_exchanged_id: definedNonNullAnySchema.nullish(),
    gacha_lose: definedNonNullAnySchema.nullish(),
    gacha_lose_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    message: definedNonNullAnySchema.nullish(),
    month_first_point_id: definedNonNullAnySchema.nullish(),
    physical_prize: definedNonNullAnySchema.nullish(),
    physical_prize_id: definedNonNullAnySchema.nullish(),
    rate: definedNonNullAnySchema.nullish(),
    type: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    use_id: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish(),
    value: definedNonNullAnySchema.nullish()
  })
}

export function Point_History_Order_BySchema(): z.ZodObject<Properties<Point_History_Order_By>> {
  return z.object<Properties<Point_History_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    earn_id: definedNonNullAnySchema.nullish(),
    earned_type: definedNonNullAnySchema.nullish(),
    fixed_exchange_product_exchanged_id: definedNonNullAnySchema.nullish(),
    gacha_lose: definedNonNullAnySchema.nullish(),
    gacha_lose_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    message: definedNonNullAnySchema.nullish(),
    month_first_point_id: definedNonNullAnySchema.nullish(),
    physical_prize: definedNonNullAnySchema.nullish(),
    physical_prize_id: definedNonNullAnySchema.nullish(),
    rate: definedNonNullAnySchema.nullish(),
    type: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    use_id: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish(),
    value: definedNonNullAnySchema.nullish()
  })
}

export const Point_History_Select_ColumnSchema = z.nativeEnum(Point_History_Select_Column);

export function Point_History_Stream_Cursor_InputSchema(): z.ZodObject<Properties<Point_History_Stream_Cursor_Input>> {
  return z.object<Properties<Point_History_Stream_Cursor_Input>>({
    initial_value: definedNonNullAnySchema,
    ordering: definedNonNullAnySchema.nullish()
  })
}

export function Point_History_Stream_Cursor_Value_InputSchema(): z.ZodObject<Properties<Point_History_Stream_Cursor_Value_Input>> {
  return z.object<Properties<Point_History_Stream_Cursor_Value_Input>>({
    created_at: definedNonNullAnySchema.nullish(),
    earn_id: z.string().nullish(),
    earned_type: z.string().nullish(),
    fixed_exchange_product_exchanged_id: z.string().nullish(),
    gacha_lose_id: z.string().nullish(),
    id: z.string().nullish(),
    message: z.string().nullish(),
    month_first_point_id: z.string().nullish(),
    physical_prize_id: z.string().nullish(),
    rate: z.number().nullish(),
    type: z.string().nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    use_id: z.string().nullish(),
    user_id: z.string().nullish(),
    value: z.number().nullish()
  })
}

export function Point_Max_Order_BySchema(): z.ZodObject<Properties<Point_Max_Order_By>> {
  return z.object<Properties<Point_Max_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    day_point_count: definedNonNullAnySchema.nullish(),
    earned_type: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    message: definedNonNullAnySchema.nullish(),
    month_first_point_id: definedNonNullAnySchema.nullish(),
    rate: definedNonNullAnySchema.nullish(),
    read_at: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish(),
    value: definedNonNullAnySchema.nullish()
  })
}

export function Point_Min_Order_BySchema(): z.ZodObject<Properties<Point_Min_Order_By>> {
  return z.object<Properties<Point_Min_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    day_point_count: definedNonNullAnySchema.nullish(),
    earned_type: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    message: definedNonNullAnySchema.nullish(),
    month_first_point_id: definedNonNullAnySchema.nullish(),
    rate: definedNonNullAnySchema.nullish(),
    read_at: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish(),
    value: definedNonNullAnySchema.nullish()
  })
}

export function Point_Order_BySchema(): z.ZodObject<Properties<Point_Order_By>> {
  return z.object<Properties<Point_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    day_point_count: definedNonNullAnySchema.nullish(),
    earned_type: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    message: definedNonNullAnySchema.nullish(),
    month_first_point_id: definedNonNullAnySchema.nullish(),
    rate: definedNonNullAnySchema.nullish(),
    read_at: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish(),
    value: definedNonNullAnySchema.nullish()
  })
}

export function Point_Pk_Columns_InputSchema(): z.ZodObject<Properties<Point_Pk_Columns_Input>> {
  return z.object<Properties<Point_Pk_Columns_Input>>({
    id: z.string()
  })
}

export const Point_Select_ColumnSchema = z.nativeEnum(Point_Select_Column);

export function Point_Set_InputSchema(): z.ZodObject<Properties<Point_Set_Input>> {
  return z.object<Properties<Point_Set_Input>>({
    read_at: definedNonNullAnySchema.nullish()
  })
}

export function Point_Stddev_Order_BySchema(): z.ZodObject<Properties<Point_Stddev_Order_By>> {
  return z.object<Properties<Point_Stddev_Order_By>>({
    day_point_count: definedNonNullAnySchema.nullish(),
    rate: definedNonNullAnySchema.nullish(),
    value: definedNonNullAnySchema.nullish()
  })
}

export function Point_Stddev_Pop_Order_BySchema(): z.ZodObject<Properties<Point_Stddev_Pop_Order_By>> {
  return z.object<Properties<Point_Stddev_Pop_Order_By>>({
    day_point_count: definedNonNullAnySchema.nullish(),
    rate: definedNonNullAnySchema.nullish(),
    value: definedNonNullAnySchema.nullish()
  })
}

export function Point_Stddev_Samp_Order_BySchema(): z.ZodObject<Properties<Point_Stddev_Samp_Order_By>> {
  return z.object<Properties<Point_Stddev_Samp_Order_By>>({
    day_point_count: definedNonNullAnySchema.nullish(),
    rate: definedNonNullAnySchema.nullish(),
    value: definedNonNullAnySchema.nullish()
  })
}

export function Point_Stream_Cursor_InputSchema(): z.ZodObject<Properties<Point_Stream_Cursor_Input>> {
  return z.object<Properties<Point_Stream_Cursor_Input>>({
    initial_value: definedNonNullAnySchema,
    ordering: definedNonNullAnySchema.nullish()
  })
}

export function Point_Stream_Cursor_Value_InputSchema(): z.ZodObject<Properties<Point_Stream_Cursor_Value_Input>> {
  return z.object<Properties<Point_Stream_Cursor_Value_Input>>({
    created_at: definedNonNullAnySchema.nullish(),
    day_point_count: z.number().nullish(),
    earned_type: z.string().nullish(),
    id: z.string().nullish(),
    message: z.string().nullish(),
    month_first_point_id: z.string().nullish(),
    rate: z.number().nullish(),
    read_at: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: z.string().nullish(),
    value: z.number().nullish()
  })
}

export function Point_Sum_Order_BySchema(): z.ZodObject<Properties<Point_Sum_Order_By>> {
  return z.object<Properties<Point_Sum_Order_By>>({
    day_point_count: definedNonNullAnySchema.nullish(),
    rate: definedNonNullAnySchema.nullish(),
    value: definedNonNullAnySchema.nullish()
  })
}

export function Point_UpdatesSchema(): z.ZodObject<Properties<Point_Updates>> {
  return z.object<Properties<Point_Updates>>({
    _set: definedNonNullAnySchema.nullish(),
    where: definedNonNullAnySchema
  })
}

export function Point_Var_Pop_Order_BySchema(): z.ZodObject<Properties<Point_Var_Pop_Order_By>> {
  return z.object<Properties<Point_Var_Pop_Order_By>>({
    day_point_count: definedNonNullAnySchema.nullish(),
    rate: definedNonNullAnySchema.nullish(),
    value: definedNonNullAnySchema.nullish()
  })
}

export function Point_Var_Samp_Order_BySchema(): z.ZodObject<Properties<Point_Var_Samp_Order_By>> {
  return z.object<Properties<Point_Var_Samp_Order_By>>({
    day_point_count: definedNonNullAnySchema.nullish(),
    rate: definedNonNullAnySchema.nullish(),
    value: definedNonNullAnySchema.nullish()
  })
}

export function Point_Variance_Order_BySchema(): z.ZodObject<Properties<Point_Variance_Order_By>> {
  return z.object<Properties<Point_Variance_Order_By>>({
    day_point_count: definedNonNullAnySchema.nullish(),
    rate: definedNonNullAnySchema.nullish(),
    value: definedNonNullAnySchema.nullish()
  })
}

export function Review_Aggregate_Bool_ExpSchema(): z.ZodObject<Properties<Review_Aggregate_Bool_Exp>> {
  return z.object<Properties<Review_Aggregate_Bool_Exp>>({
    bool_and: definedNonNullAnySchema.nullish(),
    bool_or: definedNonNullAnySchema.nullish(),
    count: definedNonNullAnySchema.nullish()
  })
}

export function Review_Aggregate_Bool_Exp_Bool_AndSchema(): z.ZodObject<Properties<Review_Aggregate_Bool_Exp_Bool_And>> {
  return z.object<Properties<Review_Aggregate_Bool_Exp_Bool_And>>({
    arguments: definedNonNullAnySchema,
    distinct: z.boolean().nullish(),
    filter: definedNonNullAnySchema.nullish(),
    predicate: definedNonNullAnySchema
  })
}

export function Review_Aggregate_Bool_Exp_Bool_OrSchema(): z.ZodObject<Properties<Review_Aggregate_Bool_Exp_Bool_Or>> {
  return z.object<Properties<Review_Aggregate_Bool_Exp_Bool_Or>>({
    arguments: definedNonNullAnySchema,
    distinct: z.boolean().nullish(),
    filter: definedNonNullAnySchema.nullish(),
    predicate: definedNonNullAnySchema
  })
}

export function Review_Aggregate_Bool_Exp_CountSchema(): z.ZodObject<Properties<Review_Aggregate_Bool_Exp_Count>> {
  return z.object<Properties<Review_Aggregate_Bool_Exp_Count>>({
    arguments: z.array(definedNonNullAnySchema).nullish(),
    distinct: z.boolean().nullish(),
    filter: definedNonNullAnySchema.nullish(),
    predicate: definedNonNullAnySchema
  })
}

export function Review_Aggregate_Order_BySchema(): z.ZodObject<Properties<Review_Aggregate_Order_By>> {
  return z.object<Properties<Review_Aggregate_Order_By>>({
    avg: definedNonNullAnySchema.nullish(),
    count: definedNonNullAnySchema.nullish(),
    max: definedNonNullAnySchema.nullish(),
    min: definedNonNullAnySchema.nullish(),
    stddev: definedNonNullAnySchema.nullish(),
    stddev_pop: definedNonNullAnySchema.nullish(),
    stddev_samp: definedNonNullAnySchema.nullish(),
    sum: definedNonNullAnySchema.nullish(),
    var_pop: definedNonNullAnySchema.nullish(),
    var_samp: definedNonNullAnySchema.nullish(),
    variance: definedNonNullAnySchema.nullish()
  })
}

export function Review_Avg_Order_BySchema(): z.ZodObject<Properties<Review_Avg_Order_By>> {
  return z.object<Properties<Review_Avg_Order_By>>({
    total_good_num: definedNonNullAnySchema.nullish()
  })
}

export function Review_Bool_ExpSchema(): z.ZodObject<Properties<Review_Bool_Exp>> {
  return z.object<Properties<Review_Bool_Exp>>({
    _and: z.array(definedNonNullAnySchema).nullish(),
    _not: definedNonNullAnySchema.nullish(),
    _or: z.array(definedNonNullAnySchema).nullish(),
    campsite: definedNonNullAnySchema.nullish(),
    campsite_id: definedNonNullAnySchema.nullish(),
    content: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    public: definedNonNullAnySchema.nullish(),
    review_goods: definedNonNullAnySchema.nullish(),
    review_goods_aggregate: definedNonNullAnySchema.nullish(),
    review_images: definedNonNullAnySchema.nullish(),
    review_images_aggregate: definedNonNullAnySchema.nullish(),
    total_good_num: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish(),
    user_public: definedNonNullAnySchema.nullish()
  })
}

export const Review_ConstraintSchema = z.nativeEnum(Review_Constraint);

export function Review_Good_Aggregate_Bool_ExpSchema(): z.ZodObject<Properties<Review_Good_Aggregate_Bool_Exp>> {
  return z.object<Properties<Review_Good_Aggregate_Bool_Exp>>({
    count: definedNonNullAnySchema.nullish()
  })
}

export function Review_Good_Aggregate_Bool_Exp_CountSchema(): z.ZodObject<Properties<Review_Good_Aggregate_Bool_Exp_Count>> {
  return z.object<Properties<Review_Good_Aggregate_Bool_Exp_Count>>({
    arguments: z.array(definedNonNullAnySchema).nullish(),
    distinct: z.boolean().nullish(),
    filter: definedNonNullAnySchema.nullish(),
    predicate: definedNonNullAnySchema
  })
}

export function Review_Good_Aggregate_Order_BySchema(): z.ZodObject<Properties<Review_Good_Aggregate_Order_By>> {
  return z.object<Properties<Review_Good_Aggregate_Order_By>>({
    count: definedNonNullAnySchema.nullish(),
    max: definedNonNullAnySchema.nullish(),
    min: definedNonNullAnySchema.nullish()
  })
}

export function Review_Good_Arr_Rel_Insert_InputSchema(): z.ZodObject<Properties<Review_Good_Arr_Rel_Insert_Input>> {
  return z.object<Properties<Review_Good_Arr_Rel_Insert_Input>>({
    data: z.array(definedNonNullAnySchema),
    on_conflict: definedNonNullAnySchema.nullish()
  })
}

export function Review_Good_Bool_ExpSchema(): z.ZodObject<Properties<Review_Good_Bool_Exp>> {
  return z.object<Properties<Review_Good_Bool_Exp>>({
    _and: z.array(definedNonNullAnySchema).nullish(),
    _not: definedNonNullAnySchema.nullish(),
    _or: z.array(definedNonNullAnySchema).nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    for_review_id: definedNonNullAnySchema.nullish(),
    from_user_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    review: definedNonNullAnySchema.nullish(),
    user: definedNonNullAnySchema.nullish()
  })
}

export const Review_Good_ConstraintSchema = z.nativeEnum(Review_Good_Constraint);

export function Review_Good_Insert_InputSchema(): z.ZodObject<Properties<Review_Good_Insert_Input>> {
  return z.object<Properties<Review_Good_Insert_Input>>({
    for_review_id: z.string().nullish(),
    from_user_id: z.string().nullish(),
    review: definedNonNullAnySchema.nullish()
  })
}

export function Review_Good_Max_Order_BySchema(): z.ZodObject<Properties<Review_Good_Max_Order_By>> {
  return z.object<Properties<Review_Good_Max_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    for_review_id: definedNonNullAnySchema.nullish(),
    from_user_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish()
  })
}

export function Review_Good_Min_Order_BySchema(): z.ZodObject<Properties<Review_Good_Min_Order_By>> {
  return z.object<Properties<Review_Good_Min_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    for_review_id: definedNonNullAnySchema.nullish(),
    from_user_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish()
  })
}

export function Review_Good_On_ConflictSchema(): z.ZodObject<Properties<Review_Good_On_Conflict>> {
  return z.object<Properties<Review_Good_On_Conflict>>({
    constraint: definedNonNullAnySchema,
    update_columns: z.array(definedNonNullAnySchema),
    where: definedNonNullAnySchema.nullish()
  })
}

export function Review_Good_Order_BySchema(): z.ZodObject<Properties<Review_Good_Order_By>> {
  return z.object<Properties<Review_Good_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    for_review_id: definedNonNullAnySchema.nullish(),
    from_user_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    review: definedNonNullAnySchema.nullish(),
    user: definedNonNullAnySchema.nullish()
  })
}

export const Review_Good_Select_ColumnSchema = z.nativeEnum(Review_Good_Select_Column);

export function Review_Good_Stream_Cursor_InputSchema(): z.ZodObject<Properties<Review_Good_Stream_Cursor_Input>> {
  return z.object<Properties<Review_Good_Stream_Cursor_Input>>({
    initial_value: definedNonNullAnySchema,
    ordering: definedNonNullAnySchema.nullish()
  })
}

export function Review_Good_Stream_Cursor_Value_InputSchema(): z.ZodObject<Properties<Review_Good_Stream_Cursor_Value_Input>> {
  return z.object<Properties<Review_Good_Stream_Cursor_Value_Input>>({
    created_at: definedNonNullAnySchema.nullish(),
    for_review_id: z.string().nullish(),
    from_user_id: z.string().nullish(),
    id: z.string().nullish()
  })
}

export const Review_Good_Update_ColumnSchema = z.nativeEnum(Review_Good_Update_Column);

export function Review_Image_Aggregate_Bool_ExpSchema(): z.ZodObject<Properties<Review_Image_Aggregate_Bool_Exp>> {
  return z.object<Properties<Review_Image_Aggregate_Bool_Exp>>({
    count: definedNonNullAnySchema.nullish()
  })
}

export function Review_Image_Aggregate_Bool_Exp_CountSchema(): z.ZodObject<Properties<Review_Image_Aggregate_Bool_Exp_Count>> {
  return z.object<Properties<Review_Image_Aggregate_Bool_Exp_Count>>({
    arguments: z.array(definedNonNullAnySchema).nullish(),
    distinct: z.boolean().nullish(),
    filter: definedNonNullAnySchema.nullish(),
    predicate: definedNonNullAnySchema
  })
}

export function Review_Image_Aggregate_Order_BySchema(): z.ZodObject<Properties<Review_Image_Aggregate_Order_By>> {
  return z.object<Properties<Review_Image_Aggregate_Order_By>>({
    count: definedNonNullAnySchema.nullish(),
    max: definedNonNullAnySchema.nullish(),
    min: definedNonNullAnySchema.nullish()
  })
}

export function Review_Image_Arr_Rel_Insert_InputSchema(): z.ZodObject<Properties<Review_Image_Arr_Rel_Insert_Input>> {
  return z.object<Properties<Review_Image_Arr_Rel_Insert_Input>>({
    data: z.array(definedNonNullAnySchema),
    on_conflict: definedNonNullAnySchema.nullish()
  })
}

export function Review_Image_Bool_ExpSchema(): z.ZodObject<Properties<Review_Image_Bool_Exp>> {
  return z.object<Properties<Review_Image_Bool_Exp>>({
    _and: z.array(definedNonNullAnySchema).nullish(),
    _not: definedNonNullAnySchema.nullish(),
    _or: z.array(definedNonNullAnySchema).nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    image: definedNonNullAnySchema.nullish(),
    image_id: definedNonNullAnySchema.nullish(),
    review: definedNonNullAnySchema.nullish(),
    review_id: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish()
  })
}

export const Review_Image_ConstraintSchema = z.nativeEnum(Review_Image_Constraint);

export function Review_Image_Insert_InputSchema(): z.ZodObject<Properties<Review_Image_Insert_Input>> {
  return z.object<Properties<Review_Image_Insert_Input>>({
    image: definedNonNullAnySchema.nullish(),
    image_id: z.string().nullish(),
    review: definedNonNullAnySchema.nullish(),
    review_id: z.string().nullish()
  })
}

export function Review_Image_Max_Order_BySchema(): z.ZodObject<Properties<Review_Image_Max_Order_By>> {
  return z.object<Properties<Review_Image_Max_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    image_id: definedNonNullAnySchema.nullish(),
    review_id: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish()
  })
}

export function Review_Image_Min_Order_BySchema(): z.ZodObject<Properties<Review_Image_Min_Order_By>> {
  return z.object<Properties<Review_Image_Min_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    image_id: definedNonNullAnySchema.nullish(),
    review_id: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish()
  })
}

export function Review_Image_On_ConflictSchema(): z.ZodObject<Properties<Review_Image_On_Conflict>> {
  return z.object<Properties<Review_Image_On_Conflict>>({
    constraint: definedNonNullAnySchema,
    update_columns: z.array(definedNonNullAnySchema),
    where: definedNonNullAnySchema.nullish()
  })
}

export function Review_Image_Order_BySchema(): z.ZodObject<Properties<Review_Image_Order_By>> {
  return z.object<Properties<Review_Image_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    image: definedNonNullAnySchema.nullish(),
    image_id: definedNonNullAnySchema.nullish(),
    review: definedNonNullAnySchema.nullish(),
    review_id: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish()
  })
}

export const Review_Image_Select_ColumnSchema = z.nativeEnum(Review_Image_Select_Column);

export function Review_Image_Stream_Cursor_InputSchema(): z.ZodObject<Properties<Review_Image_Stream_Cursor_Input>> {
  return z.object<Properties<Review_Image_Stream_Cursor_Input>>({
    initial_value: definedNonNullAnySchema,
    ordering: definedNonNullAnySchema.nullish()
  })
}

export function Review_Image_Stream_Cursor_Value_InputSchema(): z.ZodObject<Properties<Review_Image_Stream_Cursor_Value_Input>> {
  return z.object<Properties<Review_Image_Stream_Cursor_Value_Input>>({
    created_at: definedNonNullAnySchema.nullish(),
    id: z.string().nullish(),
    image_id: z.string().nullish(),
    review_id: z.string().nullish(),
    updated_at: definedNonNullAnySchema.nullish()
  })
}

export const Review_Image_Update_ColumnSchema = z.nativeEnum(Review_Image_Update_Column);

export function Review_Insert_InputSchema(): z.ZodObject<Properties<Review_Insert_Input>> {
  return z.object<Properties<Review_Insert_Input>>({
    campsite_id: z.string().nullish(),
    content: z.string().nullish(),
    public: z.boolean().nullish(),
    review_goods: definedNonNullAnySchema.nullish(),
    review_images: definedNonNullAnySchema.nullish(),
    user_id: z.string().nullish()
  })
}

export function Review_Max_Order_BySchema(): z.ZodObject<Properties<Review_Max_Order_By>> {
  return z.object<Properties<Review_Max_Order_By>>({
    campsite_id: definedNonNullAnySchema.nullish(),
    content: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    total_good_num: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function Review_Min_Order_BySchema(): z.ZodObject<Properties<Review_Min_Order_By>> {
  return z.object<Properties<Review_Min_Order_By>>({
    campsite_id: definedNonNullAnySchema.nullish(),
    content: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    total_good_num: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function Review_Obj_Rel_Insert_InputSchema(): z.ZodObject<Properties<Review_Obj_Rel_Insert_Input>> {
  return z.object<Properties<Review_Obj_Rel_Insert_Input>>({
    data: definedNonNullAnySchema,
    on_conflict: definedNonNullAnySchema.nullish()
  })
}

export function Review_On_ConflictSchema(): z.ZodObject<Properties<Review_On_Conflict>> {
  return z.object<Properties<Review_On_Conflict>>({
    constraint: definedNonNullAnySchema,
    update_columns: z.array(definedNonNullAnySchema),
    where: definedNonNullAnySchema.nullish()
  })
}

export function Review_Order_BySchema(): z.ZodObject<Properties<Review_Order_By>> {
  return z.object<Properties<Review_Order_By>>({
    campsite: definedNonNullAnySchema.nullish(),
    campsite_id: definedNonNullAnySchema.nullish(),
    content: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    public: definedNonNullAnySchema.nullish(),
    review_goods_aggregate: definedNonNullAnySchema.nullish(),
    review_images_aggregate: definedNonNullAnySchema.nullish(),
    total_good_num: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish(),
    user_public: definedNonNullAnySchema.nullish()
  })
}

export function Review_Pk_Columns_InputSchema(): z.ZodObject<Properties<Review_Pk_Columns_Input>> {
  return z.object<Properties<Review_Pk_Columns_Input>>({
    id: z.string()
  })
}

export const Review_Select_ColumnSchema = z.nativeEnum(Review_Select_Column);

export const Review_Select_Column_Review_Aggregate_Bool_Exp_Bool_And_Arguments_ColumnsSchema = z.nativeEnum(Review_Select_Column_Review_Aggregate_Bool_Exp_Bool_And_Arguments_Columns);

export const Review_Select_Column_Review_Aggregate_Bool_Exp_Bool_Or_Arguments_ColumnsSchema = z.nativeEnum(Review_Select_Column_Review_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns);

export function Review_Set_InputSchema(): z.ZodObject<Properties<Review_Set_Input>> {
  return z.object<Properties<Review_Set_Input>>({
    content: z.string().nullish(),
    public: z.boolean().nullish()
  })
}

export function Review_Stddev_Order_BySchema(): z.ZodObject<Properties<Review_Stddev_Order_By>> {
  return z.object<Properties<Review_Stddev_Order_By>>({
    total_good_num: definedNonNullAnySchema.nullish()
  })
}

export function Review_Stddev_Pop_Order_BySchema(): z.ZodObject<Properties<Review_Stddev_Pop_Order_By>> {
  return z.object<Properties<Review_Stddev_Pop_Order_By>>({
    total_good_num: definedNonNullAnySchema.nullish()
  })
}

export function Review_Stddev_Samp_Order_BySchema(): z.ZodObject<Properties<Review_Stddev_Samp_Order_By>> {
  return z.object<Properties<Review_Stddev_Samp_Order_By>>({
    total_good_num: definedNonNullAnySchema.nullish()
  })
}

export function Review_Stream_Cursor_InputSchema(): z.ZodObject<Properties<Review_Stream_Cursor_Input>> {
  return z.object<Properties<Review_Stream_Cursor_Input>>({
    initial_value: definedNonNullAnySchema,
    ordering: definedNonNullAnySchema.nullish()
  })
}

export function Review_Stream_Cursor_Value_InputSchema(): z.ZodObject<Properties<Review_Stream_Cursor_Value_Input>> {
  return z.object<Properties<Review_Stream_Cursor_Value_Input>>({
    campsite_id: z.string().nullish(),
    content: z.string().nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: z.string().nullish(),
    public: z.boolean().nullish(),
    total_good_num: z.number().nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: z.string().nullish()
  })
}

export function Review_Sum_Order_BySchema(): z.ZodObject<Properties<Review_Sum_Order_By>> {
  return z.object<Properties<Review_Sum_Order_By>>({
    total_good_num: definedNonNullAnySchema.nullish()
  })
}

export const Review_Update_ColumnSchema = z.nativeEnum(Review_Update_Column);

export function Review_UpdatesSchema(): z.ZodObject<Properties<Review_Updates>> {
  return z.object<Properties<Review_Updates>>({
    _set: definedNonNullAnySchema.nullish(),
    where: definedNonNullAnySchema
  })
}

export function Review_Var_Pop_Order_BySchema(): z.ZodObject<Properties<Review_Var_Pop_Order_By>> {
  return z.object<Properties<Review_Var_Pop_Order_By>>({
    total_good_num: definedNonNullAnySchema.nullish()
  })
}

export function Review_Var_Samp_Order_BySchema(): z.ZodObject<Properties<Review_Var_Samp_Order_By>> {
  return z.object<Properties<Review_Var_Samp_Order_By>>({
    total_good_num: definedNonNullAnySchema.nullish()
  })
}

export function Review_Variance_Order_BySchema(): z.ZodObject<Properties<Review_Variance_Order_By>> {
  return z.object<Properties<Review_Variance_Order_By>>({
    total_good_num: definedNonNullAnySchema.nullish()
  })
}

export function Submit_Physical_Prize_Delivery_Address_ArgsSchema(): z.ZodObject<Properties<Submit_Physical_Prize_Delivery_Address_Args>> {
  return z.object<Properties<Submit_Physical_Prize_Delivery_Address_Args>>({
    target_building: z.string().nullish(),
    target_city: z.string().nullish(),
    target_name: z.string().nullish(),
    target_physical_prize_id: z.string().nullish(),
    target_postal_code: z.string().nullish(),
    target_prefecture: z.string().nullish(),
    target_street: z.string().nullish(),
    target_tel_body: z.string().nullish(),
    target_tel_head: z.string().nullish(),
    target_tel_tail: z.string().nullish()
  })
}

export function Timestamp_Comparison_ExpSchema(): z.ZodObject<Properties<Timestamp_Comparison_Exp>> {
  return z.object<Properties<Timestamp_Comparison_Exp>>({
    _eq: definedNonNullAnySchema.nullish(),
    _gt: definedNonNullAnySchema.nullish(),
    _gte: definedNonNullAnySchema.nullish(),
    _in: z.array(definedNonNullAnySchema).nullish(),
    _is_null: z.boolean().nullish(),
    _lt: definedNonNullAnySchema.nullish(),
    _lte: definedNonNullAnySchema.nullish(),
    _neq: definedNonNullAnySchema.nullish(),
    _nin: z.array(definedNonNullAnySchema).nullish()
  })
}

export function Update_Campsite_Info_ArgsSchema(): z.ZodObject<Properties<Update_Campsite_Info_Args>> {
  return z.object<Properties<Update_Campsite_Info_Args>>({
    target_campsite_id: z.string().nullish(),
    v_activity_athletic: z.boolean().nullish(),
    v_activity_bbq: z.boolean().nullish(),
    v_activity_bicycle: z.boolean().nullish(),
    v_activity_canoe: z.boolean().nullish(),
    v_activity_craft: z.boolean().nullish(),
    v_activity_fishing: z.boolean().nullish(),
    v_activity_flower: z.boolean().nullish(),
    v_activity_hiking: z.boolean().nullish(),
    v_activity_insect: z.boolean().nullish(),
    v_activity_playset: z.boolean().nullish(),
    v_activity_pool: z.boolean().nullish(),
    v_activity_ranch: z.boolean().nullish(),
    v_activity_river: z.boolean().nullish(),
    v_activity_sauna: z.boolean().nullish(),
    v_activity_sea: z.boolean().nullish(),
    v_activity_star: z.boolean().nullish(),
    v_activity_taste: z.boolean().nullish(),
    v_activity_tentsauna: z.boolean().nullish(),
    v_bath_hotspring: z.boolean().nullish(),
    v_bath_room: z.boolean().nullish(),
    v_business_newyear: z.boolean().nullish(),
    v_business_period: z.boolean().nullish(),
    v_checkin_end_hour: z.string().nullish(),
    v_checkin_end_minute: z.string().nullish(),
    v_checkin_start_hour: z.string().nullish(),
    v_checkin_start_minute: z.string().nullish(),
    v_checkout_end_hour: z.string().nullish(),
    v_checkout_end_minute: z.string().nullish(),
    v_checkout_start_hour: z.string().nullish(),
    v_checkout_start_minute: z.string().nullish(),
    v_closed_friday: z.boolean().nullish(),
    v_closed_holiday: z.boolean().nullish(),
    v_closed_irregular: z.boolean().nullish(),
    v_closed_monday: z.boolean().nullish(),
    v_closed_not: z.boolean().nullish(),
    v_closed_saturday: z.boolean().nullish(),
    v_closed_sunday: z.boolean().nullish(),
    v_closed_thursday: z.boolean().nullish(),
    v_closed_tuesday: z.boolean().nullish(),
    v_closed_wednesday: z.boolean().nullish(),
    v_facilities_barrierfree: z.boolean().nullish(),
    v_facilities_dogrun: z.boolean().nullish(),
    v_facilities_laundry: z.boolean().nullish(),
    v_facilities_restaurant: z.boolean().nullish(),
    v_facilities_store: z.boolean().nullish(),
    v_facilities_workspace: z.boolean().nullish(),
    v_facility_acsite: z.boolean().nullish(),
    v_facility_bungalow: z.boolean().nullish(),
    v_facility_cottage: z.boolean().nullish(),
    v_facility_freesite: z.boolean().nullish(),
    v_facility_glamping: z.boolean().nullish(),
    v_facility_privatesite: z.boolean().nullish(),
    v_facility_sectionsite: z.boolean().nullish(),
    v_facility_solo: z.boolean().nullish(),
    v_facility_tipi: z.boolean().nullish(),
    v_facility_trailerhouse: z.boolean().nullish(),
    v_facility_treehouse: z.boolean().nullish(),
    v_introduction_content: z.string().nullish(),
    v_introduction_title: z.string().nullish(),
    v_location_forest: z.boolean().nullish(),
    v_location_hill: z.boolean().nullish(),
    v_location_lake: z.boolean().nullish(),
    v_location_meadow: z.boolean().nullish(),
    v_location_ocean: z.boolean().nullish(),
    v_location_park: z.boolean().nullish(),
    v_location_plateau: z.boolean().nullish(),
    v_location_river: z.boolean().nullish(),
    v_main_image_id: z.string().nullish(),
    v_official_url: z.string().nullish(),
    v_service_firewood: z.boolean().nullish(),
    v_service_firework: z.boolean().nullish(),
    v_service_freecharge: z.boolean().nullish(),
    v_service_garbage: z.boolean().nullish(),
    v_service_group: z.boolean().nullish(),
    v_service_hotwater: z.boolean().nullish(),
    v_service_openfire: z.boolean().nullish(),
    v_service_pet: z.boolean().nullish(),
    v_service_rental: z.boolean().nullish(),
    v_service_washlet: z.boolean().nullish(),
    v_service_wifi: z.boolean().nullish(),
    v_tel_bottom: z.string().nullish(),
    v_tel_head: z.string().nullish(),
    v_tel_while: z.string().nullish(),
    v_vehicles_autocamp: z.boolean().nullish(),
    v_vehicles_campingcar: z.boolean().nullish()
  })
}

export function Update_Campsite_Like_From_Edit_ArgsSchema(): z.ZodObject<Properties<Update_Campsite_Like_From_Edit_Args>> {
  return z.object<Properties<Update_Campsite_Like_From_Edit_Args>>({
    campsite_ids: definedNonNullAnySchema.nullish(),
    input_type: z.string().nullish()
  })
}

export function Upsert_Campsite_Image_ArgsSchema(): z.ZodObject<Properties<Upsert_Campsite_Image_Args>> {
  return z.object<Properties<Upsert_Campsite_Image_Args>>({
    target_campsite_id: z.string().nullish(),
    target_image_ids: definedNonNullAnySchema.nullish(),
    target_image_titles: definedNonNullAnySchema.nullish(),
    target_type: z.string().nullish()
  })
}

export function User_Aggregate_Order_BySchema(): z.ZodObject<Properties<User_Aggregate_Order_By>> {
  return z.object<Properties<User_Aggregate_Order_By>>({
    avg: definedNonNullAnySchema.nullish(),
    count: definedNonNullAnySchema.nullish(),
    max: definedNonNullAnySchema.nullish(),
    min: definedNonNullAnySchema.nullish(),
    stddev: definedNonNullAnySchema.nullish(),
    stddev_pop: definedNonNullAnySchema.nullish(),
    stddev_samp: definedNonNullAnySchema.nullish(),
    sum: definedNonNullAnySchema.nullish(),
    var_pop: definedNonNullAnySchema.nullish(),
    var_samp: definedNonNullAnySchema.nullish(),
    variance: definedNonNullAnySchema.nullish()
  })
}

export function User_Avg_Order_BySchema(): z.ZodObject<Properties<User_Avg_Order_By>> {
  return z.object<Properties<User_Avg_Order_By>>({
    camping_days: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_point: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish()
  })
}

export function User_Bool_ExpSchema(): z.ZodObject<Properties<User_Bool_Exp>> {
  return z.object<Properties<User_Bool_Exp>>({
    _and: z.array(definedNonNullAnySchema).nullish(),
    _not: definedNonNullAnySchema.nullish(),
    _or: z.array(definedNonNullAnySchema).nullish(),
    addresses: definedNonNullAnySchema.nullish(),
    background_icon: definedNonNullAnySchema.nullish(),
    background_image_id: definedNonNullAnySchema.nullish(),
    birthday: definedNonNullAnySchema.nullish(),
    camping_days: definedNonNullAnySchema.nullish(),
    campsite_likes: definedNonNullAnySchema.nullish(),
    campsite_likes_aggregate: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    display_name: definedNonNullAnySchema.nullish(),
    email: definedNonNullAnySchema.nullish(),
    fixed_exchange_product_exchangeds: definedNonNullAnySchema.nullish(),
    fixed_exchange_product_exchangeds_aggregate: definedNonNullAnySchema.nullish(),
    gacha_loses: definedNonNullAnySchema.nullish(),
    gacha_loses_aggregate: definedNonNullAnySchema.nullish(),
    icon: definedNonNullAnySchema.nullish(),
    icon_image_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    liked_gear: definedNonNullAnySchema.nullish(),
    physical_prize_delivery_addresses: definedNonNullAnySchema.nullish(),
    physical_prize_delivery_addresses_aggregate: definedNonNullAnySchema.nullish(),
    physical_prizes: definedNonNullAnySchema.nullish(),
    physical_prizes_aggregate: definedNonNullAnySchema.nullish(),
    points: definedNonNullAnySchema.nullish(),
    points_aggregate: definedNonNullAnySchema.nullish(),
    review_goods: definedNonNullAnySchema.nullish(),
    review_goods_aggregate: definedNonNullAnySchema.nullish(),
    reviews: definedNonNullAnySchema.nullish(),
    reviews_aggregate: definedNonNullAnySchema.nullish(),
    self_introduction: definedNonNullAnySchema.nullish(),
    sex: definedNonNullAnySchema.nullish(),
    start_history: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_point: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    url: definedNonNullAnySchema.nullish(),
    url_title: definedNonNullAnySchema.nullish(),
    user_email: definedNonNullAnySchema.nullish(),
    user_notifications: definedNonNullAnySchema.nullish(),
    user_notifications_aggregate: definedNonNullAnySchema.nullish(),
    visiteds: definedNonNullAnySchema.nullish(),
    visiteds_aggregate: definedNonNullAnySchema.nullish(),
    withdrawal_date: definedNonNullAnySchema.nullish()
  })
}

export function User_Inc_InputSchema(): z.ZodObject<Properties<User_Inc_Input>> {
  return z.object<Properties<User_Inc_Input>>({
    camping_days: z.number().nullish(),
    total_like_num: z.number().nullish(),
    total_point: z.number().nullish(),
    total_review_num: z.number().nullish(),
    total_visited_num: z.number().nullish()
  })
}

export function User_Max_Order_BySchema(): z.ZodObject<Properties<User_Max_Order_By>> {
  return z.object<Properties<User_Max_Order_By>>({
    background_image_id: definedNonNullAnySchema.nullish(),
    birthday: definedNonNullAnySchema.nullish(),
    camping_days: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    display_name: definedNonNullAnySchema.nullish(),
    email: definedNonNullAnySchema.nullish(),
    icon_image_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    liked_gear: definedNonNullAnySchema.nullish(),
    self_introduction: definedNonNullAnySchema.nullish(),
    sex: definedNonNullAnySchema.nullish(),
    start_history: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_point: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    url: definedNonNullAnySchema.nullish(),
    url_title: definedNonNullAnySchema.nullish(),
    user_email: definedNonNullAnySchema.nullish(),
    withdrawal_date: definedNonNullAnySchema.nullish()
  })
}

export function User_Min_Order_BySchema(): z.ZodObject<Properties<User_Min_Order_By>> {
  return z.object<Properties<User_Min_Order_By>>({
    background_image_id: definedNonNullAnySchema.nullish(),
    birthday: definedNonNullAnySchema.nullish(),
    camping_days: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    display_name: definedNonNullAnySchema.nullish(),
    email: definedNonNullAnySchema.nullish(),
    icon_image_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    liked_gear: definedNonNullAnySchema.nullish(),
    self_introduction: definedNonNullAnySchema.nullish(),
    sex: definedNonNullAnySchema.nullish(),
    start_history: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_point: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    url: definedNonNullAnySchema.nullish(),
    url_title: definedNonNullAnySchema.nullish(),
    user_email: definedNonNullAnySchema.nullish(),
    withdrawal_date: definedNonNullAnySchema.nullish()
  })
}

export function User_Notification_Aggregate_Bool_ExpSchema(): z.ZodObject<Properties<User_Notification_Aggregate_Bool_Exp>> {
  return z.object<Properties<User_Notification_Aggregate_Bool_Exp>>({
    count: definedNonNullAnySchema.nullish()
  })
}

export function User_Notification_Aggregate_Bool_Exp_CountSchema(): z.ZodObject<Properties<User_Notification_Aggregate_Bool_Exp_Count>> {
  return z.object<Properties<User_Notification_Aggregate_Bool_Exp_Count>>({
    arguments: z.array(definedNonNullAnySchema).nullish(),
    distinct: z.boolean().nullish(),
    filter: definedNonNullAnySchema.nullish(),
    predicate: definedNonNullAnySchema
  })
}

export function User_Notification_Aggregate_Order_BySchema(): z.ZodObject<Properties<User_Notification_Aggregate_Order_By>> {
  return z.object<Properties<User_Notification_Aggregate_Order_By>>({
    count: definedNonNullAnySchema.nullish(),
    max: definedNonNullAnySchema.nullish(),
    min: definedNonNullAnySchema.nullish()
  })
}

export function User_Notification_Bool_ExpSchema(): z.ZodObject<Properties<User_Notification_Bool_Exp>> {
  return z.object<Properties<User_Notification_Bool_Exp>>({
    _and: z.array(definedNonNullAnySchema).nullish(),
    _not: definedNonNullAnySchema.nullish(),
    _or: z.array(definedNonNullAnySchema).nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    read_at: definedNonNullAnySchema.nullish(),
    review_like_values: definedNonNullAnySchema.nullish(),
    type: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function User_Notification_Max_Order_BySchema(): z.ZodObject<Properties<User_Notification_Max_Order_By>> {
  return z.object<Properties<User_Notification_Max_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    read_at: definedNonNullAnySchema.nullish(),
    type: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function User_Notification_Min_Order_BySchema(): z.ZodObject<Properties<User_Notification_Min_Order_By>> {
  return z.object<Properties<User_Notification_Min_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    read_at: definedNonNullAnySchema.nullish(),
    type: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function User_Notification_Order_BySchema(): z.ZodObject<Properties<User_Notification_Order_By>> {
  return z.object<Properties<User_Notification_Order_By>>({
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    read_at: definedNonNullAnySchema.nullish(),
    review_like_values: definedNonNullAnySchema.nullish(),
    type: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function User_Notification_Pk_Columns_InputSchema(): z.ZodObject<Properties<User_Notification_Pk_Columns_Input>> {
  return z.object<Properties<User_Notification_Pk_Columns_Input>>({
    id: z.string()
  })
}

export const User_Notification_Select_ColumnSchema = z.nativeEnum(User_Notification_Select_Column);

export function User_Notification_Set_InputSchema(): z.ZodObject<Properties<User_Notification_Set_Input>> {
  return z.object<Properties<User_Notification_Set_Input>>({
    read_at: definedNonNullAnySchema.nullish()
  })
}

export function User_Notification_Stream_Cursor_InputSchema(): z.ZodObject<Properties<User_Notification_Stream_Cursor_Input>> {
  return z.object<Properties<User_Notification_Stream_Cursor_Input>>({
    initial_value: definedNonNullAnySchema,
    ordering: definedNonNullAnySchema.nullish()
  })
}

export function User_Notification_Stream_Cursor_Value_InputSchema(): z.ZodObject<Properties<User_Notification_Stream_Cursor_Value_Input>> {
  return z.object<Properties<User_Notification_Stream_Cursor_Value_Input>>({
    created_at: definedNonNullAnySchema.nullish(),
    id: z.string().nullish(),
    read_at: definedNonNullAnySchema.nullish(),
    review_like_values: definedNonNullAnySchema.nullish(),
    type: z.string().nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: z.string().nullish()
  })
}

export function User_Notification_UpdatesSchema(): z.ZodObject<Properties<User_Notification_Updates>> {
  return z.object<Properties<User_Notification_Updates>>({
    _set: definedNonNullAnySchema.nullish(),
    where: definedNonNullAnySchema
  })
}

export function User_Order_BySchema(): z.ZodObject<Properties<User_Order_By>> {
  return z.object<Properties<User_Order_By>>({
    addresses_aggregate: definedNonNullAnySchema.nullish(),
    background_icon: definedNonNullAnySchema.nullish(),
    background_image_id: definedNonNullAnySchema.nullish(),
    birthday: definedNonNullAnySchema.nullish(),
    camping_days: definedNonNullAnySchema.nullish(),
    campsite_likes_aggregate: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    display_name: definedNonNullAnySchema.nullish(),
    email: definedNonNullAnySchema.nullish(),
    fixed_exchange_product_exchangeds_aggregate: definedNonNullAnySchema.nullish(),
    gacha_loses_aggregate: definedNonNullAnySchema.nullish(),
    icon: definedNonNullAnySchema.nullish(),
    icon_image_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    liked_gear: definedNonNullAnySchema.nullish(),
    physical_prize_delivery_addresses_aggregate: definedNonNullAnySchema.nullish(),
    physical_prizes_aggregate: definedNonNullAnySchema.nullish(),
    points_aggregate: definedNonNullAnySchema.nullish(),
    review_goods_aggregate: definedNonNullAnySchema.nullish(),
    reviews_aggregate: definedNonNullAnySchema.nullish(),
    self_introduction: definedNonNullAnySchema.nullish(),
    sex: definedNonNullAnySchema.nullish(),
    start_history: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_point: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    url: definedNonNullAnySchema.nullish(),
    url_title: definedNonNullAnySchema.nullish(),
    user_email: definedNonNullAnySchema.nullish(),
    user_notifications_aggregate: definedNonNullAnySchema.nullish(),
    visiteds_aggregate: definedNonNullAnySchema.nullish(),
    withdrawal_date: definedNonNullAnySchema.nullish()
  })
}

export function User_Pk_Columns_InputSchema(): z.ZodObject<Properties<User_Pk_Columns_Input>> {
  return z.object<Properties<User_Pk_Columns_Input>>({
    id: z.string()
  })
}

export function User_Public_Bool_ExpSchema(): z.ZodObject<Properties<User_Public_Bool_Exp>> {
  return z.object<Properties<User_Public_Bool_Exp>>({
    _and: z.array(definedNonNullAnySchema).nullish(),
    _not: definedNonNullAnySchema.nullish(),
    _or: z.array(definedNonNullAnySchema).nullish(),
    backgound_icon: definedNonNullAnySchema.nullish(),
    background_image_id: definedNonNullAnySchema.nullish(),
    camping_days: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    display_name: definedNonNullAnySchema.nullish(),
    icon: definedNonNullAnySchema.nullish(),
    icon_image_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    liked_gear: definedNonNullAnySchema.nullish(),
    self_introduction: definedNonNullAnySchema.nullish(),
    start_history: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    url: definedNonNullAnySchema.nullish(),
    url_title: definedNonNullAnySchema.nullish()
  })
}

export function User_Public_Order_BySchema(): z.ZodObject<Properties<User_Public_Order_By>> {
  return z.object<Properties<User_Public_Order_By>>({
    backgound_icon: definedNonNullAnySchema.nullish(),
    background_image_id: definedNonNullAnySchema.nullish(),
    camping_days: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    display_name: definedNonNullAnySchema.nullish(),
    icon: definedNonNullAnySchema.nullish(),
    icon_image_id: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    liked_gear: definedNonNullAnySchema.nullish(),
    self_introduction: definedNonNullAnySchema.nullish(),
    start_history: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    url: definedNonNullAnySchema.nullish(),
    url_title: definedNonNullAnySchema.nullish()
  })
}

export const User_Public_Select_ColumnSchema = z.nativeEnum(User_Public_Select_Column);

export function User_Public_Stream_Cursor_InputSchema(): z.ZodObject<Properties<User_Public_Stream_Cursor_Input>> {
  return z.object<Properties<User_Public_Stream_Cursor_Input>>({
    initial_value: definedNonNullAnySchema,
    ordering: definedNonNullAnySchema.nullish()
  })
}

export function User_Public_Stream_Cursor_Value_InputSchema(): z.ZodObject<Properties<User_Public_Stream_Cursor_Value_Input>> {
  return z.object<Properties<User_Public_Stream_Cursor_Value_Input>>({
    background_image_id: z.string().nullish(),
    camping_days: z.number().nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    display_name: z.string().nullish(),
    icon_image_id: z.string().nullish(),
    id: z.string().nullish(),
    liked_gear: z.string().nullish(),
    self_introduction: z.string().nullish(),
    start_history: definedNonNullAnySchema.nullish(),
    total_like_num: z.number().nullish(),
    total_review_num: z.number().nullish(),
    total_visited_num: z.number().nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    url: z.string().nullish(),
    url_title: z.string().nullish()
  })
}

export const User_Select_ColumnSchema = z.nativeEnum(User_Select_Column);

export function User_Set_InputSchema(): z.ZodObject<Properties<User_Set_Input>> {
  return z.object<Properties<User_Set_Input>>({
    background_image_id: z.string().nullish(),
    birthday: definedNonNullAnySchema.nullish(),
    camping_days: z.number().nullish(),
    display_name: z.string().nullish(),
    icon_image_id: z.string().nullish(),
    liked_gear: z.string().nullish(),
    self_introduction: z.string().nullish(),
    sex: z.string().nullish(),
    start_history: definedNonNullAnySchema.nullish(),
    total_like_num: z.number().nullish(),
    total_point: z.number().nullish(),
    total_review_num: z.number().nullish(),
    total_visited_num: z.number().nullish(),
    url: z.string().nullish(),
    url_title: z.string().nullish(),
    user_email: z.string().nullish()
  })
}

export function User_Stddev_Order_BySchema(): z.ZodObject<Properties<User_Stddev_Order_By>> {
  return z.object<Properties<User_Stddev_Order_By>>({
    camping_days: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_point: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish()
  })
}

export function User_Stddev_Pop_Order_BySchema(): z.ZodObject<Properties<User_Stddev_Pop_Order_By>> {
  return z.object<Properties<User_Stddev_Pop_Order_By>>({
    camping_days: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_point: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish()
  })
}

export function User_Stddev_Samp_Order_BySchema(): z.ZodObject<Properties<User_Stddev_Samp_Order_By>> {
  return z.object<Properties<User_Stddev_Samp_Order_By>>({
    camping_days: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_point: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish()
  })
}

export function User_Stream_Cursor_InputSchema(): z.ZodObject<Properties<User_Stream_Cursor_Input>> {
  return z.object<Properties<User_Stream_Cursor_Input>>({
    initial_value: definedNonNullAnySchema,
    ordering: definedNonNullAnySchema.nullish()
  })
}

export function User_Stream_Cursor_Value_InputSchema(): z.ZodObject<Properties<User_Stream_Cursor_Value_Input>> {
  return z.object<Properties<User_Stream_Cursor_Value_Input>>({
    background_image_id: z.string().nullish(),
    birthday: definedNonNullAnySchema.nullish(),
    camping_days: z.number().nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    display_name: z.string().nullish(),
    email: z.string().nullish(),
    icon_image_id: z.string().nullish(),
    id: z.string().nullish(),
    liked_gear: z.string().nullish(),
    self_introduction: z.string().nullish(),
    sex: z.string().nullish(),
    start_history: definedNonNullAnySchema.nullish(),
    total_like_num: z.number().nullish(),
    total_point: z.number().nullish(),
    total_review_num: z.number().nullish(),
    total_visited_num: z.number().nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    url: z.string().nullish(),
    url_title: z.string().nullish(),
    user_email: z.string().nullish(),
    withdrawal_date: definedNonNullAnySchema.nullish()
  })
}

export function User_Sum_Order_BySchema(): z.ZodObject<Properties<User_Sum_Order_By>> {
  return z.object<Properties<User_Sum_Order_By>>({
    camping_days: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_point: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish()
  })
}

export function User_UpdatesSchema(): z.ZodObject<Properties<User_Updates>> {
  return z.object<Properties<User_Updates>>({
    _inc: definedNonNullAnySchema.nullish(),
    _set: definedNonNullAnySchema.nullish(),
    where: definedNonNullAnySchema
  })
}

export function User_Var_Pop_Order_BySchema(): z.ZodObject<Properties<User_Var_Pop_Order_By>> {
  return z.object<Properties<User_Var_Pop_Order_By>>({
    camping_days: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_point: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish()
  })
}

export function User_Var_Samp_Order_BySchema(): z.ZodObject<Properties<User_Var_Samp_Order_By>> {
  return z.object<Properties<User_Var_Samp_Order_By>>({
    camping_days: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_point: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish()
  })
}

export function User_Variance_Order_BySchema(): z.ZodObject<Properties<User_Variance_Order_By>> {
  return z.object<Properties<User_Variance_Order_By>>({
    camping_days: definedNonNullAnySchema.nullish(),
    total_like_num: definedNonNullAnySchema.nullish(),
    total_point: definedNonNullAnySchema.nullish(),
    total_review_num: definedNonNullAnySchema.nullish(),
    total_visited_num: definedNonNullAnySchema.nullish()
  })
}

export function Visited_Aggregate_Bool_ExpSchema(): z.ZodObject<Properties<Visited_Aggregate_Bool_Exp>> {
  return z.object<Properties<Visited_Aggregate_Bool_Exp>>({
    count: definedNonNullAnySchema.nullish()
  })
}

export function Visited_Aggregate_Bool_Exp_CountSchema(): z.ZodObject<Properties<Visited_Aggregate_Bool_Exp_Count>> {
  return z.object<Properties<Visited_Aggregate_Bool_Exp_Count>>({
    arguments: z.array(definedNonNullAnySchema).nullish(),
    distinct: z.boolean().nullish(),
    filter: definedNonNullAnySchema.nullish(),
    predicate: definedNonNullAnySchema
  })
}

export function Visited_Aggregate_Order_BySchema(): z.ZodObject<Properties<Visited_Aggregate_Order_By>> {
  return z.object<Properties<Visited_Aggregate_Order_By>>({
    count: definedNonNullAnySchema.nullish(),
    max: definedNonNullAnySchema.nullish(),
    min: definedNonNullAnySchema.nullish()
  })
}

export function Visited_Bool_ExpSchema(): z.ZodObject<Properties<Visited_Bool_Exp>> {
  return z.object<Properties<Visited_Bool_Exp>>({
    _and: z.array(definedNonNullAnySchema).nullish(),
    _not: definedNonNullAnySchema.nullish(),
    _or: z.array(definedNonNullAnySchema).nullish(),
    campsite: definedNonNullAnySchema.nullish(),
    campsite_id: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export const Visited_ConstraintSchema = z.nativeEnum(Visited_Constraint);

export function Visited_Insert_InputSchema(): z.ZodObject<Properties<Visited_Insert_Input>> {
  return z.object<Properties<Visited_Insert_Input>>({
    campsite_id: z.string().nullish(),
    user_id: z.string().nullish()
  })
}

export function Visited_Max_Order_BySchema(): z.ZodObject<Properties<Visited_Max_Order_By>> {
  return z.object<Properties<Visited_Max_Order_By>>({
    campsite_id: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function Visited_Min_Order_BySchema(): z.ZodObject<Properties<Visited_Min_Order_By>> {
  return z.object<Properties<Visited_Min_Order_By>>({
    campsite_id: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export function Visited_On_ConflictSchema(): z.ZodObject<Properties<Visited_On_Conflict>> {
  return z.object<Properties<Visited_On_Conflict>>({
    constraint: definedNonNullAnySchema,
    update_columns: z.array(definedNonNullAnySchema),
    where: definedNonNullAnySchema.nullish()
  })
}

export function Visited_Order_BySchema(): z.ZodObject<Properties<Visited_Order_By>> {
  return z.object<Properties<Visited_Order_By>>({
    campsite: definedNonNullAnySchema.nullish(),
    campsite_id: definedNonNullAnySchema.nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: definedNonNullAnySchema.nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user: definedNonNullAnySchema.nullish(),
    user_id: definedNonNullAnySchema.nullish()
  })
}

export const Visited_Select_ColumnSchema = z.nativeEnum(Visited_Select_Column);

export function Visited_Stream_Cursor_InputSchema(): z.ZodObject<Properties<Visited_Stream_Cursor_Input>> {
  return z.object<Properties<Visited_Stream_Cursor_Input>>({
    initial_value: definedNonNullAnySchema,
    ordering: definedNonNullAnySchema.nullish()
  })
}

export function Visited_Stream_Cursor_Value_InputSchema(): z.ZodObject<Properties<Visited_Stream_Cursor_Value_Input>> {
  return z.object<Properties<Visited_Stream_Cursor_Value_Input>>({
    campsite_id: z.string().nullish(),
    created_at: definedNonNullAnySchema.nullish(),
    id: z.string().nullish(),
    updated_at: definedNonNullAnySchema.nullish(),
    user_id: z.string().nullish()
  })
}

export const Visited_Update_ColumnSchema = z.nativeEnum(Visited_Update_Column);


export const AddCampsiteSearchLogByUserDocument = `
    mutation AddCampsiteSearchLogByUser($filter: json!, $order_by: String!) {
  insert_campsite_search_log(objects: {filter: $filter, order_by: $order_by}) {
    affected_rows
  }
}
    `;
export const useAddCampsiteSearchLogByUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddCampsiteSearchLogByUserMutation, TError, AddCampsiteSearchLogByUserMutationVariables, TContext>) =>
    useMutation<AddCampsiteSearchLogByUserMutation, TError, AddCampsiteSearchLogByUserMutationVariables, TContext>(
      ['AddCampsiteSearchLogByUser'],
      (variables?: AddCampsiteSearchLogByUserMutationVariables) => fetchByAuth<AddCampsiteSearchLogByUserMutation, AddCampsiteSearchLogByUserMutationVariables>(AddCampsiteSearchLogByUserDocument, variables)(),
      options
    );
useAddCampsiteSearchLogByUserMutation.fetcher = (variables: AddCampsiteSearchLogByUserMutationVariables, options?: RequestInit['headers']) => fetchByAuth<AddCampsiteSearchLogByUserMutation, AddCampsiteSearchLogByUserMutationVariables>(AddCampsiteSearchLogByUserDocument, variables, options);
export const CheckCampSiteFavoriteDocument = `
    query CheckCampSiteFavorite($campsite_id: String!) {
  campsite_likes_aggregate(where: {campsite_id: {_eq: $campsite_id}}) {
    aggregate {
      count
    }
  }
}
    `;
export const useCheckCampSiteFavoriteQuery = <
      TData = CheckCampSiteFavoriteQuery,
      TError = unknown
    >(
      variables: CheckCampSiteFavoriteQueryVariables,
      options?: UseQueryOptions<CheckCampSiteFavoriteQuery, TError, TData>
    ) =>
    useQuery<CheckCampSiteFavoriteQuery, TError, TData>(
      ['CheckCampSiteFavorite', variables],
      fetchByAuth<CheckCampSiteFavoriteQuery, CheckCampSiteFavoriteQueryVariables>(CheckCampSiteFavoriteDocument, variables),
      options
    );
useCheckCampSiteFavoriteQuery.document = CheckCampSiteFavoriteDocument;


useCheckCampSiteFavoriteQuery.getKey = (variables: CheckCampSiteFavoriteQueryVariables) => ['CheckCampSiteFavorite', variables];
;

export const useInfiniteCheckCampSiteFavoriteQuery = <
      TData = CheckCampSiteFavoriteQuery,
      TError = unknown
    >(
      pageParamKey: keyof CheckCampSiteFavoriteQueryVariables,
      variables: CheckCampSiteFavoriteQueryVariables,
      options?: UseInfiniteQueryOptions<CheckCampSiteFavoriteQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<CheckCampSiteFavoriteQuery, TError, TData>(
      ['CheckCampSiteFavorite.infinite', variables],
      (metaData) => fetchByAuth<CheckCampSiteFavoriteQuery, CheckCampSiteFavoriteQueryVariables>(CheckCampSiteFavoriteDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteCheckCampSiteFavoriteQuery.getKey = (variables: CheckCampSiteFavoriteQueryVariables) => ['CheckCampSiteFavorite.infinite', variables];
;

useCheckCampSiteFavoriteQuery.fetcher = (variables: CheckCampSiteFavoriteQueryVariables, options?: RequestInit['headers']) => fetchByAuth<CheckCampSiteFavoriteQuery, CheckCampSiteFavoriteQueryVariables>(CheckCampSiteFavoriteDocument, variables, options);
export const UpdateCampsiteByUserDocument = `
    mutation UpdateCampsiteByUser($target_campsite_id: String!, $v_activity_athletic: Boolean = false, $v_activity_bbq: Boolean = false, $v_activity_bicycle: Boolean = false, $v_activity_canoe: Boolean = false, $v_activity_craft: Boolean = false, $v_activity_fishing: Boolean = false, $v_activity_flower: Boolean = false, $v_activity_hiking: Boolean = false, $v_activity_insect: Boolean = false, $v_activity_playset: Boolean = false, $v_activity_pool: Boolean = false, $v_activity_ranch: Boolean = false, $v_activity_river: Boolean = false, $v_activity_sauna: Boolean = false, $v_activity_sea: Boolean = false, $v_activity_star: Boolean = false, $v_activity_taste: Boolean = false, $v_activity_tentsauna: Boolean = false, $v_bath_hotspring: Boolean = false, $v_bath_room: Boolean = false, $v_business_newyear: Boolean = false, $v_business_period: Boolean = false, $v_checkin_start_hour: String, $v_checkin_start_minute: String, $v_checkin_end_hour: String, $v_checkin_end_minute: String, $v_checkout_start_hour: String, $v_checkout_start_minute: String, $v_checkout_end_hour: String, $v_checkout_end_minute: String, $v_closed_friday: Boolean = false, $v_closed_holiday: Boolean = false, $v_closed_irregular: Boolean = false, $v_closed_monday: Boolean = false, $v_closed_not: Boolean = false, $v_closed_saturday: Boolean = false, $v_closed_sunday: Boolean = false, $v_closed_thursday: Boolean = false, $v_closed_tuesday: Boolean = false, $v_closed_wednesday: Boolean = false, $v_facilities_barrierfree: Boolean = false, $v_facilities_dogrun: Boolean = false, $v_facilities_laundry: Boolean = false, $v_facilities_restaurant: Boolean = false, $v_facilities_store: Boolean = false, $v_facilities_workspace: Boolean = false, $v_facility_acsite: Boolean = false, $v_facility_bungalow: Boolean = false, $v_facility_cottage: Boolean = false, $v_facility_freesite: Boolean = false, $v_facility_glamping: Boolean = false, $v_facility_privatesite: Boolean = false, $v_facility_sectionsite: Boolean = false, $v_facility_solo: Boolean = false, $v_facility_tipi: Boolean = false, $v_facility_trailerhouse: Boolean = false, $v_facility_treehouse: Boolean = false, $v_introduction_content: String = "", $v_introduction_title: String = "", $v_location_forest: Boolean = false, $v_location_hill: Boolean = false, $v_location_lake: Boolean = false, $v_location_meadow: Boolean = false, $v_location_ocean: Boolean = false, $v_location_park: Boolean = false, $v_location_plateau: Boolean = false, $v_location_river: Boolean = false, $v_service_firewood: Boolean = false, $v_service_firework: Boolean = false, $v_service_freecharge: Boolean = false, $v_service_garbage: Boolean = false, $v_service_group: Boolean = false, $v_service_hotwater: Boolean = false, $v_service_openfire: Boolean = false, $v_service_pet: Boolean = false, $v_service_rental: Boolean = false, $v_service_washlet: Boolean = false, $v_service_wifi: Boolean = false, $v_tel_bottom: String = "", $v_tel_head: String = "", $v_tel_while: String = "", $v_vehicles_autocamp: Boolean = false, $v_vehicles_campingcar: Boolean = false, $v_official_url: String = "", $v_main_image_id: String = "") {
  update_campsite_info(
    args: {target_campsite_id: $target_campsite_id, v_activity_athletic: $v_activity_athletic, v_activity_bbq: $v_activity_bbq, v_activity_bicycle: $v_activity_bicycle, v_activity_canoe: $v_activity_canoe, v_activity_craft: $v_activity_craft, v_activity_fishing: $v_activity_fishing, v_activity_flower: $v_activity_flower, v_activity_hiking: $v_activity_hiking, v_activity_insect: $v_activity_insect, v_activity_playset: $v_activity_playset, v_activity_pool: $v_activity_pool, v_activity_ranch: $v_activity_ranch, v_activity_river: $v_activity_river, v_activity_sauna: $v_activity_sauna, v_activity_sea: $v_activity_sea, v_activity_star: $v_activity_star, v_activity_taste: $v_activity_taste, v_activity_tentsauna: $v_activity_tentsauna, v_bath_hotspring: $v_bath_hotspring, v_bath_room: $v_bath_room, v_business_newyear: $v_business_newyear, v_business_period: $v_business_period, v_checkin_start_hour: $v_checkin_start_hour, v_checkin_start_minute: $v_checkin_start_minute, v_checkin_end_hour: $v_checkin_end_hour, v_checkin_end_minute: $v_checkin_end_minute, v_checkout_start_hour: $v_checkout_start_hour, v_checkout_start_minute: $v_checkout_start_minute, v_checkout_end_hour: $v_checkout_end_hour, v_checkout_end_minute: $v_checkout_end_minute, v_closed_friday: $v_closed_friday, v_closed_holiday: $v_closed_holiday, v_closed_irregular: $v_closed_irregular, v_closed_monday: $v_closed_monday, v_closed_not: $v_closed_not, v_closed_saturday: $v_closed_saturday, v_closed_sunday: $v_closed_sunday, v_closed_thursday: $v_closed_thursday, v_closed_tuesday: $v_closed_tuesday, v_closed_wednesday: $v_closed_wednesday, v_facilities_barrierfree: $v_facilities_barrierfree, v_facilities_dogrun: $v_facilities_dogrun, v_facilities_laundry: $v_facilities_laundry, v_facilities_restaurant: $v_facilities_restaurant, v_facilities_store: $v_facilities_store, v_facilities_workspace: $v_facilities_workspace, v_facility_acsite: $v_facility_acsite, v_facility_bungalow: $v_facility_bungalow, v_facility_cottage: $v_facility_cottage, v_facility_freesite: $v_facility_freesite, v_facility_glamping: $v_facility_glamping, v_facility_privatesite: $v_facility_privatesite, v_facility_sectionsite: $v_facility_sectionsite, v_facility_solo: $v_facility_solo, v_facility_tipi: $v_facility_tipi, v_facility_trailerhouse: $v_facility_trailerhouse, v_facility_treehouse: $v_facility_treehouse, v_introduction_content: $v_introduction_content, v_introduction_title: $v_introduction_title, v_location_forest: $v_location_forest, v_location_hill: $v_location_hill, v_location_lake: $v_location_lake, v_location_meadow: $v_location_meadow, v_location_ocean: $v_location_ocean, v_location_park: $v_location_park, v_location_plateau: $v_location_plateau, v_location_river: $v_location_river, v_service_firewood: $v_service_firewood, v_service_firework: $v_service_firework, v_service_freecharge: $v_service_freecharge, v_service_garbage: $v_service_garbage, v_service_group: $v_service_group, v_service_hotwater: $v_service_hotwater, v_service_openfire: $v_service_openfire, v_service_pet: $v_service_pet, v_service_rental: $v_service_rental, v_service_washlet: $v_service_washlet, v_service_wifi: $v_service_wifi, v_tel_bottom: $v_tel_bottom, v_tel_head: $v_tel_head, v_tel_while: $v_tel_while, v_vehicles_campingcar: $v_vehicles_campingcar, v_vehicles_autocamp: $v_vehicles_autocamp, v_official_url: $v_official_url, v_main_image_id: $v_main_image_id}
  ) {
    id
  }
}
    `;
export const useUpdateCampsiteByUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCampsiteByUserMutation, TError, UpdateCampsiteByUserMutationVariables, TContext>) =>
    useMutation<UpdateCampsiteByUserMutation, TError, UpdateCampsiteByUserMutationVariables, TContext>(
      ['UpdateCampsiteByUser'],
      (variables?: UpdateCampsiteByUserMutationVariables) => fetchByAuth<UpdateCampsiteByUserMutation, UpdateCampsiteByUserMutationVariables>(UpdateCampsiteByUserDocument, variables)(),
      options
    );
useUpdateCampsiteByUserMutation.fetcher = (variables: UpdateCampsiteByUserMutationVariables, options?: RequestInit['headers']) => fetchByAuth<UpdateCampsiteByUserMutation, UpdateCampsiteByUserMutationVariables>(UpdateCampsiteByUserDocument, variables, options);
export const UpsertCampsiteImageDocument = `
    mutation UpsertCampsiteImage($target_campsite_id: String = "", $target_image_ids: _text = "", $target_image_titles: _text = "", $target_type: String = "") {
  upsert_campsite_image(
    args: {target_campsite_id: $target_campsite_id, target_image_ids: $target_image_ids, target_image_titles: $target_image_titles, target_type: $target_type}
  ) {
    id
  }
}
    `;
export const useUpsertCampsiteImageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpsertCampsiteImageMutation, TError, UpsertCampsiteImageMutationVariables, TContext>) =>
    useMutation<UpsertCampsiteImageMutation, TError, UpsertCampsiteImageMutationVariables, TContext>(
      ['UpsertCampsiteImage'],
      (variables?: UpsertCampsiteImageMutationVariables) => fetchByAuth<UpsertCampsiteImageMutation, UpsertCampsiteImageMutationVariables>(UpsertCampsiteImageDocument, variables)(),
      options
    );
useUpsertCampsiteImageMutation.fetcher = (variables?: UpsertCampsiteImageMutationVariables, options?: RequestInit['headers']) => fetchByAuth<UpsertCampsiteImageMutation, UpsertCampsiteImageMutationVariables>(UpsertCampsiteImageDocument, variables, options);
export const GetUserByIdDocument = `
    query getUserByID($id: String!) {
  user_by_pk(id: $id) {
    withdrawal_date
    user_email
    url_title
    url
    updated_at
    total_visited_num
    total_review_num
    total_point
    total_like_num
    start_history
    sex
    self_introduction
    liked_gear
    id
    icon_image_id
    email
    display_name
    created_at
    birthday
    camping_days
    background_image_id
  }
}
    `;
export const useGetUserByIdQuery = <
      TData = GetUserByIdQuery,
      TError = unknown
    >(
      variables: GetUserByIdQueryVariables,
      options?: UseQueryOptions<GetUserByIdQuery, TError, TData>
    ) =>
    useQuery<GetUserByIdQuery, TError, TData>(
      ['getUserByID', variables],
      fetchByAuth<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, variables),
      options
    );
useGetUserByIdQuery.document = GetUserByIdDocument;


useGetUserByIdQuery.getKey = (variables: GetUserByIdQueryVariables) => ['getUserByID', variables];
;

export const useInfiniteGetUserByIdQuery = <
      TData = GetUserByIdQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetUserByIdQueryVariables,
      variables: GetUserByIdQueryVariables,
      options?: UseInfiniteQueryOptions<GetUserByIdQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetUserByIdQuery, TError, TData>(
      ['getUserByID.infinite', variables],
      (metaData) => fetchByAuth<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetUserByIdQuery.getKey = (variables: GetUserByIdQueryVariables) => ['getUserByID.infinite', variables];
;

useGetUserByIdQuery.fetcher = (variables: GetUserByIdQueryVariables, options?: RequestInit['headers']) => fetchByAuth<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, variables, options);
export const AddCampSiteLikeDocument = `
    mutation AddCampSiteLike($campsite_id: String!, $type: String!, $user_id: String!) {
  insert_campsite_likes_one(
    object: {campsite_id: $campsite_id, type: $type, user_id: $user_id}
  ) {
    campsite_id
    created_at
    id
    type
    updated_at
    user_id
  }
}
    `;
export const useAddCampSiteLikeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddCampSiteLikeMutation, TError, AddCampSiteLikeMutationVariables, TContext>) =>
    useMutation<AddCampSiteLikeMutation, TError, AddCampSiteLikeMutationVariables, TContext>(
      ['AddCampSiteLike'],
      (variables?: AddCampSiteLikeMutationVariables) => fetchByAuth<AddCampSiteLikeMutation, AddCampSiteLikeMutationVariables>(AddCampSiteLikeDocument, variables)(),
      options
    );
useAddCampSiteLikeMutation.fetcher = (variables: AddCampSiteLikeMutationVariables, options?: RequestInit['headers']) => fetchByAuth<AddCampSiteLikeMutation, AddCampSiteLikeMutationVariables>(AddCampSiteLikeDocument, variables, options);
export const DeleteCampSiteLikeDocument = `
    mutation DeleteCampSiteLike($campsite_id: String!, $user_id: String!) {
  delete_campsite_likes(
    where: {user_id: {_eq: $user_id}, campsite_id: {_eq: $campsite_id}}
  ) {
    affected_rows
  }
}
    `;
export const useDeleteCampSiteLikeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteCampSiteLikeMutation, TError, DeleteCampSiteLikeMutationVariables, TContext>) =>
    useMutation<DeleteCampSiteLikeMutation, TError, DeleteCampSiteLikeMutationVariables, TContext>(
      ['DeleteCampSiteLike'],
      (variables?: DeleteCampSiteLikeMutationVariables) => fetchByAuth<DeleteCampSiteLikeMutation, DeleteCampSiteLikeMutationVariables>(DeleteCampSiteLikeDocument, variables)(),
      options
    );
useDeleteCampSiteLikeMutation.fetcher = (variables: DeleteCampSiteLikeMutationVariables, options?: RequestInit['headers']) => fetchByAuth<DeleteCampSiteLikeMutation, DeleteCampSiteLikeMutationVariables>(DeleteCampSiteLikeDocument, variables, options);
export const UpdateCampsiteLikeFromEditDocument = `
    mutation UpdateCampsiteLikeFromEdit($campsite_ids: _text!, $input_type: String!) {
  update_campsite_like_from_edit(
    args: {input_type: $input_type, campsite_ids: $campsite_ids}
  ) {
    id
  }
}
    `;
export const useUpdateCampsiteLikeFromEditMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateCampsiteLikeFromEditMutation, TError, UpdateCampsiteLikeFromEditMutationVariables, TContext>) =>
    useMutation<UpdateCampsiteLikeFromEditMutation, TError, UpdateCampsiteLikeFromEditMutationVariables, TContext>(
      ['UpdateCampsiteLikeFromEdit'],
      (variables?: UpdateCampsiteLikeFromEditMutationVariables) => fetchByAuth<UpdateCampsiteLikeFromEditMutation, UpdateCampsiteLikeFromEditMutationVariables>(UpdateCampsiteLikeFromEditDocument, variables)(),
      options
    );
useUpdateCampsiteLikeFromEditMutation.fetcher = (variables: UpdateCampsiteLikeFromEditMutationVariables, options?: RequestInit['headers']) => fetchByAuth<UpdateCampsiteLikeFromEditMutation, UpdateCampsiteLikeFromEditMutationVariables>(UpdateCampsiteLikeFromEditDocument, variables, options);
export const CampsiteLikeDocument = `
    query CampsiteLike {
  favorite: campsite_likes(where: {type: {_eq: "FAVORITE"}}) {
    campsite_id
    created_at
    id
    type
    updated_at
  }
  favorite_count: campsite_likes_aggregate(where: {type: {_eq: "FAVORITE"}}) {
    aggregate {
      count
    }
  }
  special: campsite_likes(where: {type: {_eq: "SPECIAL"}}) {
    campsite_id
    created_at
    id
    type
    updated_at
  }
  special_count: campsite_likes_aggregate(where: {type: {_eq: "SPECIAL"}}) {
    aggregate {
      count
    }
  }
  all: campsite_likes(where: {type: {_eq: "ALL"}}) {
    campsite_id
    created_at
    id
    type
    updated_at
  }
  all_count: campsite_likes_aggregate(where: {type: {_eq: "ALL"}}) {
    aggregate {
      count
    }
  }
}
    `;
export const useCampsiteLikeQuery = <
      TData = CampsiteLikeQuery,
      TError = unknown
    >(
      variables?: CampsiteLikeQueryVariables,
      options?: UseQueryOptions<CampsiteLikeQuery, TError, TData>
    ) =>
    useQuery<CampsiteLikeQuery, TError, TData>(
      variables === undefined ? ['CampsiteLike'] : ['CampsiteLike', variables],
      fetchByAuth<CampsiteLikeQuery, CampsiteLikeQueryVariables>(CampsiteLikeDocument, variables),
      options
    );
useCampsiteLikeQuery.document = CampsiteLikeDocument;


useCampsiteLikeQuery.getKey = (variables?: CampsiteLikeQueryVariables) => variables === undefined ? ['CampsiteLike'] : ['CampsiteLike', variables];
;

export const useInfiniteCampsiteLikeQuery = <
      TData = CampsiteLikeQuery,
      TError = unknown
    >(
      pageParamKey: keyof CampsiteLikeQueryVariables,
      variables?: CampsiteLikeQueryVariables,
      options?: UseInfiniteQueryOptions<CampsiteLikeQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<CampsiteLikeQuery, TError, TData>(
      variables === undefined ? ['CampsiteLike.infinite'] : ['CampsiteLike.infinite', variables],
      (metaData) => fetchByAuth<CampsiteLikeQuery, CampsiteLikeQueryVariables>(CampsiteLikeDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteCampsiteLikeQuery.getKey = (variables?: CampsiteLikeQueryVariables) => variables === undefined ? ['CampsiteLike.infinite'] : ['CampsiteLike.infinite', variables];
;

useCampsiteLikeQuery.fetcher = (variables?: CampsiteLikeQueryVariables, options?: RequestInit['headers']) => fetchByAuth<CampsiteLikeQuery, CampsiteLikeQueryVariables>(CampsiteLikeDocument, variables, options);
export const AddVisitedDocument = `
    mutation AddVisited($campsite_id: String!, $user_id: String!) {
  insert_visited(objects: {campsite_id: $campsite_id, user_id: $user_id}) {
    affected_rows
    returning {
      campsite_id
      created_at
      id
      updated_at
      user_id
    }
  }
}
    `;
export const useAddVisitedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddVisitedMutation, TError, AddVisitedMutationVariables, TContext>) =>
    useMutation<AddVisitedMutation, TError, AddVisitedMutationVariables, TContext>(
      ['AddVisited'],
      (variables?: AddVisitedMutationVariables) => fetchByAuth<AddVisitedMutation, AddVisitedMutationVariables>(AddVisitedDocument, variables)(),
      options
    );
useAddVisitedMutation.fetcher = (variables: AddVisitedMutationVariables, options?: RequestInit['headers']) => fetchByAuth<AddVisitedMutation, AddVisitedMutationVariables>(AddVisitedDocument, variables, options);
export const CheckVisitedByCampsiteIdDocument = `
    query CheckVisitedByCampsiteID($user_id: String!, $campsite_id: String!) {
  visited(
    where: {user_id: {_eq: $user_id}, _and: {campsite_id: {_eq: $campsite_id}}}
  ) {
    campsite_id
    created_at
    id
    updated_at
    user_id
  }
}
    `;
export const useCheckVisitedByCampsiteIdQuery = <
      TData = CheckVisitedByCampsiteIdQuery,
      TError = unknown
    >(
      variables: CheckVisitedByCampsiteIdQueryVariables,
      options?: UseQueryOptions<CheckVisitedByCampsiteIdQuery, TError, TData>
    ) =>
    useQuery<CheckVisitedByCampsiteIdQuery, TError, TData>(
      ['CheckVisitedByCampsiteID', variables],
      fetchByAuth<CheckVisitedByCampsiteIdQuery, CheckVisitedByCampsiteIdQueryVariables>(CheckVisitedByCampsiteIdDocument, variables),
      options
    );
useCheckVisitedByCampsiteIdQuery.document = CheckVisitedByCampsiteIdDocument;


useCheckVisitedByCampsiteIdQuery.getKey = (variables: CheckVisitedByCampsiteIdQueryVariables) => ['CheckVisitedByCampsiteID', variables];
;

export const useInfiniteCheckVisitedByCampsiteIdQuery = <
      TData = CheckVisitedByCampsiteIdQuery,
      TError = unknown
    >(
      pageParamKey: keyof CheckVisitedByCampsiteIdQueryVariables,
      variables: CheckVisitedByCampsiteIdQueryVariables,
      options?: UseInfiniteQueryOptions<CheckVisitedByCampsiteIdQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<CheckVisitedByCampsiteIdQuery, TError, TData>(
      ['CheckVisitedByCampsiteID.infinite', variables],
      (metaData) => fetchByAuth<CheckVisitedByCampsiteIdQuery, CheckVisitedByCampsiteIdQueryVariables>(CheckVisitedByCampsiteIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteCheckVisitedByCampsiteIdQuery.getKey = (variables: CheckVisitedByCampsiteIdQueryVariables) => ['CheckVisitedByCampsiteID.infinite', variables];
;

useCheckVisitedByCampsiteIdQuery.fetcher = (variables: CheckVisitedByCampsiteIdQueryVariables, options?: RequestInit['headers']) => fetchByAuth<CheckVisitedByCampsiteIdQuery, CheckVisitedByCampsiteIdQueryVariables>(CheckVisitedByCampsiteIdDocument, variables, options);
export const RemoveVisitedDocument = `
    mutation RemoveVisited($campsite_id: String!, $user_id: String!) {
  delete_visited(
    where: {user_id: {_eq: $user_id}, _and: {campsite_id: {_eq: $campsite_id}}}
  ) {
    affected_rows
    returning {
      campsite_id
      created_at
      id
      updated_at
      user_id
    }
  }
}
    `;
export const useRemoveVisitedMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<RemoveVisitedMutation, TError, RemoveVisitedMutationVariables, TContext>) =>
    useMutation<RemoveVisitedMutation, TError, RemoveVisitedMutationVariables, TContext>(
      ['RemoveVisited'],
      (variables?: RemoveVisitedMutationVariables) => fetchByAuth<RemoveVisitedMutation, RemoveVisitedMutationVariables>(RemoveVisitedDocument, variables)(),
      options
    );
useRemoveVisitedMutation.fetcher = (variables: RemoveVisitedMutationVariables, options?: RequestInit['headers']) => fetchByAuth<RemoveVisitedMutation, RemoveVisitedMutationVariables>(RemoveVisitedDocument, variables, options);
export const ExchangeFirewoodDocument = `
    mutation ExchangeFirewood($target_campsite_id: String!) {
  exchange_fixed_exchange_product(
    args: {target_fixed_exchange_product_id: "firewood", target_campsite_id: $target_campsite_id}
  ) {
    created_at
    fixed_exchange_product_id
    id
    point_used_id
    updated_at
    user_id
  }
}
    `;
export const useExchangeFirewoodMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ExchangeFirewoodMutation, TError, ExchangeFirewoodMutationVariables, TContext>) =>
    useMutation<ExchangeFirewoodMutation, TError, ExchangeFirewoodMutationVariables, TContext>(
      ['ExchangeFirewood'],
      (variables?: ExchangeFirewoodMutationVariables) => fetchByAuth<ExchangeFirewoodMutation, ExchangeFirewoodMutationVariables>(ExchangeFirewoodDocument, variables)(),
      options
    );
useExchangeFirewoodMutation.fetcher = (variables: ExchangeFirewoodMutationVariables, options?: RequestInit['headers']) => fetchByAuth<ExchangeFirewoodMutation, ExchangeFirewoodMutationVariables>(ExchangeFirewoodDocument, variables, options);
export const DrawGatchaDocument = `
    mutation drawGatcha($targetGachaId: String!) {
  drawGacha(targetGachaId: $targetGachaId, targetUserId: "") {
    error_code
    error_message
    gacha_lose_id
    physical_prize_id
    result
    status
  }
}
    `;
export const useDrawGatchaMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DrawGatchaMutation, TError, DrawGatchaMutationVariables, TContext>) =>
    useMutation<DrawGatchaMutation, TError, DrawGatchaMutationVariables, TContext>(
      ['drawGatcha'],
      (variables?: DrawGatchaMutationVariables) => fetchByAuth<DrawGatchaMutation, DrawGatchaMutationVariables>(DrawGatchaDocument, variables)(),
      options
    );
useDrawGatchaMutation.fetcher = (variables: DrawGatchaMutationVariables, options?: RequestInit['headers']) => fetchByAuth<DrawGatchaMutation, DrawGatchaMutationVariables>(DrawGatchaDocument, variables, options);
export const GetPrismicIdByPhysicalPrizeIdDocument = `
    query GetPrismicIdByPhysicalPrizeId($_eq: String!) {
  physical_prize(where: {id: {_eq: $_eq}}) {
    id
    gacha_id
    physical_prize_delivery_address_id
  }
}
    `;
export const useGetPrismicIdByPhysicalPrizeIdQuery = <
      TData = GetPrismicIdByPhysicalPrizeIdQuery,
      TError = unknown
    >(
      variables: GetPrismicIdByPhysicalPrizeIdQueryVariables,
      options?: UseQueryOptions<GetPrismicIdByPhysicalPrizeIdQuery, TError, TData>
    ) =>
    useQuery<GetPrismicIdByPhysicalPrizeIdQuery, TError, TData>(
      ['GetPrismicIdByPhysicalPrizeId', variables],
      fetchByAuth<GetPrismicIdByPhysicalPrizeIdQuery, GetPrismicIdByPhysicalPrizeIdQueryVariables>(GetPrismicIdByPhysicalPrizeIdDocument, variables),
      options
    );
useGetPrismicIdByPhysicalPrizeIdQuery.document = GetPrismicIdByPhysicalPrizeIdDocument;


useGetPrismicIdByPhysicalPrizeIdQuery.getKey = (variables: GetPrismicIdByPhysicalPrizeIdQueryVariables) => ['GetPrismicIdByPhysicalPrizeId', variables];
;

export const useInfiniteGetPrismicIdByPhysicalPrizeIdQuery = <
      TData = GetPrismicIdByPhysicalPrizeIdQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetPrismicIdByPhysicalPrizeIdQueryVariables,
      variables: GetPrismicIdByPhysicalPrizeIdQueryVariables,
      options?: UseInfiniteQueryOptions<GetPrismicIdByPhysicalPrizeIdQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetPrismicIdByPhysicalPrizeIdQuery, TError, TData>(
      ['GetPrismicIdByPhysicalPrizeId.infinite', variables],
      (metaData) => fetchByAuth<GetPrismicIdByPhysicalPrizeIdQuery, GetPrismicIdByPhysicalPrizeIdQueryVariables>(GetPrismicIdByPhysicalPrizeIdDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetPrismicIdByPhysicalPrizeIdQuery.getKey = (variables: GetPrismicIdByPhysicalPrizeIdQueryVariables) => ['GetPrismicIdByPhysicalPrizeId.infinite', variables];
;

useGetPrismicIdByPhysicalPrizeIdQuery.fetcher = (variables: GetPrismicIdByPhysicalPrizeIdQueryVariables, options?: RequestInit['headers']) => fetchByAuth<GetPrismicIdByPhysicalPrizeIdQuery, GetPrismicIdByPhysicalPrizeIdQueryVariables>(GetPrismicIdByPhysicalPrizeIdDocument, variables, options);
export const SubmitPhysicalPriseDeliveryAddressDocument = `
    mutation SubmitPhysicalPriseDeliveryAddress($target_street: String!, $target_building: String = "", $target_city: String!, $target_postal_code: String!, $target_prefecture: String!, $target_physical_prize_id: String = null, $target_tel_body: String!, $target_name: String!, $target_tel_head: String!, $target_tel_tail: String!) {
  submit_physical_prize_delivery_address(
    args: {target_city: $target_city, target_street: $target_street, target_building: $target_building, target_prefecture: $target_prefecture, target_physical_prize_id: $target_physical_prize_id, target_postal_code: $target_postal_code, target_tel_body: $target_tel_body, target_name: $target_name, target_tel_head: $target_tel_head, target_tel_tail: $target_tel_tail}
  ) {
    building
    city
    created_at
    postal_code
    id
    updated_at
    street
    prefecture
    user_id
    name
    tel_body
    tel_head
    tel_tail
  }
}
    `;
export const useSubmitPhysicalPriseDeliveryAddressMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<SubmitPhysicalPriseDeliveryAddressMutation, TError, SubmitPhysicalPriseDeliveryAddressMutationVariables, TContext>) =>
    useMutation<SubmitPhysicalPriseDeliveryAddressMutation, TError, SubmitPhysicalPriseDeliveryAddressMutationVariables, TContext>(
      ['SubmitPhysicalPriseDeliveryAddress'],
      (variables?: SubmitPhysicalPriseDeliveryAddressMutationVariables) => fetchByAuth<SubmitPhysicalPriseDeliveryAddressMutation, SubmitPhysicalPriseDeliveryAddressMutationVariables>(SubmitPhysicalPriseDeliveryAddressDocument, variables)(),
      options
    );
useSubmitPhysicalPriseDeliveryAddressMutation.fetcher = (variables: SubmitPhysicalPriseDeliveryAddressMutationVariables, options?: RequestInit['headers']) => fetchByAuth<SubmitPhysicalPriseDeliveryAddressMutation, SubmitPhysicalPriseDeliveryAddressMutationVariables>(SubmitPhysicalPriseDeliveryAddressDocument, variables, options);
export const GeneratePresignUrlDocument = `
    mutation GeneratePresignUrl($fileName: String!) {
  generatePresignedUrl(fileName: $fileName) {
    fileName
    status
    url
  }
}
    `;
export const useGeneratePresignUrlMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<GeneratePresignUrlMutation, TError, GeneratePresignUrlMutationVariables, TContext>) =>
    useMutation<GeneratePresignUrlMutation, TError, GeneratePresignUrlMutationVariables, TContext>(
      ['GeneratePresignUrl'],
      (variables?: GeneratePresignUrlMutationVariables) => fetchByAuth<GeneratePresignUrlMutation, GeneratePresignUrlMutationVariables>(GeneratePresignUrlDocument, variables)(),
      options
    );
useGeneratePresignUrlMutation.fetcher = (variables: GeneratePresignUrlMutationVariables, options?: RequestInit['headers']) => fetchByAuth<GeneratePresignUrlMutation, GeneratePresignUrlMutationVariables>(GeneratePresignUrlDocument, variables, options);
export const InsertImageDocument = `
    mutation InsertImage($alt: String!, $file_name: String!, $title: String!, $user_id: String!) {
  insert_image_one(
    object: {alt: $alt, file_name: $file_name, title: $title, user_id: $user_id}
  ) {
    id
  }
}
    `;
export const useInsertImageMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<InsertImageMutation, TError, InsertImageMutationVariables, TContext>) =>
    useMutation<InsertImageMutation, TError, InsertImageMutationVariables, TContext>(
      ['InsertImage'],
      (variables?: InsertImageMutationVariables) => fetchByAuth<InsertImageMutation, InsertImageMutationVariables>(InsertImageDocument, variables)(),
      options
    );
useInsertImageMutation.fetcher = (variables: InsertImageMutationVariables, options?: RequestInit['headers']) => fetchByAuth<InsertImageMutation, InsertImageMutationVariables>(InsertImageDocument, variables, options);
export const GetMyPointNotificationDocument = `
    query GetMyPointNotification {
  point(where: {read_at: {_is_null: true}}) {
    created_at
    earned_type
    id
    message
    rate
    read_at
    updated_at
    user_id
    value
    month_first_point_id
  }
}
    `;
export const useGetMyPointNotificationQuery = <
      TData = GetMyPointNotificationQuery,
      TError = unknown
    >(
      variables?: GetMyPointNotificationQueryVariables,
      options?: UseQueryOptions<GetMyPointNotificationQuery, TError, TData>
    ) =>
    useQuery<GetMyPointNotificationQuery, TError, TData>(
      variables === undefined ? ['GetMyPointNotification'] : ['GetMyPointNotification', variables],
      fetchByAuth<GetMyPointNotificationQuery, GetMyPointNotificationQueryVariables>(GetMyPointNotificationDocument, variables),
      options
    );
useGetMyPointNotificationQuery.document = GetMyPointNotificationDocument;


useGetMyPointNotificationQuery.getKey = (variables?: GetMyPointNotificationQueryVariables) => variables === undefined ? ['GetMyPointNotification'] : ['GetMyPointNotification', variables];
;

export const useInfiniteGetMyPointNotificationQuery = <
      TData = GetMyPointNotificationQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetMyPointNotificationQueryVariables,
      variables?: GetMyPointNotificationQueryVariables,
      options?: UseInfiniteQueryOptions<GetMyPointNotificationQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetMyPointNotificationQuery, TError, TData>(
      variables === undefined ? ['GetMyPointNotification.infinite'] : ['GetMyPointNotification.infinite', variables],
      (metaData) => fetchByAuth<GetMyPointNotificationQuery, GetMyPointNotificationQueryVariables>(GetMyPointNotificationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetMyPointNotificationQuery.getKey = (variables?: GetMyPointNotificationQueryVariables) => variables === undefined ? ['GetMyPointNotification.infinite'] : ['GetMyPointNotification.infinite', variables];
;

useGetMyPointNotificationQuery.fetcher = (variables?: GetMyPointNotificationQueryVariables, options?: RequestInit['headers']) => fetchByAuth<GetMyPointNotificationQuery, GetMyPointNotificationQueryVariables>(GetMyPointNotificationDocument, variables, options);
export const UpdateMyPointNotificationDocument = `
    mutation UpdateMyPointNotification($read_at: timestamp!, $_in: [String!]!) {
  update_point(where: {id: {_in: $_in}}, _set: {read_at: $read_at}) {
    affected_rows
  }
}
    `;
export const useUpdateMyPointNotificationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateMyPointNotificationMutation, TError, UpdateMyPointNotificationMutationVariables, TContext>) =>
    useMutation<UpdateMyPointNotificationMutation, TError, UpdateMyPointNotificationMutationVariables, TContext>(
      ['UpdateMyPointNotification'],
      (variables?: UpdateMyPointNotificationMutationVariables) => fetchByAuth<UpdateMyPointNotificationMutation, UpdateMyPointNotificationMutationVariables>(UpdateMyPointNotificationDocument, variables)(),
      options
    );
useUpdateMyPointNotificationMutation.fetcher = (variables: UpdateMyPointNotificationMutationVariables, options?: RequestInit['headers']) => fetchByAuth<UpdateMyPointNotificationMutation, UpdateMyPointNotificationMutationVariables>(UpdateMyPointNotificationDocument, variables, options);
export const AddReviewGoodDocument = `
    mutation AddReviewGood($from_user_id: String!, $for_review_id: String!) {
  insert_review_good(
    objects: {for_review_id: $for_review_id, from_user_id: $from_user_id}
  ) {
    affected_rows
  }
}
    `;
export const useAddReviewGoodMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddReviewGoodMutation, TError, AddReviewGoodMutationVariables, TContext>) =>
    useMutation<AddReviewGoodMutation, TError, AddReviewGoodMutationVariables, TContext>(
      ['AddReviewGood'],
      (variables?: AddReviewGoodMutationVariables) => fetchByAuth<AddReviewGoodMutation, AddReviewGoodMutationVariables>(AddReviewGoodDocument, variables)(),
      options
    );
useAddReviewGoodMutation.fetcher = (variables: AddReviewGoodMutationVariables, options?: RequestInit['headers']) => fetchByAuth<AddReviewGoodMutation, AddReviewGoodMutationVariables>(AddReviewGoodDocument, variables, options);
export const DeleteReviewByPkDocument = `
    mutation DeleteReviewByPK($id: String!) {
  delete_review_by_pk(id: $id) {
    id
  }
}
    `;
export const useDeleteReviewByPkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteReviewByPkMutation, TError, DeleteReviewByPkMutationVariables, TContext>) =>
    useMutation<DeleteReviewByPkMutation, TError, DeleteReviewByPkMutationVariables, TContext>(
      ['DeleteReviewByPK'],
      (variables?: DeleteReviewByPkMutationVariables) => fetchByAuth<DeleteReviewByPkMutation, DeleteReviewByPkMutationVariables>(DeleteReviewByPkDocument, variables)(),
      options
    );
useDeleteReviewByPkMutation.fetcher = (variables: DeleteReviewByPkMutationVariables, options?: RequestInit['headers']) => fetchByAuth<DeleteReviewByPkMutation, DeleteReviewByPkMutationVariables>(DeleteReviewByPkDocument, variables, options);
export const DeleteReviewGoodDocument = `
    mutation DeleteReviewGood($for_review_id: String!, $from_user_id: String!) {
  delete_review_good(
    where: {for_review_id: {_eq: $for_review_id}, from_user_id: {_eq: $from_user_id}}
  ) {
    affected_rows
  }
}
    `;
export const useDeleteReviewGoodMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteReviewGoodMutation, TError, DeleteReviewGoodMutationVariables, TContext>) =>
    useMutation<DeleteReviewGoodMutation, TError, DeleteReviewGoodMutationVariables, TContext>(
      ['DeleteReviewGood'],
      (variables?: DeleteReviewGoodMutationVariables) => fetchByAuth<DeleteReviewGoodMutation, DeleteReviewGoodMutationVariables>(DeleteReviewGoodDocument, variables)(),
      options
    );
useDeleteReviewGoodMutation.fetcher = (variables: DeleteReviewGoodMutationVariables, options?: RequestInit['headers']) => fetchByAuth<DeleteReviewGoodMutation, DeleteReviewGoodMutationVariables>(DeleteReviewGoodDocument, variables, options);
export const ReviewByPkFromUserDocument = `
    query ReviewByPKFromUser($id: String!) {
  review_by_pk(id: $id) {
    user_id
    updated_at
    total_good_num
    review_images {
      id
      image {
        alt
        created_at
        file_name
        id
        title
        user_id
      }
    }
    campsite_id
    content
    created_at
    id
    public
    review_goods_aggregate {
      aggregate {
        count
      }
    }
    review_images_aggregate {
      aggregate {
        count
      }
    }
    user_public {
      icon_image_id
      id
      liked_gear
      self_introduction
      start_history
      total_review_num
      total_visited_num
      updated_at
      url
      url_title
      display_name
      created_at
      camping_days
      background_image_id
      icon {
        file_name
        id
        created_at
        alt
        title
        user_id
      }
    }
    campsite {
      id
      name
    }
  }
}
    `;
export const useReviewByPkFromUserQuery = <
      TData = ReviewByPkFromUserQuery,
      TError = unknown
    >(
      variables: ReviewByPkFromUserQueryVariables,
      options?: UseQueryOptions<ReviewByPkFromUserQuery, TError, TData>
    ) =>
    useQuery<ReviewByPkFromUserQuery, TError, TData>(
      ['ReviewByPKFromUser', variables],
      fetchByAuth<ReviewByPkFromUserQuery, ReviewByPkFromUserQueryVariables>(ReviewByPkFromUserDocument, variables),
      options
    );
useReviewByPkFromUserQuery.document = ReviewByPkFromUserDocument;


useReviewByPkFromUserQuery.getKey = (variables: ReviewByPkFromUserQueryVariables) => ['ReviewByPKFromUser', variables];
;

export const useInfiniteReviewByPkFromUserQuery = <
      TData = ReviewByPkFromUserQuery,
      TError = unknown
    >(
      pageParamKey: keyof ReviewByPkFromUserQueryVariables,
      variables: ReviewByPkFromUserQueryVariables,
      options?: UseInfiniteQueryOptions<ReviewByPkFromUserQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ReviewByPkFromUserQuery, TError, TData>(
      ['ReviewByPKFromUser.infinite', variables],
      (metaData) => fetchByAuth<ReviewByPkFromUserQuery, ReviewByPkFromUserQueryVariables>(ReviewByPkFromUserDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteReviewByPkFromUserQuery.getKey = (variables: ReviewByPkFromUserQueryVariables) => ['ReviewByPKFromUser.infinite', variables];
;

useReviewByPkFromUserQuery.fetcher = (variables: ReviewByPkFromUserQueryVariables, options?: RequestInit['headers']) => fetchByAuth<ReviewByPkFromUserQuery, ReviewByPkFromUserQueryVariables>(ReviewByPkFromUserDocument, variables, options);
export const ReviewFromUserDocument = `
    query ReviewFromUser {
  review(order_by: {created_at: desc}) {
    user_id
    updated_at
    total_good_num
    review_images {
      id
      image {
        alt
        created_at
        file_name
        id
        title
        user_id
      }
    }
    campsite_id
    content
    created_at
    id
    public
    review_goods_aggregate {
      aggregate {
        count
      }
    }
    review_images_aggregate {
      aggregate {
        count
      }
    }
    user_public {
      icon_image_id
      id
      liked_gear
      self_introduction
      start_history
      total_review_num
      total_visited_num
      updated_at
      url
      url_title
      display_name
      created_at
      camping_days
      background_image_id
      icon {
        file_name
        id
        created_at
        alt
        title
        user_id
      }
    }
    campsite {
      id
      name
    }
  }
}
    `;
export const useReviewFromUserQuery = <
      TData = ReviewFromUserQuery,
      TError = unknown
    >(
      variables?: ReviewFromUserQueryVariables,
      options?: UseQueryOptions<ReviewFromUserQuery, TError, TData>
    ) =>
    useQuery<ReviewFromUserQuery, TError, TData>(
      variables === undefined ? ['ReviewFromUser'] : ['ReviewFromUser', variables],
      fetchByAuth<ReviewFromUserQuery, ReviewFromUserQueryVariables>(ReviewFromUserDocument, variables),
      options
    );
useReviewFromUserQuery.document = ReviewFromUserDocument;


useReviewFromUserQuery.getKey = (variables?: ReviewFromUserQueryVariables) => variables === undefined ? ['ReviewFromUser'] : ['ReviewFromUser', variables];
;

export const useInfiniteReviewFromUserQuery = <
      TData = ReviewFromUserQuery,
      TError = unknown
    >(
      pageParamKey: keyof ReviewFromUserQueryVariables,
      variables?: ReviewFromUserQueryVariables,
      options?: UseInfiniteQueryOptions<ReviewFromUserQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ReviewFromUserQuery, TError, TData>(
      variables === undefined ? ['ReviewFromUser.infinite'] : ['ReviewFromUser.infinite', variables],
      (metaData) => fetchByAuth<ReviewFromUserQuery, ReviewFromUserQueryVariables>(ReviewFromUserDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteReviewFromUserQuery.getKey = (variables?: ReviewFromUserQueryVariables) => variables === undefined ? ['ReviewFromUser.infinite'] : ['ReviewFromUser.infinite', variables];
;

useReviewFromUserQuery.fetcher = (variables?: ReviewFromUserQueryVariables, options?: RequestInit['headers']) => fetchByAuth<ReviewFromUserQuery, ReviewFromUserQueryVariables>(ReviewFromUserDocument, variables, options);
export const AddReviewDocument = `
    mutation AddReview($public: Boolean!, $content: String!, $campsite_id: String!, $user_id: String!) {
  insert_review(
    objects: {campsite_id: $campsite_id, content: $content, public: $public, user_id: $user_id}
  ) {
    affected_rows
    returning {
      id
    }
  }
}
    `;
export const useAddReviewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddReviewMutation, TError, AddReviewMutationVariables, TContext>) =>
    useMutation<AddReviewMutation, TError, AddReviewMutationVariables, TContext>(
      ['AddReview'],
      (variables?: AddReviewMutationVariables) => fetchByAuth<AddReviewMutation, AddReviewMutationVariables>(AddReviewDocument, variables)(),
      options
    );
useAddReviewMutation.fetcher = (variables: AddReviewMutationVariables, options?: RequestInit['headers']) => fetchByAuth<AddReviewMutation, AddReviewMutationVariables>(AddReviewDocument, variables, options);
export const UpdateReviewDocument = `
    mutation updateReview($id: String!, $content: String!, $public: Boolean!) {
  update_review_by_pk(
    pk_columns: {id: $id}
    _set: {content: $content, public: $public}
  ) {
    id
  }
}
    `;
export const useUpdateReviewMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateReviewMutation, TError, UpdateReviewMutationVariables, TContext>) =>
    useMutation<UpdateReviewMutation, TError, UpdateReviewMutationVariables, TContext>(
      ['updateReview'],
      (variables?: UpdateReviewMutationVariables) => fetchByAuth<UpdateReviewMutation, UpdateReviewMutationVariables>(UpdateReviewDocument, variables)(),
      options
    );
useUpdateReviewMutation.fetcher = (variables: UpdateReviewMutationVariables, options?: RequestInit['headers']) => fetchByAuth<UpdateReviewMutation, UpdateReviewMutationVariables>(UpdateReviewDocument, variables, options);
export const DeleteReviewImageByPkDocument = `
    mutation DeleteReviewImageByPK($id: String!) {
  delete_review_image_by_pk(id: $id) {
    id
  }
}
    `;
export const useDeleteReviewImageByPkMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<DeleteReviewImageByPkMutation, TError, DeleteReviewImageByPkMutationVariables, TContext>) =>
    useMutation<DeleteReviewImageByPkMutation, TError, DeleteReviewImageByPkMutationVariables, TContext>(
      ['DeleteReviewImageByPK'],
      (variables?: DeleteReviewImageByPkMutationVariables) => fetchByAuth<DeleteReviewImageByPkMutation, DeleteReviewImageByPkMutationVariables>(DeleteReviewImageByPkDocument, variables)(),
      options
    );
useDeleteReviewImageByPkMutation.fetcher = (variables: DeleteReviewImageByPkMutationVariables, options?: RequestInit['headers']) => fetchByAuth<DeleteReviewImageByPkMutation, DeleteReviewImageByPkMutationVariables>(DeleteReviewImageByPkDocument, variables, options);
export const AddReviewImagesDocument = `
    mutation addReviewImages($images: [review_image_insert_input!]!) {
  insert_review_image(objects: $images) {
    affected_rows
  }
}
    `;
export const useAddReviewImagesMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AddReviewImagesMutation, TError, AddReviewImagesMutationVariables, TContext>) =>
    useMutation<AddReviewImagesMutation, TError, AddReviewImagesMutationVariables, TContext>(
      ['addReviewImages'],
      (variables?: AddReviewImagesMutationVariables) => fetchByAuth<AddReviewImagesMutation, AddReviewImagesMutationVariables>(AddReviewImagesDocument, variables)(),
      options
    );
useAddReviewImagesMutation.fetcher = (variables: AddReviewImagesMutationVariables, options?: RequestInit['headers']) => fetchByAuth<AddReviewImagesMutation, AddReviewImagesMutationVariables>(AddReviewImagesDocument, variables, options);
export const ReviewGoodDocument = `
    query ReviewGood {
  review_good {
    created_at
    for_review_id
    from_user_id
    id
  }
}
    `;
export const useReviewGoodQuery = <
      TData = ReviewGoodQuery,
      TError = unknown
    >(
      variables?: ReviewGoodQueryVariables,
      options?: UseQueryOptions<ReviewGoodQuery, TError, TData>
    ) =>
    useQuery<ReviewGoodQuery, TError, TData>(
      variables === undefined ? ['ReviewGood'] : ['ReviewGood', variables],
      fetchByAuth<ReviewGoodQuery, ReviewGoodQueryVariables>(ReviewGoodDocument, variables),
      options
    );
useReviewGoodQuery.document = ReviewGoodDocument;


useReviewGoodQuery.getKey = (variables?: ReviewGoodQueryVariables) => variables === undefined ? ['ReviewGood'] : ['ReviewGood', variables];
;

export const useInfiniteReviewGoodQuery = <
      TData = ReviewGoodQuery,
      TError = unknown
    >(
      pageParamKey: keyof ReviewGoodQueryVariables,
      variables?: ReviewGoodQueryVariables,
      options?: UseInfiniteQueryOptions<ReviewGoodQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<ReviewGoodQuery, TError, TData>(
      variables === undefined ? ['ReviewGood.infinite'] : ['ReviewGood.infinite', variables],
      (metaData) => fetchByAuth<ReviewGoodQuery, ReviewGoodQueryVariables>(ReviewGoodDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteReviewGoodQuery.getKey = (variables?: ReviewGoodQueryVariables) => variables === undefined ? ['ReviewGood.infinite'] : ['ReviewGood.infinite', variables];
;

useReviewGoodQuery.fetcher = (variables?: ReviewGoodQueryVariables, options?: RequestInit['headers']) => fetchByAuth<ReviewGoodQuery, ReviewGoodQueryVariables>(ReviewGoodDocument, variables, options);
export const GetMyAddressDocument = `
    query GetMyAddress {
  address {
    building
    city
    created_at
    id
    name
    postal_code
    tel_head
    tel_tail
    updated_at
    tel_body
    street
    prefecture
    user_id
  }
}
    `;
export const useGetMyAddressQuery = <
      TData = GetMyAddressQuery,
      TError = unknown
    >(
      variables?: GetMyAddressQueryVariables,
      options?: UseQueryOptions<GetMyAddressQuery, TError, TData>
    ) =>
    useQuery<GetMyAddressQuery, TError, TData>(
      variables === undefined ? ['GetMyAddress'] : ['GetMyAddress', variables],
      fetchByAuth<GetMyAddressQuery, GetMyAddressQueryVariables>(GetMyAddressDocument, variables),
      options
    );
useGetMyAddressQuery.document = GetMyAddressDocument;


useGetMyAddressQuery.getKey = (variables?: GetMyAddressQueryVariables) => variables === undefined ? ['GetMyAddress'] : ['GetMyAddress', variables];
;

export const useInfiniteGetMyAddressQuery = <
      TData = GetMyAddressQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetMyAddressQueryVariables,
      variables?: GetMyAddressQueryVariables,
      options?: UseInfiniteQueryOptions<GetMyAddressQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetMyAddressQuery, TError, TData>(
      variables === undefined ? ['GetMyAddress.infinite'] : ['GetMyAddress.infinite', variables],
      (metaData) => fetchByAuth<GetMyAddressQuery, GetMyAddressQueryVariables>(GetMyAddressDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetMyAddressQuery.getKey = (variables?: GetMyAddressQueryVariables) => variables === undefined ? ['GetMyAddress.infinite'] : ['GetMyAddress.infinite', variables];
;

useGetMyAddressQuery.fetcher = (variables?: GetMyAddressQueryVariables, options?: RequestInit['headers']) => fetchByAuth<GetMyAddressQuery, GetMyAddressQueryVariables>(GetMyAddressDocument, variables, options);
export const GetTotalAcquiredPointsDocument = `
    query GetTotalAcquiredPoints {
  point_history_aggregate(where: {type: {_eq: "earn"}}) {
    aggregate {
      sum {
        value
        rate
      }
      count
    }
  }
}
    `;
export const useGetTotalAcquiredPointsQuery = <
      TData = GetTotalAcquiredPointsQuery,
      TError = unknown
    >(
      variables?: GetTotalAcquiredPointsQueryVariables,
      options?: UseQueryOptions<GetTotalAcquiredPointsQuery, TError, TData>
    ) =>
    useQuery<GetTotalAcquiredPointsQuery, TError, TData>(
      variables === undefined ? ['GetTotalAcquiredPoints'] : ['GetTotalAcquiredPoints', variables],
      fetchByAuth<GetTotalAcquiredPointsQuery, GetTotalAcquiredPointsQueryVariables>(GetTotalAcquiredPointsDocument, variables),
      options
    );
useGetTotalAcquiredPointsQuery.document = GetTotalAcquiredPointsDocument;


useGetTotalAcquiredPointsQuery.getKey = (variables?: GetTotalAcquiredPointsQueryVariables) => variables === undefined ? ['GetTotalAcquiredPoints'] : ['GetTotalAcquiredPoints', variables];
;

export const useInfiniteGetTotalAcquiredPointsQuery = <
      TData = GetTotalAcquiredPointsQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetTotalAcquiredPointsQueryVariables,
      variables?: GetTotalAcquiredPointsQueryVariables,
      options?: UseInfiniteQueryOptions<GetTotalAcquiredPointsQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetTotalAcquiredPointsQuery, TError, TData>(
      variables === undefined ? ['GetTotalAcquiredPoints.infinite'] : ['GetTotalAcquiredPoints.infinite', variables],
      (metaData) => fetchByAuth<GetTotalAcquiredPointsQuery, GetTotalAcquiredPointsQueryVariables>(GetTotalAcquiredPointsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetTotalAcquiredPointsQuery.getKey = (variables?: GetTotalAcquiredPointsQueryVariables) => variables === undefined ? ['GetTotalAcquiredPoints.infinite'] : ['GetTotalAcquiredPoints.infinite', variables];
;

useGetTotalAcquiredPointsQuery.fetcher = (variables?: GetTotalAcquiredPointsQueryVariables, options?: RequestInit['headers']) => fetchByAuth<GetTotalAcquiredPointsQuery, GetTotalAcquiredPointsQueryVariables>(GetTotalAcquiredPointsDocument, variables, options);
export const GetWinGachaDocument = `
    query GetWinGacha {
  physical_prize(order_by: {created_at: desc}) {
    created_at
    gacha_id
    id
    input_delivery_address_at
    physical_prize_delivery_address_id
    point_used_id
    updated_at
    user_id
  }
  physical_prize_aggregate {
    aggregate {
      count
    }
  }
}
    `;
export const useGetWinGachaQuery = <
      TData = GetWinGachaQuery,
      TError = unknown
    >(
      variables?: GetWinGachaQueryVariables,
      options?: UseQueryOptions<GetWinGachaQuery, TError, TData>
    ) =>
    useQuery<GetWinGachaQuery, TError, TData>(
      variables === undefined ? ['GetWinGacha'] : ['GetWinGacha', variables],
      fetchByAuth<GetWinGachaQuery, GetWinGachaQueryVariables>(GetWinGachaDocument, variables),
      options
    );
useGetWinGachaQuery.document = GetWinGachaDocument;


useGetWinGachaQuery.getKey = (variables?: GetWinGachaQueryVariables) => variables === undefined ? ['GetWinGacha'] : ['GetWinGacha', variables];
;

export const useInfiniteGetWinGachaQuery = <
      TData = GetWinGachaQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetWinGachaQueryVariables,
      variables?: GetWinGachaQueryVariables,
      options?: UseInfiniteQueryOptions<GetWinGachaQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetWinGachaQuery, TError, TData>(
      variables === undefined ? ['GetWinGacha.infinite'] : ['GetWinGacha.infinite', variables],
      (metaData) => fetchByAuth<GetWinGachaQuery, GetWinGachaQueryVariables>(GetWinGachaDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetWinGachaQuery.getKey = (variables?: GetWinGachaQueryVariables) => variables === undefined ? ['GetWinGacha.infinite'] : ['GetWinGacha.infinite', variables];
;

useGetWinGachaQuery.fetcher = (variables?: GetWinGachaQueryVariables, options?: RequestInit['headers']) => fetchByAuth<GetWinGachaQuery, GetWinGachaQueryVariables>(GetWinGachaDocument, variables, options);
export const InsertAddressFromUserDocument = `
    mutation InsertAddressFromUser($object: address_insert_input = {}) {
  insert_address_one(object: $object) {
    id
  }
}
    `;
export const useInsertAddressFromUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<InsertAddressFromUserMutation, TError, InsertAddressFromUserMutationVariables, TContext>) =>
    useMutation<InsertAddressFromUserMutation, TError, InsertAddressFromUserMutationVariables, TContext>(
      ['InsertAddressFromUser'],
      (variables?: InsertAddressFromUserMutationVariables) => fetchByAuth<InsertAddressFromUserMutation, InsertAddressFromUserMutationVariables>(InsertAddressFromUserDocument, variables)(),
      options
    );
useInsertAddressFromUserMutation.fetcher = (variables?: InsertAddressFromUserMutationVariables, options?: RequestInit['headers']) => fetchByAuth<InsertAddressFromUserMutation, InsertAddressFromUserMutationVariables>(InsertAddressFromUserDocument, variables, options);
export const MyPointDocument = `
    query MyPoint {
  point_history_aggregate {
    aggregate {
      sum {
        rate
        value
      }
    }
  }
}
    `;
export const useMyPointQuery = <
      TData = MyPointQuery,
      TError = unknown
    >(
      variables?: MyPointQueryVariables,
      options?: UseQueryOptions<MyPointQuery, TError, TData>
    ) =>
    useQuery<MyPointQuery, TError, TData>(
      variables === undefined ? ['MyPoint'] : ['MyPoint', variables],
      fetchByAuth<MyPointQuery, MyPointQueryVariables>(MyPointDocument, variables),
      options
    );
useMyPointQuery.document = MyPointDocument;


useMyPointQuery.getKey = (variables?: MyPointQueryVariables) => variables === undefined ? ['MyPoint'] : ['MyPoint', variables];
;

export const useInfiniteMyPointQuery = <
      TData = MyPointQuery,
      TError = unknown
    >(
      pageParamKey: keyof MyPointQueryVariables,
      variables?: MyPointQueryVariables,
      options?: UseInfiniteQueryOptions<MyPointQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<MyPointQuery, TError, TData>(
      variables === undefined ? ['MyPoint.infinite'] : ['MyPoint.infinite', variables],
      (metaData) => fetchByAuth<MyPointQuery, MyPointQueryVariables>(MyPointDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteMyPointQuery.getKey = (variables?: MyPointQueryVariables) => variables === undefined ? ['MyPoint.infinite'] : ['MyPoint.infinite', variables];
;

useMyPointQuery.fetcher = (variables?: MyPointQueryVariables, options?: RequestInit['headers']) => fetchByAuth<MyPointQuery, MyPointQueryVariables>(MyPointDocument, variables, options);
export const MyPointHistoryDocument = `
    query MyPointHistory($offset: Int!, $limit: Int = 20, $sumOffset: Int!) {
  point_history(offset: $offset, limit: $limit, order_by: {created_at: desc}) {
    created_at
    earn_id
    earned_type
    fixed_exchange_product_exchanged_id
    gacha_lose_id
    message
    physical_prize_id
    rate
    type
    updated_at
    use_id
    user_id
    value
    physical_prize {
      gacha {
        name
        total_win_num_limit
        end_at
      }
    }
    gacha_lose {
      gacha {
        name
        end_at
        total_win_num_limit
      }
    }
    month_first_point_id
  }
  point_history_aggregate_with_offset: point_history_aggregate(
    order_by: {created_at: desc}
    offset: $sumOffset
  ) {
    aggregate {
      count
      sum {
        value
      }
    }
  }
  point_history_aggregate_total: point_history_aggregate(
    order_by: {created_at: desc}
  ) {
    aggregate {
      count
      sum {
        value
      }
    }
  }
}
    `;
export const useMyPointHistoryQuery = <
      TData = MyPointHistoryQuery,
      TError = unknown
    >(
      variables: MyPointHistoryQueryVariables,
      options?: UseQueryOptions<MyPointHistoryQuery, TError, TData>
    ) =>
    useQuery<MyPointHistoryQuery, TError, TData>(
      ['MyPointHistory', variables],
      fetchByAuth<MyPointHistoryQuery, MyPointHistoryQueryVariables>(MyPointHistoryDocument, variables),
      options
    );
useMyPointHistoryQuery.document = MyPointHistoryDocument;


useMyPointHistoryQuery.getKey = (variables: MyPointHistoryQueryVariables) => ['MyPointHistory', variables];
;

export const useInfiniteMyPointHistoryQuery = <
      TData = MyPointHistoryQuery,
      TError = unknown
    >(
      pageParamKey: keyof MyPointHistoryQueryVariables,
      variables: MyPointHistoryQueryVariables,
      options?: UseInfiniteQueryOptions<MyPointHistoryQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<MyPointHistoryQuery, TError, TData>(
      ['MyPointHistory.infinite', variables],
      (metaData) => fetchByAuth<MyPointHistoryQuery, MyPointHistoryQueryVariables>(MyPointHistoryDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteMyPointHistoryQuery.getKey = (variables: MyPointHistoryQueryVariables) => ['MyPointHistory.infinite', variables];
;

useMyPointHistoryQuery.fetcher = (variables: MyPointHistoryQueryVariables, options?: RequestInit['headers']) => fetchByAuth<MyPointHistoryQuery, MyPointHistoryQueryVariables>(MyPointHistoryDocument, variables, options);
export const NotificationDocument = `
    query Notification($limit: Int = 16) {
  user_notification(order_by: {created_at: desc}) {
    updated_at
    type
    review_like_values
    read_at
    id
    created_at
    user_id
  }
  unread_total: user_notification_aggregate(
    where: {read_at: {_is_null: true}}
    limit: $limit
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const useNotificationQuery = <
      TData = NotificationQuery,
      TError = unknown
    >(
      variables?: NotificationQueryVariables,
      options?: UseQueryOptions<NotificationQuery, TError, TData>
    ) =>
    useQuery<NotificationQuery, TError, TData>(
      variables === undefined ? ['Notification'] : ['Notification', variables],
      fetchByAuth<NotificationQuery, NotificationQueryVariables>(NotificationDocument, variables),
      options
    );
useNotificationQuery.document = NotificationDocument;


useNotificationQuery.getKey = (variables?: NotificationQueryVariables) => variables === undefined ? ['Notification'] : ['Notification', variables];
;

export const useInfiniteNotificationQuery = <
      TData = NotificationQuery,
      TError = unknown
    >(
      pageParamKey: keyof NotificationQueryVariables,
      variables?: NotificationQueryVariables,
      options?: UseInfiniteQueryOptions<NotificationQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<NotificationQuery, TError, TData>(
      variables === undefined ? ['Notification.infinite'] : ['Notification.infinite', variables],
      (metaData) => fetchByAuth<NotificationQuery, NotificationQueryVariables>(NotificationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteNotificationQuery.getKey = (variables?: NotificationQueryVariables) => variables === undefined ? ['Notification.infinite'] : ['Notification.infinite', variables];
;

useNotificationQuery.fetcher = (variables?: NotificationQueryVariables, options?: RequestInit['headers']) => fetchByAuth<NotificationQuery, NotificationQueryVariables>(NotificationDocument, variables, options);
export const ReadNotificationDocument = `
    mutation ReadNotification($id: String!, $read_at: timestamp!) {
  update_user_notification_by_pk(pk_columns: {id: $id}, _set: {read_at: $read_at}) {
    read_at
  }
}
    `;
export const useReadNotificationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ReadNotificationMutation, TError, ReadNotificationMutationVariables, TContext>) =>
    useMutation<ReadNotificationMutation, TError, ReadNotificationMutationVariables, TContext>(
      ['ReadNotification'],
      (variables?: ReadNotificationMutationVariables) => fetchByAuth<ReadNotificationMutation, ReadNotificationMutationVariables>(ReadNotificationDocument, variables)(),
      options
    );
useReadNotificationMutation.fetcher = (variables: ReadNotificationMutationVariables, options?: RequestInit['headers']) => fetchByAuth<ReadNotificationMutation, ReadNotificationMutationVariables>(ReadNotificationDocument, variables, options);
export const UpdateAddressFromUserDocument = `
    mutation UpdateAddressFromUser($address_id: String!, $_set: address_set_input = {}) {
  update_address_by_pk(pk_columns: {id: $address_id}, _set: $_set) {
    id
    name
  }
}
    `;
export const useUpdateAddressFromUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateAddressFromUserMutation, TError, UpdateAddressFromUserMutationVariables, TContext>) =>
    useMutation<UpdateAddressFromUserMutation, TError, UpdateAddressFromUserMutationVariables, TContext>(
      ['UpdateAddressFromUser'],
      (variables?: UpdateAddressFromUserMutationVariables) => fetchByAuth<UpdateAddressFromUserMutation, UpdateAddressFromUserMutationVariables>(UpdateAddressFromUserDocument, variables)(),
      options
    );
useUpdateAddressFromUserMutation.fetcher = (variables: UpdateAddressFromUserMutationVariables, options?: RequestInit['headers']) => fetchByAuth<UpdateAddressFromUserMutation, UpdateAddressFromUserMutationVariables>(UpdateAddressFromUserDocument, variables, options);
export const UpdateUserDocument = `
    mutation UpdateUser($id: String!, $_set: user_set_input = {}) {
  update_user_by_pk(pk_columns: {id: $id}, _set: $_set) {
    id
  }
}
    `;
export const useUpdateUserMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>) =>
    useMutation<UpdateUserMutation, TError, UpdateUserMutationVariables, TContext>(
      ['UpdateUser'],
      (variables?: UpdateUserMutationVariables) => fetchByAuth<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, variables)(),
      options
    );
useUpdateUserMutation.fetcher = (variables: UpdateUserMutationVariables, options?: RequestInit['headers']) => fetchByAuth<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, variables, options);
export const WithdrawDocument = `
    mutation Withdraw {
  withDraw {
    error_message
    status
  }
}
    `;
export const useWithdrawMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<WithdrawMutation, TError, WithdrawMutationVariables, TContext>) =>
    useMutation<WithdrawMutation, TError, WithdrawMutationVariables, TContext>(
      ['Withdraw'],
      (variables?: WithdrawMutationVariables) => fetchByAuth<WithdrawMutation, WithdrawMutationVariables>(WithdrawDocument, variables)(),
      options
    );
useWithdrawMutation.fetcher = (variables?: WithdrawMutationVariables, options?: RequestInit['headers']) => fetchByAuth<WithdrawMutation, WithdrawMutationVariables>(WithdrawDocument, variables, options);
export const GetLoginUserDocument = `
    query GetLoginUser {
  user {
    display_name
    email
    birthday
    background_image_id
    camping_days
    created_at
    icon_image_id
    id
    liked_gear
    self_introduction
    sex
    start_history
    total_like_num
    total_point
    total_review_num
    total_visited_num
    updated_at
    url
    url_title
    user_email
    withdrawal_date
    campsite_likes_aggregate {
      aggregate {
        count
      }
    }
    visiteds_aggregate {
      aggregate {
        count
      }
    }
    user_notifications_aggregate {
      aggregate {
        count
      }
    }
    background_icon {
      user_id
      title
      id
      file_name
      created_at
      alt
    }
    icon {
      user_id
      title
      id
      file_name
      created_at
      alt
    }
  }
}
    `;
export const useGetLoginUserQuery = <
      TData = GetLoginUserQuery,
      TError = unknown
    >(
      variables?: GetLoginUserQueryVariables,
      options?: UseQueryOptions<GetLoginUserQuery, TError, TData>
    ) =>
    useQuery<GetLoginUserQuery, TError, TData>(
      variables === undefined ? ['GetLoginUser'] : ['GetLoginUser', variables],
      fetchByAuth<GetLoginUserQuery, GetLoginUserQueryVariables>(GetLoginUserDocument, variables),
      options
    );
useGetLoginUserQuery.document = GetLoginUserDocument;


useGetLoginUserQuery.getKey = (variables?: GetLoginUserQueryVariables) => variables === undefined ? ['GetLoginUser'] : ['GetLoginUser', variables];
;

export const useInfiniteGetLoginUserQuery = <
      TData = GetLoginUserQuery,
      TError = unknown
    >(
      pageParamKey: keyof GetLoginUserQueryVariables,
      variables?: GetLoginUserQueryVariables,
      options?: UseInfiniteQueryOptions<GetLoginUserQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<GetLoginUserQuery, TError, TData>(
      variables === undefined ? ['GetLoginUser.infinite'] : ['GetLoginUser.infinite', variables],
      (metaData) => fetchByAuth<GetLoginUserQuery, GetLoginUserQueryVariables>(GetLoginUserDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteGetLoginUserQuery.getKey = (variables?: GetLoginUserQueryVariables) => variables === undefined ? ['GetLoginUser.infinite'] : ['GetLoginUser.infinite', variables];
;

useGetLoginUserQuery.fetcher = (variables?: GetLoginUserQueryVariables, options?: RequestInit['headers']) => fetchByAuth<GetLoginUserQuery, GetLoginUserQueryVariables>(GetLoginUserDocument, variables, options);
export const AfterLoginDocument = `
    mutation AfterLogin($cognitoUserId: String!) {
  afterLogin(cognitoUserId: $cognitoUserId)
}
    `;
export const useAfterLoginMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<AfterLoginMutation, TError, AfterLoginMutationVariables, TContext>) =>
    useMutation<AfterLoginMutation, TError, AfterLoginMutationVariables, TContext>(
      ['AfterLogin'],
      (variables?: AfterLoginMutationVariables) => fetchByAuth<AfterLoginMutation, AfterLoginMutationVariables>(AfterLoginDocument, variables)(),
      options
    );
useAfterLoginMutation.fetcher = (variables: AfterLoginMutationVariables, options?: RequestInit['headers']) => fetchByAuth<AfterLoginMutation, AfterLoginMutationVariables>(AfterLoginDocument, variables, options);
export const UserNotificationDocument = `
    query UserNotification {
  user_notification(where: {read_at: {_is_null: true}}) {
    user_id
    updated_at
    type
    read_at
    id
    created_at
    review_like_values
  }
  user_notification_aggregate(where: {read_at: {_is_null: true}}) {
    aggregate {
      count
    }
  }
}
    `;
export const useUserNotificationQuery = <
      TData = UserNotificationQuery,
      TError = unknown
    >(
      variables?: UserNotificationQueryVariables,
      options?: UseQueryOptions<UserNotificationQuery, TError, TData>
    ) =>
    useQuery<UserNotificationQuery, TError, TData>(
      variables === undefined ? ['UserNotification'] : ['UserNotification', variables],
      fetchByAuth<UserNotificationQuery, UserNotificationQueryVariables>(UserNotificationDocument, variables),
      options
    );
useUserNotificationQuery.document = UserNotificationDocument;


useUserNotificationQuery.getKey = (variables?: UserNotificationQueryVariables) => variables === undefined ? ['UserNotification'] : ['UserNotification', variables];
;

export const useInfiniteUserNotificationQuery = <
      TData = UserNotificationQuery,
      TError = unknown
    >(
      pageParamKey: keyof UserNotificationQueryVariables,
      variables?: UserNotificationQueryVariables,
      options?: UseInfiniteQueryOptions<UserNotificationQuery, TError, TData>
    ) =>{
    
    return useInfiniteQuery<UserNotificationQuery, TError, TData>(
      variables === undefined ? ['UserNotification.infinite'] : ['UserNotification.infinite', variables],
      (metaData) => fetchByAuth<UserNotificationQuery, UserNotificationQueryVariables>(UserNotificationDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      options
    )};


useInfiniteUserNotificationQuery.getKey = (variables?: UserNotificationQueryVariables) => variables === undefined ? ['UserNotification.infinite'] : ['UserNotification.infinite', variables];
;

useUserNotificationQuery.fetcher = (variables?: UserNotificationQueryVariables, options?: RequestInit['headers']) => fetchByAuth<UserNotificationQuery, UserNotificationQueryVariables>(UserNotificationDocument, variables, options);